algoliaShopify.externals = (function (e) {
  function t(n) {
    if (r[n]) return r[n].exports;
    var i = (r[n] = { i: n, l: !1, exports: {} });
    return e[n].call(i.exports, i, i.exports, t), (i.l = !0), i.exports;
  }
  var r = {};
  return (
    (t.m = e),
    (t.c = r),
    (t.d = function (e, r, n) {
      t.o(e, r) ||
        Object.defineProperty(e, r, {
          configurable: !1,
          enumerable: !0,
          get: n,
        });
    }),
    (t.n = function (e) {
      var r =
        e && e.__esModule
          ? function () {
              return e.default;
            }
          : function () {
              return e;
            };
      return t.d(r, "a", r), r;
    }),
    (t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (t.p = ""),
    t((t.s = 90))
  );
})([
  function (e, t, r) {
    "use strict";
    function n(e) {
      return e && e.__esModule ? e : { default: e };
    }
    e.exports = n;
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(42);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(43);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
    var o = r(105);
    Object.keys(o).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return o[e];
          },
        });
    });
    var a = r(106);
    Object.keys(a).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return a[e];
          },
        });
    });
    var s = r(107);
    Object.keys(s).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return s[e];
          },
        });
    });
    var c = r(108);
    Object.keys(c).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return c[e];
          },
        });
    });
    var u = r(109);
    Object.keys(u).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return u[e];
          },
        });
    });
    var l = r(110);
    Object.keys(l).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return l[e];
          },
        });
    });
    var f = r(111);
    Object.keys(f).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return f[e];
          },
        });
    });
    var d = r(50);
    Object.keys(d).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return d[e];
          },
        });
    });
    var p = r(112);
    Object.keys(p).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return p[e];
          },
        });
    });
    var h = r(113);
    Object.keys(h).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return h[e];
          },
        });
    });
    var v = r(114);
    Object.keys(v).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return v[e];
          },
        });
    });
    var m = r(115);
    Object.keys(m).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return m[e];
          },
        });
    });
    var g = r(29);
    Object.keys(g).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return g[e];
          },
        });
    });
    var y = r(30);
    Object.keys(y).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return y[e];
          },
        });
    });
    var b = r(51);
    Object.keys(b).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return b[e];
          },
        });
    });
    var _ = r(52);
    Object.keys(_).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return _[e];
          },
        });
    });
    var O = r(53);
    Object.keys(O).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return O[e];
          },
        });
    });
    var j = r(116);
    Object.keys(j).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return j[e];
          },
        });
    });
    var P = r(117);
    Object.keys(P).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return P[e];
          },
        });
    });
    var w = r(118);
    Object.keys(w).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return w[e];
          },
        });
    });
    var S = r(119);
    Object.keys(S).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return S[e];
          },
        });
    });
    var E = r(55);
    Object.keys(E).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return E[e];
          },
        });
    });
    var R = r(46);
    Object.keys(R).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return R[e];
          },
        });
    });
    var x = r(120);
    Object.keys(x).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return x[e];
          },
        });
    });
    var k = r(121);
    Object.keys(k).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return k[e];
          },
        });
    });
    var I = r(122);
    Object.keys(I).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return I[e];
          },
        });
    });
    var A = r(123);
    Object.keys(A).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return A[e];
          },
        });
    });
    var M = r(124);
    Object.keys(M).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return M[e];
          },
        });
    });
    var C = r(54);
    Object.keys(C).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return C[e];
          },
        });
    });
    var T = r(125);
    Object.keys(T).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return T[e];
          },
        });
    });
    var N = r(48);
    Object.keys(N).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return N[e];
          },
        });
    });
    var D = r(126);
    Object.keys(D).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return D[e];
          },
        });
    });
    var F = r(47);
    Object.keys(F).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return F[e];
          },
        });
    });
    var H = r(127);
    Object.keys(H).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return H[e];
          },
        });
    });
    var L = r(44);
    Object.keys(L).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return L[e];
          },
        });
    });
    var U = r(128);
    Object.keys(U).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return U[e];
          },
        });
    });
    var q = r(45);
    Object.keys(q).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return q[e];
          },
        });
    });
    var B = r(129);
    Object.keys(B).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return B[e];
          },
        });
    });
    var W = r(130);
    Object.keys(W).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return W[e];
          },
        });
    });
    var V = r(131);
    Object.keys(V).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return V[e];
          },
        });
    });
    var Q = r(132);
    Object.keys(Q).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return Q[e];
          },
        });
    });
    var $ = r(133);
    Object.keys($).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return $[e];
          },
        });
    });
    var G = r(49);
    Object.keys(G).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return G[e];
          },
        });
    });
    var K = r(134);
    Object.keys(K).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return K[e];
          },
        });
    });
    var J = r(31);
    Object.keys(J).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return J[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      for (var r in t) e[r] = t[r];
      return e;
    }
    function i(e) {
      var t = e.parentNode;
      t && t.removeChild(e);
    }
    function o(e, t, r) {
      var n,
        i,
        o,
        s = {};
      for (o in t)
        "key" == o ? (n = t[o]) : "ref" == o ? (i = t[o]) : (s[o] = t[o]);
      if (
        (arguments.length > 2 &&
          (s.children = arguments.length > 3 ? C.call(arguments, 2) : r),
        "function" == typeof e && null != e.defaultProps)
      )
        for (o in e.defaultProps) void 0 === s[o] && (s[o] = e.defaultProps[o]);
      return a(e, s, n, i, null);
    }
    function a(e, t, r, n, i) {
      var o = {
        type: e,
        props: t,
        key: r,
        ref: n,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == i ? ++N : i,
      };
      return null == i && null != T.vnode && T.vnode(o), o;
    }
    function s() {
      return { current: null };
    }
    function c(e) {
      return e.children;
    }
    function u(e, t) {
      (this.props = e), (this.context = t);
    }
    function l(e, t) {
      if (null == t) return e.__ ? l(e.__, e.__.__k.indexOf(e) + 1) : null;
      for (var r; t < e.__k.length; t++)
        if (null != (r = e.__k[t]) && null != r.__e) return r.__e;
      return "function" == typeof e.type ? l(e) : null;
    }
    function f(e) {
      var t, r;
      if (null != (e = e.__) && null != e.__c) {
        for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)
          if (null != (r = e.__k[t]) && null != r.__e) {
            e.__e = e.__c.base = r.__e;
            break;
          }
        return f(e);
      }
    }
    function d(e) {
      ((!e.__d && (e.__d = !0) && F.push(e) && !p.__r++) ||
        H !== T.debounceRendering) &&
        ((H = T.debounceRendering) || setTimeout)(p);
    }
    function p() {
      for (var e; (p.__r = F.length); )
        (e = F.sort(function (e, t) {
          return e.__v.__b - t.__v.__b;
        })),
          (F = []),
          e.some(function (e) {
            var t, r, i, o, a, s;
            e.__d &&
              ((a = (o = (t = e).__v).__e),
              (s = t.__P) &&
                ((r = []),
                ((i = n({}, o)).__v = o.__v + 1),
                P(
                  s,
                  o,
                  i,
                  t.__n,
                  void 0 !== s.ownerSVGElement,
                  null != o.__h ? [a] : null,
                  r,
                  null == a ? l(o) : a,
                  o.__h
                ),
                w(r, o),
                o.__e != a && f(o)));
          });
    }
    function h(e, t, r, n, i, o, s, u, f, d) {
      var p,
        h,
        m,
        y,
        b,
        _,
        O,
        j = (n && n.__k) || q,
        w = j.length;
      for (r.__k = [], p = 0; p < t.length; p++)
        if (
          null !=
          (y = r.__k[p] =
            null == (y = t[p]) || "boolean" == typeof y
              ? null
              : "string" == typeof y ||
                "number" == typeof y ||
                "bigint" == typeof y
              ? a(null, y, null, null, y)
              : Array.isArray(y)
              ? a(c, { children: y }, null, null, null)
              : y.__b > 0
              ? a(y.type, y.props, y.key, y.ref ? y.ref : null, y.__v)
              : y)
        ) {
          if (
            ((y.__ = r),
            (y.__b = r.__b + 1),
            null === (m = j[p]) || (m && y.key == m.key && y.type === m.type))
          )
            j[p] = void 0;
          else
            for (h = 0; h < w; h++) {
              if ((m = j[h]) && y.key == m.key && y.type === m.type) {
                j[h] = void 0;
                break;
              }
              m = null;
            }
          P(e, y, (m = m || U), i, o, s, u, f, d),
            (b = y.__e),
            (h = y.ref) &&
              m.ref != h &&
              (O || (O = []),
              m.ref && O.push(m.ref, null, y),
              O.push(h, y.__c || b, y)),
            null != b
              ? (null == _ && (_ = b),
                "function" == typeof y.type && y.__k === m.__k
                  ? (y.__d = f = v(y, f, e))
                  : (f = g(e, y, m, j, b, f)),
                "function" == typeof r.type && (r.__d = f))
              : f && m.__e == f && f.parentNode != e && (f = l(m));
        }
      for (r.__e = _, p = w; p--; ) null != j[p] && R(j[p], j[p]);
      if (O) for (p = 0; p < O.length; p++) E(O[p], O[++p], O[++p]);
    }
    function v(e, t, r) {
      for (var n, i = e.__k, o = 0; i && o < i.length; o++)
        (n = i[o]) &&
          ((n.__ = e),
          (t =
            "function" == typeof n.type
              ? v(n, t, r)
              : g(r, n, n, i, n.__e, t)));
      return t;
    }
    function m(e, t) {
      return (
        (t = t || []),
        null == e ||
          "boolean" == typeof e ||
          (Array.isArray(e)
            ? e.some(function (e) {
                m(e, t);
              })
            : t.push(e)),
        t
      );
    }
    function g(e, t, r, n, i, o) {
      var a, s, c;
      if (void 0 !== t.__d) (a = t.__d), (t.__d = void 0);
      else if (null == r || i != o || null == i.parentNode)
        e: if (null == o || o.parentNode !== e) e.appendChild(i), (a = null);
        else {
          for (s = o, c = 0; (s = s.nextSibling) && c < n.length; c += 2)
            if (s == i) break e;
          e.insertBefore(i, o), (a = o);
        }
      return void 0 !== a ? a : i.nextSibling;
    }
    function y(e, t, r, n, i) {
      var o;
      for (o in r)
        "children" === o || "key" === o || o in t || _(e, o, null, r[o], n);
      for (o in t)
        (i && "function" != typeof t[o]) ||
          "children" === o ||
          "key" === o ||
          "value" === o ||
          "checked" === o ||
          r[o] === t[o] ||
          _(e, o, t[o], r[o], n);
    }
    function b(e, t, r) {
      "-" === t[0]
        ? e.setProperty(t, r)
        : (e[t] =
            null == r ? "" : "number" != typeof r || B.test(t) ? r : r + "px");
    }
    function _(e, t, r, n, i) {
      var o;
      e: if ("style" === t)
        if ("string" == typeof r) e.style.cssText = r;
        else {
          if (("string" == typeof n && (e.style.cssText = n = ""), n))
            for (t in n) (r && t in r) || b(e.style, t, "");
          if (r) for (t in r) (n && r[t] === n[t]) || b(e.style, t, r[t]);
        }
      else if ("o" === t[0] && "n" === t[1])
        (o = t !== (t = t.replace(/Capture$/, ""))),
          (t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2)),
          e.l || (e.l = {}),
          (e.l[t + o] = r),
          r
            ? n || e.addEventListener(t, o ? j : O, o)
            : e.removeEventListener(t, o ? j : O, o);
      else if ("dangerouslySetInnerHTML" !== t) {
        if (i) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if (
          "href" !== t &&
          "list" !== t &&
          "form" !== t &&
          "tabIndex" !== t &&
          "download" !== t &&
          t in e
        )
          try {
            e[t] = null == r ? "" : r;
            break e;
          } catch (e) {}
        "function" == typeof r ||
          (null == r || (!1 === r && -1 == t.indexOf("-"))
            ? e.removeAttribute(t)
            : e.setAttribute(t, r));
      }
    }
    function O(e) {
      this.l[e.type + !1](T.event ? T.event(e) : e);
    }
    function j(e) {
      this.l[e.type + !0](T.event ? T.event(e) : e);
    }
    function P(e, t, r, i, o, a, s, l, f) {
      var d,
        p,
        v,
        m,
        g,
        y,
        b,
        _,
        O,
        j,
        P,
        w,
        E,
        R = t.type;
      if (void 0 !== t.constructor) return null;
      null != r.__h &&
        ((f = r.__h), (l = t.__e = r.__e), (t.__h = null), (a = [l])),
        (d = T.__b) && d(t);
      try {
        e: if ("function" == typeof R) {
          (_ = t.props),
            (O = (d = R.contextType) && i[d.__c]),
            (j = d ? (O ? O.props.value : d.__) : i),
            r.__c
              ? (b = (p = t.__c = r.__c).__ = p.__E)
              : ("prototype" in R && R.prototype.render
                  ? (t.__c = p = new R(_, j))
                  : ((t.__c = p = new u(_, j)),
                    (p.constructor = R),
                    (p.render = x)),
                O && O.sub(p),
                (p.props = _),
                p.state || (p.state = {}),
                (p.context = j),
                (p.__n = i),
                (v = p.__d = !0),
                (p.__h = []),
                (p._sb = [])),
            null == p.__s && (p.__s = p.state),
            null != R.getDerivedStateFromProps &&
              (p.__s == p.state && (p.__s = n({}, p.__s)),
              n(p.__s, R.getDerivedStateFromProps(_, p.__s))),
            (m = p.props),
            (g = p.state);
          for (d = 0; d < p._sb.length; d++) p.__h.push(p._sb[d]), (p._sb = []);
          if (v)
            null == R.getDerivedStateFromProps &&
              null != p.componentWillMount &&
              p.componentWillMount(),
              null != p.componentDidMount && p.__h.push(p.componentDidMount);
          else {
            if (
              (null == R.getDerivedStateFromProps &&
                _ !== m &&
                null != p.componentWillReceiveProps &&
                p.componentWillReceiveProps(_, j),
              (!p.__e &&
                null != p.shouldComponentUpdate &&
                !1 === p.shouldComponentUpdate(_, p.__s, j)) ||
                t.__v === r.__v)
            ) {
              (p.props = _),
                (p.state = p.__s),
                t.__v !== r.__v && (p.__d = !1),
                (p.__v = t),
                (t.__e = r.__e),
                (t.__k = r.__k),
                t.__k.forEach(function (e) {
                  e && (e.__ = t);
                }),
                p.__h.length && s.push(p);
              break e;
            }
            null != p.componentWillUpdate && p.componentWillUpdate(_, p.__s, j),
              null != p.componentDidUpdate &&
                p.__h.push(function () {
                  p.componentDidUpdate(m, g, y);
                });
          }
          if (
            ((p.context = j),
            (p.props = _),
            (p.__v = t),
            (p.__P = e),
            (P = T.__r),
            (w = 0),
            "prototype" in R && R.prototype.render)
          )
            (p.state = p.__s),
              (p.__d = !1),
              P && P(t),
              (d = p.render(p.props, p.state, p.context));
          else
            do {
              (p.__d = !1),
                P && P(t),
                (d = p.render(p.props, p.state, p.context)),
                (p.state = p.__s);
            } while (p.__d && ++w < 25);
          (p.state = p.__s),
            null != p.getChildContext && (i = n(n({}, i), p.getChildContext())),
            v ||
              null == p.getSnapshotBeforeUpdate ||
              (y = p.getSnapshotBeforeUpdate(m, g)),
            (E =
              null != d && d.type === c && null == d.key
                ? d.props.children
                : d),
            h(e, Array.isArray(E) ? E : [E], t, r, i, o, a, s, l, f),
            (p.base = t.__e),
            (t.__h = null),
            p.__h.length && s.push(p),
            b && (p.__E = p.__ = null),
            (p.__e = !1);
        } else
          null == a && t.__v === r.__v
            ? ((t.__k = r.__k), (t.__e = r.__e))
            : (t.__e = S(r.__e, t, r, i, o, a, s, f));
        (d = T.diffed) && d(t);
      } catch (e) {
        (t.__v = null),
          (f || null != a) &&
            ((t.__e = l), (t.__h = !!f), (a[a.indexOf(l)] = null)),
          T.__e(e, t, r);
      }
    }
    function w(e, t) {
      T.__c && T.__c(t, e),
        e.some(function (t) {
          try {
            (e = t.__h),
              (t.__h = []),
              e.some(function (e) {
                e.call(t);
              });
          } catch (e) {
            T.__e(e, t.__v);
          }
        });
    }
    function S(e, t, r, n, o, a, s, c) {
      var u,
        f,
        d,
        p = r.props,
        v = t.props,
        m = t.type,
        g = 0;
      if (("svg" === m && (o = !0), null != a))
        for (; g < a.length; g++)
          if (
            (u = a[g]) &&
            "setAttribute" in u == !!m &&
            (m ? u.localName === m : 3 === u.nodeType)
          ) {
            (e = u), (a[g] = null);
            break;
          }
      if (null == e) {
        if (null === m) return document.createTextNode(v);
        (e = o
          ? document.createElementNS("http://www.w3.org/2000/svg", m)
          : document.createElement(m, v.is && v)),
          (a = null),
          (c = !1);
      }
      if (null === m) p === v || (c && e.data === v) || (e.data = v);
      else {
        if (
          ((a = a && C.call(e.childNodes)),
          (f = (p = r.props || U).dangerouslySetInnerHTML),
          (d = v.dangerouslySetInnerHTML),
          !c)
        ) {
          if (null != a)
            for (p = {}, g = 0; g < e.attributes.length; g++)
              p[e.attributes[g].name] = e.attributes[g].value;
          (d || f) &&
            ((d && ((f && d.__html == f.__html) || d.__html === e.innerHTML)) ||
              (e.innerHTML = (d && d.__html) || ""));
        }
        if ((y(e, v, p, o, c), d)) t.__k = [];
        else if (
          ((g = t.props.children),
          h(
            e,
            Array.isArray(g) ? g : [g],
            t,
            r,
            n,
            o && "foreignObject" !== m,
            a,
            s,
            a ? a[0] : r.__k && l(r, 0),
            c
          ),
          null != a)
        )
          for (g = a.length; g--; ) null != a[g] && i(a[g]);
        c ||
          ("value" in v &&
            void 0 !== (g = v.value) &&
            (g !== e.value ||
              ("progress" === m && !g) ||
              ("option" === m && g !== p.value)) &&
            _(e, "value", g, p.value, !1),
          "checked" in v &&
            void 0 !== (g = v.checked) &&
            g !== e.checked &&
            _(e, "checked", g, p.checked, !1));
      }
      return e;
    }
    function E(e, t, r) {
      try {
        "function" == typeof e ? e(t) : (e.current = t);
      } catch (e) {
        T.__e(e, r);
      }
    }
    function R(e, t, r) {
      var n, o;
      if (
        (T.unmount && T.unmount(e),
        (n = e.ref) && ((n.current && n.current !== e.__e) || E(n, null, t)),
        null != (n = e.__c))
      ) {
        if (n.componentWillUnmount)
          try {
            n.componentWillUnmount();
          } catch (e) {
            T.__e(e, t);
          }
        (n.base = n.__P = null), (e.__c = void 0);
      }
      if ((n = e.__k))
        for (o = 0; o < n.length; o++)
          n[o] && R(n[o], t, r || "function" != typeof e.type);
      r || null == e.__e || i(e.__e), (e.__ = e.__e = e.__d = void 0);
    }
    function x(e, t, r) {
      return this.constructor(e, r);
    }
    function k(e, t, r) {
      var n, i, a;
      T.__ && T.__(e, t),
        (i = (n = "function" == typeof r) ? null : (r && r.__k) || t.__k),
        (a = []),
        P(
          t,
          (e = ((!n && r) || t).__k = o(c, null, [e])),
          i || U,
          U,
          void 0 !== t.ownerSVGElement,
          !n && r ? [r] : i ? null : t.firstChild ? C.call(t.childNodes) : null,
          a,
          !n && r ? r : i ? i.__e : t.firstChild,
          n
        ),
        w(a, e);
    }
    function I(e, t) {
      k(e, t, I);
    }
    function A(e, t, r) {
      var i,
        o,
        s,
        c = n({}, e.props);
      for (s in t)
        "key" == s ? (i = t[s]) : "ref" == s ? (o = t[s]) : (c[s] = t[s]);
      return (
        arguments.length > 2 &&
          (c.children = arguments.length > 3 ? C.call(arguments, 2) : r),
        a(e.type, c, i || e.key, o || e.ref, null)
      );
    }
    function M(e, t) {
      var r = {
        __c: (t = "__cC" + L++),
        __: e,
        Consumer: function (e, t) {
          return e.children(t);
        },
        Provider: function (e) {
          var r, n;
          return (
            this.getChildContext ||
              ((r = []),
              ((n = {})[t] = this),
              (this.getChildContext = function () {
                return n;
              }),
              (this.shouldComponentUpdate = function (e) {
                this.props.value !== e.value && r.some(d);
              }),
              (this.sub = function (e) {
                r.push(e);
                var t = e.componentWillUnmount;
                e.componentWillUnmount = function () {
                  r.splice(r.indexOf(e), 1), t && t.call(e);
                };
              })),
            e.children
          );
        },
      };
      return (r.Provider.__ = r.Consumer.contextType = r);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.Component = u),
      (t.Fragment = c),
      (t.cloneElement = A),
      (t.createContext = M),
      (t.h = t.createElement = o),
      (t.createRef = s),
      (t.hydrate = I),
      (t.render = k),
      (t.toChildArray = m),
      (t.options = t.isValidElement = void 0);
    var C,
      T,
      N,
      D,
      F,
      H,
      L,
      U = {},
      q = [],
      B = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
    (t.isValidElement = D),
      (t.options = T),
      (C = q.slice),
      (t.options = T =
        {
          __e: function (e, t, r, n) {
            for (var i, o, a; (t = t.__); )
              if ((i = t.__c) && !i.__)
                try {
                  if (
                    ((o = i.constructor) &&
                      null != o.getDerivedStateFromError &&
                      (i.setState(o.getDerivedStateFromError(e)), (a = i.__d)),
                    null != i.componentDidCatch &&
                      (i.componentDidCatch(e, n || {}), (a = i.__d)),
                    a)
                  )
                    return (i.__E = i);
                } catch (t) {
                  e = t;
                }
            throw e;
          },
        }),
      (N = 0),
      (t.isValidElement = D =
        function (e) {
          return null != e && void 0 === e.constructor;
        }),
      (u.prototype.setState = function (e, t) {
        var r;
        (r =
          null != this.__s && this.__s !== this.state
            ? this.__s
            : (this.__s = n({}, this.state))),
          "function" == typeof e && (e = e(n({}, r), this.props)),
          e && n(r, e),
          null != e && this.__v && (t && this._sb.push(t), d(this));
      }),
      (u.prototype.forceUpdate = function (e) {
        this.__v && ((this.__e = !0), e && this.__h.push(e), d(this));
      }),
      (u.prototype.render = c),
      (F = []),
      (p.__r = 0),
      (L = 0);
  },
  function (e, t, r) {
    "use strict";
    var n,
      i,
      o = r(0),
      a = o(r(4));
    !(function () {
      function o() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var r = arguments[t];
          if (r) {
            var n = (0, a.default)(r);
            if ("string" === n || "number" === n) e.push(r);
            else if (Array.isArray(r)) {
              if (r.length) {
                var i = o.apply(null, r);
                i && e.push(i);
              }
            } else if ("object" === n) {
              if (
                r.toString !== Object.prototype.toString &&
                !r.toString.toString().includes("[native code]")
              ) {
                e.push(r.toString());
                continue;
              }
              for (var c in r) s.call(r, c) && r[c] && e.push(c);
            }
          }
        }
        return e.join(" ");
      }
      var s = {}.hasOwnProperty;
      void 0 !== e && e.exports
        ? ((o.default = o), (e.exports = o))
        : "object" === (0, a.default)(r(86)) && r(86)
        ? ((n = []),
          void 0 !==
            (i = function () {
              return o;
            }.apply(t, n)) && (e.exports = i))
        : (window.classNames = o);
    })();
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      "@babel/helpers - typeof";
      return (
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? (t.default = n =
              function (e) {
                return typeof e;
              })
          : (t.default = n =
              function (e) {
                return e &&
                  "function" == typeof Symbol &&
                  e.constructor === Symbol &&
                  e !== Symbol.prototype
                  ? "symbol"
                  : typeof e;
              }),
        n(e)
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = n);
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(191);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(192);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
    var o = r(193);
    Object.keys(o).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return o[e];
          },
        });
    });
    var a = r(194);
    Object.keys(a).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return a[e];
          },
        });
    });
    var s = r(195);
    Object.keys(s).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return s[e];
          },
        });
    });
    var c = r(196);
    Object.keys(c).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return c[e];
          },
        });
    });
    var u = r(197);
    Object.keys(u).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return u[e];
          },
        });
    });
    var l = r(198);
    Object.keys(l).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return l[e];
          },
        });
    });
    var f = r(199);
    Object.keys(f).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return f[e];
          },
        });
    });
    var d = r(200);
    Object.keys(d).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return d[e];
          },
        });
    });
    var p = r(201);
    Object.keys(p).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return p[e];
          },
        });
    });
    var h = r(202);
    Object.keys(h).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return h[e];
          },
        });
    });
    var v = r(203);
    Object.keys(v).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return v[e];
          },
        });
    });
    var m = r(68);
    Object.keys(m).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return m[e];
          },
        });
    });
    var g = r(204);
    Object.keys(g).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return g[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.component = void 0);
    var n = function (e) {
      return function () {
        var t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          r = t.descendantName,
          n = t.modifierName,
          i = r ? "-".concat(r) : "",
          o = n ? "--".concat(n) : "";
        return "".concat("ais", "-").concat(e).concat(i).concat(o);
      };
    };
    t.component = n;
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(206);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(207);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
    var o = r(208);
    Object.keys(o).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return o[e];
          },
        });
    });
    var a = r(209);
    Object.keys(a).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return a[e];
          },
        });
    });
    var s = r(210);
    Object.keys(s).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return s[e];
          },
        });
    });
    var c = r(211);
    Object.keys(c).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return c[e];
          },
        });
    });
    var u = r(212);
    Object.keys(u).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return u[e];
          },
        });
    });
    var l = r(213);
    Object.keys(l).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return l[e];
          },
        });
    });
    var f = r(214);
    Object.keys(f).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return f[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    function n() {
      return (
        (n =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r)
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          }),
        n.apply(this, arguments)
      );
    }
    function i(e) {
      "@babel/helpers - typeof";
      return (i =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    function o(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function a(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n);
      }
    }
    function s(e, t, r) {
      return t && a(e.prototype, t), r && a(e, r), e;
    }
    function c(e, t) {
      if ("function" != typeof t && null !== t)
        throw new TypeError(
          "Super expression must either be null or a function"
        );
      (e.prototype = Object.create(t && t.prototype, {
        constructor: { value: e, writable: !0, configurable: !0 },
      })),
        t && u(e, t);
    }
    function u(e, t) {
      return (u =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        })(e, t);
    }
    function l(e) {
      var t = p();
      return function () {
        var r,
          n = h(e);
        if (t) {
          var i = h(this).constructor;
          r = Reflect.construct(n, arguments, i);
        } else r = n.apply(this, arguments);
        return f(this, r);
      };
    }
    function f(e, t) {
      return !t || ("object" !== i(t) && "function" != typeof t) ? d(e) : t;
    }
    function d(e) {
      if (void 0 === e)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return e;
    }
    function p() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return (
          Date.prototype.toString.call(
            Reflect.construct(Date, [], function () {})
          ),
          !0
        );
      } catch (e) {
        return !1;
      }
    }
    function h(e) {
      return (h = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var v = r(2),
      m = r(1),
      g = r(12),
      y = {
        data: {},
        rootTagName: "div",
        useCustomCompileOptions: {},
        templates: {},
        templatesConfig: {},
      },
      b = (function (e) {
        function t() {
          return o(this, t), r.apply(this, arguments);
        }
        c(t, e);
        var r = l(t);
        return (
          s(t, [
            {
              key: "shouldComponentUpdate",
              value: function (e) {
                return (
                  !(0, m.isEqual)(this.props.data, e.data) ||
                  this.props.templateKey !== e.templateKey ||
                  !(0, m.isEqual)(this.props.rootProps, e.rootProps)
                );
              },
            },
            {
              key: "render",
              value: function () {
                var e = this.props.rootTagName,
                  t =
                    this.props.useCustomCompileOptions[this.props.templateKey],
                  r = t ? this.props.templatesConfig.compileOptions : {},
                  o = (0, g.renderTemplate)({
                    templates: this.props.templates,
                    templateKey: this.props.templateKey,
                    compileOptions: r,
                    helpers: this.props.templatesConfig.helpers,
                    data: this.props.data,
                    bindEvent: this.props.bindEvent,
                    sendEvent: this.props.sendEvent,
                  });
                return null === o
                  ? null
                  : "object" === i(o)
                  ? (0, v.h)(e, this.props.rootProps, o)
                  : (0, v.h)(
                      e,
                      n({}, this.props.rootProps, {
                        dangerouslySetInnerHTML: { __html: o },
                      })
                    );
              },
            },
          ]),
          t
        );
      })(v.Component);
    !(function (e, t, r) {
      t in e
        ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = r);
    })(b, "defaultProps", y);
    var _ = b;
    t.default = _;
  },
  function (e, t, r) {
    "use strict";
    var n = Object.prototype.hasOwnProperty,
      i = Object.prototype.toString;
    e.exports = function (e, t, r) {
      if ("[object Function]" !== i.call(t))
        throw new TypeError("iterator must be a function");
      var o = e.length;
      if (o === +o) for (var a = 0; a < o; a++) t.call(r, e[a], a, e);
      else for (var s in e) n.call(e, s) && t.call(r, e[s], s, e);
    };
  },
  function (e, t, r) {
    "use strict";
    e.exports = function (e) {
      return JSON.parse(JSON.stringify(e));
    };
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(241);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(242);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
    var o = r(243);
    Object.keys(o).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return o[e];
          },
        });
    });
    var a = r(244);
    Object.keys(a).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return a[e];
          },
        });
    });
    var s = r(245);
    Object.keys(s).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return s[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(320);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(321);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(254);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(260);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
    var o = r(79);
    Object.keys(o).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return o[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(328);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(329);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return "object" === (0, c.default)(e) && null !== e
        ? o(Array.isArray(e) ? [] : {}, e)
        : e;
    }
    function i(e) {
      return (
        "function" == typeof e ||
        Array.isArray(e) ||
        "[object Object]" === Object.prototype.toString.call(e)
      );
    }
    function o(e, t) {
      if (e === t) return e;
      for (var r in t)
        if (Object.prototype.hasOwnProperty.call(t, r) && "__proto__" !== r) {
          var a = t[r],
            s = e[r];
          (void 0 !== s && void 0 === a) ||
            (i(s) && i(a) ? (e[r] = o(s, a)) : (e[r] = n(a)));
        }
      return e;
    }
    function a(e) {
      i(e) || (e = {});
      for (var t = 1, r = arguments.length; t < r; t++) {
        var n = arguments[t];
        i(n) && o(e, n);
      }
      return e;
    }
    var s = r(0),
      c = s(r(4));
    e.exports = a;
  },
  function (e, t, r) {
    "use strict";
    e.exports = function (e, t) {
      if (Array.isArray(e))
        for (var r = 0; r < e.length; r++) if (t(e[r])) return e[r];
    };
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      return e.toLocaleString(t);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.formatNumber = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var n = r(9),
        i = this;
      "function" == typeof Error.captureStackTrace
        ? Error.captureStackTrace(this, this.constructor)
        : (i.stack =
            new Error().stack || "Cannot get a stacktrace, browser is too old"),
        (this.name = "AlgoliaSearchError"),
        (this.message = e || "Unknown error"),
        t &&
          n(t, function (e, t) {
            i[t] = e;
          });
    }
    function i(e, t) {
      function r() {
        var r = Array.prototype.slice.call(arguments, 0);
        "string" != typeof r[0] && r.unshift(t),
          n.apply(this, r),
          (this.name = "AlgoliaSearch" + e + "Error");
      }
      return o(r, n), r;
    }
    var o = r(62);
    o(n, Error),
      (e.exports = {
        AlgoliaSearchError: n,
        UnparsableJSON: i(
          "UnparsableJSON",
          "Could not parse the incoming response as JSON, see err.more for details"
        ),
        RequestTimeout: i(
          "RequestTimeout",
          "Request timed out before getting a response"
        ),
        Network: i("Network", "Network issue, see err.more for details"),
        JSONPScriptFail: i(
          "JSONPScriptFail",
          "<script> was loaded but did not call our provided callback"
        ),
        ValidUntilNotFound: i(
          "ValidUntilNotFound",
          "The SecuredAPIKey does not have a validUntil parameter."
        ),
        JSONPScriptError: i(
          "JSONPScriptError",
          "<script> unable to load due to an `error` event on it"
        ),
        ObjectNotFound: i("ObjectNotFound", "Object not found"),
        Unknown: i("Unknown", "Unknown error occured"),
      });
  },
  function (e, t, r) {
    "use strict";
    var n = {}.toString;
    e.exports =
      Array.isArray ||
      function (e) {
        return "[object Array]" == n.call(e);
      };
  },
  function (e, t, r) {
    "use strict";
    var n = r(9);
    e.exports = function (e, t) {
      var r = [];
      return (
        n(e, function (n, i) {
          r.push(t(n, i, e));
        }),
        r
      );
    };
  },
  function (e, t, r) {
    "use strict";
    (function (n) {
      function i() {
        return (
          !(
            "undefined" == typeof window ||
            !window.process ||
            "renderer" !== window.process.type
          ) ||
          ("undefined" != typeof document &&
            document.documentElement &&
            document.documentElement.style &&
            document.documentElement.style.WebkitAppearance) ||
          ("undefined" != typeof window &&
            window.console &&
            (window.console.firebug ||
              (window.console.exception && window.console.table))) ||
          ("undefined" != typeof navigator &&
            navigator.userAgent &&
            navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) &&
            parseInt(RegExp.$1, 10) >= 31) ||
          ("undefined" != typeof navigator &&
            navigator.userAgent &&
            navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/))
        );
      }
      function o(e) {
        var r = this.useColors;
        if (
          ((e[0] =
            (r ? "%c" : "") +
            this.namespace +
            (r ? " %c" : " ") +
            e[0] +
            (r ? "%c " : " ") +
            "+" +
            t.humanize(this.diff)),
          r)
        ) {
          var n = "color: " + this.color;
          e.splice(1, 0, n, "color: inherit");
          var i = 0,
            o = 0;
          e[0].replace(/%[a-zA-Z%]/g, function (e) {
            "%%" !== e && (i++, "%c" === e && (o = i));
          }),
            e.splice(o, 0, n);
        }
      }
      function a() {
        return (
          "object" ===
            ("undefined" == typeof console
              ? "undefined"
              : (0, l.default)(console)) &&
          console.log &&
          Function.prototype.apply.call(console.log, console, arguments)
        );
      }
      function s(e) {
        try {
          null == e ? t.storage.removeItem("debug") : (t.storage.debug = e);
        } catch (e) {}
      }
      function c() {
        var e;
        try {
          e = t.storage.debug;
        } catch (e) {}
        return (
          !e &&
            void 0 !== n &&
            "env" in n &&
            (e = Object({ NODE_ENV: "production" }).DEBUG),
          e
        );
      }
      var u = r(0),
        l = u(r(4));
      (t = e.exports = r(175)),
        (t.log = a),
        (t.formatArgs = o),
        (t.save = s),
        (t.load = c),
        (t.useColors = i),
        (t.storage =
          "undefined" != typeof chrome && void 0 !== chrome.storage
            ? chrome.storage.local
            : (function () {
                try {
                  return window.localStorage;
                } catch (e) {}
              })()),
        (t.colors = [
          "lightseagreen",
          "forestgreen",
          "goldenrod",
          "dodgerblue",
          "darkorchid",
          "crimson",
        ]),
        (t.formatters.j = function (e) {
          try {
            return JSON.stringify(e);
          } catch (e) {
            return "[UnexpectedJSONParseError]: " + e.message;
          }
        }),
        t.enable(c());
    }.call(t, r(65)));
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.InternalHighlight = void 0);
    var n = r(330),
      i = r(2),
      o = (0, n.createHighlightComponent)({
        createElement: i.createElement,
        Fragment: i.Fragment,
      });
    t.InternalHighlight = o;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t, r) {
      return new i(e, t, r);
    }
    var i = r(93),
      o = r(36),
      a = r(37);
    (n.version = r(41)),
      (n.AlgoliaSearchHelper = i),
      (n.SearchParameters = o),
      (n.SearchResults = a),
      (e.exports = n);
  },
  function (e, t, r) {
    "use strict";
    e.exports = function () {
      return Array.prototype.slice.call(arguments).reduceRight(function (e, t) {
        return (
          Object.keys(Object(t)).forEach(function (r) {
            void 0 !== t[r] && (void 0 !== e[r] && delete e[r], (e[r] = t[r]));
          }),
          e
        );
      }, {});
    };
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      if (null === e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    e.exports = n;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return e && Object.keys(e).length > 0;
    }
    e.exports = n;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return "string" != typeof e ? e : String(e).replace(/^-/, "\\-");
    }
    function i(e) {
      return "string" != typeof e ? e : e.replace(/^\\-/, "-");
    }
    e.exports = { escapeFacetValue: n, unescapeFacetValue: i };
  },
  function (e, t, r) {
    "use strict";
    function n() {
      (this._events = this._events || {}),
        (this._maxListeners = this._maxListeners || void 0);
    }
    function i(e) {
      return "function" == typeof e;
    }
    function o(e) {
      return "number" == typeof e;
    }
    function a(e) {
      return "object" === (0, u.default)(e) && null !== e;
    }
    function s(e) {
      return void 0 === e;
    }
    var c = r(0),
      u = c(r(4));
    (e.exports = n),
      (n.prototype._events = void 0),
      (n.prototype._maxListeners = void 0),
      (n.defaultMaxListeners = 10),
      (n.prototype.setMaxListeners = function (e) {
        if (!o(e) || e < 0 || isNaN(e))
          throw TypeError("n must be a positive number");
        return (this._maxListeners = e), this;
      }),
      (n.prototype.emit = function (e) {
        var t, r, n, o, c, u;
        if (
          (this._events || (this._events = {}),
          "error" === e &&
            (!this._events.error ||
              (a(this._events.error) && !this._events.error.length)))
        ) {
          if ((t = arguments[1]) instanceof Error) throw t;
          var l = new Error('Uncaught, unspecified "error" event. (' + t + ")");
          throw ((l.context = t), l);
        }
        if (((r = this._events[e]), s(r))) return !1;
        if (i(r))
          switch (arguments.length) {
            case 1:
              r.call(this);
              break;
            case 2:
              r.call(this, arguments[1]);
              break;
            case 3:
              r.call(this, arguments[1], arguments[2]);
              break;
            default:
              (o = Array.prototype.slice.call(arguments, 1)), r.apply(this, o);
          }
        else if (a(r))
          for (
            o = Array.prototype.slice.call(arguments, 1),
              u = r.slice(),
              n = u.length,
              c = 0;
            c < n;
            c++
          )
            u[c].apply(this, o);
        return !0;
      }),
      (n.prototype.addListener = function (e, t) {
        var r;
        if (!i(t)) throw TypeError("listener must be a function");
        return (
          this._events || (this._events = {}),
          this._events.newListener &&
            this.emit("newListener", e, i(t.listener) ? t.listener : t),
          this._events[e]
            ? a(this._events[e])
              ? this._events[e].push(t)
              : (this._events[e] = [this._events[e], t])
            : (this._events[e] = t),
          a(this._events[e]) &&
            !this._events[e].warned &&
            (r = s(this._maxListeners)
              ? n.defaultMaxListeners
              : this._maxListeners) &&
            r > 0 &&
            this._events[e].length > r &&
            ((this._events[e].warned = !0),
            console.error(
              "(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",
              this._events[e].length
            ),
            "function" == typeof console.trace && console.trace()),
          this
        );
      }),
      (n.prototype.on = n.prototype.addListener),
      (n.prototype.once = function (e, t) {
        function r() {
          this.removeListener(e, r), n || ((n = !0), t.apply(this, arguments));
        }
        if (!i(t)) throw TypeError("listener must be a function");
        var n = !1;
        return (r.listener = t), this.on(e, r), this;
      }),
      (n.prototype.removeListener = function (e, t) {
        var r, n, o, s;
        if (!i(t)) throw TypeError("listener must be a function");
        if (!this._events || !this._events[e]) return this;
        if (
          ((r = this._events[e]),
          (o = r.length),
          (n = -1),
          r === t || (i(r.listener) && r.listener === t))
        )
          delete this._events[e],
            this._events.removeListener && this.emit("removeListener", e, t);
        else if (a(r)) {
          for (s = o; s-- > 0; )
            if (r[s] === t || (r[s].listener && r[s].listener === t)) {
              n = s;
              break;
            }
          if (n < 0) return this;
          1 === r.length
            ? ((r.length = 0), delete this._events[e])
            : r.splice(n, 1),
            this._events.removeListener && this.emit("removeListener", e, t);
        }
        return this;
      }),
      (n.prototype.removeAllListeners = function (e) {
        var t, r;
        if (!this._events) return this;
        if (!this._events.removeListener)
          return (
            0 === arguments.length
              ? (this._events = {})
              : this._events[e] && delete this._events[e],
            this
          );
        if (0 === arguments.length) {
          for (t in this._events)
            "removeListener" !== t && this.removeAllListeners(t);
          return (
            this.removeAllListeners("removeListener"), (this._events = {}), this
          );
        }
        if (((r = this._events[e]), i(r))) this.removeListener(e, r);
        else if (r) for (; r.length; ) this.removeListener(e, r[r.length - 1]);
        return delete this._events[e], this;
      }),
      (n.prototype.listeners = function (e) {
        return this._events && this._events[e]
          ? i(this._events[e])
            ? [this._events[e]]
            : this._events[e].slice()
          : [];
      }),
      (n.prototype.listenerCount = function (e) {
        if (this._events) {
          var t = this._events[e];
          if (i(t)) return 1;
          if (t) return t.length;
        }
        return 0;
      }),
      (n.listenerCount = function (e, t) {
        return e.listenerCount(t);
      });
  },
  function (e, t, r) {
    "use strict";
    function n() {
      return (
        (n =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r)
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          }),
        n.apply(this, arguments)
      );
    }
    function i(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function o(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? i(Object(r), !0).forEach(function (t) {
              a(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : i(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function a(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function s(e) {
      return (0, f.escape)(e)
        .replace(new RegExp(p.highlightPreTag, "g"), h.highlightPreTag)
        .replace(new RegExp(p.highlightPostTag, "g"), h.highlightPostTag);
    }
    function c(e) {
      return (0, d.isPlainObject)(e) && "string" != typeof e.value
        ? Object.keys(e).reduce(function (t, r) {
            return o(o({}, t), {}, a({}, r, c(e[r])));
          }, {})
        : Array.isArray(e)
        ? e.map(c)
        : o(o({}, e), {}, { value: s(e.value) });
    }
    function u(e) {
      return (
        void 0 === e.__escaped &&
          ((e = e.map(function (e) {
            var t = n({}, e);
            return (
              t._highlightResult &&
                (t._highlightResult = c(t._highlightResult)),
              t._snippetResult && (t._snippetResult = c(t._snippetResult)),
              t
            );
          })),
          (e.__escaped = !0)),
        e
      );
    }
    function l(e) {
      return e.map(function (e) {
        return o(o({}, e), {}, { highlighted: s(e.highlighted) });
      });
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.escapeHits = u),
      (t.escapeFacets = l),
      (t.TAG_REPLACEMENT = t.TAG_PLACEHOLDER = void 0);
    var f = r(30),
      d = r(47),
      p = {
        highlightPreTag: "__ais-highlight__",
        highlightPostTag: "__/ais-highlight__",
      };
    t.TAG_PLACEHOLDER = p;
    var h = { highlightPreTag: "<mark>", highlightPostTag: "</mark>" };
    t.TAG_REPLACEMENT = h;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return e && s.test(e)
        ? e.replace(a, function (e) {
            return o[e];
          })
        : e;
    }
    function i(e) {
      return e && l.test(e)
        ? e.replace(u, function (e) {
            return c[e];
          })
        : e;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.escape = n),
      (t.unescape = i);
    var o = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      },
      a = /[&<>"']/g,
      s = RegExp(a.source),
      c = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'",
      },
      u = /&(amp|quot|lt|gt|#39);/g,
      l = RegExp(u.source);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return e.filter(function (e, t, r) {
        return r.indexOf(e) === t;
      });
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.uniq = n);
  },
  function (e, t, r) {
    "use strict";
    var n = r(0),
      i = r(57);
    Object.defineProperty(t, "__esModule", { value: !0 });
    var o = {
      highlight: !0,
      reverseHighlight: !0,
      snippet: !0,
      reverseSnippet: !0,
      insights: !0,
      getInsightsAnonymousUserToken: !0,
      getInsightsAnonymousUserTokenInternal: !0,
    };
    Object.defineProperty(t, "highlight", {
      enumerable: !0,
      get: function () {
        return a.default;
      },
    }),
      Object.defineProperty(t, "reverseHighlight", {
        enumerable: !0,
        get: function () {
          return s.default;
        },
      }),
      Object.defineProperty(t, "snippet", {
        enumerable: !0,
        get: function () {
          return c.default;
        },
      }),
      Object.defineProperty(t, "reverseSnippet", {
        enumerable: !0,
        get: function () {
          return u.default;
        },
      }),
      Object.defineProperty(t, "insights", {
        enumerable: !0,
        get: function () {
          return l.default;
        },
      }),
      Object.defineProperty(t, "getInsightsAnonymousUserToken", {
        enumerable: !0,
        get: function () {
          return f.default;
        },
      }),
      Object.defineProperty(t, "getInsightsAnonymousUserTokenInternal", {
        enumerable: !0,
        get: function () {
          return f.getInsightsAnonymousUserTokenInternal;
        },
      });
    var a = i(r(137));
    Object.keys(a).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        (Object.prototype.hasOwnProperty.call(o, e) ||
          Object.defineProperty(t, e, {
            enumerable: !0,
            get: function () {
              return a[e];
            },
          }));
    });
    var s = i(r(138));
    Object.keys(s).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        (Object.prototype.hasOwnProperty.call(o, e) ||
          Object.defineProperty(t, e, {
            enumerable: !0,
            get: function () {
              return s[e];
            },
          }));
    });
    var c = i(r(139));
    Object.keys(c).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        (Object.prototype.hasOwnProperty.call(o, e) ||
          Object.defineProperty(t, e, {
            enumerable: !0,
            get: function () {
              return c[e];
            },
          }));
    });
    var u = i(r(140));
    Object.keys(u).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        (Object.prototype.hasOwnProperty.call(o, e) ||
          Object.defineProperty(t, e, {
            enumerable: !0,
            get: function () {
              return u[e];
            },
          }));
    });
    var l = n(r(58)),
      f = i(r(141));
  },
  function (e, t, r) {
    "use strict";
    var n = String.prototype.replace,
      i = /%20/g,
      o = { RFC1738: "RFC1738", RFC3986: "RFC3986" };
    e.exports = {
      default: o.RFC3986,
      formatters: {
        RFC1738: function (e) {
          return n.call(e, i, "+");
        },
        RFC3986: function (e) {
          return String(e);
        },
      },
      RFC1738: o.RFC1738,
      RFC3986: o.RFC3986,
    };
  },
  function (e, t, r) {
    "use strict";
    var n,
      i = r(0),
      o = i(r(4));
    n = (function () {
      return this;
    })();
    try {
      n = n || Function("return this")() || (0, eval)("this");
    } catch (e) {
      "object" ===
        ("undefined" == typeof window ? "undefined" : (0, o.default)(window)) &&
        (n = window);
    }
    e.exports = n;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = s(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (n = 0; n < o.length; n++)
          (r = o[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function s(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    function c(e) {
      var t = e.event,
        r = e.nextState,
        n = void 0 === r ? {} : r,
        o = e.props,
        s = e.query,
        c = e.refresh,
        v = e.store,
        m = a(e, d);
      p && o.environment.clearTimeout(p);
      var g = m.setCollections,
        y = m.setIsOpen,
        b = m.setQuery,
        _ = m.setActiveItemId,
        O = m.setStatus;
      if ((b(s), _(o.defaultActiveItemId), !s && !1 === o.openOnFocus)) {
        var j,
          P = v.getState().collections.map(function (e) {
            return i(i({}, e), {}, { items: [] });
          });
        O("idle"),
          g(P),
          y(
            null !== (j = n.isOpen) && void 0 !== j
              ? j
              : o.shouldPanelOpen({ state: v.getState() })
          );
        var w = (0, f.cancelable)(
          h(P).then(function () {
            return Promise.resolve();
          })
        );
        return v.pendingRequests.add(w);
      }
      O("loading"),
        (p = o.environment.setTimeout(function () {
          O("stalled");
        }, o.stallThreshold));
      var S = (0, f.cancelable)(
        h(
          o
            .getSources(i({ query: s, refresh: c, state: v.getState() }, m))
            .then(function (e) {
              return Promise.all(
                e.map(function (e) {
                  return Promise.resolve(
                    e.getItems(
                      i({ query: s, refresh: c, state: v.getState() }, m)
                    )
                  ).then(function (t) {
                    return (0, l.preResolve)(t, e.sourceId);
                  });
                })
              )
                .then(l.resolve)
                .then(function (t) {
                  return (0, l.postResolve)(t, e);
                })
                .then(function (e) {
                  return (0,
                  u.reshape)({ collections: e, props: o, state: v.getState() });
                });
            })
        )
      )
        .then(function (e) {
          var r;
          O("idle"), g(e);
          var a = o.shouldPanelOpen({ state: v.getState() });
          y(
            null !== (r = n.isOpen) && void 0 !== r
              ? r
              : (o.openOnFocus && !s && a) || a
          );
          var u = (0, f.getActiveItem)(v.getState());
          if (null !== v.getState().activeItemId && u) {
            var l = u.item,
              d = u.itemInputValue,
              p = u.itemUrl,
              h = u.source;
            h.onActive(
              i(
                {
                  event: t,
                  item: l,
                  itemInputValue: d,
                  itemUrl: p,
                  refresh: c,
                  source: h,
                  state: v.getState(),
                },
                m
              )
            );
          }
        })
        .finally(function () {
          O("idle"), p && o.environment.clearTimeout(p);
        });
      return v.pendingRequests.add(S);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.onInput = c);
    var u = r(217),
      l = r(218),
      f = r(7),
      d = ["event", "nextState", "props", "query", "refresh", "store"],
      p = null,
      h = (0, f.createConcurrentSafePromise)();
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      return Array.isArray(e) && Array.isArray(t)
        ? e.length === t.length &&
            e.every(function (e, r) {
              return n(t[r], e);
            })
        : e === t;
    }
    function i(e, t) {
      return u(e, function (e) {
        return n(e, t);
      });
    }
    function o(e) {
      var t = e ? o._parseNumbers(e) : {};
      void 0 === t.userToken ||
        p(t.userToken) ||
        console.warn(
          "[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}"
        ),
        (this.facets = t.facets || []),
        (this.disjunctiveFacets = t.disjunctiveFacets || []),
        (this.hierarchicalFacets = t.hierarchicalFacets || []),
        (this.facetsRefinements = t.facetsRefinements || {}),
        (this.facetsExcludes = t.facetsExcludes || {}),
        (this.disjunctiveFacetsRefinements =
          t.disjunctiveFacetsRefinements || {}),
        (this.numericRefinements = t.numericRefinements || {}),
        (this.tagRefinements = t.tagRefinements || []),
        (this.hierarchicalFacetsRefinements =
          t.hierarchicalFacetsRefinements || {});
      var r = this;
      Object.keys(t).forEach(function (e) {
        var n = -1 !== o.PARAMETERS.indexOf(e),
          i = void 0 !== t[e];
        !n && i && (r[e] = t[e]);
      });
    }
    var a = r(15),
      s = r(24),
      c = r(94),
      u = r(16),
      l = r(95),
      f = r(25),
      d = r(26),
      p = r(96),
      h = r(97);
    (o.PARAMETERS = Object.keys(new o())),
      (o._parseNumbers = function (e) {
        if (e instanceof o) return e;
        var t = {};
        if (
          ([
            "aroundPrecision",
            "aroundRadius",
            "getRankingInfo",
            "minWordSizefor2Typos",
            "minWordSizefor1Typo",
            "page",
            "maxValuesPerFacet",
            "distinct",
            "minimumAroundRadius",
            "hitsPerPage",
            "minProximity",
          ].forEach(function (r) {
            var n = e[r];
            if ("string" == typeof n) {
              var i = parseFloat(n);
              t[r] = isNaN(i) ? n : i;
            }
          }),
          Array.isArray(e.insideBoundingBox) &&
            (t.insideBoundingBox = e.insideBoundingBox.map(function (e) {
              return Array.isArray(e)
                ? e.map(function (e) {
                    return parseFloat(e);
                  })
                : e;
            })),
          e.numericRefinements)
        ) {
          var r = {};
          Object.keys(e.numericRefinements).forEach(function (t) {
            var n = e.numericRefinements[t] || {};
            (r[t] = {}),
              Object.keys(n).forEach(function (e) {
                var i = n[e],
                  o = i.map(function (e) {
                    return Array.isArray(e)
                      ? e.map(function (e) {
                          return "string" == typeof e ? parseFloat(e) : e;
                        })
                      : "string" == typeof e
                      ? parseFloat(e)
                      : e;
                  });
                r[t][e] = o;
              });
          }),
            (t.numericRefinements = r);
        }
        return a({}, e, t);
      }),
      (o.make = function (e) {
        var t = new o(e);
        return (
          (e.hierarchicalFacets || []).forEach(function (e) {
            if (e.rootPath) {
              var r = t.getHierarchicalRefinement(e.name);
              r.length > 0 &&
                0 !== r[0].indexOf(e.rootPath) &&
                (t = t.clearRefinements(e.name)),
                (r = t.getHierarchicalRefinement(e.name)),
                0 === r.length &&
                  (t = t.toggleHierarchicalFacetRefinement(e.name, e.rootPath));
            }
          }),
          t
        );
      }),
      (o.validate = function (e, t) {
        var r = t || {};
        return e.tagFilters && r.tagRefinements && r.tagRefinements.length > 0
          ? new Error(
              "[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method."
            )
          : e.tagRefinements.length > 0 && r.tagFilters
          ? new Error(
              "[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method."
            )
          : e.numericFilters && r.numericRefinements && d(r.numericRefinements)
          ? new Error(
              "[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters."
            )
          : d(e.numericRefinements) && r.numericFilters
          ? new Error(
              "[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters."
            )
          : null;
      }),
      (o.prototype = {
        constructor: o,
        clearRefinements: function (e) {
          var t = {
            numericRefinements: this._clearNumericRefinements(e),
            facetsRefinements: h.clearRefinement(
              this.facetsRefinements,
              e,
              "conjunctiveFacet"
            ),
            facetsExcludes: h.clearRefinement(
              this.facetsExcludes,
              e,
              "exclude"
            ),
            disjunctiveFacetsRefinements: h.clearRefinement(
              this.disjunctiveFacetsRefinements,
              e,
              "disjunctiveFacet"
            ),
            hierarchicalFacetsRefinements: h.clearRefinement(
              this.hierarchicalFacetsRefinements,
              e,
              "hierarchicalFacet"
            ),
          };
          return t.numericRefinements === this.numericRefinements &&
            t.facetsRefinements === this.facetsRefinements &&
            t.facetsExcludes === this.facetsExcludes &&
            t.disjunctiveFacetsRefinements ===
              this.disjunctiveFacetsRefinements &&
            t.hierarchicalFacetsRefinements ===
              this.hierarchicalFacetsRefinements
            ? this
            : this.setQueryParameters(t);
        },
        clearTags: function () {
          return void 0 === this.tagFilters && 0 === this.tagRefinements.length
            ? this
            : this.setQueryParameters({
                tagFilters: void 0,
                tagRefinements: [],
              });
        },
        setIndex: function (e) {
          return e === this.index
            ? this
            : this.setQueryParameters({ index: e });
        },
        setQuery: function (e) {
          return e === this.query
            ? this
            : this.setQueryParameters({ query: e });
        },
        setPage: function (e) {
          return e === this.page ? this : this.setQueryParameters({ page: e });
        },
        setFacets: function (e) {
          return this.setQueryParameters({ facets: e });
        },
        setDisjunctiveFacets: function (e) {
          return this.setQueryParameters({ disjunctiveFacets: e });
        },
        setHitsPerPage: function (e) {
          return this.hitsPerPage === e
            ? this
            : this.setQueryParameters({ hitsPerPage: e });
        },
        setTypoTolerance: function (e) {
          return this.typoTolerance === e
            ? this
            : this.setQueryParameters({ typoTolerance: e });
        },
        addNumericRefinement: function (e, t, r) {
          var n = l(r);
          if (this.isNumericRefined(e, t, n)) return this;
          var i = a({}, this.numericRefinements);
          return (
            (i[e] = a({}, i[e])),
            i[e][t]
              ? ((i[e][t] = i[e][t].slice()), i[e][t].push(n))
              : (i[e][t] = [n]),
            this.setQueryParameters({ numericRefinements: i })
          );
        },
        getConjunctiveRefinements: function (e) {
          return this.isConjunctiveFacet(e)
            ? this.facetsRefinements[e] || []
            : [];
        },
        getDisjunctiveRefinements: function (e) {
          return this.isDisjunctiveFacet(e)
            ? this.disjunctiveFacetsRefinements[e] || []
            : [];
        },
        getHierarchicalRefinement: function (e) {
          return this.hierarchicalFacetsRefinements[e] || [];
        },
        getExcludeRefinements: function (e) {
          return this.isConjunctiveFacet(e) ? this.facetsExcludes[e] || [] : [];
        },
        removeNumericRefinement: function (e, t, r) {
          return void 0 !== r
            ? this.isNumericRefined(e, t, r)
              ? this.setQueryParameters({
                  numericRefinements: this._clearNumericRefinements(function (
                    i,
                    o
                  ) {
                    return o === e && i.op === t && n(i.val, l(r));
                  }),
                })
              : this
            : void 0 !== t
            ? this.isNumericRefined(e, t)
              ? this.setQueryParameters({
                  numericRefinements: this._clearNumericRefinements(function (
                    r,
                    n
                  ) {
                    return n === e && r.op === t;
                  }),
                })
              : this
            : this.isNumericRefined(e)
            ? this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function (
                  t,
                  r
                ) {
                  return r === e;
                }),
              })
            : this;
        },
        getNumericRefinements: function (e) {
          return this.numericRefinements[e] || {};
        },
        getNumericRefinement: function (e, t) {
          return this.numericRefinements[e] && this.numericRefinements[e][t];
        },
        _clearNumericRefinements: function (e) {
          if (void 0 === e)
            return d(this.numericRefinements) ? {} : this.numericRefinements;
          if ("string" == typeof e) return f(this.numericRefinements, [e]);
          if ("function" == typeof e) {
            var t = !1,
              r = this.numericRefinements,
              n = Object.keys(r).reduce(function (n, i) {
                var o = r[i],
                  a = {};
                return (
                  (o = o || {}),
                  Object.keys(o).forEach(function (r) {
                    var n = o[r] || [],
                      s = [];
                    n.forEach(function (t) {
                      e({ val: t, op: r }, i, "numeric") || s.push(t);
                    }),
                      s.length !== n.length && (t = !0),
                      (a[r] = s);
                  }),
                  (n[i] = a),
                  n
                );
              }, {});
            return t ? n : this.numericRefinements;
          }
        },
        addFacet: function (e) {
          return this.isConjunctiveFacet(e)
            ? this
            : this.setQueryParameters({ facets: this.facets.concat([e]) });
        },
        addDisjunctiveFacet: function (e) {
          return this.isDisjunctiveFacet(e)
            ? this
            : this.setQueryParameters({
                disjunctiveFacets: this.disjunctiveFacets.concat([e]),
              });
        },
        addHierarchicalFacet: function (e) {
          if (this.isHierarchicalFacet(e.name))
            throw new Error(
              "Cannot declare two hierarchical facets with the same name: `" +
                e.name +
                "`"
            );
          return this.setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.concat([e]),
          });
        },
        addFacetRefinement: function (e, t) {
          if (!this.isConjunctiveFacet(e))
            throw new Error(
              e +
                " is not defined in the facets attribute of the helper configuration"
            );
          return h.isRefined(this.facetsRefinements, e, t)
            ? this
            : this.setQueryParameters({
                facetsRefinements: h.addRefinement(
                  this.facetsRefinements,
                  e,
                  t
                ),
              });
        },
        addExcludeRefinement: function (e, t) {
          if (!this.isConjunctiveFacet(e))
            throw new Error(
              e +
                " is not defined in the facets attribute of the helper configuration"
            );
          return h.isRefined(this.facetsExcludes, e, t)
            ? this
            : this.setQueryParameters({
                facetsExcludes: h.addRefinement(this.facetsExcludes, e, t),
              });
        },
        addDisjunctiveFacetRefinement: function (e, t) {
          if (!this.isDisjunctiveFacet(e))
            throw new Error(
              e +
                " is not defined in the disjunctiveFacets attribute of the helper configuration"
            );
          return h.isRefined(this.disjunctiveFacetsRefinements, e, t)
            ? this
            : this.setQueryParameters({
                disjunctiveFacetsRefinements: h.addRefinement(
                  this.disjunctiveFacetsRefinements,
                  e,
                  t
                ),
              });
        },
        addTagRefinement: function (e) {
          if (this.isTagRefined(e)) return this;
          var t = { tagRefinements: this.tagRefinements.concat(e) };
          return this.setQueryParameters(t);
        },
        removeFacet: function (e) {
          return this.isConjunctiveFacet(e)
            ? this.clearRefinements(e).setQueryParameters({
                facets: this.facets.filter(function (t) {
                  return t !== e;
                }),
              })
            : this;
        },
        removeDisjunctiveFacet: function (e) {
          return this.isDisjunctiveFacet(e)
            ? this.clearRefinements(e).setQueryParameters({
                disjunctiveFacets: this.disjunctiveFacets.filter(function (t) {
                  return t !== e;
                }),
              })
            : this;
        },
        removeHierarchicalFacet: function (e) {
          return this.isHierarchicalFacet(e)
            ? this.clearRefinements(e).setQueryParameters({
                hierarchicalFacets: this.hierarchicalFacets.filter(function (
                  t
                ) {
                  return t.name !== e;
                }),
              })
            : this;
        },
        removeFacetRefinement: function (e, t) {
          if (!this.isConjunctiveFacet(e))
            throw new Error(
              e +
                " is not defined in the facets attribute of the helper configuration"
            );
          return h.isRefined(this.facetsRefinements, e, t)
            ? this.setQueryParameters({
                facetsRefinements: h.removeRefinement(
                  this.facetsRefinements,
                  e,
                  t
                ),
              })
            : this;
        },
        removeExcludeRefinement: function (e, t) {
          if (!this.isConjunctiveFacet(e))
            throw new Error(
              e +
                " is not defined in the facets attribute of the helper configuration"
            );
          return h.isRefined(this.facetsExcludes, e, t)
            ? this.setQueryParameters({
                facetsExcludes: h.removeRefinement(this.facetsExcludes, e, t),
              })
            : this;
        },
        removeDisjunctiveFacetRefinement: function (e, t) {
          if (!this.isDisjunctiveFacet(e))
            throw new Error(
              e +
                " is not defined in the disjunctiveFacets attribute of the helper configuration"
            );
          return h.isRefined(this.disjunctiveFacetsRefinements, e, t)
            ? this.setQueryParameters({
                disjunctiveFacetsRefinements: h.removeRefinement(
                  this.disjunctiveFacetsRefinements,
                  e,
                  t
                ),
              })
            : this;
        },
        removeTagRefinement: function (e) {
          if (!this.isTagRefined(e)) return this;
          var t = {
            tagRefinements: this.tagRefinements.filter(function (t) {
              return t !== e;
            }),
          };
          return this.setQueryParameters(t);
        },
        toggleRefinement: function (e, t) {
          return this.toggleFacetRefinement(e, t);
        },
        toggleFacetRefinement: function (e, t) {
          if (this.isHierarchicalFacet(e))
            return this.toggleHierarchicalFacetRefinement(e, t);
          if (this.isConjunctiveFacet(e))
            return this.toggleConjunctiveFacetRefinement(e, t);
          if (this.isDisjunctiveFacet(e))
            return this.toggleDisjunctiveFacetRefinement(e, t);
          throw new Error(
            "Cannot refine the undeclared facet " +
              e +
              "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets"
          );
        },
        toggleConjunctiveFacetRefinement: function (e, t) {
          if (!this.isConjunctiveFacet(e))
            throw new Error(
              e +
                " is not defined in the facets attribute of the helper configuration"
            );
          return this.setQueryParameters({
            facetsRefinements: h.toggleRefinement(this.facetsRefinements, e, t),
          });
        },
        toggleExcludeFacetRefinement: function (e, t) {
          if (!this.isConjunctiveFacet(e))
            throw new Error(
              e +
                " is not defined in the facets attribute of the helper configuration"
            );
          return this.setQueryParameters({
            facetsExcludes: h.toggleRefinement(this.facetsExcludes, e, t),
          });
        },
        toggleDisjunctiveFacetRefinement: function (e, t) {
          if (!this.isDisjunctiveFacet(e))
            throw new Error(
              e +
                " is not defined in the disjunctiveFacets attribute of the helper configuration"
            );
          return this.setQueryParameters({
            disjunctiveFacetsRefinements: h.toggleRefinement(
              this.disjunctiveFacetsRefinements,
              e,
              t
            ),
          });
        },
        toggleHierarchicalFacetRefinement: function (e, t) {
          if (!this.isHierarchicalFacet(e))
            throw new Error(
              e +
                " is not defined in the hierarchicalFacets attribute of the helper configuration"
            );
          var r = this._getHierarchicalFacetSeparator(
              this.getHierarchicalFacetByName(e)
            ),
            n = {};
          return (
            void 0 !== this.hierarchicalFacetsRefinements[e] &&
            this.hierarchicalFacetsRefinements[e].length > 0 &&
            (this.hierarchicalFacetsRefinements[e][0] === t ||
              0 === this.hierarchicalFacetsRefinements[e][0].indexOf(t + r))
              ? -1 === t.indexOf(r)
                ? (n[e] = [])
                : (n[e] = [t.slice(0, t.lastIndexOf(r))])
              : (n[e] = [t]),
            this.setQueryParameters({
              hierarchicalFacetsRefinements: s(
                {},
                n,
                this.hierarchicalFacetsRefinements
              ),
            })
          );
        },
        addHierarchicalFacetRefinement: function (e, t) {
          if (this.isHierarchicalFacetRefined(e))
            throw new Error(e + " is already refined.");
          if (!this.isHierarchicalFacet(e))
            throw new Error(
              e +
                " is not defined in the hierarchicalFacets attribute of the helper configuration."
            );
          var r = {};
          return (
            (r[e] = [t]),
            this.setQueryParameters({
              hierarchicalFacetsRefinements: s(
                {},
                r,
                this.hierarchicalFacetsRefinements
              ),
            })
          );
        },
        removeHierarchicalFacetRefinement: function (e) {
          if (!this.isHierarchicalFacetRefined(e)) return this;
          var t = {};
          return (
            (t[e] = []),
            this.setQueryParameters({
              hierarchicalFacetsRefinements: s(
                {},
                t,
                this.hierarchicalFacetsRefinements
              ),
            })
          );
        },
        toggleTagRefinement: function (e) {
          return this.isTagRefined(e)
            ? this.removeTagRefinement(e)
            : this.addTagRefinement(e);
        },
        isDisjunctiveFacet: function (e) {
          return this.disjunctiveFacets.indexOf(e) > -1;
        },
        isHierarchicalFacet: function (e) {
          return void 0 !== this.getHierarchicalFacetByName(e);
        },
        isConjunctiveFacet: function (e) {
          return this.facets.indexOf(e) > -1;
        },
        isFacetRefined: function (e, t) {
          return (
            !!this.isConjunctiveFacet(e) &&
            h.isRefined(this.facetsRefinements, e, t)
          );
        },
        isExcludeRefined: function (e, t) {
          return (
            !!this.isConjunctiveFacet(e) &&
            h.isRefined(this.facetsExcludes, e, t)
          );
        },
        isDisjunctiveFacetRefined: function (e, t) {
          return (
            !!this.isDisjunctiveFacet(e) &&
            h.isRefined(this.disjunctiveFacetsRefinements, e, t)
          );
        },
        isHierarchicalFacetRefined: function (e, t) {
          if (!this.isHierarchicalFacet(e)) return !1;
          var r = this.getHierarchicalRefinement(e);
          return t ? -1 !== r.indexOf(t) : r.length > 0;
        },
        isNumericRefined: function (e, t, r) {
          if (void 0 === r && void 0 === t) return !!this.numericRefinements[e];
          var n =
            this.numericRefinements[e] &&
            void 0 !== this.numericRefinements[e][t];
          if (void 0 === r || !n) return n;
          var o = l(r),
            a = void 0 !== i(this.numericRefinements[e][t], o);
          return n && a;
        },
        isTagRefined: function (e) {
          return -1 !== this.tagRefinements.indexOf(e);
        },
        getRefinedDisjunctiveFacets: function () {
          var e = this,
            t = c(
              Object.keys(this.numericRefinements).filter(function (t) {
                return Object.keys(e.numericRefinements[t]).length > 0;
              }),
              this.disjunctiveFacets
            );
          return Object.keys(this.disjunctiveFacetsRefinements)
            .filter(function (t) {
              return e.disjunctiveFacetsRefinements[t].length > 0;
            })
            .concat(t)
            .concat(this.getRefinedHierarchicalFacets());
        },
        getRefinedHierarchicalFacets: function () {
          var e = this;
          return c(
            this.hierarchicalFacets.map(function (e) {
              return e.name;
            }),
            Object.keys(this.hierarchicalFacetsRefinements).filter(function (
              t
            ) {
              return e.hierarchicalFacetsRefinements[t].length > 0;
            })
          );
        },
        getUnrefinedDisjunctiveFacets: function () {
          var e = this.getRefinedDisjunctiveFacets();
          return this.disjunctiveFacets.filter(function (t) {
            return -1 === e.indexOf(t);
          });
        },
        managedParameters: [
          "index",
          "facets",
          "disjunctiveFacets",
          "facetsRefinements",
          "hierarchicalFacets",
          "facetsExcludes",
          "disjunctiveFacetsRefinements",
          "numericRefinements",
          "tagRefinements",
          "hierarchicalFacetsRefinements",
        ],
        getQueryParams: function () {
          var e = this.managedParameters,
            t = {},
            r = this;
          return (
            Object.keys(this).forEach(function (n) {
              var i = r[n];
              -1 === e.indexOf(n) && void 0 !== i && (t[n] = i);
            }),
            t
          );
        },
        setQueryParameter: function (e, t) {
          if (this[e] === t) return this;
          var r = {};
          return (r[e] = t), this.setQueryParameters(r);
        },
        setQueryParameters: function (e) {
          if (!e) return this;
          var t = o.validate(this, e);
          if (t) throw t;
          var r = this,
            n = o._parseNumbers(e),
            i = Object.keys(this).reduce(function (e, t) {
              return (e[t] = r[t]), e;
            }, {}),
            a = Object.keys(n).reduce(function (e, t) {
              var r = void 0 !== e[t],
                i = void 0 !== n[t];
              return r && !i ? f(e, [t]) : (i && (e[t] = n[t]), e);
            }, i);
          return new this.constructor(a);
        },
        resetPage: function () {
          return void 0 === this.page ? this : this.setPage(0);
        },
        _getHierarchicalFacetSortBy: function (e) {
          return e.sortBy || ["isRefined:desc", "name:asc"];
        },
        _getHierarchicalFacetSeparator: function (e) {
          return e.separator || " > ";
        },
        _getHierarchicalRootPath: function (e) {
          return e.rootPath || null;
        },
        _getHierarchicalShowParentLevel: function (e) {
          return "boolean" != typeof e.showParentLevel || e.showParentLevel;
        },
        getHierarchicalFacetByName: function (e) {
          return u(this.hierarchicalFacets, function (t) {
            return t.name === e;
          });
        },
        getHierarchicalFacetBreadcrumb: function (e) {
          if (!this.isHierarchicalFacet(e)) return [];
          var t = this.getHierarchicalRefinement(e)[0];
          if (!t) return [];
          var r = this._getHierarchicalFacetSeparator(
            this.getHierarchicalFacetByName(e)
          );
          return t.split(r).map(function (e) {
            return e.trim();
          });
        },
        toString: function () {
          return JSON.stringify(this, null, 2);
        },
      }),
      (e.exports = o);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t = {};
      return (
        e.forEach(function (e, r) {
          t[e] = r;
        }),
        t
      );
    }
    function i(e, t, r) {
      t && t[r] && (e.stats = t[r]);
    }
    function o(e, t) {
      return b(e, function (e) {
        return (e.attributes || []).indexOf(t) > -1;
      });
    }
    function a(e, t, r) {
      var a = t[0];
      this._rawResults = t;
      var s = this;
      Object.keys(a).forEach(function (e) {
        s[e] = a[e];
      }),
        Object.keys(r || {}).forEach(function (e) {
          s[e] = r[e];
        }),
        (this.processingTimeMS = t.reduce(function (e, t) {
          return void 0 === t.processingTimeMS ? e : e + t.processingTimeMS;
        }, 0)),
        (this.disjunctiveFacets = []),
        (this.hierarchicalFacets = e.hierarchicalFacets.map(function () {
          return [];
        })),
        (this.facets = []);
      var c = e.getRefinedDisjunctiveFacets(),
        u = n(e.facets),
        l = n(e.disjunctiveFacets),
        f = 1,
        d = a.facets || {};
      Object.keys(d).forEach(function (t) {
        var r = d[t],
          n = o(e.hierarchicalFacets, t);
        if (n) {
          var c = n.attributes.indexOf(t),
            f = _(e.hierarchicalFacets, function (e) {
              return e.name === n.name;
            });
          s.hierarchicalFacets[f][c] = {
            attribute: t,
            data: r,
            exhaustive: a.exhaustiveFacetsCount,
          };
        } else {
          var p,
            h = -1 !== e.disjunctiveFacets.indexOf(t),
            v = -1 !== e.facets.indexOf(t);
          h &&
            ((p = l[t]),
            (s.disjunctiveFacets[p] = {
              name: t,
              data: r,
              exhaustive: a.exhaustiveFacetsCount,
            }),
            i(s.disjunctiveFacets[p], a.facets_stats, t)),
            v &&
              ((p = u[t]),
              (s.facets[p] = {
                name: t,
                data: r,
                exhaustive: a.exhaustiveFacetsCount,
              }),
              i(s.facets[p], a.facets_stats, t));
        }
      }),
        (this.hierarchicalFacets = y(this.hierarchicalFacets)),
        c.forEach(function (r) {
          var n = t[f],
            o = n && n.facets ? n.facets : {},
            c = e.getHierarchicalFacetByName(r);
          Object.keys(o).forEach(function (t) {
            var r,
              u = o[t];
            if (c) {
              r = _(e.hierarchicalFacets, function (e) {
                return e.name === c.name;
              });
              var f = _(s.hierarchicalFacets[r], function (e) {
                return e.attribute === t;
              });
              if (-1 === f) return;
              s.hierarchicalFacets[r][f].data = v(
                {},
                s.hierarchicalFacets[r][f].data,
                u
              );
            } else {
              r = l[t];
              var d = (a.facets && a.facets[t]) || {};
              (s.disjunctiveFacets[r] = {
                name: t,
                data: m({}, u, d),
                exhaustive: n.exhaustiveFacetsCount,
              }),
                i(s.disjunctiveFacets[r], n.facets_stats, t),
                e.disjunctiveFacetsRefinements[t] &&
                  e.disjunctiveFacetsRefinements[t].forEach(function (n) {
                    !s.disjunctiveFacets[r].data[n] &&
                      e.disjunctiveFacetsRefinements[t].indexOf(w(n)) > -1 &&
                      (s.disjunctiveFacets[r].data[n] = 0);
                  });
            }
          }),
            f++;
        }),
        e.getRefinedHierarchicalFacets().forEach(function (r) {
          var n = e.getHierarchicalFacetByName(r),
            i = e._getHierarchicalFacetSeparator(n),
            o = e.getHierarchicalRefinement(r);
          0 === o.length ||
            o[0].split(i).length < 2 ||
            t.slice(f).forEach(function (t) {
              var r = t && t.facets ? t.facets : {};
              Object.keys(r).forEach(function (t) {
                var a = r[t],
                  c = _(e.hierarchicalFacets, function (e) {
                    return e.name === n.name;
                  }),
                  u = _(s.hierarchicalFacets[c], function (e) {
                    return e.attribute === t;
                  });
                if (-1 !== u) {
                  var l = {};
                  if (o.length > 0) {
                    var f = o[0].split(i)[0];
                    l[f] = s.hierarchicalFacets[c][u].data[f];
                  }
                  s.hierarchicalFacets[c][u].data = m(
                    l,
                    a,
                    s.hierarchicalFacets[c][u].data
                  );
                }
              }),
                f++;
            });
        }),
        Object.keys(e.facetsExcludes).forEach(function (t) {
          var r = e.facetsExcludes[t],
            n = u[t];
          (s.facets[n] = {
            name: t,
            data: a.facets[t],
            exhaustive: a.exhaustiveFacetsCount,
          }),
            r.forEach(function (e) {
              (s.facets[n] = s.facets[n] || { name: t }),
                (s.facets[n].data = s.facets[n].data || {}),
                (s.facets[n].data[e] = 0);
            });
        }),
        (this.hierarchicalFacets = this.hierarchicalFacets.map(S(e))),
        (this.facets = y(this.facets)),
        (this.disjunctiveFacets = y(this.disjunctiveFacets)),
        (this._state = e);
    }
    function s(e, t) {
      function r(e) {
        return e.name === t;
      }
      if (e._state.isConjunctiveFacet(t)) {
        var n = b(e.facets, r);
        return n
          ? Object.keys(n.data).map(function (r) {
              var i = P(r);
              return {
                name: r,
                escapedValue: i,
                count: n.data[r],
                isRefined: e._state.isFacetRefined(t, i),
                isExcluded: e._state.isExcludeRefined(t, r),
              };
            })
          : [];
      }
      if (e._state.isDisjunctiveFacet(t)) {
        var i = b(e.disjunctiveFacets, r);
        return i
          ? Object.keys(i.data).map(function (r) {
              var n = P(r);
              return {
                name: r,
                escapedValue: n,
                count: i.data[r],
                isRefined: e._state.isDisjunctiveFacetRefined(t, n),
              };
            })
          : [];
      }
      if (e._state.isHierarchicalFacet(t)) return b(e.hierarchicalFacets, r);
    }
    function c(e, t, r, n) {
      if (((n = n || 0), Array.isArray(t))) return e(t, r[n]);
      if (!t.data || 0 === t.data.length) return t;
      var i = t.data.map(function (t) {
          return c(e, t, r, n + 1);
        }),
        o = e(i, r[n]);
      return m({ data: o }, t);
    }
    function u(e, t) {
      return t.sort(e);
    }
    function l(e, t) {
      var r = [],
        n = [],
        i = t.order || [],
        o = i.reduce(function (e, t, r) {
          return (e[t] = r), e;
        }, {});
      e.forEach(function (e) {
        var t = e.path || e.name;
        void 0 !== o[t] ? (r[o[t]] = e) : n.push(e);
      }),
        (r = r.filter(function (e) {
          return e;
        }));
      var a,
        s = t.sortRemainingBy;
      return "hidden" === s
        ? r
        : ((a =
            "alpha" === s
              ? [
                  ["path", "name"],
                  ["asc", "asc"],
                ]
              : [["count"], ["desc"]]),
          r.concat(g(n, a[0], a[1])));
    }
    function f(e, t) {
      return (
        e.renderingContent &&
        e.renderingContent.facetOrdering &&
        e.renderingContent.facetOrdering.values &&
        e.renderingContent.facetOrdering.values[t]
      );
    }
    function d(e, t) {
      var r = b(e, function (e) {
        return e.name === t;
      });
      return r && r.stats;
    }
    function p(e, t, r, n, i) {
      var o = b(i, function (e) {
          return e.name === r;
        }),
        a = o && o.data && o.data[n] ? o.data[n] : 0,
        s = (o && o.exhaustive) || !1;
      return { type: t, attributeName: r, name: n, count: a, exhaustive: s };
    }
    function h(e, t, r, n) {
      var i = e.getHierarchicalFacetByName(t),
        o = e._getHierarchicalFacetSeparator(i),
        a = r.split(o),
        s = b(n, function (e) {
          return e.name === t;
        }),
        c = a.reduce(function (e, t) {
          var r =
            e &&
            b(e.data, function (e) {
              return e.name === t;
            });
          return void 0 !== r ? r : e;
        }, s),
        u = (c && c.count) || 0,
        l = (c && c.exhaustive) || !1,
        f = (c && c.path) || "";
      return {
        type: "hierarchical",
        attributeName: t,
        name: f,
        count: u,
        exhaustive: l,
      };
    }
    var v = r(15),
      m = r(24),
      g = r(38),
      y = r(98),
      b = r(16),
      _ = r(99),
      O = r(39),
      j = r(27),
      P = j.escapeFacetValue,
      w = j.unescapeFacetValue,
      S = r(100);
    (a.prototype.getFacetByName = function (e) {
      function t(t) {
        return t.name === e;
      }
      return (
        b(this.facets, t) ||
        b(this.disjunctiveFacets, t) ||
        b(this.hierarchicalFacets, t)
      );
    }),
      (a.DEFAULT_SORT = ["isRefined:desc", "count:desc", "name:asc"]),
      (a.prototype.getFacetValues = function (e, t) {
        var r = s(this, e);
        if (r) {
          var n,
            i = m({}, t, {
              sortBy: a.DEFAULT_SORT,
              facetOrdering: !(t && t.sortBy),
            }),
            o = this;
          return (
            (n = Array.isArray(r)
              ? [e]
              : o._state.getHierarchicalFacetByName(r.name).attributes),
            c(
              function (e, t) {
                if (i.facetOrdering) {
                  var r = f(o, t);
                  if (Boolean(r)) return l(e, r);
                }
                if (Array.isArray(i.sortBy)) {
                  var n = O(i.sortBy, a.DEFAULT_SORT);
                  return g(e, n[0], n[1]);
                }
                if ("function" == typeof i.sortBy) return u(i.sortBy, e);
                throw new Error(
                  "options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function"
                );
              },
              r,
              n
            )
          );
        }
      }),
      (a.prototype.getFacetStats = function (e) {
        return this._state.isConjunctiveFacet(e)
          ? d(this.facets, e)
          : this._state.isDisjunctiveFacet(e)
          ? d(this.disjunctiveFacets, e)
          : void 0;
      }),
      (a.prototype.getRefinements = function () {
        var e = this._state,
          t = this,
          r = [];
        return (
          Object.keys(e.facetsRefinements).forEach(function (n) {
            e.facetsRefinements[n].forEach(function (i) {
              r.push(p(e, "facet", n, i, t.facets));
            });
          }),
          Object.keys(e.facetsExcludes).forEach(function (n) {
            e.facetsExcludes[n].forEach(function (i) {
              r.push(p(e, "exclude", n, i, t.facets));
            });
          }),
          Object.keys(e.disjunctiveFacetsRefinements).forEach(function (n) {
            e.disjunctiveFacetsRefinements[n].forEach(function (i) {
              r.push(p(e, "disjunctive", n, i, t.disjunctiveFacets));
            });
          }),
          Object.keys(e.hierarchicalFacetsRefinements).forEach(function (n) {
            e.hierarchicalFacetsRefinements[n].forEach(function (i) {
              r.push(h(e, n, i, t.hierarchicalFacets));
            });
          }),
          Object.keys(e.numericRefinements).forEach(function (t) {
            var n = e.numericRefinements[t];
            Object.keys(n).forEach(function (e) {
              n[e].forEach(function (n) {
                r.push({
                  type: "numeric",
                  attributeName: t,
                  name: n,
                  numericValue: n,
                  operator: e,
                });
              });
            });
          }),
          e.tagRefinements.forEach(function (e) {
            r.push({ type: "tag", attributeName: "_tags", name: e });
          }),
          r
        );
      }),
      (e.exports = a);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      if (e !== t) {
        var r = void 0 !== e,
          n = null === e,
          i = void 0 !== t,
          o = null === t;
        if ((!o && e > t) || (n && i) || !r) return 1;
        if ((!n && e < t) || (o && r) || !i) return -1;
      }
      return 0;
    }
    function i(e, t, r) {
      if (!Array.isArray(e)) return [];
      Array.isArray(r) || (r = []);
      var i = e.map(function (e, r) {
        return {
          criteria: t.map(function (t) {
            return e[t];
          }),
          index: r,
          value: e,
        };
      });
      return (
        i.sort(function (e, t) {
          for (var i = -1; ++i < e.criteria.length; ) {
            var o = n(e.criteria[i], t.criteria[i]);
            if (o) return i >= r.length ? o : "desc" === r[i] ? -o : o;
          }
          return e.index - t.index;
        }),
        i.map(function (e) {
          return e.value;
        })
      );
    }
    e.exports = i;
  },
  function (e, t, r) {
    "use strict";
    var n = r(16);
    e.exports = function (e, t) {
      var r = (t || []).map(function (e) {
        return e.split(":");
      });
      return e.reduce(
        function (e, t) {
          var i = t.split(":"),
            o = n(r, function (e) {
              return e[0] === i[0];
            });
          return i.length > 1 || !o
            ? (e[0].push(i[0]), e[1].push(i[1]), e)
            : (e[0].push(o[0]), e[1].push(o[1]), e);
        },
        [[], []]
      );
    };
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      e.prototype = Object.create(t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0,
        },
      });
    }
    e.exports = n;
  },
  function (e, t, r) {
    "use strict";
    e.exports = "3.11.1";
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return e.toString().charAt(0).toUpperCase() + e.toString().slice(1);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.capitalize = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t = e.index,
        r = e.indexUiState,
        n = t
          .getWidgets()
          .map(function (e) {
            return e.$$type;
          })
          .filter(Boolean);
      (0, i.keys)(r).reduce(function (e, t) {
        var r = o[t];
        if (!r) return e;
        var i = r.widgets;
        return (
          i &&
            !i.some(function (e) {
              return n.includes(e);
            }) &&
            e.push([
              t,
              {
                connectors: r.connectors,
                widgets: r.widgets.map(function (e) {
                  return e.split("ais.")[1];
                }),
              },
            ]),
          e
        );
      }, []);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.checkIndexUiState = n);
    var i = (r(42), r(44), r(104)),
      o = {
        query: {
          connectors: ["connectSearchBox"],
          widgets: ["ais.searchBox", "ais.autocomplete", "ais.voiceSearch"],
        },
        refinementList: {
          connectors: ["connectRefinementList"],
          widgets: ["ais.refinementList"],
        },
        menu: { connectors: ["connectMenu"], widgets: ["ais.menu"] },
        hierarchicalMenu: {
          connectors: ["connectHierarchicalMenu"],
          widgets: ["ais.hierarchicalMenu"],
        },
        numericMenu: {
          connectors: ["connectNumericMenu"],
          widgets: ["ais.numericMenu"],
        },
        ratingMenu: {
          connectors: ["connectRatingMenu"],
          widgets: ["ais.ratingMenu"],
        },
        range: {
          connectors: ["connectRange"],
          widgets: ["ais.rangeInput", "ais.rangeSlider", "ais.range"],
        },
        toggle: {
          connectors: ["connectToggleRefinement"],
          widgets: ["ais.toggleRefinement"],
        },
        geoSearch: {
          connectors: ["connectGeoSearch"],
          widgets: ["ais.geoSearch"],
        },
        sortBy: { connectors: ["connectSortBy"], widgets: ["ais.sortBy"] },
        page: {
          connectors: ["connectPagination"],
          widgets: ["ais.pagination", "ais.infiniteHits"],
        },
        hitsPerPage: {
          connectors: ["connectHitsPerPage"],
          widgets: ["ais.hitsPerPage"],
        },
        configure: {
          connectors: ["connectConfigure"],
          widgets: ["ais.configure"],
        },
        places: { connectors: [], widgets: ["ais.places"] },
      };
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.warning = t.deprecate = t.warn = void 0);
    var n = r(45),
      i = function (e, t) {
        return e;
      };
    t.deprecate = i;
    var o = n.noop;
    t.warn = o;
    var a = n.noop;
    t.warning = a;
  },
  function (e, t, r) {
    "use strict";
    function n() {}
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.noop = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return Object.prototype.toString.call(e).slice(8, -1);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getObjectType = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      "@babel/helpers - typeof";
      return (n =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    function i(e) {
      return null === e
        ? void 0 === e
          ? "[object Undefined]"
          : "[object Null]"
        : Object.prototype.toString.call(e);
    }
    function o(e) {
      return "object" === n(e) && null !== e;
    }
    function a(e) {
      if (!o(e) || "[object Object]" !== i(e)) return !1;
      if (null === Object.getPrototypeOf(e)) return !0;
      for (var t = e; null !== Object.getPrototypeOf(t); )
        t = Object.getPrototypeOf(t);
      return Object.getPrototypeOf(e) === t;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.isPlainObject = a);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t, r) {
      return e.state.isHierarchicalFacet(t)
        ? e.state.isHierarchicalFacetRefined(t, r)
        : e.state.isConjunctiveFacet(t)
        ? e.state.isFacetRefined(t, r)
        : e.state.isDisjunctiveFacetRefined(t, r);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.isFacetRefined = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return btoa(encodeURIComponent(JSON.stringify(e)));
    }
    function i(e) {
      return JSON.parse(decodeURIComponent(atob(e)));
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.serializePayload = n),
      (t.deserializePayload = i);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return "ais.index" === e.$$type;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.isIndexWidget = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return "string" == typeof e ? e.replace(/^\\-/, "-") : e;
    }
    function i(e) {
      return ("number" == typeof e && e < 0) || "string" == typeof e
        ? String(e).replace(/^-/, "\\-")
        : e;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.unescapeFacetValue = n),
      (t.escapeFacetValue = i);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      for (var r, n = 0; n < e.length; n++)
        if (((r = e[n]), t(r, n, e))) return r;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.find = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      if (!Array.isArray(e)) return -1;
      for (var r = 0; r < e.length; r++) if (t(e[r])) return r;
      return -1;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.findIndex = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return e instanceof HTMLElement || (Boolean(e) && e.nodeType > 0);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.isDomElement = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r,
        n,
        a = e[t],
        s =
          (null === (r = e[t + 1]) || void 0 === r
            ? void 0
            : r.isHighlighted) || !0,
        c =
          (null === (n = e[t - 1]) || void 0 === n
            ? void 0
            : n.isHighlighted) || !0;
      return o.test((0, i.unescape)(a.value)) || c !== s ? a.isHighlighted : c;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getHighlightFromSiblings = n);
    var i = r(30),
      o = new RegExp(/\w/i);
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      (t.default = "4.48.0");
  },
  function (e, t, r) {
    "use strict";
    function n() {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap();
      return (
        (n = function () {
          return e;
        }),
        e
      );
    }
    function i(e) {
      if (e && e.__esModule) return e;
      if (null === e || ("object" !== o(e) && "function" != typeof e))
        return { default: e };
      var t = n();
      if (t && t.has(e)) return t.get(e);
      var r = {},
        i = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var a in e)
        if (Object.prototype.hasOwnProperty.call(e, a)) {
          var s = i ? Object.getOwnPropertyDescriptor(e, a) : null;
          s && (s.get || s.set)
            ? Object.defineProperty(r, a, s)
            : (r[a] = e[a]);
        }
      return (r.default = e), t && t.set(e, r), r;
    }
    var o = r(136);
    e.exports = i;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      "@babel/helpers - typeof";
      return (n =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    function i(e) {
      var t = e.getAttribute("data-insights-method"),
        r = e.getAttribute("data-insights-payload");
      if ("string" != typeof r)
        throw new Error(
          "The insights helper expects `data-insights-payload` to be a base64-encoded JSON string."
        );
      try {
        return { method: t, payload: (0, c.deserializePayload)(r) };
      } catch (e) {
        throw new Error(
          "The insights helper was unable to parse `data-insights-payload`."
        );
      }
    }
    function o(e) {
      return e.hasAttribute("data-insights-method");
    }
    function a(e) {
      var t = e.method,
        r = e.payload;
      if ("object" !== n(r))
        throw new Error(
          "The insights helper expects the payload to be an object."
        );
      var i;
      try {
        i = (0, c.serializePayload)(r);
      } catch (e) {
        throw new Error("Could not JSON serialize the payload object.");
      }
      return 'data-insights-method="'
        .concat(t, '" data-insights-payload="')
        .concat(i, '"');
    }
    function s(e, t) {
      return a({ method: e, payload: t });
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.readDataAttributes = i),
      (t.hasDataAttributes = o),
      (t.writeDataAttributes = a),
      (t.default = s);
    var c = r(1);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    var a = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createRouterMiddleware = void 0);
    var s = a(r(142)),
      c = a(r(143)),
      u = r(1),
      l = function () {
        var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.router,
          r = void 0 === t ? (0, c.default)() : t,
          n = e.stateMapping,
          a = void 0 === n ? (0, s.default)() : n;
        return function (e) {
          function t(e) {
            var t = Object.keys(e).reduce(function (t, r) {
                return i(i({}, t), {}, o({}, r, e[r]));
              }, n.mainIndex.getWidgetUiState({})),
              s = a.stateToRoute(t);
            return r.createURL(s);
          }
          var n = e.instantSearchInstance;
          n._createURL = t;
          var s = void 0,
            c = n._initialUiState;
          return {
            onStateChange: function (e) {
              var t = e.uiState,
                n = a.stateToRoute(t);
              (void 0 !== s && (0, u.isEqual)(s, n)) || (r.write(n), (s = n));
            },
            subscribe: function () {
              (n._initialUiState = i(i({}, c), a.routeToState(r.read()))),
                r.onUpdate(function (e) {
                  n.setUiState(a.routeToState(e));
                });
            },
            started: function () {},
            unsubscribe: function () {
              r.dispose();
            },
          };
        };
      };
    t.createRouterMiddleware = l;
  },
  function (e, t, r) {
    "use strict";
    var n = r(0),
      i = n(r(4)),
      o = r(33),
      a = Object.prototype.hasOwnProperty,
      s = Array.isArray,
      c = (function () {
        for (var e = [], t = 0; t < 256; ++t)
          e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
        return e;
      })(),
      u = function (e) {
        for (; e.length > 1; ) {
          var t = e.pop(),
            r = t.obj[t.prop];
          if (s(r)) {
            for (var n = [], i = 0; i < r.length; ++i)
              void 0 !== r[i] && n.push(r[i]);
            t.obj[t.prop] = n;
          }
        }
      },
      l = function (e, t) {
        for (
          var r = t && t.plainObjects ? Object.create(null) : {}, n = 0;
          n < e.length;
          ++n
        )
          void 0 !== e[n] && (r[n] = e[n]);
        return r;
      },
      f = function e(t, r, n) {
        if (!r) return t;
        if ("object" !== (0, i.default)(r)) {
          if (s(t)) t.push(r);
          else {
            if (!t || "object" !== (0, i.default)(t)) return [t, r];
            ((n && (n.plainObjects || n.allowPrototypes)) ||
              !a.call(Object.prototype, r)) &&
              (t[r] = !0);
          }
          return t;
        }
        if (!t || "object" !== (0, i.default)(t)) return [t].concat(r);
        var o = t;
        return (
          s(t) && !s(r) && (o = l(t, n)),
          s(t) && s(r)
            ? (r.forEach(function (r, o) {
                if (a.call(t, o)) {
                  var s = t[o];
                  s &&
                  "object" === (0, i.default)(s) &&
                  r &&
                  "object" === (0, i.default)(r)
                    ? (t[o] = e(s, r, n))
                    : t.push(r);
                } else t[o] = r;
              }),
              t)
            : Object.keys(r).reduce(function (t, i) {
                var o = r[i];
                return a.call(t, i) ? (t[i] = e(t[i], o, n)) : (t[i] = o), t;
              }, o)
        );
      },
      d = function (e, t) {
        return Object.keys(t).reduce(function (e, r) {
          return (e[r] = t[r]), e;
        }, e);
      },
      p = function (e, t, r) {
        var n = e.replace(/\+/g, " ");
        if ("iso-8859-1" === r) return n.replace(/%[0-9a-f]{2}/gi, unescape);
        try {
          return decodeURIComponent(n);
        } catch (e) {
          return n;
        }
      },
      h = function (e, t, r, n, a) {
        if (0 === e.length) return e;
        var s = e;
        if (
          ("symbol" === (0, i.default)(e)
            ? (s = Symbol.prototype.toString.call(e))
            : "string" != typeof e && (s = String(e)),
          "iso-8859-1" === r)
        )
          return escape(s).replace(/%u[0-9a-f]{4}/gi, function (e) {
            return "%26%23" + parseInt(e.slice(2), 16) + "%3B";
          });
        for (var u = "", l = 0; l < s.length; ++l) {
          var f = s.charCodeAt(l);
          45 === f ||
          46 === f ||
          95 === f ||
          126 === f ||
          (f >= 48 && f <= 57) ||
          (f >= 65 && f <= 90) ||
          (f >= 97 && f <= 122) ||
          (a === o.RFC1738 && (40 === f || 41 === f))
            ? (u += s.charAt(l))
            : f < 128
            ? (u += c[f])
            : f < 2048
            ? (u += c[192 | (f >> 6)] + c[128 | (63 & f)])
            : f < 55296 || f >= 57344
            ? (u +=
                c[224 | (f >> 12)] +
                c[128 | ((f >> 6) & 63)] +
                c[128 | (63 & f)])
            : ((l += 1),
              (f = 65536 + (((1023 & f) << 10) | (1023 & s.charCodeAt(l)))),
              (u +=
                c[240 | (f >> 18)] +
                c[128 | ((f >> 12) & 63)] +
                c[128 | ((f >> 6) & 63)] +
                c[128 | (63 & f)]));
        }
        return u;
      },
      v = function (e) {
        for (
          var t = [{ obj: { o: e }, prop: "o" }], r = [], n = 0;
          n < t.length;
          ++n
        )
          for (
            var o = t[n], a = o.obj[o.prop], s = Object.keys(a), c = 0;
            c < s.length;
            ++c
          ) {
            var l = s[c],
              f = a[l];
            "object" === (0, i.default)(f) &&
              null !== f &&
              -1 === r.indexOf(f) &&
              (t.push({ obj: a, prop: l }), r.push(f));
          }
        return u(t), e;
      },
      m = function (e) {
        return "[object RegExp]" === Object.prototype.toString.call(e);
      },
      g = function (e) {
        return !(
          !e ||
          "object" !== (0, i.default)(e) ||
          !(
            e.constructor &&
            e.constructor.isBuffer &&
            e.constructor.isBuffer(e)
          )
        );
      },
      y = function (e, t) {
        return [].concat(e, t);
      },
      b = function (e, t) {
        if (s(e)) {
          for (var r = [], n = 0; n < e.length; n += 1) r.push(t(e[n]));
          return r;
        }
        return t(e);
      };
    e.exports = {
      arrayToObject: l,
      assign: d,
      combine: y,
      compact: v,
      decode: p,
      encode: h,
      isBuffer: g,
      isRegExp: m,
      maybeMap: b,
      merge: f,
    };
  },
  function (e, t, r) {
    "use strict";
    function n(e, t, r) {
      var i = (0, a.createInitArgs)(t, t.mainIndex, t._initialUiState);
      e.forEach(function (e) {
        var o = {};
        if (e.getWidgetRenderState) {
          var a = e.getWidgetRenderState(i);
          a && a.widgetParams && (o = a.widgetParams);
        }
        var s = Object.keys(o).filter(function (e) {
          return void 0 !== o[e];
        });
        r.widgets.push({
          type: e.$$type,
          widgetType: e.$$widgetType,
          params: s,
        }),
          "ais.index" === e.$$type && n(e.getWidgets(), t, r);
      });
    }
    function i() {
      return (0, a.safelyRunOnBrowser)(
        function (e) {
          var t, r;
          return (
            (null === (t = e.window.navigator) || void 0 === t
              ? void 0
              : null === (r = t.userAgent) || void 0 === r
              ? void 0
              : r.indexOf("Algolia Crawler")) > -1
          );
        },
        {
          fallback: function () {
            return !1;
          },
        }
      );
    }
    function o() {
      return function (e) {
        var t = e.instantSearchInstance,
          r = { widgets: [] },
          i = document.createElement("meta"),
          o = document.querySelector("head");
        return (
          (i.name = "instantsearch:widgets"),
          {
            onStateChange: function () {},
            subscribe: function () {
              setTimeout(function () {
                var e = t.client;
                (r.ua =
                  e.transporter && e.transporter.userAgent
                    ? e.transporter.userAgent.value
                    : e._ua),
                  n(t.mainIndex.getWidgets(), t, r),
                  (i.content = JSON.stringify(r)),
                  o.appendChild(i);
              }, 0);
            },
            started: function () {},
            unsubscribe: function () {
              i.remove();
            },
          }
        );
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.isMetadataEnabled = i),
      (t.createMetadataMiddleware = o);
    var a = r(1);
  },
  function (e, t, r) {
    "use strict";
    "function" == typeof Object.create
      ? (e.exports = function (e, t) {
          (e.super_ = t),
            (e.prototype = Object.create(t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0,
              },
            }));
        })
      : (e.exports = function (e, t) {
          e.super_ = t;
          var r = function () {};
          (r.prototype = t.prototype),
            (e.prototype = new r()),
            (e.prototype.constructor = e);
        });
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      return function (r, n, i) {
        if (
          ("function" == typeof r && "object" === (0, o.default)(n)) ||
          "object" === (0, o.default)(i)
        )
          throw new a.AlgoliaSearchError(
            "index.search usage is index.search(query, params, cb)"
          );
        0 === arguments.length || "function" == typeof r
          ? ((i = r), (r = ""))
          : (1 !== arguments.length && "function" != typeof n) ||
            ((i = n), (n = void 0)),
          "object" === (0, o.default)(r) && null !== r
            ? ((n = r), (r = void 0))
            : (void 0 !== r && null !== r) || (r = "");
        var s = "";
        void 0 !== r && (s += e + "=" + encodeURIComponent(r));
        var c;
        return (
          void 0 !== n &&
            (n.additionalUA && ((c = n.additionalUA), delete n.additionalUA),
            (s = this.as._getSearchParams(n, s))),
          this._search(s, t, i, c)
        );
      };
    }
    var i = r(0),
      o = i(r(4));
    e.exports = n;
    var a = r(18);
  },
  function (e, t, r) {
    "use strict";
    e.exports = function (e, t) {
      var n = r(172),
        i = r(9),
        o = {};
      return (
        i(n(e), function (r) {
          !0 !== t(r) && (o[r] = e[r]);
        }),
        o
      );
    };
  },
  function (e, t, r) {
    "use strict";
    function n() {
      throw new Error("setTimeout has not been defined");
    }
    function i() {
      throw new Error("clearTimeout has not been defined");
    }
    function o(e) {
      if (f === setTimeout) return setTimeout(e, 0);
      if ((f === n || !f) && setTimeout)
        return (f = setTimeout), setTimeout(e, 0);
      try {
        return f(e, 0);
      } catch (t) {
        try {
          return f.call(null, e, 0);
        } catch (t) {
          return f.call(this, e, 0);
        }
      }
    }
    function a(e) {
      if (d === clearTimeout) return clearTimeout(e);
      if ((d === i || !d) && clearTimeout)
        return (d = clearTimeout), clearTimeout(e);
      try {
        return d(e);
      } catch (t) {
        try {
          return d.call(null, e);
        } catch (t) {
          return d.call(this, e);
        }
      }
    }
    function s() {
      m &&
        h &&
        ((m = !1), h.length ? (v = h.concat(v)) : (g = -1), v.length && c());
    }
    function c() {
      if (!m) {
        var e = o(s);
        m = !0;
        for (var t = v.length; t; ) {
          for (h = v, v = []; ++g < t; ) h && h[g].run();
          (g = -1), (t = v.length);
        }
        (h = null), (m = !1), a(e);
      }
    }
    function u(e, t) {
      (this.fun = e), (this.array = t);
    }
    function l() {}
    var f,
      d,
      p = (e.exports = {});
    !(function () {
      try {
        f = "function" == typeof setTimeout ? setTimeout : n;
      } catch (e) {
        f = n;
      }
      try {
        d = "function" == typeof clearTimeout ? clearTimeout : i;
      } catch (e) {
        d = i;
      }
    })();
    var h,
      v = [],
      m = !1,
      g = -1;
    (p.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1)
        for (var r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
      v.push(new u(e, t)), 1 !== v.length || m || o(c);
    }),
      (u.prototype.run = function () {
        this.fun.apply(null, this.array);
      }),
      (p.title = "browser"),
      (p.browser = !0),
      (p.env = {}),
      (p.argv = []),
      (p.version = ""),
      (p.versions = {}),
      (p.on = l),
      (p.addListener = l),
      (p.once = l),
      (p.off = l),
      (p.removeListener = l),
      (p.removeAllListeners = l),
      (p.emit = l),
      (p.prependListener = l),
      (p.prependOnceListener = l),
      (p.listeners = function (e) {
        return [];
      }),
      (p.binding = function (e) {
        throw new Error("process.binding is not supported");
      }),
      (p.cwd = function () {
        return "/";
      }),
      (p.chdir = function (e) {
        throw new Error("process.chdir is not supported");
      }),
      (p.umask = function () {
        return 0;
      });
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      if (e.map) return e.map(t);
      for (var r = [], n = 0; n < e.length; n++) r.push(t(e[n], n));
      return r;
    }
    var i = r(0),
      o = i(r(4)),
      a = function (e) {
        switch ((0, o.default)(e)) {
          case "string":
            return e;
          case "boolean":
            return e ? "true" : "false";
          case "number":
            return isFinite(e) ? e : "";
          default:
            return "";
        }
      };
    e.exports = function (e, t, r, i) {
      return (
        (t = t || "&"),
        (r = r || "="),
        null === e && (e = void 0),
        "object" === (0, o.default)(e)
          ? n(c(e), function (i) {
              var o = encodeURIComponent(a(i)) + r;
              return s(e[i])
                ? n(e[i], function (e) {
                    return o + encodeURIComponent(a(e));
                  }).join(t)
                : o + encodeURIComponent(a(e[i]));
            }).join(t)
          : i
          ? encodeURIComponent(a(i)) + r + encodeURIComponent(a(e))
          : ""
      );
    };
    var s =
        Array.isArray ||
        function (e) {
          return "[object Array]" === Object.prototype.toString.call(e);
        },
      c =
        Object.keys ||
        function (e) {
          var t = [];
          for (var r in e)
            Object.prototype.hasOwnProperty.call(e, r) && t.push(r);
          return t;
        };
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(187);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(269);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
    var o = r(272);
    Object.keys(o).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return o[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.version = void 0),
      (t.version = "1.6.2");
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return s(e) || a(e) || o(e) || i();
    }
    function i() {
      throw new TypeError(
        "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function o(e, t) {
      if (e) {
        if ("string" == typeof e) return c(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? c(e, t)
            : void 0
        );
      }
    }
    function a(e) {
      if (
        ("undefined" != typeof Symbol && null != e[Symbol.iterator]) ||
        null != e["@@iterator"]
      )
        return Array.from(e);
    }
    function s(e) {
      if (Array.isArray(e)) return c(e);
    }
    function c(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function u(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function l(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? u(Object(r), !0).forEach(function (t) {
              f(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : u(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function f(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function d(e, t) {
      var r,
        i = "undefined" != typeof window ? window : {},
        o = e.plugins || [];
      return l(
        l(
          {
            debug: !1,
            openOnFocus: !1,
            placeholder: "",
            autoFocus: !1,
            defaultActiveItemId: null,
            stallThreshold: 300,
            environment: i,
            shouldPanelOpen: function (e) {
              var t = e.state;
              return (0, p.getItemsCount)(t) > 0;
            },
            reshape: function (e) {
              return e.sources;
            },
          },
          e
        ),
        {},
        {
          id:
            null !== (r = e.id) && void 0 !== r
              ? r
              : (0, p.generateAutocompleteId)(),
          plugins: o,
          initialState: l(
            {
              activeItemId: null,
              query: "",
              completion: null,
              collections: [],
              isOpen: !1,
              status: "idle",
              context: {},
            },
            e.initialState
          ),
          onStateChange: function (t) {
            var r;
            null === (r = e.onStateChange) || void 0 === r || r.call(e, t),
              o.forEach(function (e) {
                var r;
                return null === (r = e.onStateChange) || void 0 === r
                  ? void 0
                  : r.call(e, t);
              });
          },
          onSubmit: function (t) {
            var r;
            null === (r = e.onSubmit) || void 0 === r || r.call(e, t),
              o.forEach(function (e) {
                var r;
                return null === (r = e.onSubmit) || void 0 === r
                  ? void 0
                  : r.call(e, t);
              });
          },
          onReset: function (t) {
            var r;
            null === (r = e.onReset) || void 0 === r || r.call(e, t),
              o.forEach(function (e) {
                var r;
                return null === (r = e.onReset) || void 0 === r
                  ? void 0
                  : r.call(e, t);
              });
          },
          getSources: function (r) {
            return Promise.all(
              []
                .concat(
                  n(
                    o.map(function (e) {
                      return e.getSources;
                    })
                  ),
                  [e.getSources]
                )
                .filter(Boolean)
                .map(function (e) {
                  return (0, h.getNormalizedSources)(e, r);
                })
            )
              .then(function (e) {
                return (0, p.flatten)(e);
              })
              .then(function (e) {
                return e.map(function (e) {
                  return l(
                    l({}, e),
                    {},
                    {
                      onSelect: function (r) {
                        e.onSelect(r),
                          t.forEach(function (e) {
                            var t;
                            return null === (t = e.onSelect) || void 0 === t
                              ? void 0
                              : t.call(e, r);
                          });
                      },
                      onActive: function (r) {
                        e.onActive(r),
                          t.forEach(function (e) {
                            var t;
                            return null === (t = e.onActive) || void 0 === t
                              ? void 0
                              : t.call(e, r);
                          });
                      },
                    }
                  );
                });
              });
          },
          navigator: l(
            {
              navigate: function (e) {
                var t = e.itemUrl;
                i.location.assign(t);
              },
              navigateNewTab: function (e) {
                var t = e.itemUrl,
                  r = i.open(t, "_blank", "noopener");
                null === r || void 0 === r || r.focus();
              },
              navigateNewWindow: function (e) {
                var t = e.itemUrl;
                i.open(t, "_blank", "noopener");
              },
            },
            e.navigator
          ),
        }
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getDefaultProps = d);
    var p = r(5),
      h = r(7);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t = o.get(this);
      return (
        t || ((t = new Map()), o.set(this, t)),
        (t = i(
          this,
          t.get(e) ||
            (t.set(
              e,
              (t = (function (e) {
                for (
                  var t,
                    r,
                    n = 1,
                    i = "",
                    o = "",
                    a = [0],
                    s = function (e) {
                      1 === n &&
                      (e || (i = i.replace(/^\s*\n\s*|\s*\n\s*$/g, "")))
                        ? a.push(0, e, i)
                        : 3 === n && (e || i)
                        ? (a.push(3, e, i), (n = 2))
                        : 2 === n && "..." === i && e
                        ? a.push(4, e, 0)
                        : 2 === n && i && !e
                        ? a.push(5, 0, !0, i)
                        : n >= 5 &&
                          ((i || (!e && 5 === n)) &&
                            (a.push(n, 0, i, r), (n = 6)),
                          e && (a.push(n, e, 0, r), (n = 6))),
                        (i = "");
                    },
                    c = 0;
                  c < e.length;
                  c++
                ) {
                  c && (1 === n && s(), s(c));
                  for (var u = 0; u < e[c].length; u++)
                    (t = e[c][u]),
                      1 === n
                        ? "<" === t
                          ? (s(), (a = [a]), (n = 3))
                          : (i += t)
                        : 4 === n
                        ? "--" === i && ">" === t
                          ? ((n = 1), (i = ""))
                          : (i = t + i[0])
                        : o
                        ? t === o
                          ? (o = "")
                          : (i += t)
                        : '"' === t || "'" === t
                        ? (o = t)
                        : ">" === t
                        ? (s(), (n = 1))
                        : n &&
                          ("=" === t
                            ? ((n = 5), (r = i), (i = ""))
                            : "/" === t && (n < 5 || ">" === e[c][u + 1])
                            ? (s(),
                              3 === n && (a = a[0]),
                              (n = a),
                              (a = a[0]).push(2, 0, n),
                              (n = 0))
                            : " " === t ||
                              "\t" === t ||
                              "\n" === t ||
                              "\r" === t
                            ? (s(), (n = 2))
                            : (i += t)),
                      3 === n && "!--" === i && ((n = 4), (a = a[0]));
                }
                return s(), a;
              })(e))
            ),
            t),
          arguments,
          []
        )).length > 1
          ? t
          : t[0]
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = n);
    var i = function e(t, r, n, i) {
        var o;
        r[0] = 0;
        for (var a = 1; a < r.length; a++) {
          var s = r[a++],
            c = r[a] ? ((r[0] |= s ? 1 : 2), n[r[a++]]) : r[++a];
          3 === s
            ? (i[0] = c)
            : 4 === s
            ? (i[1] = Object.assign(i[1] || {}, c))
            : 5 === s
            ? ((i[1] = i[1] || {})[r[++a]] = c)
            : 6 === s
            ? (i[1][r[++a]] += c + "")
            : s
            ? ((o = t.apply(c, e(t, c, n, ["", null]))),
              i.push(o),
              c[0] ? (r[0] |= 2) : ((r[a - 2] = 0), (r[a] = o)))
            : i.push(c);
        }
        return i;
      },
      o = new Map();
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return s(e) || a(e) || o(e) || i();
    }
    function i() {
      throw new TypeError(
        "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function o(e, t) {
      if (e) {
        if ("string" == typeof e) return c(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? c(e, t)
            : void 0
        );
      }
    }
    function a(e) {
      if (
        ("undefined" != typeof Symbol && null != e[Symbol.iterator]) ||
        null != e["@@iterator"]
      )
        return Array.from(e);
    }
    function s(e) {
      if (Array.isArray(e)) return c(e);
    }
    function c(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function u(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = l(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (n = 0; n < o.length; n++)
          (r = o[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function l(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    function f(e) {
      return function (t, r) {
        var i = r.children,
          o = void 0 === i ? [] : i,
          a = u(r, p),
          s = e.document.createElement(t);
        return (0, d.setProperties)(s, a), s.append.apply(s, n(o)), s;
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getCreateDomElement = f);
    var d = r(11),
      p = ["children"];
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return s(e) || a(e) || o(e) || i();
    }
    function i() {
      throw new TypeError(
        "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function o(e, t) {
      if (e) {
        if ("string" == typeof e) return c(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? c(e, t)
            : void 0
        );
      }
    }
    function a(e) {
      if (
        ("undefined" != typeof Symbol && null != e[Symbol.iterator]) ||
        null != e["@@iterator"]
      )
        return Array.from(e);
    }
    function s(e) {
      if (Array.isArray(e)) return c(e);
    }
    function c(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function u(e) {
      var t = e.hit,
        r = e.attribute,
        i = Array.isArray(r) ? r : [r],
        o = (0, l.getAttributeValueByPath)(
          t,
          ["_highlightResult"].concat(n(i), ["value"])
        );
      return (
        "string" != typeof o &&
          (o = (0, l.getAttributeValueByPath)(t, i) || ""),
        (0, f.parseAttribute)({ highlightedValue: o })
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.parseAlgoliaHitHighlight = u);
    var l = r(5),
      f = r(73);
  },
  function (e, t, r) {
    "use strict";
    function n() {
      var e =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
        t = e;
      return {
        get: function () {
          return t;
        },
        add: function (e) {
          var r = t[t.length - 1];
          (null === r || void 0 === r ? void 0 : r.isHighlighted) ===
          e.isHighlighted
            ? (t[t.length - 1] = {
                value: r.value + e.value,
                isHighlighted: r.isHighlighted,
              })
            : t.push(e);
        },
      };
    }
    function i(e) {
      var t = e.highlightedValue,
        r = t.split(o.HIGHLIGHT_PRE_TAG),
        i = r.shift(),
        a = n(i ? [{ value: i, isHighlighted: !1 }] : []);
      return (
        r.forEach(function (e) {
          var t = e.split(o.HIGHLIGHT_POST_TAG);
          a.add({ value: t[0], isHighlighted: !0 }),
            "" !== t[1] && a.add({ value: t[1], isHighlighted: !1 });
        }),
        a.get()
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.parseAttribute = i);
    var o = r(74);
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.HIGHLIGHT_POST_TAG = t.HIGHLIGHT_PRE_TAG = void 0),
      (t.HIGHLIGHT_PRE_TAG = "__aa-highlight__"),
      (t.HIGHLIGHT_POST_TAG = "__/aa-highlight__");
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e) {
      return e.some(function (e) {
        return e.isHighlighted;
      })
        ? e.map(function (t, r) {
            return i(
              i({}, t),
              {},
              { isHighlighted: !(0, s.isPartHighlighted)(e, r) }
            );
          })
        : e.map(function (e) {
            return i(i({}, e), {}, { isHighlighted: !1 });
          });
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.reverseHighlightedParts = a);
    var s = r(257);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return s(e) || a(e) || o(e) || i();
    }
    function i() {
      throw new TypeError(
        "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function o(e, t) {
      if (e) {
        if ("string" == typeof e) return c(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? c(e, t)
            : void 0
        );
      }
    }
    function a(e) {
      if (
        ("undefined" != typeof Symbol && null != e[Symbol.iterator]) ||
        null != e["@@iterator"]
      )
        return Array.from(e);
    }
    function s(e) {
      if (Array.isArray(e)) return c(e);
    }
    function c(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function u(e) {
      var t = e.hit,
        r = e.attribute,
        i = Array.isArray(r) ? r : [r],
        o = (0, l.getAttributeValueByPath)(
          t,
          ["_snippetResult"].concat(n(i), ["value"])
        );
      return (
        "string" != typeof o &&
          (o = (0, l.getAttributeValueByPath)(t, i) || ""),
        (0, f.parseAttribute)({ highlightedValue: o })
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.parseAlgoliaHitSnippet = u);
    var l = r(5),
      f = r(73);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e, t) {
      function r(t) {
        return e({
          searchClient: t.searchClient,
          queries: t.requests.map(function (e) {
            return e.query;
          }),
        }).then(function (e) {
          return e.map(function (e, r) {
            var n = t.requests[r];
            return {
              items: e,
              sourceId: n.sourceId,
              transformResponse: n.transformResponse,
            };
          });
        });
      }
      return function (e) {
        return function (n) {
          return i(i({ requesterId: t, execute: r }, e), n);
        };
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createRequester = a);
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createAlgoliaRequester = void 0);
    var n = r(79),
      i = r(77),
      o = (0, i.createRequester)(n.fetchAlgoliaResults, "algolia");
    t.createAlgoliaRequester = o;
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(262);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.userAgents = void 0);
    var n = r(5),
      i = [{ segment: "autocomplete-js", version: n.version }];
    t.userAgents = i;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createAlgoliaRequester = void 0);
    var a = r(13),
      s = r(80),
      c = (0, a.createRequester)(function (e) {
        return (0,
        a.fetchAlgoliaResults)(i(i({}, e), {}, { userAgents: s.userAgents }));
      }, "algolia");
    t.createAlgoliaRequester = c;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t = e.onTapAhead;
      return {
        item: function (e) {
          var r = e.item,
            n = e.createElement,
            i = e.components;
          return r.__autocomplete_qsCategory
            ? n(
                "div",
                { className: "aa-ItemWrapper" },
                n(
                  "div",
                  { className: "aa-ItemContent aa-ItemContent--indented" },
                  n(
                    "div",
                    {
                      className:
                        "aa-ItemContentSubtitle aa-ItemContentSubtitle--standalone",
                    },
                    n("span", { className: "aa-ItemContentSubtitleIcon" }),
                    n(
                      "span",
                      null,
                      "in",
                      " ",
                      n(
                        "span",
                        { className: "aa-ItemContentSubtitleCategory" },
                        r.__autocomplete_qsCategory
                      )
                    )
                  )
                )
              )
            : n(
                "div",
                { className: "aa-ItemWrapper" },
                n(
                  "div",
                  { className: "aa-ItemContent" },
                  n(
                    "div",
                    { className: "aa-ItemIcon aa-ItemIcon--noBorder" },
                    n(
                      "svg",
                      { viewBox: "0 0 24 24", fill: "currentColor" },
                      n("path", {
                        d: "M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z",
                      })
                    )
                  ),
                  n(
                    "div",
                    { className: "aa-ItemContentBody" },
                    n(
                      "div",
                      { className: "aa-ItemContentTitle" },
                      n(i.ReverseHighlight, { hit: r, attribute: "query" })
                    )
                  )
                ),
                n(
                  "div",
                  { className: "aa-ItemActions" },
                  n(
                    "button",
                    {
                      className: "aa-ItemActionButton",
                      title: 'Fill query with "'.concat(r.query, '"'),
                      onClick: function (e) {
                        e.preventDefault(), e.stopPropagation(), t(r);
                      },
                    },
                    n(
                      "svg",
                      { viewBox: "0 0 24 24", fill: "currentColor" },
                      n("path", {
                        d: "M8 17v-7.586l8.293 8.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-8.293-8.293h7.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-10c-0.552 0-1 0.448-1 1v10c0 0.552 0.448 1 1 1s1-0.448 1-1z",
                      })
                    )
                  )
                )
              );
        },
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.getTemplates = n);
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.version = void 0),
      (t.version = "1.7.1");
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      for (var r in t) e[r] = t[r];
      return e;
    }
    function i(e) {
      var t = e.parentNode;
      t && t.removeChild(e);
    }
    function o(e, t, r) {
      var n,
        i,
        o,
        s = {};
      for (o in t)
        "key" == o ? (n = t[o]) : "ref" == o ? (i = t[o]) : (s[o] = t[o]);
      if (
        (arguments.length > 2 &&
          (s.children = arguments.length > 3 ? C.call(arguments, 2) : r),
        "function" == typeof e && null != e.defaultProps)
      )
        for (o in e.defaultProps) void 0 === s[o] && (s[o] = e.defaultProps[o]);
      return a(e, s, n, i, null);
    }
    function a(e, t, r, n, i) {
      var o = {
        type: e,
        props: t,
        key: r,
        ref: n,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == i ? ++N : i,
      };
      return null == i && null != T.vnode && T.vnode(o), o;
    }
    function s() {
      return { current: null };
    }
    function c(e) {
      return e.children;
    }
    function u(e, t) {
      (this.props = e), (this.context = t);
    }
    function l(e, t) {
      if (null == t) return e.__ ? l(e.__, e.__.__k.indexOf(e) + 1) : null;
      for (var r; t < e.__k.length; t++)
        if (null != (r = e.__k[t]) && null != r.__e) return r.__e;
      return "function" == typeof e.type ? l(e) : null;
    }
    function f(e) {
      var t, r;
      if (null != (e = e.__) && null != e.__c) {
        for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)
          if (null != (r = e.__k[t]) && null != r.__e) {
            e.__e = e.__c.base = r.__e;
            break;
          }
        return f(e);
      }
    }
    function d(e) {
      ((!e.__d && (e.__d = !0) && F.push(e) && !p.__r++) ||
        H !== T.debounceRendering) &&
        ((H = T.debounceRendering) || setTimeout)(p);
    }
    function p() {
      for (var e; (p.__r = F.length); )
        (e = F.sort(function (e, t) {
          return e.__v.__b - t.__v.__b;
        })),
          (F = []),
          e.some(function (e) {
            var t, r, i, o, a, s;
            e.__d &&
              ((a = (o = (t = e).__v).__e),
              (s = t.__P) &&
                ((r = []),
                ((i = n({}, o)).__v = o.__v + 1),
                P(
                  s,
                  o,
                  i,
                  t.__n,
                  void 0 !== s.ownerSVGElement,
                  null != o.__h ? [a] : null,
                  r,
                  null == a ? l(o) : a,
                  o.__h
                ),
                w(r, o),
                o.__e != a && f(o)));
          });
    }
    function h(e, t, r, n, i, o, s, u, f, d) {
      var p,
        h,
        m,
        y,
        b,
        _,
        O,
        j = (n && n.__k) || q,
        w = j.length;
      for (r.__k = [], p = 0; p < t.length; p++)
        if (
          null !=
          (y = r.__k[p] =
            null == (y = t[p]) || "boolean" == typeof y
              ? null
              : "string" == typeof y ||
                "number" == typeof y ||
                "bigint" == typeof y
              ? a(null, y, null, null, y)
              : Array.isArray(y)
              ? a(c, { children: y }, null, null, null)
              : y.__b > 0
              ? a(y.type, y.props, y.key, y.ref ? y.ref : null, y.__v)
              : y)
        ) {
          if (
            ((y.__ = r),
            (y.__b = r.__b + 1),
            null === (m = j[p]) || (m && y.key == m.key && y.type === m.type))
          )
            j[p] = void 0;
          else
            for (h = 0; h < w; h++) {
              if ((m = j[h]) && y.key == m.key && y.type === m.type) {
                j[h] = void 0;
                break;
              }
              m = null;
            }
          P(e, y, (m = m || U), i, o, s, u, f, d),
            (b = y.__e),
            (h = y.ref) &&
              m.ref != h &&
              (O || (O = []),
              m.ref && O.push(m.ref, null, y),
              O.push(h, y.__c || b, y)),
            null != b
              ? (null == _ && (_ = b),
                "function" == typeof y.type && y.__k === m.__k
                  ? (y.__d = f = v(y, f, e))
                  : (f = g(e, y, m, j, b, f)),
                "function" == typeof r.type && (r.__d = f))
              : f && m.__e == f && f.parentNode != e && (f = l(m));
        }
      for (r.__e = _, p = w; p--; ) null != j[p] && R(j[p], j[p]);
      if (O) for (p = 0; p < O.length; p++) E(O[p], O[++p], O[++p]);
    }
    function v(e, t, r) {
      for (var n, i = e.__k, o = 0; i && o < i.length; o++)
        (n = i[o]) &&
          ((n.__ = e),
          (t =
            "function" == typeof n.type
              ? v(n, t, r)
              : g(r, n, n, i, n.__e, t)));
      return t;
    }
    function m(e, t) {
      return (
        (t = t || []),
        null == e ||
          "boolean" == typeof e ||
          (Array.isArray(e)
            ? e.some(function (e) {
                m(e, t);
              })
            : t.push(e)),
        t
      );
    }
    function g(e, t, r, n, i, o) {
      var a, s, c;
      if (void 0 !== t.__d) (a = t.__d), (t.__d = void 0);
      else if (null == r || i != o || null == i.parentNode)
        e: if (null == o || o.parentNode !== e) e.appendChild(i), (a = null);
        else {
          for (s = o, c = 0; (s = s.nextSibling) && c < n.length; c += 2)
            if (s == i) break e;
          e.insertBefore(i, o), (a = o);
        }
      return void 0 !== a ? a : i.nextSibling;
    }
    function y(e, t, r, n, i) {
      var o;
      for (o in r)
        "children" === o || "key" === o || o in t || _(e, o, null, r[o], n);
      for (o in t)
        (i && "function" != typeof t[o]) ||
          "children" === o ||
          "key" === o ||
          "value" === o ||
          "checked" === o ||
          r[o] === t[o] ||
          _(e, o, t[o], r[o], n);
    }
    function b(e, t, r) {
      "-" === t[0]
        ? e.setProperty(t, r)
        : (e[t] =
            null == r ? "" : "number" != typeof r || B.test(t) ? r : r + "px");
    }
    function _(e, t, r, n, i) {
      var o;
      e: if ("style" === t)
        if ("string" == typeof r) e.style.cssText = r;
        else {
          if (("string" == typeof n && (e.style.cssText = n = ""), n))
            for (t in n) (r && t in r) || b(e.style, t, "");
          if (r) for (t in r) (n && r[t] === n[t]) || b(e.style, t, r[t]);
        }
      else if ("o" === t[0] && "n" === t[1])
        (o = t !== (t = t.replace(/Capture$/, ""))),
          (t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2)),
          e.l || (e.l = {}),
          (e.l[t + o] = r),
          r
            ? n || e.addEventListener(t, o ? j : O, o)
            : e.removeEventListener(t, o ? j : O, o);
      else if ("dangerouslySetInnerHTML" !== t) {
        if (i) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if (
          "href" !== t &&
          "list" !== t &&
          "form" !== t &&
          "tabIndex" !== t &&
          "download" !== t &&
          t in e
        )
          try {
            e[t] = null == r ? "" : r;
            break e;
          } catch (e) {}
        "function" == typeof r ||
          (null == r || (!1 === r && -1 == t.indexOf("-"))
            ? e.removeAttribute(t)
            : e.setAttribute(t, r));
      }
    }
    function O(e) {
      this.l[e.type + !1](T.event ? T.event(e) : e);
    }
    function j(e) {
      this.l[e.type + !0](T.event ? T.event(e) : e);
    }
    function P(e, t, r, i, o, a, s, l, f) {
      var d,
        p,
        v,
        m,
        g,
        y,
        b,
        _,
        O,
        j,
        P,
        w,
        E,
        R,
        k,
        I = t.type;
      if (void 0 !== t.constructor) return null;
      null != r.__h &&
        ((f = r.__h), (l = t.__e = r.__e), (t.__h = null), (a = [l])),
        (d = T.__b) && d(t);
      try {
        e: if ("function" == typeof I) {
          if (
            ((_ = t.props),
            (O = (d = I.contextType) && i[d.__c]),
            (j = d ? (O ? O.props.value : d.__) : i),
            r.__c
              ? (b = (p = t.__c = r.__c).__ = p.__E)
              : ("prototype" in I && I.prototype.render
                  ? (t.__c = p = new I(_, j))
                  : ((t.__c = p = new u(_, j)),
                    (p.constructor = I),
                    (p.render = x)),
                O && O.sub(p),
                (p.props = _),
                p.state || (p.state = {}),
                (p.context = j),
                (p.__n = i),
                (v = p.__d = !0),
                (p.__h = []),
                (p._sb = [])),
            null == p.__s && (p.__s = p.state),
            null != I.getDerivedStateFromProps &&
              (p.__s == p.state && (p.__s = n({}, p.__s)),
              n(p.__s, I.getDerivedStateFromProps(_, p.__s))),
            (m = p.props),
            (g = p.state),
            v)
          )
            null == I.getDerivedStateFromProps &&
              null != p.componentWillMount &&
              p.componentWillMount(),
              null != p.componentDidMount && p.__h.push(p.componentDidMount);
          else {
            if (
              (null == I.getDerivedStateFromProps &&
                _ !== m &&
                null != p.componentWillReceiveProps &&
                p.componentWillReceiveProps(_, j),
              (!p.__e &&
                null != p.shouldComponentUpdate &&
                !1 === p.shouldComponentUpdate(_, p.__s, j)) ||
                t.__v === r.__v)
            ) {
              for (
                p.props = _,
                  p.state = p.__s,
                  t.__v !== r.__v && (p.__d = !1),
                  p.__v = t,
                  t.__e = r.__e,
                  t.__k = r.__k,
                  t.__k.forEach(function (e) {
                    e && (e.__ = t);
                  }),
                  P = 0;
                P < p._sb.length;
                P++
              )
                p.__h.push(p._sb[P]);
              (p._sb = []), p.__h.length && s.push(p);
              break e;
            }
            null != p.componentWillUpdate && p.componentWillUpdate(_, p.__s, j),
              null != p.componentDidUpdate &&
                p.__h.push(function () {
                  p.componentDidUpdate(m, g, y);
                });
          }
          if (
            ((p.context = j),
            (p.props = _),
            (p.__v = t),
            (p.__P = e),
            (w = T.__r),
            (E = 0),
            "prototype" in I && I.prototype.render)
          ) {
            for (
              p.state = p.__s,
                p.__d = !1,
                w && w(t),
                d = p.render(p.props, p.state, p.context),
                R = 0;
              R < p._sb.length;
              R++
            )
              p.__h.push(p._sb[R]);
            p._sb = [];
          } else
            do {
              (p.__d = !1),
                w && w(t),
                (d = p.render(p.props, p.state, p.context)),
                (p.state = p.__s);
            } while (p.__d && ++E < 25);
          (p.state = p.__s),
            null != p.getChildContext && (i = n(n({}, i), p.getChildContext())),
            v ||
              null == p.getSnapshotBeforeUpdate ||
              (y = p.getSnapshotBeforeUpdate(m, g)),
            (k =
              null != d && d.type === c && null == d.key
                ? d.props.children
                : d),
            h(e, Array.isArray(k) ? k : [k], t, r, i, o, a, s, l, f),
            (p.base = t.__e),
            (t.__h = null),
            p.__h.length && s.push(p),
            b && (p.__E = p.__ = null),
            (p.__e = !1);
        } else
          null == a && t.__v === r.__v
            ? ((t.__k = r.__k), (t.__e = r.__e))
            : (t.__e = S(r.__e, t, r, i, o, a, s, f));
        (d = T.diffed) && d(t);
      } catch (e) {
        (t.__v = null),
          (f || null != a) &&
            ((t.__e = l), (t.__h = !!f), (a[a.indexOf(l)] = null)),
          T.__e(e, t, r);
      }
    }
    function w(e, t) {
      T.__c && T.__c(t, e),
        e.some(function (t) {
          try {
            (e = t.__h),
              (t.__h = []),
              e.some(function (e) {
                e.call(t);
              });
          } catch (e) {
            T.__e(e, t.__v);
          }
        });
    }
    function S(e, t, r, n, o, a, s, c) {
      var u,
        f,
        d,
        p = r.props,
        v = t.props,
        m = t.type,
        g = 0;
      if (("svg" === m && (o = !0), null != a))
        for (; g < a.length; g++)
          if (
            (u = a[g]) &&
            "setAttribute" in u == !!m &&
            (m ? u.localName === m : 3 === u.nodeType)
          ) {
            (e = u), (a[g] = null);
            break;
          }
      if (null == e) {
        if (null === m) return document.createTextNode(v);
        (e = o
          ? document.createElementNS("http://www.w3.org/2000/svg", m)
          : document.createElement(m, v.is && v)),
          (a = null),
          (c = !1);
      }
      if (null === m) p === v || (c && e.data === v) || (e.data = v);
      else {
        if (
          ((a = a && C.call(e.childNodes)),
          (f = (p = r.props || U).dangerouslySetInnerHTML),
          (d = v.dangerouslySetInnerHTML),
          !c)
        ) {
          if (null != a)
            for (p = {}, g = 0; g < e.attributes.length; g++)
              p[e.attributes[g].name] = e.attributes[g].value;
          (d || f) &&
            ((d && ((f && d.__html == f.__html) || d.__html === e.innerHTML)) ||
              (e.innerHTML = (d && d.__html) || ""));
        }
        if ((y(e, v, p, o, c), d)) t.__k = [];
        else if (
          ((g = t.props.children),
          h(
            e,
            Array.isArray(g) ? g : [g],
            t,
            r,
            n,
            o && "foreignObject" !== m,
            a,
            s,
            a ? a[0] : r.__k && l(r, 0),
            c
          ),
          null != a)
        )
          for (g = a.length; g--; ) null != a[g] && i(a[g]);
        c ||
          ("value" in v &&
            void 0 !== (g = v.value) &&
            (g !== e.value ||
              ("progress" === m && !g) ||
              ("option" === m && g !== p.value)) &&
            _(e, "value", g, p.value, !1),
          "checked" in v &&
            void 0 !== (g = v.checked) &&
            g !== e.checked &&
            _(e, "checked", g, p.checked, !1));
      }
      return e;
    }
    function E(e, t, r) {
      try {
        "function" == typeof e ? e(t) : (e.current = t);
      } catch (e) {
        T.__e(e, r);
      }
    }
    function R(e, t, r) {
      var n, o;
      if (
        (T.unmount && T.unmount(e),
        (n = e.ref) && ((n.current && n.current !== e.__e) || E(n, null, t)),
        null != (n = e.__c))
      ) {
        if (n.componentWillUnmount)
          try {
            n.componentWillUnmount();
          } catch (e) {
            T.__e(e, t);
          }
        (n.base = n.__P = null), (e.__c = void 0);
      }
      if ((n = e.__k))
        for (o = 0; o < n.length; o++)
          n[o] && R(n[o], t, r || "function" != typeof e.type);
      r || null == e.__e || i(e.__e), (e.__ = e.__e = e.__d = void 0);
    }
    function x(e, t, r) {
      return this.constructor(e, r);
    }
    function k(e, t, r) {
      var n, i, a;
      T.__ && T.__(e, t),
        (i = (n = "function" == typeof r) ? null : (r && r.__k) || t.__k),
        (a = []),
        P(
          t,
          (e = ((!n && r) || t).__k = o(c, null, [e])),
          i || U,
          U,
          void 0 !== t.ownerSVGElement,
          !n && r ? [r] : i ? null : t.firstChild ? C.call(t.childNodes) : null,
          a,
          !n && r ? r : i ? i.__e : t.firstChild,
          n
        ),
        w(a, e);
    }
    function I(e, t) {
      k(e, t, I);
    }
    function A(e, t, r) {
      var i,
        o,
        s,
        c = n({}, e.props);
      for (s in t)
        "key" == s ? (i = t[s]) : "ref" == s ? (o = t[s]) : (c[s] = t[s]);
      return (
        arguments.length > 2 &&
          (c.children = arguments.length > 3 ? C.call(arguments, 2) : r),
        a(e.type, c, i || e.key, o || e.ref, null)
      );
    }
    function M(e, t) {
      var r = {
        __c: (t = "__cC" + L++),
        __: e,
        Consumer: function (e, t) {
          return e.children(t);
        },
        Provider: function (e) {
          var r, n;
          return (
            this.getChildContext ||
              ((r = []),
              ((n = {})[t] = this),
              (this.getChildContext = function () {
                return n;
              }),
              (this.shouldComponentUpdate = function (e) {
                this.props.value !== e.value && r.some(d);
              }),
              (this.sub = function (e) {
                r.push(e);
                var t = e.componentWillUnmount;
                e.componentWillUnmount = function () {
                  r.splice(r.indexOf(e), 1), t && t.call(e);
                };
              })),
            e.children
          );
        },
      };
      return (r.Provider.__ = r.Consumer.contextType = r);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.Component = u),
      (t.Fragment = c),
      (t.cloneElement = A),
      (t.createContext = M),
      (t.h = t.createElement = o),
      (t.createRef = s),
      (t.hydrate = I),
      (t.render = k),
      (t.toChildArray = m),
      (t.options = t.isValidElement = void 0);
    var C,
      T,
      N,
      D,
      F,
      H,
      L,
      U = {},
      q = [],
      B = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
    (t.isValidElement = D),
      (t.options = T),
      (C = q.slice),
      (t.options = T =
        {
          __e: function (e, t, r, n) {
            for (var i, o, a; (t = t.__); )
              if ((i = t.__c) && !i.__)
                try {
                  if (
                    ((o = i.constructor) &&
                      null != o.getDerivedStateFromError &&
                      (i.setState(o.getDerivedStateFromError(e)), (a = i.__d)),
                    null != i.componentDidCatch &&
                      (i.componentDidCatch(e, n || {}), (a = i.__d)),
                    a)
                  )
                    return (i.__E = i);
                } catch (t) {
                  e = t;
                }
            throw e;
          },
        }),
      (N = 0),
      (t.isValidElement = D =
        function (e) {
          return null != e && void 0 === e.constructor;
        }),
      (u.prototype.setState = function (e, t) {
        var r;
        (r =
          null != this.__s && this.__s !== this.state
            ? this.__s
            : (this.__s = n({}, this.state))),
          "function" == typeof e && (e = e(n({}, r), this.props)),
          e && n(r, e),
          null != e && this.__v && (t && this._sb.push(t), d(this));
      }),
      (u.prototype.forceUpdate = function (e) {
        this.__v && ((this.__e = !0), e && this.__h.push(e), d(this));
      }),
      (u.prototype.render = c),
      (F = []),
      (p.__r = 0),
      (L = 0);
  },
  function (e, t, r) {
    "use strict";
    var n = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }),
      Object.defineProperty(t, "h", {
        enumerable: !0,
        get: function () {
          return i.h;
        },
      }),
      Object.defineProperty(t, "render", {
        enumerable: !0,
        get: function () {
          return i.render;
        },
      }),
      Object.defineProperty(t, "Component", {
        enumerable: !0,
        get: function () {
          return i.Component;
        },
      }),
      (t.html = void 0);
    var i = r(84),
      o = n(r(70)),
      a = o.default.bind(i.h);
    t.html = a;
  },
  function (e, t) {
    (function (t) {
      e.exports = t;
    }.call(t, {}));
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      "@babel/helpers - typeof";
      return (n =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    function i(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function o(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? i(Object(r), !0).forEach(function (t) {
              b(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : i(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function a() {
      return (
        (a =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r)
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          }),
        a.apply(this, arguments)
      );
    }
    function s(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = c(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (n = 0; n < o.length; n++)
          (r = o[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function c(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    function u(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function l(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n);
      }
    }
    function f(e, t, r) {
      return t && l(e.prototype, t), r && l(e, r), e;
    }
    function d(e, t) {
      if ("function" != typeof t && null !== t)
        throw new TypeError(
          "Super expression must either be null or a function"
        );
      (e.prototype = Object.create(t && t.prototype, {
        constructor: { value: e, writable: !0, configurable: !0 },
      })),
        t && p(e, t);
    }
    function p(e, t) {
      return (p =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        })(e, t);
    }
    function h(e) {
      var t = g();
      return function () {
        var r,
          n = y(e);
        if (t) {
          var i = y(this).constructor;
          r = Reflect.construct(n, arguments, i);
        } else r = n.apply(this, arguments);
        return v(this, r);
      };
    }
    function v(e, t) {
      return !t || ("object" !== n(t) && "function" != typeof t) ? m(e) : t;
    }
    function m(e) {
      if (void 0 === e)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return e;
    }
    function g() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return (
          Date.prototype.toString.call(
            Reflect.construct(Date, [], function () {})
          ),
          !0
        );
      } catch (e) {
        return !1;
      }
    }
    function y(e) {
      return (y = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
    }
    function b(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function _(e) {
      return void 0 !== e.data;
    }
    var O = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var j = r(2),
      P = O(r(3)),
      w = r(1),
      S = O(r(8)),
      E = O(r(342)),
      R = O(r(88)),
      x = { cssClasses: {}, depth: 0 },
      k = (function (e) {
        function t(e) {
          var n;
          return (
            u(this, t),
            (n = r.call(this, e)),
            b(m(n), "searchBox", (0, j.createRef)()),
            (n.handleItemClick = n.handleItemClick.bind(m(n))),
            n
          );
        }
        d(t, e);
        var r = h(t);
        return (
          f(t, [
            {
              key: "shouldComponentUpdate",
              value: function (e) {
                return !(0, w.isEqual)(this.props.facetValues, e.facetValues);
              },
            },
            {
              key: "refine",
              value: function (e) {
                this.props.toggleRefinement(e);
              },
            },
            {
              key: "_generateFacetItem",
              value: function (e) {
                var r, n;
                if (_(e) && Array.isArray(e.data) && e.data.length > 0) {
                  var i = this.props.cssClasses,
                    c = (i.root, s(i, ["root"]));
                  n = (0, j.h)(
                    t,
                    a({}, this.props, {
                      cssClasses: c,
                      depth: this.props.depth + 1,
                      facetValues: e.data,
                      showMore: !1,
                      className: this.props.cssClasses.childList,
                    })
                  );
                }
                var u = this.props.createURL(e.value),
                  l = o(
                    o({}, e),
                    {},
                    {
                      url: u,
                      attribute: this.props.attribute,
                      cssClasses: this.props.cssClasses,
                      isFromSearch: this.props.isFromSearch,
                    }
                  ),
                  f = e.value;
                void 0 !== e.isRefined && (f += "/".concat(e.isRefined)),
                  void 0 !== e.count && (f += "/".concat(e.count));
                var d = (0, P.default)(
                  this.props.cssClasses.item,
                  ((r = {}),
                  b(r, this.props.cssClasses.selectedItem, e.isRefined),
                  b(r, this.props.cssClasses.disabledItem, !e.count),
                  b(
                    r,
                    this.props.cssClasses.parentItem,
                    _(e) && Array.isArray(e.data) && e.data.length > 0
                  ),
                  r)
                );
                return (0, j.h)(E.default, {
                  templateKey: "item",
                  key: f,
                  facetValueToRefine: e.value,
                  handleClick: this.handleItemClick,
                  isRefined: e.isRefined,
                  className: d,
                  subItems: n,
                  templateData: l,
                  templateProps: this.props.templateProps,
                });
              },
            },
            {
              key: "handleItemClick",
              value: function (e) {
                var t = e.facetValueToRefine,
                  r = e.isRefined,
                  n = e.originalEvent;
                if (
                  !(0, w.isSpecialClick)(n) &&
                  n.target instanceof HTMLElement &&
                  n.target.parentNode instanceof HTMLElement &&
                  (!r ||
                    !n.target.parentNode.querySelector(
                      'input[type="radio"]:checked'
                    ))
                ) {
                  if ("INPUT" === n.target.tagName) return void this.refine(t);
                  for (var i = n.target; i !== n.currentTarget; ) {
                    if (
                      "LABEL" === i.tagName &&
                      (i.querySelector('input[type="checkbox"]') ||
                        i.querySelector('input[type="radio"]'))
                    )
                      return;
                    "A" === i.tagName && i.href && n.preventDefault(),
                      (i = i.parentNode);
                  }
                  n.stopPropagation(), this.refine(t);
                }
              },
            },
            {
              key: "componentWillReceiveProps",
              value: function (e) {
                this.searchBox.current &&
                  !e.isFromSearch &&
                  this.searchBox.current.resetInput();
              },
            },
            {
              key: "refineFirstValue",
              value: function () {
                var e = this.props.facetValues && this.props.facetValues[0];
                if (e) {
                  var t = e.value;
                  this.props.toggleRefinement(t);
                }
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = (0, P.default)(
                    this.props.cssClasses.showMore,
                    b(
                      {},
                      this.props.cssClasses.disabledShowMore,
                      !(
                        !0 === this.props.showMore &&
                        this.props.canToggleShowMore
                      )
                    )
                  ),
                  r =
                    !0 === this.props.showMore &&
                    (0, j.h)(
                      S.default,
                      a({}, this.props.templateProps, {
                        templateKey: "showMoreText",
                        rootTagName: "button",
                        rootProps: {
                          className: t,
                          disabled: !this.props.canToggleShowMore,
                          onClick: this.props.toggleShowMore,
                        },
                        data: { isShowingMore: this.props.isShowingMore },
                      })
                    ),
                  n =
                    !0 !== this.props.searchIsAlwaysActive &&
                    !(
                      this.props.isFromSearch || !this.props.hasExhaustiveItems
                    ),
                  i =
                    this.props.searchFacetValues &&
                    (0, j.h)(
                      "div",
                      { className: this.props.cssClasses.searchBox },
                      (0, j.h)(R.default, {
                        ref: this.searchBox,
                        placeholder: this.props.searchPlaceholder,
                        disabled: n,
                        cssClasses: this.props.cssClasses.searchable,
                        templates: this.props.searchBoxTemplateProps.templates,
                        onChange: function (t) {
                          return e.props.searchFacetValues(t.target.value);
                        },
                        onReset: function () {
                          return e.props.searchFacetValues("");
                        },
                        onSubmit: function () {
                          return e.refineFirstValue();
                        },
                        searchAsYouType: !1,
                      })
                    ),
                  o =
                    this.props.facetValues &&
                    this.props.facetValues.length > 0 &&
                    (0, j.h)(
                      "ul",
                      { className: this.props.cssClasses.list },
                      this.props.facetValues.map(this._generateFacetItem, this)
                    ),
                  s =
                    this.props.searchFacetValues &&
                    this.props.isFromSearch &&
                    (!this.props.facetValues ||
                      0 === this.props.facetValues.length) &&
                    (0, j.h)(
                      S.default,
                      a({}, this.props.templateProps, {
                        templateKey: "searchableNoResults",
                        rootProps: {
                          className: this.props.cssClasses.noResults,
                        },
                      })
                    ),
                  c = (0, P.default)(
                    this.props.cssClasses.root,
                    b(
                      {},
                      this.props.cssClasses.noRefinementRoot,
                      !this.props.facetValues ||
                        0 === this.props.facetValues.length
                    ),
                    this.props.className
                  );
                return (0, j.h)(
                  "div",
                  { className: c },
                  this.props.children,
                  i,
                  o,
                  s,
                  r
                );
              },
            },
          ]),
          t
        );
      })(j.Component);
    b(k, "defaultProps", x);
    var I = k;
    t.default = I;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      "@babel/helpers - typeof";
      return (n =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    function i(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function o(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n);
      }
    }
    function a(e, t, r) {
      return t && o(e.prototype, t), r && o(e, r), e;
    }
    function s(e, t) {
      if ("function" != typeof t && null !== t)
        throw new TypeError(
          "Super expression must either be null or a function"
        );
      (e.prototype = Object.create(t && t.prototype, {
        constructor: { value: e, writable: !0, configurable: !0 },
      })),
        t && c(e, t);
    }
    function c(e, t) {
      return (c =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        })(e, t);
    }
    function u(e) {
      var t = d();
      return function () {
        var r,
          n = p(e);
        if (t) {
          var i = p(this).constructor;
          r = Reflect.construct(n, arguments, i);
        } else r = n.apply(this, arguments);
        return l(this, r);
      };
    }
    function l(e, t) {
      return !t || ("object" !== n(t) && "function" != typeof t) ? f(e) : t;
    }
    function f(e) {
      if (void 0 === e)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return e;
    }
    function d() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return (
          Date.prototype.toString.call(
            Reflect.construct(Date, [], function () {})
          ),
          !0
        );
      } catch (e) {
        return !1;
      }
    }
    function p(e) {
      return (p = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
    }
    function h(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    var v = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var m = r(2),
      g = r(1),
      y = v(r(8)),
      b = {
        query: "",
        showSubmit: !0,
        showReset: !0,
        showLoadingIndicator: !0,
        autofocus: !1,
        searchAsYouType: !0,
        isSearchStalled: !1,
        disabled: !1,
        onChange: g.noop,
        onSubmit: g.noop,
        onReset: g.noop,
        refine: g.noop,
      },
      _ = (function (e) {
        function t() {
          var e;
          i(this, t);
          for (var n = arguments.length, o = new Array(n), a = 0; a < n; a++)
            o[a] = arguments[a];
          return (
            (e = r.call.apply(r, [this].concat(o))),
            h(f(e), "state", { query: e.props.query, focused: !1 }),
            h(f(e), "input", (0, m.createRef)()),
            h(f(e), "onInput", function (t) {
              var r = e.props,
                n = r.searchAsYouType,
                i = r.refine,
                o = r.onChange,
                a = t.target.value;
              n && i(a), e.setState({ query: a }), o(t);
            }),
            h(f(e), "onSubmit", function (t) {
              var r = e.props,
                n = r.searchAsYouType,
                i = r.refine,
                o = r.onSubmit;
              return (
                t.preventDefault(),
                t.stopPropagation(),
                e.input.current && e.input.current.blur(),
                n || i(e.state.query),
                o(t),
                !1
              );
            }),
            h(f(e), "onReset", function (t) {
              var r = e.props,
                n = r.refine,
                i = r.onReset;
              e.input.current && e.input.current.focus(),
                n(""),
                e.setState({ query: "" }),
                i(t);
            }),
            h(f(e), "onBlur", function () {
              e.setState({ focused: !1 });
            }),
            h(f(e), "onFocus", function () {
              e.setState({ focused: !0 });
            }),
            e
          );
        }
        s(t, e);
        var r = u(t);
        return (
          a(t, [
            {
              key: "resetInput",
              value: function () {
                this.setState({ query: "" });
              },
            },
            {
              key: "componentWillReceiveProps",
              value: function (e) {
                this.state.focused ||
                  e.query === this.state.query ||
                  this.setState({ query: e.query });
              },
            },
            {
              key: "render",
              value: function () {
                var e = this.props,
                  t = e.cssClasses,
                  r = e.placeholder,
                  n = e.autofocus,
                  i = e.showSubmit,
                  o = e.showReset,
                  a = e.showLoadingIndicator,
                  s = e.templates,
                  c = e.isSearchStalled;
                return (0, m.h)(
                  "div",
                  { className: t.root },
                  (0, m.h)(
                    "form",
                    {
                      action: "",
                      role: "search",
                      className: t.form,
                      noValidate: !0,
                      onSubmit: this.onSubmit,
                      onReset: this.onReset,
                    },
                    (0, m.h)("input", {
                      ref: this.input,
                      value: this.state.query,
                      disabled: this.props.disabled,
                      className: t.input,
                      type: "search",
                      placeholder: r,
                      autoFocus: n,
                      autoComplete: "off",
                      autoCorrect: "off",
                      autoCapitalize: "off",
                      spellCheck: "false",
                      maxLength: 512,
                      onInput: this.onInput,
                      onBlur: this.onBlur,
                      onFocus: this.onFocus,
                    }),
                    (0, m.h)(y.default, {
                      templateKey: "submit",
                      rootTagName: "button",
                      rootProps: {
                        className: t.submit,
                        type: "submit",
                        title: "Submit the search query.",
                        hidden: !i,
                      },
                      templates: s,
                      data: { cssClasses: t },
                    }),
                    (0, m.h)(y.default, {
                      templateKey: "reset",
                      rootTagName: "button",
                      rootProps: {
                        className: t.reset,
                        type: "reset",
                        title: "Clear the search query.",
                        hidden: !(o && this.state.query.trim() && !c),
                      },
                      templates: s,
                      data: { cssClasses: t },
                    }),
                    a &&
                      (0, m.h)(y.default, {
                        templateKey: "loadingIndicator",
                        rootTagName: "span",
                        rootProps: {
                          className: t.loadingIndicator,
                          hidden: !c,
                        },
                        templates: s,
                        data: { cssClasses: t },
                      })
                  )
                );
              },
            },
          ]),
          t
        );
      })(m.Component);
    h(_, "defaultProps", b);
    var O = _;
    t.default = O;
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var n = r(2),
      i = (0, n.h)("path", {
        d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z",
      }),
      o = (0, n.h)("path", {
        d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z",
      }),
      a = (0, n.h)(
        "g",
        { fill: "none", fillRule: "evenodd" },
        (0, n.h)(
          "g",
          { transform: "translate(1 1)", strokeWidth: "2" },
          (0, n.h)("circle", {
            strokeOpacity: ".5",
            cx: "18",
            cy: "18",
            r: "18",
          }),
          (0, n.h)(
            "path",
            { d: "M36 18c0-9.94-8.06-18-18-18" },
            (0, n.h)("animateTransform", {
              attributeName: "transform",
              type: "rotate",
              from: "0 18 18",
              to: "360 18 18",
              dur: "1s",
              repeatCount: "indefinite",
            })
          )
        )
      ),
      s = {
        reset: function (e) {
          var t = e.cssClasses;
          return (0, n.h)(
            "svg",
            {
              className: t.resetIcon,
              viewBox: "0 0 20 20",
              width: "10",
              height: "10",
            },
            i
          );
        },
        submit: function (e) {
          var t = e.cssClasses;
          return (0, n.h)(
            "svg",
            {
              className: t.submitIcon,
              width: "10",
              height: "10",
              viewBox: "0 0 40 40",
            },
            o
          );
        },
        loadingIndicator: function (e) {
          var t = e.cssClasses;
          return (0, n.h)(
            "svg",
            {
              className: t.loadingIcon,
              width: "16",
              height: "16",
              viewBox: "0 0 38 38",
              stroke: "#444",
            },
            a
          );
        },
      },
      c = s;
    t.default = c;
  },
  function (e, t, r) {
    "use strict";
    var n = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }),
      Object.defineProperty(t, "instantsearch", {
        enumerable: !0,
        get: function () {
          return i.default;
        },
      }),
      Object.defineProperty(t, "algoliasearch", {
        enumerable: !0,
        get: function () {
          return o.default;
        },
      }),
      Object.defineProperty(t, "autocomplete", {
        enumerable: !0,
        get: function () {
          return a.autocomplete;
        },
      }),
      Object.defineProperty(t, "getAlgoliaResults", {
        enumerable: !0,
        get: function () {
          return a.getAlgoliaResults;
        },
      }),
      Object.defineProperty(t, "createQuerySuggestionsPlugin", {
        enumerable: !0,
        get: function () {
          return s.createQuerySuggestionsPlugin;
        },
      }),
      Object.defineProperty(t, "insightsClient", {
        enumerable: !0,
        get: function () {
          return c.default;
        },
      }),
      Object.defineProperty(t, "createAlgoliaInsightsPlugin", {
        enumerable: !0,
        get: function () {
          return u.createAlgoliaInsightsPlugin;
        },
      }),
      Object.defineProperty(t, "createInsightsMiddleware", {
        enumerable: !0,
        get: function () {
          return l.createInsightsMiddleware;
        },
      }),
      Object.defineProperty(t, "render", {
        enumerable: !0,
        get: function () {
          return f.render;
        },
      }),
      Object.defineProperty(t, "html", {
        enumerable: !0,
        get: function () {
          return d.html;
        },
      }),
      (t.connectors = t.widgets = void 0);
    var i = n(r(91)),
      o = n(r(165)),
      a = r(67),
      s = r(287),
      c = n(r(289)),
      u = r(291),
      l = r(312),
      f = r(84),
      d = r(85),
      p = n(r(314)),
      h = n(r(319)),
      v = n(r(345)),
      m = n(r(348)),
      g = n(r(350)),
      y = n(r(353)),
      b = n(r(356)),
      _ = n(r(360)),
      O = n(r(363)),
      j = n(r(370)),
      P = n(r(374)),
      w = n(r(376)),
      S = {
        rangeSlider: p.default,
        menu: h.default,
        refinementList: v.default,
        searchBox: m.default,
        stats: g.default,
        sortBy: y.default,
        clearRefinements: b.default,
        panel: _.default,
        hits: O.default,
        pagination: j.default,
        configure: P.default,
      };
    t.widgets = S;
    var E = { connectCurrentRefinements: w.default };
    t.connectors = E;
  },
  function (e, t, r) {
    "use strict";
    var n = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 });
    var i = {};
    t.default = void 0;
    var o = n(r(92)),
      a = n(r(56)),
      s = r(32),
      c = r(147),
      u = r(1),
      l = r(149);
    Object.keys(l).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        (Object.prototype.hasOwnProperty.call(i, e) ||
          Object.defineProperty(t, e, {
            enumerable: !0,
            get: function () {
              return l[e];
            },
          }));
    });
    var f = function (e) {
      return new o.default(e);
    };
    (f.version = a.default),
      (f.createInfiniteHitsSessionStorageCache = (0, u.deprecate)(
        c.createInfiniteHitsSessionStorageCache,
        "import { createInfiniteHitsSessionStorageCache } from 'instantsearch.js/es/lib/infiniteHitsCache'"
      )),
      (f.highlight = (0, u.deprecate)(
        s.highlight,
        "import { highlight } from 'instantsearch.js/es/helpers'"
      )),
      (f.reverseHighlight = (0, u.deprecate)(
        s.reverseHighlight,
        "import { reverseHighlight } from 'instantsearch.js/es/helpers'"
      )),
      (f.snippet = (0, u.deprecate)(
        s.snippet,
        "import { snippet } from 'instantsearch.js/es/helpers'"
      )),
      (f.reverseSnippet = (0, u.deprecate)(
        s.reverseSnippet,
        "import { reverseSnippet } from 'instantsearch.js/es/helpers'"
      )),
      (f.insights = s.insights),
      (f.getInsightsAnonymousUserToken = s.getInsightsAnonymousUserToken),
      Object.defineProperty(f, "widgets", {
        get: function () {
          throw new ReferenceError(
            "\"instantsearch.widgets\" are not available from the ES build.\n\nTo import the widgets:\n\nimport { searchBox } from 'instantsearch.js/es/widgets'"
          );
        },
      }),
      Object.defineProperty(f, "connectors", {
        get: function () {
          throw new ReferenceError(
            "\"instantsearch.connectors\" are not available from the ES build.\n\nTo import the connectors:\n\nimport { connectSearchBox } from 'instantsearch.js/es/connectors'"
          );
        },
      });
    var d = f;
    t.default = d;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      "@babel/helpers - typeof";
      return (n =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    function i(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function o(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? i(Object(r), !0).forEach(function (t) {
              m(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : i(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function a(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function s(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n);
      }
    }
    function c(e, t, r) {
      return t && s(e.prototype, t), r && s(e, r), e;
    }
    function u(e, t) {
      if ("function" != typeof t && null !== t)
        throw new TypeError(
          "Super expression must either be null or a function"
        );
      (e.prototype = Object.create(t && t.prototype, {
        constructor: { value: e, writable: !0, configurable: !0 },
      })),
        t && l(e, t);
    }
    function l(e, t) {
      return (l =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        })(e, t);
    }
    function f(e) {
      var t = h();
      return function () {
        var r,
          n = v(e);
        if (t) {
          var i = v(this).constructor;
          r = Reflect.construct(n, arguments, i);
        } else r = n.apply(this, arguments);
        return d(this, r);
      };
    }
    function d(e, t) {
      return !t || ("object" !== n(t) && "function" != typeof t) ? p(e) : t;
    }
    function p(e) {
      if (void 0 === e)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return e;
    }
    function h() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return (
          Date.prototype.toString.call(
            Reflect.construct(Date, [], function () {})
          ),
          !0
        );
      } catch (e) {
        return !1;
      }
    }
    function v(e) {
      return (v = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
    }
    function m(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function g() {
      return "#";
    }
    var y = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var b = y(r(23)),
      _ = y(r(28)),
      O = y(r(103)),
      j = y(r(56)),
      P = y(r(135)),
      w = r(1),
      S = r(59),
      E = r(61),
      R = (0, w.createDocumentationMessageGenerator)({ name: "instantsearch" }),
      x = (function (e) {
        function t(e) {
          var n;
          a(this, t),
            (n = r.call(this)),
            m(p(n), "client", void 0),
            m(p(n), "indexName", void 0),
            m(p(n), "insightsClient", void 0),
            m(p(n), "onStateChange", null),
            m(p(n), "helper", void 0),
            m(p(n), "mainHelper", void 0),
            m(p(n), "mainIndex", void 0),
            m(p(n), "started", void 0),
            m(p(n), "templatesConfig", void 0),
            m(p(n), "renderState", {}),
            m(p(n), "_stalledSearchDelay", void 0),
            m(p(n), "_searchStalledTimer", void 0),
            m(p(n), "_initialUiState", void 0),
            m(p(n), "_initialResults", void 0),
            m(p(n), "_createURL", void 0),
            m(p(n), "_searchFunction", void 0),
            m(p(n), "_mainHelperSearch", void 0),
            m(p(n), "middleware", []),
            m(p(n), "sendEventToInsights", void 0),
            m(p(n), "status", "idle"),
            m(p(n), "error", void 0),
            m(
              p(n),
              "scheduleSearch",
              (0, w.defer)(function () {
                n.started && n.mainHelper.search();
              })
            ),
            m(
              p(n),
              "scheduleRender",
              (0, w.defer)(function () {
                var e =
                  !(arguments.length > 0 && void 0 !== arguments[0]) ||
                  arguments[0];
                n.mainHelper.hasPendingRequests() ||
                  (clearTimeout(n._searchStalledTimer),
                  (n._searchStalledTimer = null),
                  e && ((n.status = "idle"), (n.error = void 0))),
                  n.mainIndex.render({ instantSearchInstance: p(n) }),
                  n.emit("render");
              })
            ),
            m(
              p(n),
              "onInternalStateChange",
              (0, w.defer)(function () {
                var e = n.mainIndex.getWidgetUiState({});
                n.middleware.forEach(function (t) {
                  t.instance.onStateChange({ uiState: e });
                });
              })
            );
          var i = e.indexName,
            o = void 0 === i ? null : i,
            s = e.numberLocale,
            c = e.initialUiState,
            u = void 0 === c ? {} : c,
            l = e.routing,
            f = void 0 === l ? null : l,
            d = e.searchFunction,
            h = e.stalledSearchDelay,
            v = void 0 === h ? 200 : h,
            y = e.searchClient,
            b = void 0 === y ? null : y,
            _ = e.insightsClient,
            x = void 0 === _ ? null : _,
            k = e.onStateChange,
            I = void 0 === k ? null : k;
          if (null === o)
            throw new Error(R("The `indexName` option is required."));
          if (null === b)
            throw new Error(R("The `searchClient` option is required."));
          if ("function" != typeof b.search)
            throw new Error(
              "The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/"
            );
          if (
            ("function" == typeof b.addAlgoliaAgent &&
              b.addAlgoliaAgent("instantsearch.js (".concat(j.default, ")")),
            x && "function" != typeof x)
          )
            throw new Error(
              R("The `insightsClient` option should be a function.")
            );
          if (
            ((n.client = b),
            (n.insightsClient = x),
            (n.indexName = o),
            (n.helper = null),
            (n.mainHelper = null),
            (n.mainIndex = (0, O.default)({ indexName: o })),
            (n.onStateChange = I),
            (n.started = !1),
            (n.templatesConfig = {
              helpers: (0, P.default)({ numberLocale: s }),
              compileOptions: {},
            }),
            (n._stalledSearchDelay = v),
            (n._searchStalledTimer = null),
            (n._createURL = g),
            (n._initialUiState = u),
            (n._initialResults = null),
            d && (n._searchFunction = d),
            (n.sendEventToInsights = w.noop),
            f)
          ) {
            var A = "boolean" == typeof f ? void 0 : f;
            n.use((0, S.createRouterMiddleware)(A));
          }
          return (
            (0, E.isMetadataEnabled)() &&
              n.use((0, E.createMetadataMiddleware)()),
            n
          );
        }
        u(t, e);
        var r = f(t);
        return (
          c(t, [
            {
              key: "_isSearchStalled",
              get: function () {
                return "stalled" === this.status;
              },
            },
            {
              key: "use",
              value: function () {
                for (
                  var e = this, t = arguments.length, r = new Array(t), n = 0;
                  n < t;
                  n++
                )
                  r[n] = arguments[n];
                var i = r.map(function (t) {
                  var r = o(
                    {
                      subscribe: w.noop,
                      started: w.noop,
                      unsubscribe: w.noop,
                      onStateChange: w.noop,
                    },
                    t({ instantSearchInstance: e })
                  );
                  return e.middleware.push({ creator: t, instance: r }), r;
                });
                return (
                  this.started &&
                    i.forEach(function (e) {
                      e.subscribe(), e.started();
                    }),
                  this
                );
              },
            },
            {
              key: "unuse",
              value: function () {
                for (
                  var e = arguments.length, t = new Array(e), r = 0;
                  r < e;
                  r++
                )
                  t[r] = arguments[r];
                return (
                  this.middleware
                    .filter(function (e) {
                      return t.includes(e.creator);
                    })
                    .forEach(function (e) {
                      return e.instance.unsubscribe();
                    }),
                  (this.middleware = this.middleware.filter(function (e) {
                    return !t.includes(e.creator);
                  })),
                  this
                );
              },
            },
            {
              key: "EXPERIMENTAL_use",
              value: function () {
                return this.use.apply(this, arguments);
              },
            },
            {
              key: "addWidget",
              value: function (e) {
                return this.addWidgets([e]);
              },
            },
            {
              key: "addWidgets",
              value: function (e) {
                if (!Array.isArray(e))
                  throw new Error(
                    R(
                      "The `addWidgets` method expects an array of widgets. Please use `addWidget`."
                    )
                  );
                if (
                  e.some(function (e) {
                    return (
                      "function" != typeof e.init &&
                      "function" != typeof e.render
                    );
                  })
                )
                  throw new Error(
                    R(
                      "The widget definition expects a `render` and/or an `init` method."
                    )
                  );
                return this.mainIndex.addWidgets(e), this;
              },
            },
            {
              key: "removeWidget",
              value: function (e) {
                return this.removeWidgets([e]);
              },
            },
            {
              key: "removeWidgets",
              value: function (e) {
                if (!Array.isArray(e))
                  throw new Error(
                    R(
                      "The `removeWidgets` method expects an array of widgets. Please use `removeWidget`."
                    )
                  );
                if (
                  e.some(function (e) {
                    return "function" != typeof e.dispose;
                  })
                )
                  throw new Error(
                    R("The widget definition expects a `dispose` method.")
                  );
                return this.mainIndex.removeWidgets(e), this;
              },
            },
            {
              key: "start",
              value: function () {
                var e = this;
                if (this.started)
                  throw new Error(
                    R("The `start` method has already been called once.")
                  );
                var t =
                  this.mainHelper ||
                  (0, b.default)(this.client, this.indexName);
                if (
                  ((t.search = function () {
                    return (
                      (e.status = "loading"),
                      e.emit("render"),
                      t.searchOnlyWithDerivedHelpers()
                    );
                  }),
                  this._searchFunction)
                ) {
                  var r = {
                    search: function () {
                      return new Promise(w.noop);
                    },
                  };
                  (this._mainHelperSearch = t.search.bind(t)),
                    (t.search = function () {
                      var n = e.mainIndex.getHelper(),
                        i = (0, b.default)(r, n.state.index, n.state);
                      return (
                        i.once("search", function (t) {
                          var r = t.state;
                          n.overrideStateWithoutTriggeringChangeEvent(r),
                            e._mainHelperSearch();
                        }),
                        i.on("change", function (e) {
                          var t = e.state;
                          n.setState(t);
                        }),
                        e._searchFunction(i),
                        t
                      );
                    });
                }
                if (
                  (t.on("error", function (t) {
                    var r = t.error;
                    if (!(r instanceof Error)) {
                      var n = r;
                      r = Object.keys(n).reduce(function (e, t) {
                        return (e[t] = n[t]), e;
                      }, new Error(n.message));
                    }
                    (r.error = r),
                      (e.error = r),
                      (e.status = "error"),
                      e.scheduleRender(!1),
                      e.emit("error", r);
                  }),
                  (this.mainHelper = t),
                  this.middleware.forEach(function (e) {
                    e.instance.subscribe();
                  }),
                  this.mainIndex.init({
                    instantSearchInstance: this,
                    parent: null,
                    uiState: this._initialUiState,
                  }),
                  this._initialResults)
                ) {
                  var n = this.scheduleSearch;
                  (this.scheduleSearch = (0, w.defer)(w.noop)),
                    (0, w.defer)(function () {
                      e.scheduleSearch = n;
                    })();
                } else
                  this.mainIndex.getWidgets().length > 0 &&
                    this.scheduleSearch();
                (this.helper = this.mainIndex.getHelper()),
                  (this.started = !0),
                  this.middleware.forEach(function (e) {
                    e.instance.started();
                  });
              },
            },
            {
              key: "dispose",
              value: function () {
                this.scheduleSearch.cancel(),
                  this.scheduleRender.cancel(),
                  clearTimeout(this._searchStalledTimer),
                  this.removeWidgets(this.mainIndex.getWidgets()),
                  this.mainIndex.dispose(),
                  (this.started = !1),
                  this.removeAllListeners(),
                  this.mainHelper.removeAllListeners(),
                  (this.mainHelper = null),
                  (this.helper = null),
                  this.middleware.forEach(function (e) {
                    e.instance.unsubscribe();
                  });
              },
            },
            {
              key: "scheduleStalledRender",
              value: function () {
                var e = this;
                this._searchStalledTimer ||
                  (this._searchStalledTimer = setTimeout(function () {
                    (e.status = "stalled"), e.scheduleRender();
                  }, this._stalledSearchDelay));
              },
            },
            {
              key: "setUiState",
              value: function (e) {
                var t = this,
                  r =
                    !(arguments.length > 1 && void 0 !== arguments[1]) ||
                    arguments[1];
                if (!this.mainHelper)
                  throw new Error(
                    R(
                      "The `start` method needs to be called before `setUiState`."
                    )
                  );
                this.mainIndex.refreshUiState();
                var n =
                  "function" == typeof e
                    ? e(this.mainIndex.getWidgetUiState({}))
                    : e;
                this.onStateChange && r
                  ? this.onStateChange({
                      uiState: n,
                      setUiState: function (e) {
                        (0, w.setIndexHelperState)(
                          "function" == typeof e ? e(n) : e,
                          t.mainIndex
                        ),
                          t.scheduleSearch(),
                          t.onInternalStateChange();
                      },
                    })
                  : ((0, w.setIndexHelperState)(n, this.mainIndex),
                    this.scheduleSearch(),
                    this.onInternalStateChange());
              },
            },
            {
              key: "getUiState",
              value: function () {
                return (
                  this.started && this.mainIndex.refreshUiState(),
                  this.mainIndex.getWidgetUiState({})
                );
              },
            },
            {
              key: "createURL",
              value: function () {
                var e =
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : {};
                if (!this.started)
                  throw new Error(
                    R(
                      "The `start` method needs to be called before `createURL`."
                    )
                  );
                return this._createURL(e);
              },
            },
            {
              key: "refresh",
              value: function () {
                if (!this.mainHelper)
                  throw new Error(
                    R("The `start` method needs to be called before `refresh`.")
                  );
                this.mainHelper.clearCache().search();
              },
            },
          ]),
          t
        );
      })(_.default),
      k = x;
    t.default = k;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t, r) {
      "function" == typeof e.addAlgoliaAgent &&
        e.addAlgoliaAgent("JS Helper (" + v + ")"),
        this.setClient(e);
      var n = r || {};
      (n.index = t),
        (this.state = a.make(n)),
        (this.lastResults = null),
        (this._queryId = 0),
        (this._lastQueryIdReceived = -1),
        (this.derivedHelpers = []),
        (this._currentNbQueries = 0);
    }
    function i(e) {
      if (e < 0) throw new Error("Page requested below 0.");
      return (
        this._change({ state: this.state.setPage(e), isPageReset: !1 }), this
      );
    }
    function o() {
      return this.state.page;
    }
    var a = r(36),
      s = r(37),
      c = r(101),
      u = r(102),
      l = r(28),
      f = r(40),
      d = r(26),
      p = r(25),
      h = r(15),
      v = r(41),
      m = r(27).escapeFacetValue;
    f(n, l),
      (n.prototype.search = function () {
        return this._search({ onlyWithDerivedHelpers: !1 }), this;
      }),
      (n.prototype.searchOnlyWithDerivedHelpers = function () {
        return this._search({ onlyWithDerivedHelpers: !0 }), this;
      }),
      (n.prototype.getQuery = function () {
        var e = this.state;
        return u._getHitsSearchParams(e);
      }),
      (n.prototype.searchOnce = function (e, t) {
        var r = e ? this.state.setQueryParameters(e) : this.state,
          n = u._getQueries(r.index, r),
          i = this;
        return (
          this._currentNbQueries++,
          this.emit("searchOnce", { state: r }),
          t
            ? void this.client
                .search(n)
                .then(function (e) {
                  i._currentNbQueries--,
                    0 === i._currentNbQueries && i.emit("searchQueueEmpty"),
                    t(null, new s(r, e.results), r);
                })
                .catch(function (e) {
                  i._currentNbQueries--,
                    0 === i._currentNbQueries && i.emit("searchQueueEmpty"),
                    t(e, null, r);
                })
            : this.client.search(n).then(
                function (e) {
                  return (
                    i._currentNbQueries--,
                    0 === i._currentNbQueries && i.emit("searchQueueEmpty"),
                    {
                      content: new s(r, e.results),
                      state: r,
                      _originalResponse: e,
                    }
                  );
                },
                function (e) {
                  throw (
                    (i._currentNbQueries--,
                    0 === i._currentNbQueries && i.emit("searchQueueEmpty"),
                    e)
                  );
                }
              )
        );
      }),
      (n.prototype.findAnswers = function (e) {
        var t = this.state,
          r = this.derivedHelpers[0];
        if (!r) return Promise.resolve([]);
        var n = r.getModifiedState(t),
          i = h(
            {
              attributesForPrediction: e.attributesForPrediction,
              nbHits: e.nbHits,
            },
            {
              params: p(u._getHitsSearchParams(n), [
                "attributesToSnippet",
                "hitsPerPage",
                "restrictSearchableAttributes",
                "snippetEllipsisText",
              ]),
            }
          ),
          o =
            "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
        if ("function" != typeof this.client.initIndex) throw new Error(o);
        var a = this.client.initIndex(n.index);
        if ("function" != typeof a.findAnswers) throw new Error(o);
        return a.findAnswers(n.query, e.queryLanguages, i);
      }),
      (n.prototype.searchForFacetValues = function (e, t, r, n) {
        var i = "function" == typeof this.client.searchForFacetValues,
          o = "function" == typeof this.client.initIndex;
        if (!i && !o && "function" != typeof this.client.search)
          throw new Error(
            "search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues"
          );
        var a = this.state.setQueryParameters(n || {}),
          s = a.isDisjunctiveFacet(e),
          c = u.getSearchForFacetQuery(e, t, r, a);
        this._currentNbQueries++;
        var l,
          f = this;
        return (
          i
            ? (l = this.client.searchForFacetValues([
                { indexName: a.index, params: c },
              ]))
            : o
            ? (l = this.client.initIndex(a.index).searchForFacetValues(c))
            : (delete c.facetName,
              (l = this.client
                .search([
                  { type: "facet", facet: e, indexName: a.index, params: c },
                ])
                .then(function (e) {
                  return e.results[0];
                }))),
          this.emit("searchForFacetValues", { state: a, facet: e, query: t }),
          l.then(
            function (t) {
              return (
                f._currentNbQueries--,
                0 === f._currentNbQueries && f.emit("searchQueueEmpty"),
                (t = Array.isArray(t) ? t[0] : t),
                t.facetHits.forEach(function (t) {
                  (t.escapedValue = m(t.value)),
                    (t.isRefined = s
                      ? a.isDisjunctiveFacetRefined(e, t.escapedValue)
                      : a.isFacetRefined(e, t.escapedValue));
                }),
                t
              );
            },
            function (e) {
              throw (
                (f._currentNbQueries--,
                0 === f._currentNbQueries && f.emit("searchQueueEmpty"),
                e)
              );
            }
          )
        );
      }),
      (n.prototype.setQuery = function (e) {
        return (
          this._change({
            state: this.state.resetPage().setQuery(e),
            isPageReset: !0,
          }),
          this
        );
      }),
      (n.prototype.clearRefinements = function (e) {
        return (
          this._change({
            state: this.state.resetPage().clearRefinements(e),
            isPageReset: !0,
          }),
          this
        );
      }),
      (n.prototype.clearTags = function () {
        return (
          this._change({
            state: this.state.resetPage().clearTags(),
            isPageReset: !0,
          }),
          this
        );
      }),
      (n.prototype.addDisjunctiveFacetRefinement = function (e, t) {
        return (
          this._change({
            state: this.state.resetPage().addDisjunctiveFacetRefinement(e, t),
            isPageReset: !0,
          }),
          this
        );
      }),
      (n.prototype.addDisjunctiveRefine = function () {
        return this.addDisjunctiveFacetRefinement.apply(this, arguments);
      }),
      (n.prototype.addHierarchicalFacetRefinement = function (e, t) {
        return (
          this._change({
            state: this.state.resetPage().addHierarchicalFacetRefinement(e, t),
            isPageReset: !0,
          }),
          this
        );
      }),
      (n.prototype.addNumericRefinement = function (e, t, r) {
        return (
          this._change({
            state: this.state.resetPage().addNumericRefinement(e, t, r),
            isPageReset: !0,
          }),
          this
        );
      }),
      (n.prototype.addFacetRefinement = function (e, t) {
        return (
          this._change({
            state: this.state.resetPage().addFacetRefinement(e, t),
            isPageReset: !0,
          }),
          this
        );
      }),
      (n.prototype.addRefine = function () {
        return this.addFacetRefinement.apply(this, arguments);
      }),
      (n.prototype.addFacetExclusion = function (e, t) {
        return (
          this._change({
            state: this.state.resetPage().addExcludeRefinement(e, t),
            isPageReset: !0,
          }),
          this
        );
      }),
      (n.prototype.addExclude = function () {
        return this.addFacetExclusion.apply(this, arguments);
      }),
      (n.prototype.addTag = function (e) {
        return (
          this._change({
            state: this.state.resetPage().addTagRefinement(e),
            isPageReset: !0,
          }),
          this
        );
      }),
      (n.prototype.removeNumericRefinement = function (e, t, r) {
        return (
          this._change({
            state: this.state.resetPage().removeNumericRefinement(e, t, r),
            isPageReset: !0,
          }),
          this
        );
      }),
      (n.prototype.removeDisjunctiveFacetRefinement = function (e, t) {
        return (
          this._change({
            state: this.state
              .resetPage()
              .removeDisjunctiveFacetRefinement(e, t),
            isPageReset: !0,
          }),
          this
        );
      }),
      (n.prototype.removeDisjunctiveRefine = function () {
        return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
      }),
      (n.prototype.removeHierarchicalFacetRefinement = function (e) {
        return (
          this._change({
            state: this.state.resetPage().removeHierarchicalFacetRefinement(e),
            isPageReset: !0,
          }),
          this
        );
      }),
      (n.prototype.removeFacetRefinement = function (e, t) {
        return (
          this._change({
            state: this.state.resetPage().removeFacetRefinement(e, t),
            isPageReset: !0,
          }),
          this
        );
      }),
      (n.prototype.removeRefine = function () {
        return this.removeFacetRefinement.apply(this, arguments);
      }),
      (n.prototype.removeFacetExclusion = function (e, t) {
        return (
          this._change({
            state: this.state.resetPage().removeExcludeRefinement(e, t),
            isPageReset: !0,
          }),
          this
        );
      }),
      (n.prototype.removeExclude = function () {
        return this.removeFacetExclusion.apply(this, arguments);
      }),
      (n.prototype.removeTag = function (e) {
        return (
          this._change({
            state: this.state.resetPage().removeTagRefinement(e),
            isPageReset: !0,
          }),
          this
        );
      }),
      (n.prototype.toggleFacetExclusion = function (e, t) {
        return (
          this._change({
            state: this.state.resetPage().toggleExcludeFacetRefinement(e, t),
            isPageReset: !0,
          }),
          this
        );
      }),
      (n.prototype.toggleExclude = function () {
        return this.toggleFacetExclusion.apply(this, arguments);
      }),
      (n.prototype.toggleRefinement = function (e, t) {
        return this.toggleFacetRefinement(e, t);
      }),
      (n.prototype.toggleFacetRefinement = function (e, t) {
        return (
          this._change({
            state: this.state.resetPage().toggleFacetRefinement(e, t),
            isPageReset: !0,
          }),
          this
        );
      }),
      (n.prototype.toggleRefine = function () {
        return this.toggleFacetRefinement.apply(this, arguments);
      }),
      (n.prototype.toggleTag = function (e) {
        return (
          this._change({
            state: this.state.resetPage().toggleTagRefinement(e),
            isPageReset: !0,
          }),
          this
        );
      }),
      (n.prototype.nextPage = function () {
        var e = this.state.page || 0;
        return this.setPage(e + 1);
      }),
      (n.prototype.previousPage = function () {
        var e = this.state.page || 0;
        return this.setPage(e - 1);
      }),
      (n.prototype.setCurrentPage = i),
      (n.prototype.setPage = i),
      (n.prototype.setIndex = function (e) {
        return (
          this._change({
            state: this.state.resetPage().setIndex(e),
            isPageReset: !0,
          }),
          this
        );
      }),
      (n.prototype.setQueryParameter = function (e, t) {
        return (
          this._change({
            state: this.state.resetPage().setQueryParameter(e, t),
            isPageReset: !0,
          }),
          this
        );
      }),
      (n.prototype.setState = function (e) {
        return this._change({ state: a.make(e), isPageReset: !1 }), this;
      }),
      (n.prototype.overrideStateWithoutTriggeringChangeEvent = function (e) {
        return (this.state = new a(e)), this;
      }),
      (n.prototype.hasRefinements = function (e) {
        return (
          !!d(this.state.getNumericRefinements(e)) ||
          (this.state.isConjunctiveFacet(e)
            ? this.state.isFacetRefined(e)
            : this.state.isDisjunctiveFacet(e)
            ? this.state.isDisjunctiveFacetRefined(e)
            : !!this.state.isHierarchicalFacet(e) &&
              this.state.isHierarchicalFacetRefined(e))
        );
      }),
      (n.prototype.isExcluded = function (e, t) {
        return this.state.isExcludeRefined(e, t);
      }),
      (n.prototype.isDisjunctiveRefined = function (e, t) {
        return this.state.isDisjunctiveFacetRefined(e, t);
      }),
      (n.prototype.hasTag = function (e) {
        return this.state.isTagRefined(e);
      }),
      (n.prototype.isTagRefined = function () {
        return this.hasTagRefinements.apply(this, arguments);
      }),
      (n.prototype.getIndex = function () {
        return this.state.index;
      }),
      (n.prototype.getCurrentPage = o),
      (n.prototype.getPage = o),
      (n.prototype.getTags = function () {
        return this.state.tagRefinements;
      }),
      (n.prototype.getRefinements = function (e) {
        var t = [];
        if (this.state.isConjunctiveFacet(e))
          this.state.getConjunctiveRefinements(e).forEach(function (e) {
            t.push({ value: e, type: "conjunctive" });
          }),
            this.state.getExcludeRefinements(e).forEach(function (e) {
              t.push({ value: e, type: "exclude" });
            });
        else if (this.state.isDisjunctiveFacet(e)) {
          var r = this.state.getDisjunctiveRefinements(e);
          r.forEach(function (e) {
            t.push({ value: e, type: "disjunctive" });
          });
        }
        var n = this.state.getNumericRefinements(e);
        return (
          Object.keys(n).forEach(function (e) {
            var r = n[e];
            t.push({ value: r, operator: e, type: "numeric" });
          }),
          t
        );
      }),
      (n.prototype.getNumericRefinement = function (e, t) {
        return this.state.getNumericRefinement(e, t);
      }),
      (n.prototype.getHierarchicalFacetBreadcrumb = function (e) {
        return this.state.getHierarchicalFacetBreadcrumb(e);
      }),
      (n.prototype._search = function (e) {
        var t = this.state,
          r = [],
          n = [];
        e.onlyWithDerivedHelpers ||
          ((n = u._getQueries(t.index, t)),
          r.push({ state: t, queriesCount: n.length, helper: this }),
          this.emit("search", { state: t, results: this.lastResults }));
        var i = this.derivedHelpers.map(function (e) {
            var n = e.getModifiedState(t),
              i = u._getQueries(n.index, n);
            return (
              r.push({ state: n, queriesCount: i.length, helper: e }),
              e.emit("search", { state: n, results: e.lastResults }),
              i
            );
          }),
          o = Array.prototype.concat.apply(n, i),
          a = this._queryId++;
        this._currentNbQueries++;
        try {
          this.client
            .search(o)
            .then(this._dispatchAlgoliaResponse.bind(this, r, a))
            .catch(this._dispatchAlgoliaError.bind(this, a));
        } catch (e) {
          this.emit("error", { error: e });
        }
      }),
      (n.prototype._dispatchAlgoliaResponse = function (e, t, r) {
        if (!(t < this._lastQueryIdReceived)) {
          (this._currentNbQueries -= t - this._lastQueryIdReceived),
            (this._lastQueryIdReceived = t),
            0 === this._currentNbQueries && this.emit("searchQueueEmpty");
          var n = r.results.slice();
          e.forEach(function (e) {
            var t = e.state,
              r = e.queriesCount,
              i = e.helper,
              o = n.splice(0, r),
              a = (i.lastResults = new s(t, o));
            i.emit("result", { results: a, state: t });
          });
        }
      }),
      (n.prototype._dispatchAlgoliaError = function (e, t) {
        e < this._lastQueryIdReceived ||
          ((this._currentNbQueries -= e - this._lastQueryIdReceived),
          (this._lastQueryIdReceived = e),
          this.emit("error", { error: t }),
          0 === this._currentNbQueries && this.emit("searchQueueEmpty"));
      }),
      (n.prototype.containsRefinement = function (e, t, r, n) {
        return e || 0 !== t.length || 0 !== r.length || 0 !== n.length;
      }),
      (n.prototype._hasDisjunctiveRefinements = function (e) {
        return (
          this.state.disjunctiveRefinements[e] &&
          this.state.disjunctiveRefinements[e].length > 0
        );
      }),
      (n.prototype._change = function (e) {
        var t = e.state,
          r = e.isPageReset;
        t !== this.state &&
          ((this.state = t),
          this.emit("change", {
            state: this.state,
            results: this.lastResults,
            isPageReset: r,
          }));
      }),
      (n.prototype.clearCache = function () {
        return this.client.clearCache && this.client.clearCache(), this;
      }),
      (n.prototype.setClient = function (e) {
        return this.client === e
          ? this
          : ("function" == typeof e.addAlgoliaAgent &&
              e.addAlgoliaAgent("JS Helper (" + v + ")"),
            (this.client = e),
            this);
      }),
      (n.prototype.getClient = function () {
        return this.client;
      }),
      (n.prototype.derive = function (e) {
        var t = new c(this, e);
        return this.derivedHelpers.push(t), t;
      }),
      (n.prototype.detachDerivedHelper = function (e) {
        var t = this.derivedHelpers.indexOf(e);
        if (-1 === t) throw new Error("Derived helper already detached");
        this.derivedHelpers.splice(t, 1);
      }),
      (n.prototype.hasPendingRequests = function () {
        return this._currentNbQueries > 0;
      }),
      (e.exports = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      return e.filter(function (r, n) {
        return t.indexOf(r) > -1 && e.indexOf(r) === n;
      });
    }
    e.exports = n;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      if ("number" == typeof e) return e;
      if ("string" == typeof e) return parseFloat(e);
      if (Array.isArray(e)) return e.map(n);
      throw new Error(
        "The value should be a number, a parsable string or an array of those."
      );
    }
    e.exports = n;
  },
  function (e, t, r) {
    "use strict";
    e.exports = function (e) {
      return null !== e && /^[a-zA-Z0-9_-]{1,64}$/.test(e);
    };
  },
  function (e, t, r) {
    "use strict";
    var n = r(24),
      i = r(25),
      o = r(26),
      a = {
        addRefinement: function (e, t, r) {
          if (a.isRefined(e, t, r)) return e;
          var i = "" + r,
            o = e[t] ? e[t].concat(i) : [i],
            s = {};
          return (s[t] = o), n({}, s, e);
        },
        removeRefinement: function (e, t, r) {
          if (void 0 === r)
            return a.clearRefinement(e, function (e, r) {
              return t === r;
            });
          var n = "" + r;
          return a.clearRefinement(e, function (e, r) {
            return t === r && n === e;
          });
        },
        toggleRefinement: function (e, t, r) {
          if (void 0 === r)
            throw new Error("toggleRefinement should be used with a value");
          return a.isRefined(e, t, r)
            ? a.removeRefinement(e, t, r)
            : a.addRefinement(e, t, r);
        },
        clearRefinement: function (e, t, r) {
          if (void 0 === t) return o(e) ? {} : e;
          if ("string" == typeof t) return i(e, [t]);
          if ("function" == typeof t) {
            var n = !1,
              a = Object.keys(e).reduce(function (i, o) {
                var a = e[o] || [],
                  s = a.filter(function (e) {
                    return !t(e, o, r);
                  });
                return s.length !== a.length && (n = !0), (i[o] = s), i;
              }, {});
            return n ? a : e;
          }
        },
        isRefined: function (e, t, r) {
          var n = !!e[t] && e[t].length > 0;
          if (void 0 === r || !n) return n;
          var i = "" + r;
          return -1 !== e[t].indexOf(i);
        },
      };
    e.exports = a;
  },
  function (e, t, r) {
    "use strict";
    e.exports = function (e) {
      return Array.isArray(e) ? e.filter(Boolean) : [];
    };
  },
  function (e, t, r) {
    "use strict";
    e.exports = function (e, t) {
      if (!Array.isArray(e)) return -1;
      for (var r = 0; r < e.length; r++) if (t(e[r])) return r;
      return -1;
    };
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return function (t, r) {
        var n = e.hierarchicalFacets[r],
          o =
            (e.hierarchicalFacetsRefinements[n.name] &&
              e.hierarchicalFacetsRefinements[n.name][0]) ||
            "",
          a = e._getHierarchicalFacetSeparator(n),
          s = e._getHierarchicalRootPath(n),
          c = e._getHierarchicalShowParentLevel(n),
          l = u(e._getHierarchicalFacetSortBy(n)),
          f = t.every(function (e) {
            return e.exhaustive;
          }),
          d = i(l, a, s, c, o),
          p = t;
        return (
          s && (p = t.slice(s.split(a).length)),
          p.reduce(d, {
            name: e.hierarchicalFacets[r].name,
            count: null,
            isRefined: !0,
            path: null,
            escapedValue: null,
            exhaustive: f,
            data: null,
          })
        );
      };
    }
    function i(e, t, r, n, i) {
      return function (u, l, f) {
        var p = u;
        if (f > 0) {
          var h = 0;
          for (p = u; h < f; ) {
            var v = p && Array.isArray(p.data) ? p.data : [];
            (p = c(v, function (e) {
              return e.isRefined;
            })),
              h++;
          }
        }
        if (p) {
          var m = Object.keys(l.data)
            .map(function (e) {
              return [e, l.data[e]];
            })
            .filter(function (e) {
              return o(e[0], p.path || r, i, t, r, n);
            });
          p.data = s(
            m.map(function (e) {
              var r = e[0];
              return a(e[1], r, t, d(i), l.exhaustive);
            }),
            e[0],
            e[1]
          );
        }
        return u;
      };
    }
    function o(e, t, r, n, i, o) {
      return (
        (!i || (0 === e.indexOf(i) && i !== e)) &&
        ((!i && -1 === e.indexOf(n)) ||
          (i && e.split(n).length - i.split(n).length == 1) ||
          (-1 === e.indexOf(n) && -1 === r.indexOf(n)) ||
          0 === r.indexOf(e) ||
          (0 === e.indexOf(t + n) && (o || 0 === e.indexOf(r))))
      );
    }
    function a(e, t, r, n, i) {
      var o = t.split(r);
      return {
        name: o[o.length - 1].trim(),
        path: t,
        escapedValue: f(t),
        count: e,
        isRefined: n === t || 0 === n.indexOf(t + r),
        exhaustive: i,
        data: null,
      };
    }
    e.exports = n;
    var s = r(38),
      c = r(16),
      u = r(39),
      l = r(27),
      f = l.escapeFacetValue,
      d = l.unescapeFacetValue;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      (this.main = e), (this.fn = t), (this.lastResults = null);
    }
    var i = r(28);
    r(40)(n, i),
      (n.prototype.detach = function () {
        this.removeAllListeners(), this.main.detachDerivedHelper(this);
      }),
      (n.prototype.getModifiedState = function (e) {
        return this.fn(e);
      }),
      (e.exports = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return Object.keys(e)
        .sort(function (e, t) {
          return e.localeCompare(t);
        })
        .reduce(function (t, r) {
          return (t[r] = e[r]), t;
        }, {});
    }
    var i = r(15),
      o = {
        _getQueries: function (e, t) {
          var r = [];
          return (
            r.push({ indexName: e, params: o._getHitsSearchParams(t) }),
            t.getRefinedDisjunctiveFacets().forEach(function (n) {
              r.push({
                indexName: e,
                params: o._getDisjunctiveFacetSearchParams(t, n),
              });
            }),
            t.getRefinedHierarchicalFacets().forEach(function (n) {
              var i = t.getHierarchicalFacetByName(n),
                a = t.getHierarchicalRefinement(n),
                s = t._getHierarchicalFacetSeparator(i);
              if (a.length > 0 && a[0].split(s).length > 1) {
                var c = a[0]
                  .split(s)
                  .slice(0, -1)
                  .reduce(function (e, t, r) {
                    return e.concat({
                      attribute: i.attributes[r],
                      value: 0 === r ? t : [e[e.length - 1].value, t].join(s),
                    });
                  }, []);
                c.forEach(function (n, a) {
                  function s(e) {
                    return i.attributes.some(function (t) {
                      return t === e.split(":")[0];
                    });
                  }
                  var u = o._getDisjunctiveFacetSearchParams(
                      t,
                      n.attribute,
                      0 === a
                    ),
                    l = (u.facetFilters || []).reduce(function (e, t) {
                      if (Array.isArray(t)) {
                        var r = t.filter(function (e) {
                          return !s(e);
                        });
                        r.length > 0 && e.push(r);
                      }
                      return "string" != typeof t || s(t) || e.push(t), e;
                    }, []),
                    f = c[a - 1];
                  (u.facetFilters =
                    a > 0
                      ? l.concat(f.attribute + ":" + f.value)
                      : l.length > 0
                      ? l
                      : void 0),
                    r.push({ indexName: e, params: u });
                });
              }
            }),
            r
          );
        },
        _getHitsSearchParams: function (e) {
          var t = e.facets
              .concat(e.disjunctiveFacets)
              .concat(o._getHitsHierarchicalFacetsAttributes(e)),
            r = o._getFacetFilters(e),
            a = o._getNumericFilters(e),
            s = o._getTagFilters(e),
            c = { facets: t.indexOf("*") > -1 ? ["*"] : t, tagFilters: s };
          return (
            r.length > 0 && (c.facetFilters = r),
            a.length > 0 && (c.numericFilters = a),
            n(i({}, e.getQueryParams(), c))
          );
        },
        _getDisjunctiveFacetSearchParams: function (e, t, r) {
          var a = o._getFacetFilters(e, t, r),
            s = o._getNumericFilters(e, t),
            c = o._getTagFilters(e),
            u = { hitsPerPage: 0, page: 0, analytics: !1, clickAnalytics: !1 };
          c.length > 0 && (u.tagFilters = c);
          var l = e.getHierarchicalFacetByName(t);
          return (
            (u.facets = l
              ? o._getDisjunctiveHierarchicalFacetAttribute(e, l, r)
              : t),
            s.length > 0 && (u.numericFilters = s),
            a.length > 0 && (u.facetFilters = a),
            n(i({}, e.getQueryParams(), u))
          );
        },
        _getNumericFilters: function (e, t) {
          if (e.numericFilters) return e.numericFilters;
          var r = [];
          return (
            Object.keys(e.numericRefinements).forEach(function (n) {
              var i = e.numericRefinements[n] || {};
              Object.keys(i).forEach(function (e) {
                var o = i[e] || [];
                t !== n &&
                  o.forEach(function (t) {
                    if (Array.isArray(t)) {
                      var i = t.map(function (t) {
                        return n + e + t;
                      });
                      r.push(i);
                    } else r.push(n + e + t);
                  });
              });
            }),
            r
          );
        },
        _getTagFilters: function (e) {
          return e.tagFilters ? e.tagFilters : e.tagRefinements.join(",");
        },
        _getFacetFilters: function (e, t, r) {
          var n = [],
            i = e.facetsRefinements || {};
          Object.keys(i).forEach(function (e) {
            (i[e] || []).forEach(function (t) {
              n.push(e + ":" + t);
            });
          });
          var o = e.facetsExcludes || {};
          Object.keys(o).forEach(function (e) {
            (o[e] || []).forEach(function (t) {
              n.push(e + ":-" + t);
            });
          });
          var a = e.disjunctiveFacetsRefinements || {};
          Object.keys(a).forEach(function (e) {
            var r = a[e] || [];
            if (e !== t && r && 0 !== r.length) {
              var i = [];
              r.forEach(function (t) {
                i.push(e + ":" + t);
              }),
                n.push(i);
            }
          });
          var s = e.hierarchicalFacetsRefinements || {};
          return (
            Object.keys(s).forEach(function (i) {
              var o = s[i] || [],
                a = o[0];
              if (void 0 !== a) {
                var c,
                  u,
                  l = e.getHierarchicalFacetByName(i),
                  f = e._getHierarchicalFacetSeparator(l),
                  d = e._getHierarchicalRootPath(l);
                if (t === i) {
                  if (
                    -1 === a.indexOf(f) ||
                    (!d && !0 === r) ||
                    (d && d.split(f).length === a.split(f).length)
                  )
                    return;
                  d
                    ? ((u = d.split(f).length - 1), (a = d))
                    : ((u = a.split(f).length - 2),
                      (a = a.slice(0, a.lastIndexOf(f)))),
                    (c = l.attributes[u]);
                } else (u = a.split(f).length - 1), (c = l.attributes[u]);
                c && n.push([c + ":" + a]);
              }
            }),
            n
          );
        },
        _getHitsHierarchicalFacetsAttributes: function (e) {
          var t = [];
          return e.hierarchicalFacets.reduce(function (t, r) {
            var n = e.getHierarchicalRefinement(r.name)[0];
            if (!n) return t.push(r.attributes[0]), t;
            var i = e._getHierarchicalFacetSeparator(r),
              o = n.split(i).length,
              a = r.attributes.slice(0, o + 1);
            return t.concat(a);
          }, t);
        },
        _getDisjunctiveHierarchicalFacetAttribute: function (e, t, r) {
          var n = e._getHierarchicalFacetSeparator(t);
          if (!0 === r) {
            var i = e._getHierarchicalRootPath(t),
              o = 0;
            return i && (o = i.split(n).length), [t.attributes[o]];
          }
          var a = e.getHierarchicalRefinement(t.name)[0] || "",
            s = a.split(n).length - 1;
          return t.attributes.slice(0, s + 1);
        },
        getSearchForFacetQuery: function (e, t, r, a) {
          var s = a.isDisjunctiveFacet(e) ? a.clearRefinements(e) : a,
            c = { facetQuery: t, facetName: e };
          return (
            "number" == typeof r && (c.maxFacetHits = r),
            n(i({}, o._getHitsSearchParams(s), c))
          );
        },
      };
    e.exports = o;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e) {
      return l(e) || u(e) || c(e) || s();
    }
    function s() {
      throw new TypeError(
        "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function c(e, t) {
      if (e) {
        if ("string" == typeof e) return f(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? f(e, t)
            : void 0
        );
      }
    }
    function u(e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e))
        return Array.from(e);
    }
    function l(e) {
      if (Array.isArray(e)) return f(e);
    }
    function f(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function d(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = p(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (n = 0; n < o.length; n++)
          (r = o[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function p(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    function h(e, t) {
      var r = t.state,
        n = t.isPageReset,
        i = t._uiState;
      r !== e.state &&
        ((e.state = r),
        e.emit("change", {
          state: e.state,
          results: e.lastResults,
          isPageReset: n,
          _uiState: i,
        }));
    }
    function v(e, t) {
      var r =
        arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      return e.reduce(function (e, r) {
        return (0, j.isIndexWidget)(r)
          ? e
          : r.getWidgetUiState || r.getWidgetState
          ? r.getWidgetUiState
            ? r.getWidgetUiState(e, t)
            : r.getWidgetState(e, t)
          : e;
      }, r);
    }
    function m(e, t) {
      var r = t.initialSearchParameters,
        n = d(t, ["initialSearchParameters"]);
      return e
        .filter(function (e) {
          return !(0, j.isIndexWidget)(e);
        })
        .reduce(function (e, t) {
          return t.getWidgetSearchParameters
            ? t.getWidgetSearchParameters(e, n)
            : e;
        }, r);
    }
    function g(e) {
      var t = e.filter(j.isIndexWidget);
      0 !== t.length &&
        t.forEach(function (e) {
          var t = e.getHelper();
          h(t, { state: t.state.resetPage(), isPageReset: !0 }),
            g(e.getWidgets());
        });
    }
    function y(e) {
      return e.filter(j.isIndexWidget).reduce(function (e, t) {
        return e.concat.apply(
          e,
          [
            {
              indexId: t.getIndexId(),
              results: t.getResults(),
              helper: t.getHelper(),
            },
          ].concat(a(y(t.getWidgets())))
        );
      }, []);
    }
    function b(e) {
      var t = e.renderState,
        r = e.instantSearchInstance,
        n = e.parent,
        a = n ? n.getIndexId() : r.mainIndex.getIndexId();
      r.renderState = i(
        i({}, r.renderState),
        {},
        o({}, a, i(i({}, r.renderState[a]), t))
      );
    }
    var _ = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var O = _(r(23)),
      j = r(1),
      P = (0, j.createDocumentationMessageGenerator)({ name: "index-widget" }),
      w = function (e) {
        if (void 0 === e || void 0 === e.indexName)
          throw new Error(P("The `indexName` option is required."));
        var t = e.indexName,
          r = e.indexId,
          n = void 0 === r ? t : r,
          s = [],
          c = {},
          u = null,
          l = null,
          f = null,
          d = null;
        return {
          $$type: "ais.index",
          $$widgetType: "ais.index",
          getIndexName: function () {
            return t;
          },
          getIndexId: function () {
            return n;
          },
          getHelper: function () {
            return f;
          },
          getResults: function () {
            return d && d.lastResults;
          },
          getScopedResults: function () {
            var e = this.getParent();
            return y(e ? e.getWidgets() : [this]);
          },
          getParent: function () {
            return l;
          },
          createURL: function (e) {
            return u._createURL(
              o({}, n, v(s, { searchParameters: e, helper: f }))
            );
          },
          getWidgets: function () {
            return s;
          },
          addWidgets: function (e) {
            var t = this;
            if (!Array.isArray(e))
              throw new Error(
                P("The `addWidgets` method expects an array of widgets.")
              );
            if (
              e.some(function (e) {
                return (
                  "function" != typeof e.init && "function" != typeof e.render
                );
              })
            )
              throw new Error(
                P(
                  "The widget definition expects a `render` and/or an `init` method."
                )
              );
            return (
              (s = s.concat(e)),
              u &&
                Boolean(e.length) &&
                (h(f, {
                  state: m(s, { uiState: c, initialSearchParameters: f.state }),
                  _uiState: c,
                }),
                e.forEach(function (e) {
                  e.getRenderState &&
                    b({
                      renderState: e.getRenderState(
                        u.renderState[t.getIndexId()] || {},
                        (0, j.createInitArgs)(u, t, u._initialUiState)
                      ),
                      instantSearchInstance: u,
                      parent: t,
                    });
                }),
                e.forEach(function (e) {
                  e.init &&
                    e.init((0, j.createInitArgs)(u, t, u._initialUiState));
                }),
                u.scheduleSearch()),
              this
            );
          },
          removeWidgets: function (e) {
            var t = this;
            if (!Array.isArray(e))
              throw new Error(
                P("The `removeWidgets` method expects an array of widgets.")
              );
            if (
              e.some(function (e) {
                return "function" != typeof e.dispose;
              })
            )
              throw new Error(
                P("The widget definition expects a `dispose` method.")
              );
            if (
              ((s = s.filter(function (t) {
                return -1 === e.indexOf(t);
              })),
              u && Boolean(e.length))
            ) {
              var r = e.reduce(function (e, r) {
                return r.dispose({ helper: f, state: e, parent: t }) || e;
              }, f.state);
              (c = v(s, { searchParameters: r, helper: f })),
                f.setState(m(s, { uiState: c, initialSearchParameters: r })),
                s.length && u.scheduleSearch();
            }
            return this;
          },
          init: function (e) {
            var r,
              i = this,
              o = e.instantSearchInstance,
              p = e.parent,
              h = e.uiState;
            if (null === f) {
              (u = o), (l = p), (c = h[n] || {});
              var y = o.mainHelper,
                _ = m(s, {
                  uiState: c,
                  initialSearchParameters: new O.default.SearchParameters({
                    index: t,
                  }),
                });
              (f = (0, O.default)({}, _.index, _)),
                (f.search = function () {
                  return o.onStateChange
                    ? (o.onStateChange({
                        uiState: o.mainIndex.getWidgetUiState({}),
                        setUiState: function (e) {
                          return o.setUiState(e, !1);
                        },
                      }),
                      y)
                    : y.search();
                }),
                (f.searchWithoutTriggeringOnStateChange = function () {
                  return y.search();
                }),
                (f.searchForFacetValues = function (e, t, r, n) {
                  var i = f.state.setQueryParameters(n);
                  return y.searchForFacetValues(e, t, r, i);
                }),
                (d = y.derive(function () {
                  return j.mergeSearchParameters.apply(
                    void 0,
                    a((0, j.resolveSearchParameters)(i))
                  );
                }));
              var P =
                null === (r = o._initialResults) || void 0 === r
                  ? void 0
                  : r[this.getIndexId()];
              if (P) {
                var w = new O.default.SearchResults(
                  new O.default.SearchParameters(P.state),
                  P.results
                );
                (d.lastResults = w), (f.lastResults = w);
              }
              f.on("change", function (e) {
                e.isPageReset && g(s);
              }),
                d.on("search", function () {
                  o.scheduleStalledRender();
                }),
                d.on("result", function (e) {
                  var t = e.results;
                  o.scheduleRender(), (f.lastResults = t);
                }),
                s.forEach(function (e) {
                  e.getRenderState &&
                    b({
                      renderState: e.getRenderState(
                        o.renderState[i.getIndexId()] || {},
                        (0, j.createInitArgs)(o, i, h)
                      ),
                      instantSearchInstance: o,
                      parent: i,
                    });
                }),
                s.forEach(function (e) {
                  e.init && e.init((0, j.createInitArgs)(o, i, h));
                }),
                f.on("change", function (e) {
                  var t = e.state,
                    r = e._uiState;
                  (c = v(s, { searchParameters: t, helper: f }, r || {})),
                    o.onStateChange || o.onInternalStateChange();
                }),
                P && o.scheduleRender();
            }
          },
          render: function (e) {
            var t = this,
              r = e.instantSearchInstance;
            this.getResults() &&
              (s.forEach(function (e) {
                e.getRenderState &&
                  b({
                    renderState: e.getRenderState(
                      r.renderState[t.getIndexId()] || {},
                      (0, j.createRenderArgs)(r, t)
                    ),
                    instantSearchInstance: r,
                    parent: t,
                  });
              }),
              s.forEach(function (e) {
                e.render && e.render((0, j.createRenderArgs)(r, t));
              }));
          },
          dispose: function () {
            var e = this;
            s.forEach(function (t) {
              t.dispose && t.dispose({ helper: f, state: f.state, parent: e });
            }),
              (u = null),
              (l = null),
              f.removeAllListeners(),
              (f = null),
              d.detach(),
              (d = null);
          },
          getWidgetUiState: function (e) {
            return s.filter(j.isIndexWidget).reduce(function (e, t) {
              return t.getWidgetUiState(e);
            }, i(i({}, e), {}, o({}, n, i(i({}, e[n]), c))));
          },
          getWidgetState: function (e) {
            return this.getWidgetUiState(e);
          },
          getWidgetSearchParameters: function (e, t) {
            var r = t.uiState;
            return m(s, { uiState: r, initialSearchParameters: e });
          },
          refreshUiState: function () {
            c = v(
              s,
              {
                searchParameters: this.getHelper().state,
                helper: this.getHelper(),
              },
              c
            );
          },
        };
      },
      S = w;
    t.default = S;
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.keys = void 0);
    var n = Object.keys;
    t.keys = n;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      if (void 0 === e || "function" != typeof e)
        throw new Error(
          "The render function is not valid (received type "
            .concat((0, i.getObjectType)(e), ").\n\n")
            .concat(t)
        );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.checkRendering = n);
    var i = r(46);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t = e.helper,
        r = e.attributesToClear,
        n = void 0 === r ? [] : r,
        i = t.state.setPage(0);
      return (
        (i = n.reduce(function (e, t) {
          return i.isNumericRefined(t)
            ? e.removeNumericRefinement(t)
            : i.isHierarchicalFacet(t)
            ? e.removeHierarchicalFacetRefinement(t)
            : i.isDisjunctiveFacet(t)
            ? e.removeDisjunctiveFacetRefinement(t)
            : i.isConjunctiveFacet(t)
            ? e.removeFacetRefinement(t)
            : e;
        }, i)),
        -1 !== n.indexOf("query") && (i = i.setQuery("")),
        i
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.clearRefinements = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t = i.TAG_REPLACEMENT.highlightPreTag,
        r = i.TAG_REPLACEMENT.highlightPostTag;
      return e
        .map(function (e) {
          return e.isHighlighted ? t + e.value + r : e.value;
        })
        .join("");
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.concatHighlightedParts = n);
    var i = r(29);
  },
  function (e, t, r) {
    "use strict";
    function n() {
      var e = -1,
        t = -1,
        r = void 0;
      return function (n) {
        var i = ++e;
        return Promise.resolve(n).then(function (e) {
          return r && i < t ? r : ((t = i), (r = e), e);
        });
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createConcurrentSafePromise = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      "@babel/helpers - typeof";
      return (n =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    function i(e) {
      var t = e.instantSearchInstance,
        r = e.helper,
        i = e.attribute,
        a = e.widgetType;
      return function () {
        for (var e = arguments.length, s = new Array(e), c = 0; c < e; c++)
          s[c] = arguments[c];
        var u = s[0],
          l = s[1],
          f = s[2],
          d = void 0 === f ? "Filter Applied" : f,
          p = "string" == typeof i ? i : i(l);
        1 === s.length && "object" === n(s[0])
          ? t.sendEventToInsights(s[0])
          : "click" !== u ||
            (2 !== s.length && 3 !== s.length) ||
            (0, o.isFacetRefined)(r, p, l) ||
            t.sendEventToInsights({
              insightsMethod: "clickedFilters",
              widgetType: a,
              eventType: u,
              payload: {
                eventName: d,
                index: r.getIndex(),
                filters: ["".concat(p, ":").concat(l)],
              },
              attribute: p,
            });
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createSendEventForFacet = i);
    var o = r(48);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      "@babel/helpers - typeof";
      return (n =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    function i(e) {
      for (
        var t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 20,
          r = [],
          n = 0;
        n < Math.ceil(e.length / t);
        n++
      )
        r.push(e.slice(n * t, (n + 1) * t));
      return r;
    }
    function o(e) {
      return e.slice();
    }
    function a(e) {
      var t = e.instantSearchInstance,
        r = e.index,
        n = e.widgetType;
      return function () {
        for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
          i[o] = arguments[o];
        u({
          widgetType: n,
          index: r,
          methodName: "sendEvent",
          args: i,
          isSearchStalled: "stalled" === t.status,
        }).forEach(function (e) {
          return t.sendEventToInsights(e);
        });
      };
    }
    function s(e) {
      var t = e.index,
        r = e.widgetType;
      return function () {
        for (var e = arguments.length, n = new Array(e), i = 0; i < e; i++)
          n[i] = arguments[i];
        var o = u({
          widgetType: r,
          index: t,
          methodName: "bindEvent",
          args: n,
          isSearchStalled: !1,
        });
        return o.length
          ? "data-insights-event=".concat((0, c.serializePayload)(o))
          : "";
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createSendEventForHits = a),
      (t.createBindEventForHits = s);
    var c = r(49),
      u = function (e) {
        var t = e.index,
          r = e.widgetType,
          a = (e.methodName, e.args),
          s = e.isSearchStalled;
        if (1 === a.length && "object" === n(a[0])) return [a[0]];
        var c = a[0],
          u = a[1],
          l = a[2];
        if (!u) return [];
        if (("click" === c || "conversion" === c) && !l) return [];
        var f = Array.isArray(u) ? o(u) : [u];
        if (0 === f.length) return [];
        var d = f[0].__queryID,
          p = i(f),
          h = p.map(function (e) {
            return e.map(function (e) {
              return e.objectID;
            });
          }),
          v = p.map(function (e) {
            return e.map(function (e) {
              return e.__position;
            });
          });
        return "view" === c
          ? s
            ? []
            : p.map(function (e, n) {
                return {
                  insightsMethod: "viewedObjectIDs",
                  widgetType: r,
                  eventType: c,
                  payload: {
                    eventName: l || "Hits Viewed",
                    index: t,
                    objectIDs: h[n],
                  },
                  hits: e,
                };
              })
          : "click" === c
          ? p.map(function (e, n) {
              return {
                insightsMethod: "clickedObjectIDsAfterSearch",
                widgetType: r,
                eventType: c,
                payload: {
                  eventName: l,
                  index: t,
                  queryID: d,
                  objectIDs: h[n],
                  positions: v[n],
                },
                hits: e,
              };
            })
          : "conversion" === c
          ? p.map(function (e, n) {
              return {
                insightsMethod: "convertedObjectIDsAfterSearch",
                widgetType: r,
                eventType: c,
                payload: {
                  eventName: l,
                  index: t,
                  queryID: d,
                  objectIDs: h[n],
                },
                hits: e,
              };
            })
          : [];
      };
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = e[t.getIndexId()] || {};
      t
        .getHelper()
        .setState(
          t.getWidgetSearchParameters(t.getHelper().state, { uiState: r })
        ),
        t
          .getWidgets()
          .filter(i.isIndexWidget)
          .forEach(function (t) {
            return n(e, t);
          });
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.setIndexHelperState = n);
    var i = r(50);
    r(43);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return Array.isArray(e) ? e.filter(Boolean).join(" ") : e || "";
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.cx = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = null;
      return function () {
        for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
          i[o] = arguments[o];
        return new Promise(function (n, o) {
          r && clearTimeout(r),
            (r = setTimeout(function () {
              (r = null),
                Promise.resolve(e.apply(void 0, i))
                  .then(n)
                  .catch(o);
            }, t));
        });
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.debounce = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t = null,
        r = !1,
        n = function () {
          for (var n = arguments.length, o = new Array(n), a = 0; a < n; a++)
            o[a] = arguments[a];
          null === t &&
            (t = i.then(function () {
              if (((t = null), r)) return void (r = !1);
              e.apply(void 0, o);
            }));
        };
      return (
        (n.wait = function () {
          if (null === t)
            throw new Error(
              "The deferred function should be called before calling `wait()`"
            );
          return t;
        }),
        (n.cancel = function () {
          null !== t && (r = !0);
        }),
        n
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.defer = n);
    var i = Promise.resolve();
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t = e.name,
        r = e.connector;
      return [
        "https://www.algolia.com/doc/api-reference/widgets/",
        t,
        "/js/",
        void 0 !== r && r ? "#connector" : "",
      ].join("");
    }
    function i() {
      for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
        t[r] = arguments[r];
      var i = t
        .map(function (e) {
          return n(e);
        })
        .join(", ");
      return function (e) {
        return [e, "See documentation: ".concat(i)]
          .filter(Boolean)
          .join("\n\n");
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createDocumentationLink = n),
      (t.createDocumentationMessageGenerator = i);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      return c(e) || s(e, t) || o(e, t) || i();
    }
    function i() {
      throw new TypeError(
        "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function o(e, t) {
      if (e) {
        if ("string" == typeof e) return a(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? a(e, t)
            : void 0
        );
      }
    }
    function a(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function s(e, t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
        var r = [],
          n = !0,
          i = !1,
          o = void 0;
        try {
          for (
            var a, s = e[Symbol.iterator]();
            !(n = (a = s.next()).done) &&
            (r.push(a.value), !t || r.length !== t);
            n = !0
          );
        } catch (e) {
          (i = !0), (o = e);
        } finally {
          try {
            n || null == s.return || s.return();
          } finally {
            if (i) throw o;
          }
        }
        return r;
      }
    }
    function c(e) {
      if (Array.isArray(e)) return e;
    }
    function u(e) {
      var t = e.match(p);
      if (!t)
        throw new Error(
          'Invalid value for "aroundLatLng" parameter: "'.concat(e, '"')
        );
      return { lat: parseFloat(t[1]), lng: parseFloat(t[2]) };
    }
    function l(e) {
      var t = n(e, 1),
        r = t[0];
      r = void 0 === r ? [void 0, void 0, void 0, void 0] : r;
      var i = n(r, 4),
        o = i[0],
        a = i[1],
        s = i[2],
        c = i[3];
      if (!(o && a && s && c))
        throw new Error(
          'Invalid value for "insideBoundingBox" parameter: ['.concat(e, "]")
        );
      return { northEast: { lat: o, lng: a }, southWest: { lat: s, lng: c } };
    }
    function f(e) {
      var t = e.split(",").map(parseFloat),
        r = n(t, 4),
        i = r[0],
        o = r[1],
        a = r[2],
        s = r[3];
      if (!(i && o && a && s))
        throw new Error(
          'Invalid value for "insideBoundingBox" parameter: "'.concat(e, '"')
        );
      return { northEast: { lat: i, lng: o }, southWest: { lat: a, lng: s } };
    }
    function d(e) {
      return Array.isArray(e) ? l(e) : f(e);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.aroundLatLngToPosition = u),
      (t.insideBoundingBoxToBoundingBox = d);
    var p = /^(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)$/;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      if (e.transporter) {
        var t = e.transporter,
          r = t.headers,
          n = t.queryParameters,
          i = "x-algolia-application-id";
        return [r[i] || n[i], r["x-algolia-api-key"] || n["x-algolia-api-key"]];
      }
      return [e.applicationID, e.apiKey];
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getAppIdAndApiKey = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t = "string" == typeof e,
        r = t ? document.querySelector(e) : e;
      if (!(0, i.isDomElement)(r)) {
        var n = "Container must be `string` or `HTMLElement`.";
        throw (t && (n += " Unable to find ".concat(e)), new Error(n));
      }
      return r;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getContainerNode = n);
    var i = r(54);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t = i.TAG_REPLACEMENT.highlightPostTag,
        r = i.TAG_REPLACEMENT.highlightPreTag,
        n = e.split(r),
        o = n.shift(),
        a = o ? [{ value: o, isHighlighted: !1 }] : [];
      return (
        n.forEach(function (e) {
          var r = e.split(t);
          a.push({ value: r[0], isHighlighted: !0 }),
            "" !== r[1] && a.push({ value: r[1], isHighlighted: !1 });
        }),
        a
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getHighlightedParts = n);
    var i = r(29);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      return (Array.isArray(t) ? t : t.split(".")).reduce(function (e, t) {
        return e && e[t];
      }, e);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getPropertyByPath = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t, r, n) {
      var i,
        s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : [],
        c = {
          type: t,
          attribute: r,
          name: n,
          escapedValue: (0, a.escapeFacetValue)(n),
        },
        u = (0, o.find)(s, function (e) {
          return e.name === r;
        });
      return (
        "hierarchical" === t
          ? (function () {
              for (
                var t = e.getHierarchicalFacetByName(r),
                  a = n.split(t.separator),
                  s = function (e) {
                    return function (t) {
                      return e[t];
                    };
                  },
                  c = 0;
                void 0 !== u && c < a.length;
                ++c
              )
                !(function (e) {
                  u =
                    u &&
                    u.data &&
                    (0, o.find)(
                      Object.keys(u.data).map(s(u.data)),
                      function (t) {
                        return t.name === a[e];
                      }
                    );
                })(c);
              i = u && u.count;
            })()
          : (i = u && u.data && u.data[c.name]),
        void 0 !== i && (c.count = i),
        u && void 0 !== u.exhaustive && (c.exhaustive = u.exhaustive),
        c
      );
    }
    function i(e, t) {
      var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
        i = [],
        o = t.facetsRefinements,
        s = void 0 === o ? {} : o,
        c = t.facetsExcludes,
        u = void 0 === c ? {} : c,
        l = t.disjunctiveFacetsRefinements,
        f = void 0 === l ? {} : l,
        d = t.hierarchicalFacetsRefinements,
        p = void 0 === d ? {} : d,
        h = t.numericRefinements,
        v = void 0 === h ? {} : h,
        m = t.tagRefinements,
        g = void 0 === m ? [] : m;
      return (
        Object.keys(s).forEach(function (r) {
          s[r].forEach(function (o) {
            i.push(n(t, "facet", r, o, e.facets));
          });
        }),
        Object.keys(u).forEach(function (e) {
          u[e].forEach(function (t) {
            i.push({ type: "exclude", attribute: e, name: t, exclude: !0 });
          });
        }),
        Object.keys(f).forEach(function (r) {
          f[r].forEach(function (o) {
            i.push(
              n(
                t,
                "disjunctive",
                r,
                (0, a.unescapeFacetValue)(o),
                e.disjunctiveFacets
              )
            );
          });
        }),
        Object.keys(p).forEach(function (r) {
          p[r].forEach(function (o) {
            i.push(n(t, "hierarchical", r, o, e.hierarchicalFacets));
          });
        }),
        Object.keys(v).forEach(function (e) {
          var t = v[e];
          Object.keys(t).forEach(function (r) {
            var n = r,
              o = t[n];
            (Array.isArray(o) ? o : [o]).forEach(function (t) {
              i.push({
                type: "numeric",
                attribute: e,
                name: "".concat(t),
                numericValue: t,
                operator: n,
              });
            });
          });
        }),
        g.forEach(function (e) {
          i.push({ type: "tag", attribute: "_tags", name: e });
        }),
        r &&
          t.query &&
          t.query.trim() &&
          i.push({
            attribute: "query",
            type: "query",
            name: t.query,
            query: t.query,
          }),
        i
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getRefinements = i);
    var o = r(52),
      a = r(51);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r,
        n =
          null === (r = e.getWidgetRenderState) || void 0 === r
            ? void 0
            : r.call(e, t),
        i = null;
      if (n && n.widgetParams) {
        var o = n.widgetParams;
        o.attribute
          ? (i = o.attribute)
          : Array.isArray(o.attributes) && (i = o.attributes[0]);
      }
      if ("string" != typeof i)
        throw new Error(
          "Could not find the attribute of the widget:\n\n".concat(
            JSON.stringify(e),
            "\n\nPlease check whether the widget's getWidgetRenderState returns widgetParams.attribute correctly."
          )
        );
      return i;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getWidgetAttribute = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e, t, r) {
      return e.map(function (e, n) {
        return i(i({}, e), {}, { __position: r * t + n + 1 });
      });
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.addAbsolutePosition = a);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e, t) {
      return t
        ? e.map(function (e) {
            return i(i({}, e), {}, { __queryID: t });
          })
        : e;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.addQueryID = a);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return e !== Object(e);
    }
    function i(e, t) {
      if (e === t) return !0;
      if (n(e) || n(t) || "function" == typeof e || "function" == typeof t)
        return e === t;
      if (Object.keys(e).length !== Object.keys(t).length) return !1;
      for (var r = 0, o = Object.keys(e); r < o.length; r++) {
        var a = o[r];
        if (!(a in t)) return !1;
        if (!i(e[a], t[a])) return !1;
      }
      return !0;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.isEqual = i);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return "number" == typeof e && isFinite(e);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.isFiniteNumber = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return 1 === e.button || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.isSpecialClick = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = s(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (n = 0; n < o.length; n++)
          (r = o[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function s(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.mergeSearchParameters = void 0);
    var c = r(53),
      u = r(31),
      l = function (e, t) {
        var r =
          (t.facets,
          t.disjunctiveFacets,
          t.facetsRefinements,
          t.facetsExcludes,
          t.disjunctiveFacetsRefinements,
          t.numericRefinements,
          t.tagRefinements,
          t.hierarchicalFacets,
          t.hierarchicalFacetsRefinements,
          t.ruleContexts,
          a(t, [
            "facets",
            "disjunctiveFacets",
            "facetsRefinements",
            "facetsExcludes",
            "disjunctiveFacetsRefinements",
            "numericRefinements",
            "tagRefinements",
            "hierarchicalFacets",
            "hierarchicalFacetsRefinements",
            "ruleContexts",
          ]));
        return e.setQueryParameters(r);
      },
      f = function (e, t) {
        return t.facets.reduce(function (e, t) {
          return e.addFacet(t);
        }, e);
      },
      d = function (e, t) {
        return t.disjunctiveFacets.reduce(function (e, t) {
          return e.addDisjunctiveFacet(t);
        }, e);
      },
      p = function (e, t) {
        return e.setQueryParameters({
          hierarchicalFacets: t.hierarchicalFacets.reduce(function (e, t) {
            var r = (0, c.findIndex)(e, function (e) {
              return e.name === t.name;
            });
            if (-1 === r) return e.concat(t);
            var n = e.slice();
            return n.splice(r, 1, t), n;
          }, e.hierarchicalFacets),
        });
      },
      h = function (e, t) {
        return t.tagRefinements.reduce(function (e, t) {
          return e.addTagRefinement(t);
        }, e);
      },
      v = function (e, t) {
        return e.setQueryParameters({
          facetsRefinements: i(i({}, e.facetsRefinements), t.facetsRefinements),
        });
      },
      m = function (e, t) {
        return e.setQueryParameters({
          facetsExcludes: i(i({}, e.facetsExcludes), t.facetsExcludes),
        });
      },
      g = function (e, t) {
        return e.setQueryParameters({
          disjunctiveFacetsRefinements: i(
            i({}, e.disjunctiveFacetsRefinements),
            t.disjunctiveFacetsRefinements
          ),
        });
      },
      y = function (e, t) {
        return e.setQueryParameters({
          numericRefinements: i(
            i({}, e.numericRefinements),
            t.numericRefinements
          ),
        });
      },
      b = function (e, t) {
        return e.setQueryParameters({
          hierarchicalFacetsRefinements: i(
            i({}, e.hierarchicalFacetsRefinements),
            t.hierarchicalFacetsRefinements
          ),
        });
      },
      _ = function (e, t) {
        var r = (0, u.uniq)(
          [].concat(e.ruleContexts).concat(t.ruleContexts).filter(Boolean)
        );
        return r.length > 0 ? e.setQueryParameters({ ruleContexts: r }) : e;
      },
      O = function () {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
          t[r] = arguments[r];
        return t.reduce(function (e, t) {
          var r = b(e, t),
            n = p(r, t),
            i = h(n, t),
            o = y(i, t),
            a = g(o, t),
            s = m(a, t),
            c = v(s, t),
            u = d(c, t),
            O = _(u, t),
            j = f(O, t);
          return l(j, t);
        });
      };
    t.mergeSearchParameters = O;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return s(e) || a(e) || o(e) || i();
    }
    function i() {
      throw new TypeError(
        "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function o(e, t) {
      if (e) {
        if ("string" == typeof e) return c(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? c(e, t)
            : void 0
        );
      }
    }
    function a(e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e))
        return Array.from(e);
    }
    function s(e) {
      if (Array.isArray(e)) return c(e);
    }
    function c(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function u(e) {
      var t = e.start,
        r = void 0 === t ? 0 : t,
        i = e.end,
        o = e.step,
        a = void 0 === o ? 1 : o,
        s = 0 === a ? 1 : a,
        c = Math.round((i - r) / s);
      return n(Array(c)).map(function (e, t) {
        return r + t * s;
      });
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.range = u);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t, r) {
      var n = t.getHelper();
      return {
        uiState: r,
        helper: n,
        parent: t,
        instantSearchInstance: e,
        state: n.state,
        renderState: e.renderState,
        templatesConfig: e.templatesConfig,
        createURL: t.createURL,
        scopedResults: [],
        searchMetadata: { isSearchStalled: "stalled" === e.status },
        status: e.status,
        error: e.error,
      };
    }
    function i(e, t) {
      var r = t.getResults();
      return {
        helper: t.getHelper(),
        parent: t,
        instantSearchInstance: e,
        results: r,
        scopedResults: t.getScopedResults(),
        state: r._state,
        renderState: e.renderState,
        templatesConfig: e.templatesConfig,
        createURL: t.createURL,
        searchMetadata: { isSearchStalled: "stalled" === e.status },
        status: e.status,
        error: e.error,
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createInitArgs = n),
      (t.createRenderArgs = i);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      for (var t = e.getParent(), r = [e.getHelper().state]; null !== t; )
        (r = [t.getHelper().state].concat(r)), (t = t.getParent());
      return r;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.resolveSearchParameters = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e) {
      return e.some(function (e) {
        return e.isHighlighted;
      })
        ? e.map(function (t, r) {
            return i(
              i({}, t),
              {},
              { isHighlighted: !(0, s.getHighlightFromSiblings)(e, r) }
            );
          })
        : e.map(function (e) {
            return i(i({}, e), {}, { isHighlighted: !1 });
          });
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.reverseHighlightedParts = a);
    var s = r(55);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : { fallback: function () {} },
        r = t.fallback;
      return "undefined" == typeof window ? r() : e({ window: window });
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.safelyRunOnBrowser = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return Array.isArray(e) ? e : [e];
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.toArray = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e) {
      var t = e.numberLocale;
      return {
        formatNumber: function (e, r) {
          return (0, c.formatNumber)(Number(r(e)), t);
        },
        highlight: function (e, t) {
          try {
            var r = JSON.parse(e);
            return t((0, s.highlight)(i(i({}, r), {}, { hit: this })));
          } catch (e) {
            throw new Error(
              '\nThe highlight helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }'
            );
          }
        },
        reverseHighlight: function (e, t) {
          try {
            var r = JSON.parse(e);
            return t((0, s.reverseHighlight)(i(i({}, r), {}, { hit: this })));
          } catch (e) {
            throw new Error(
              '\n  The reverseHighlight helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }'
            );
          }
        },
        snippet: function (e, t) {
          try {
            var r = JSON.parse(e);
            return t((0, s.snippet)(i(i({}, r), {}, { hit: this })));
          } catch (e) {
            throw new Error(
              '\nThe snippet helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }'
            );
          }
        },
        reverseSnippet: function (e, t) {
          try {
            var r = JSON.parse(e);
            return t((0, s.reverseSnippet)(i(i({}, r), {}, { hit: this })));
          } catch (e) {
            throw new Error(
              '\n  The reverseSnippet helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }'
            );
          }
        },
        insights: function (e, t) {
          try {
            var r = JSON.parse(e),
              n = r.method,
              o = r.payload;
            return t((0, s.insights)(n, i({ objectIDs: [this.objectID] }, o)));
          } catch (e) {
            throw new Error(
              '\nThe insights helper expects a JSON object of the format:\n{ "method": "method-name", "payload": { "eventName": "name of the event" } }'
            );
          }
        },
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = a);
    var s = r(32),
      c = r(17);
  },
  function (e, t, r) {
    "use strict";
    function n(t) {
      "@babel/helpers - typeof";
      return (
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? (e.exports = n =
              function (e) {
                return typeof e;
              })
          : (e.exports = n =
              function (e) {
                return e &&
                  "function" == typeof Symbol &&
                  e.constructor === Symbol &&
                  e !== Symbol.prototype
                  ? "symbol"
                  : typeof e;
              }),
        n(t)
      );
    }
    e.exports = n;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t = e.attribute,
        r = e.highlightedTagName,
        n = void 0 === r ? "mark" : r,
        i = e.hit,
        s = e.cssClasses,
        c = void 0 === s ? {} : s,
        u = (0, o.getPropertyByPath)(i._highlightResult, t),
        l = u || {},
        f = l.value,
        d = void 0 === f ? "" : f,
        p =
          a({ descendantName: "highlighted" }) +
          (c.highlighted ? " ".concat(c.highlighted) : "");
      return d
        .replace(
          new RegExp(o.TAG_REPLACEMENT.highlightPreTag, "g"),
          "<".concat(n, ' class="').concat(p, '">')
        )
        .replace(
          new RegExp(o.TAG_REPLACEMENT.highlightPostTag, "g"),
          "</".concat(n, ">")
        );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = n);
    var i = r(6),
      o = r(1),
      a = (0, i.component)("Highlight");
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t = e.attribute,
        r = e.highlightedTagName,
        n = void 0 === r ? "mark" : r,
        o = e.hit,
        s = e.cssClasses,
        c = void 0 === s ? {} : s,
        u = (0, i.getPropertyByPath)(o._highlightResult, t),
        l = u || {},
        f = l.value,
        d = void 0 === f ? "" : f,
        p =
          a({ descendantName: "highlighted" }) +
          (c.highlighted ? " ".concat(c.highlighted) : "");
      return (0, i.concatHighlightedParts)(
        (0, i.reverseHighlightedParts)((0, i.getHighlightedParts)(d))
      )
        .replace(
          new RegExp(i.TAG_REPLACEMENT.highlightPreTag, "g"),
          "<".concat(n, ' class="').concat(p, '">')
        )
        .replace(
          new RegExp(i.TAG_REPLACEMENT.highlightPostTag, "g"),
          "</".concat(n, ">")
        );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = n);
    var i = r(1),
      o = r(6),
      a = (0, o.component)("ReverseHighlight");
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t = e.attribute,
        r = e.highlightedTagName,
        n = void 0 === r ? "mark" : r,
        i = e.hit,
        s = e.cssClasses,
        c = void 0 === s ? {} : s,
        u = (0, o.getPropertyByPath)(i._snippetResult, t),
        l = u || {},
        f = l.value,
        d = void 0 === f ? "" : f,
        p =
          a({ descendantName: "highlighted" }) +
          (c.highlighted ? " ".concat(c.highlighted) : "");
      return d
        .replace(
          new RegExp(o.TAG_REPLACEMENT.highlightPreTag, "g"),
          "<".concat(n, ' class="').concat(p, '">')
        )
        .replace(
          new RegExp(o.TAG_REPLACEMENT.highlightPostTag, "g"),
          "</".concat(n, ">")
        );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = n);
    var i = r(6),
      o = r(1),
      a = (0, i.component)("Snippet");
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t = e.attribute,
        r = e.highlightedTagName,
        n = void 0 === r ? "mark" : r,
        o = e.hit,
        s = e.cssClasses,
        c = void 0 === s ? {} : s,
        u = (0, i.getPropertyByPath)(o._snippetResult, t),
        l = u || {},
        f = l.value,
        d = void 0 === f ? "" : f,
        p =
          a({ descendantName: "highlighted" }) +
          (c.highlighted ? " ".concat(c.highlighted) : "");
      return (0, i.concatHighlightedParts)(
        (0, i.reverseHighlightedParts)((0, i.getHighlightedParts)(d))
      )
        .replace(
          new RegExp(i.TAG_REPLACEMENT.highlightPreTag, "g"),
          "<".concat(n, ' class="').concat(p, '">')
        )
        .replace(
          new RegExp(i.TAG_REPLACEMENT.highlightPostTag, "g"),
          "</".concat(n, ">")
        );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = n);
    var i = r(1),
      o = r(6),
      a = (0, o.component)("ReverseSnippet");
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      for (
        var t = "".concat(e, "="), r = document.cookie.split(";"), n = 0;
        n < r.length;
        n++
      ) {
        for (var i = r[n]; " " === i.charAt(0); ) i = i.substring(1);
        if (0 === i.indexOf(t)) return i.substring(t.length, i.length);
      }
    }
    function i() {
      return n(a);
    }
    function o() {
      return i();
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getInsightsAnonymousUserTokenInternal = i),
      (t.default = o),
      (t.ANONYMOUS_TOKEN_COOKIE_KEY = void 0);
    var a = (r(1), "_ALGOLIA");
    t.ANONYMOUS_TOKEN_COOKIE_KEY = a;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = s(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (n = 0; n < o.length; n++)
          (r = o[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function s(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    function c(e) {
      return e.configure, a(e, ["configure"]);
    }
    function u() {
      return {
        stateToRoute: function (e) {
          return Object.keys(e).reduce(function (t, r) {
            return i(i({}, t), {}, o({}, r, c(e[r])));
          }, {});
        },
        routeToState: function () {
          var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return Object.keys(e).reduce(function (t, r) {
            return i(i({}, t), {}, o({}, r, c(e[r])));
          }, {});
        },
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = u);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n);
      }
    }
    function o(e, t, r) {
      return t && i(e.prototype, t), r && i(e, r), e;
    }
    function a(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function s() {
      var e =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.createURL,
        r =
          void 0 === t
            ? function (e) {
                var t = e.qsModule,
                  r = e.routeState,
                  n = e.location,
                  i = n.protocol,
                  o = n.hostname,
                  a = n.port,
                  s = void 0 === a ? "" : a,
                  c = n.pathname,
                  u = n.hash,
                  l = t.stringify(r),
                  f = "" === s ? "" : ":".concat(s);
                return l
                  ? ""
                      .concat(i, "//")
                      .concat(o)
                      .concat(f)
                      .concat(c, "?")
                      .concat(l)
                      .concat(u)
                  : "".concat(i, "//").concat(o).concat(f).concat(c).concat(u);
              }
            : t,
        n = e.parseURL,
        i =
          void 0 === n
            ? function (e) {
                var t = e.qsModule,
                  r = e.location;
                return t.parse(r.search.slice(1), { arrayLimit: 99 });
              }
            : n,
        o = e.writeDelay,
        a = void 0 === o ? 400 : o,
        s = e.windowTitle,
        c = e.getLocation;
      return new d({
        createURL: r,
        parseURL: i,
        writeDelay: a,
        windowTitle: s,
        getLocation:
          void 0 === c
            ? function () {
                return (0, l.safelyRunOnBrowser)(
                  function (e) {
                    return e.window.location;
                  },
                  {
                    fallback: function () {
                      throw new Error(
                        "You need to provide `getLocation` to the `history` router in environments where `window` does not exist."
                      );
                    },
                  }
                );
              }
            : c,
      });
    }
    var c = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = s);
    var u = c(r(144)),
      l = r(1),
      f = function (e) {
        e && (window.document.title = e);
      },
      d = (function () {
        function e(t) {
          var r = this,
            i = t.windowTitle,
            o = t.writeDelay,
            s = void 0 === o ? 400 : o,
            c = t.createURL,
            u = t.parseURL,
            d = t.getLocation;
          n(this, e),
            a(this, "windowTitle", void 0),
            a(this, "writeDelay", void 0),
            a(this, "_createURL", void 0),
            a(this, "parseURL", void 0),
            a(this, "getLocation", void 0),
            a(this, "writeTimer", void 0),
            a(this, "inPopState", !1),
            a(this, "isDisposed", !1),
            a(this, "latestAcknowledgedHistory", 0),
            (this.windowTitle = i),
            (this.writeTimer = void 0),
            (this.writeDelay = s),
            (this._createURL = c),
            (this.parseURL = u),
            (this.getLocation = d),
            (0, l.safelyRunOnBrowser)(function (e) {
              var t = e.window,
                n = r.windowTitle && r.windowTitle(r.read());
              f(n), (r.latestAcknowledgedHistory = t.history.length);
            });
        }
        return (
          o(e, [
            {
              key: "read",
              value: function () {
                return this.parseURL({
                  qsModule: u.default,
                  location: this.getLocation(),
                });
              },
            },
            {
              key: "write",
              value: function (e) {
                var t = this;
                (0, l.safelyRunOnBrowser)(function (r) {
                  var n = r.window,
                    i = t.createURL(e),
                    o = t.windowTitle && t.windowTitle(e);
                  t.writeTimer && clearTimeout(t.writeTimer),
                    (t.writeTimer = setTimeout(function () {
                      f(o),
                        t.shouldWrite(i) &&
                          (n.history.pushState(e, o || "", i),
                          (t.latestAcknowledgedHistory = n.history.length)),
                        (t.inPopState = !1),
                        (t.writeTimer = void 0);
                    }, t.writeDelay));
                });
              },
            },
            {
              key: "onUpdate",
              value: function (e) {
                var t = this;
                (this._onPopState = function (r) {
                  t.writeTimer &&
                    (clearTimeout(t.writeTimer), (t.writeTimer = void 0)),
                    (t.inPopState = !0);
                  var n = r.state;
                  e(n || t.read());
                }),
                  (0, l.safelyRunOnBrowser)(function (e) {
                    e.window.addEventListener("popstate", t._onPopState);
                  });
              },
            },
            {
              key: "createURL",
              value: function (e) {
                return this._createURL({
                  qsModule: u.default,
                  routeState: e,
                  location: this.getLocation(),
                });
              },
            },
            {
              key: "dispose",
              value: function () {
                var e = this;
                (this.isDisposed = !0),
                  (0, l.safelyRunOnBrowser)(function (t) {
                    var r = t.window;
                    e._onPopState &&
                      r.removeEventListener("popstate", e._onPopState);
                  }),
                  this.writeTimer && clearTimeout(this.writeTimer),
                  this.write({});
              },
            },
            {
              key: "shouldWrite",
              value: function (e) {
                var t = this;
                return (0, l.safelyRunOnBrowser)(function (r) {
                  var n = r.window,
                    i = !(
                      t.isDisposed &&
                      t.latestAcknowledgedHistory !== n.history.length
                    );
                  return !t.inPopState && i && e !== n.location.href;
                });
              },
            },
          ]),
          e
        );
      })();
  },
  function (e, t, r) {
    "use strict";
    var n = r(145),
      i = r(146),
      o = r(33);
    e.exports = { formats: o, parse: i, stringify: n };
  },
  function (e, t, r) {
    "use strict";
    var n = r(0),
      i = n(r(4)),
      o = r(60),
      a = r(33),
      s = Object.prototype.hasOwnProperty,
      c = {
        brackets: function (e) {
          return e + "[]";
        },
        comma: "comma",
        indices: function (e, t) {
          return e + "[" + t + "]";
        },
        repeat: function (e) {
          return e;
        },
      },
      u = Array.isArray,
      l = String.prototype.split,
      f = Array.prototype.push,
      d = function (e, t) {
        f.apply(e, u(t) ? t : [t]);
      },
      p = Date.prototype.toISOString,
      h = a.default,
      v = {
        addQueryPrefix: !1,
        allowDots: !1,
        charset: "utf-8",
        charsetSentinel: !1,
        delimiter: "&",
        encode: !0,
        encoder: o.encode,
        encodeValuesOnly: !1,
        format: h,
        formatter: a.formatters[h],
        indices: !1,
        serializeDate: function (e) {
          return p.call(e);
        },
        skipNulls: !1,
        strictNullHandling: !1,
      },
      m = function (e) {
        return (
          "string" == typeof e ||
          "number" == typeof e ||
          "boolean" == typeof e ||
          "symbol" === (0, i.default)(e) ||
          "bigint" == typeof e
        );
      },
      g = function e(t, r, n, a, s, c, f, p, h, g, y, b, _, O) {
        var j = t;
        if (
          ("function" == typeof f
            ? (j = f(r, j))
            : j instanceof Date
            ? (j = g(j))
            : "comma" === n &&
              u(j) &&
              (j = o.maybeMap(j, function (e) {
                return e instanceof Date ? g(e) : e;
              })),
          null === j)
        ) {
          if (a) return c && !_ ? c(r, v.encoder, O, "key", y) : r;
          j = "";
        }
        if (m(j) || o.isBuffer(j)) {
          if (c) {
            var P = _ ? r : c(r, v.encoder, O, "key", y);
            if ("comma" === n && _) {
              for (
                var w = l.call(String(j), ","), S = "", E = 0;
                E < w.length;
                ++E
              )
                S +=
                  (0 === E ? "" : ",") + b(c(w[E], v.encoder, O, "value", y));
              return [b(P) + "=" + S];
            }
            return [b(P) + "=" + b(c(j, v.encoder, O, "value", y))];
          }
          return [b(r) + "=" + b(String(j))];
        }
        var R = [];
        if (void 0 === j) return R;
        var x;
        if ("comma" === n && u(j))
          x = [{ value: j.length > 0 ? j.join(",") || null : void 0 }];
        else if (u(f)) x = f;
        else {
          var k = Object.keys(j);
          x = p ? k.sort(p) : k;
        }
        for (var I = 0; I < x.length; ++I) {
          var A = x[I],
            M =
              "object" === (0, i.default)(A) && void 0 !== A.value
                ? A.value
                : j[A];
          if (!s || null !== M) {
            var C = u(j)
              ? "function" == typeof n
                ? n(r, A)
                : r
              : r + (h ? "." + A : "[" + A + "]");
            d(R, e(M, C, n, a, s, c, f, p, h, g, y, b, _, O));
          }
        }
        return R;
      },
      y = function (e) {
        if (!e) return v;
        if (
          null !== e.encoder &&
          void 0 !== e.encoder &&
          "function" != typeof e.encoder
        )
          throw new TypeError("Encoder has to be a function.");
        var t = e.charset || v.charset;
        if (
          void 0 !== e.charset &&
          "utf-8" !== e.charset &&
          "iso-8859-1" !== e.charset
        )
          throw new TypeError(
            "The charset option must be either utf-8, iso-8859-1, or undefined"
          );
        var r = a.default;
        if (void 0 !== e.format) {
          if (!s.call(a.formatters, e.format))
            throw new TypeError("Unknown format option provided.");
          r = e.format;
        }
        var n = a.formatters[r],
          i = v.filter;
        return (
          ("function" == typeof e.filter || u(e.filter)) && (i = e.filter),
          {
            addQueryPrefix:
              "boolean" == typeof e.addQueryPrefix
                ? e.addQueryPrefix
                : v.addQueryPrefix,
            allowDots: void 0 === e.allowDots ? v.allowDots : !!e.allowDots,
            charset: t,
            charsetSentinel:
              "boolean" == typeof e.charsetSentinel
                ? e.charsetSentinel
                : v.charsetSentinel,
            delimiter: void 0 === e.delimiter ? v.delimiter : e.delimiter,
            encode: "boolean" == typeof e.encode ? e.encode : v.encode,
            encoder: "function" == typeof e.encoder ? e.encoder : v.encoder,
            encodeValuesOnly:
              "boolean" == typeof e.encodeValuesOnly
                ? e.encodeValuesOnly
                : v.encodeValuesOnly,
            filter: i,
            format: r,
            formatter: n,
            serializeDate:
              "function" == typeof e.serializeDate
                ? e.serializeDate
                : v.serializeDate,
            skipNulls:
              "boolean" == typeof e.skipNulls ? e.skipNulls : v.skipNulls,
            sort: "function" == typeof e.sort ? e.sort : null,
            strictNullHandling:
              "boolean" == typeof e.strictNullHandling
                ? e.strictNullHandling
                : v.strictNullHandling,
          }
        );
      };
    e.exports = function (e, t) {
      var r,
        n,
        o = e,
        a = y(t);
      "function" == typeof a.filter
        ? ((n = a.filter), (o = n("", o)))
        : u(a.filter) && ((n = a.filter), (r = n));
      var s = [];
      if ("object" !== (0, i.default)(o) || null === o) return "";
      var l;
      l =
        t && t.arrayFormat in c
          ? t.arrayFormat
          : t && "indices" in t
          ? t.indices
            ? "indices"
            : "repeat"
          : "indices";
      var f = c[l];
      r || (r = Object.keys(o)), a.sort && r.sort(a.sort);
      for (var p = 0; p < r.length; ++p) {
        var h = r[p];
        (a.skipNulls && null === o[h]) ||
          d(
            s,
            g(
              o[h],
              h,
              f,
              a.strictNullHandling,
              a.skipNulls,
              a.encode ? a.encoder : null,
              a.filter,
              a.sort,
              a.allowDots,
              a.serializeDate,
              a.format,
              a.formatter,
              a.encodeValuesOnly,
              a.charset
            )
          );
      }
      var v = s.join(a.delimiter),
        m = !0 === a.addQueryPrefix ? "?" : "";
      return (
        a.charsetSentinel &&
          ("iso-8859-1" === a.charset
            ? (m += "utf8=%26%2310003%3B&")
            : (m += "utf8=%E2%9C%93&")),
        v.length > 0 ? m + v : ""
      );
    };
  },
  function (e, t, r) {
    "use strict";
    var n = r(60),
      i = Object.prototype.hasOwnProperty,
      o = Array.isArray,
      a = {
        allowDots: !1,
        allowPrototypes: !1,
        arrayLimit: 20,
        charset: "utf-8",
        charsetSentinel: !1,
        comma: !1,
        decoder: n.decode,
        delimiter: "&",
        depth: 5,
        ignoreQueryPrefix: !1,
        interpretNumericEntities: !1,
        parameterLimit: 1e3,
        parseArrays: !0,
        plainObjects: !1,
        strictNullHandling: !1,
      },
      s = function (e) {
        return e.replace(/&#(\d+);/g, function (e, t) {
          return String.fromCharCode(parseInt(t, 10));
        });
      },
      c = function (e, t) {
        return e && "string" == typeof e && t.comma && e.indexOf(",") > -1
          ? e.split(",")
          : e;
      },
      u = function (e, t) {
        var r,
          u = {},
          l = t.ignoreQueryPrefix ? e.replace(/^\?/, "") : e,
          f = t.parameterLimit === 1 / 0 ? void 0 : t.parameterLimit,
          d = l.split(t.delimiter, f),
          p = -1,
          h = t.charset;
        if (t.charsetSentinel)
          for (r = 0; r < d.length; ++r)
            0 === d[r].indexOf("utf8=") &&
              ("utf8=%E2%9C%93" === d[r]
                ? (h = "utf-8")
                : "utf8=%26%2310003%3B" === d[r] && (h = "iso-8859-1"),
              (p = r),
              (r = d.length));
        for (r = 0; r < d.length; ++r)
          if (r !== p) {
            var v,
              m,
              g = d[r],
              y = g.indexOf("]="),
              b = -1 === y ? g.indexOf("=") : y + 1;
            -1 === b
              ? ((v = t.decoder(g, a.decoder, h, "key")),
                (m = t.strictNullHandling ? null : ""))
              : ((v = t.decoder(g.slice(0, b), a.decoder, h, "key")),
                (m = n.maybeMap(c(g.slice(b + 1), t), function (e) {
                  return t.decoder(e, a.decoder, h, "value");
                }))),
              m &&
                t.interpretNumericEntities &&
                "iso-8859-1" === h &&
                (m = s(m)),
              g.indexOf("[]=") > -1 && (m = o(m) ? [m] : m),
              i.call(u, v) ? (u[v] = n.combine(u[v], m)) : (u[v] = m);
          }
        return u;
      },
      l = function (e, t, r, n) {
        for (var i = n ? t : c(t, r), o = e.length - 1; o >= 0; --o) {
          var a,
            s = e[o];
          if ("[]" === s && r.parseArrays) a = [].concat(i);
          else {
            a = r.plainObjects ? Object.create(null) : {};
            var u =
                "[" === s.charAt(0) && "]" === s.charAt(s.length - 1)
                  ? s.slice(1, -1)
                  : s,
              l = parseInt(u, 10);
            r.parseArrays || "" !== u
              ? !isNaN(l) &&
                s !== u &&
                String(l) === u &&
                l >= 0 &&
                r.parseArrays &&
                l <= r.arrayLimit
                ? ((a = []), (a[l] = i))
                : "__proto__" !== u && (a[u] = i)
              : (a = { 0: i });
          }
          i = a;
        }
        return i;
      },
      f = function (e, t, r, n) {
        if (e) {
          var o = r.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e,
            a = /(\[[^[\]]*])/,
            s = /(\[[^[\]]*])/g,
            c = r.depth > 0 && a.exec(o),
            u = c ? o.slice(0, c.index) : o,
            f = [];
          if (u) {
            if (
              !r.plainObjects &&
              i.call(Object.prototype, u) &&
              !r.allowPrototypes
            )
              return;
            f.push(u);
          }
          for (
            var d = 0;
            r.depth > 0 && null !== (c = s.exec(o)) && d < r.depth;

          ) {
            if (
              ((d += 1),
              !r.plainObjects &&
                i.call(Object.prototype, c[1].slice(1, -1)) &&
                !r.allowPrototypes)
            )
              return;
            f.push(c[1]);
          }
          return c && f.push("[" + o.slice(c.index) + "]"), l(f, t, r, n);
        }
      },
      d = function (e) {
        if (!e) return a;
        if (
          null !== e.decoder &&
          void 0 !== e.decoder &&
          "function" != typeof e.decoder
        )
          throw new TypeError("Decoder has to be a function.");
        if (
          void 0 !== e.charset &&
          "utf-8" !== e.charset &&
          "iso-8859-1" !== e.charset
        )
          throw new TypeError(
            "The charset option must be either utf-8, iso-8859-1, or undefined"
          );
        var t = void 0 === e.charset ? a.charset : e.charset;
        return {
          allowDots: void 0 === e.allowDots ? a.allowDots : !!e.allowDots,
          allowPrototypes:
            "boolean" == typeof e.allowPrototypes
              ? e.allowPrototypes
              : a.allowPrototypes,
          arrayLimit:
            "number" == typeof e.arrayLimit ? e.arrayLimit : a.arrayLimit,
          charset: t,
          charsetSentinel:
            "boolean" == typeof e.charsetSentinel
              ? e.charsetSentinel
              : a.charsetSentinel,
          comma: "boolean" == typeof e.comma ? e.comma : a.comma,
          decoder: "function" == typeof e.decoder ? e.decoder : a.decoder,
          delimiter:
            "string" == typeof e.delimiter || n.isRegExp(e.delimiter)
              ? e.delimiter
              : a.delimiter,
          depth:
            "number" == typeof e.depth || !1 === e.depth ? +e.depth : a.depth,
          ignoreQueryPrefix: !0 === e.ignoreQueryPrefix,
          interpretNumericEntities:
            "boolean" == typeof e.interpretNumericEntities
              ? e.interpretNumericEntities
              : a.interpretNumericEntities,
          parameterLimit:
            "number" == typeof e.parameterLimit
              ? e.parameterLimit
              : a.parameterLimit,
          parseArrays: !1 !== e.parseArrays,
          plainObjects:
            "boolean" == typeof e.plainObjects
              ? e.plainObjects
              : a.plainObjects,
          strictNullHandling:
            "boolean" == typeof e.strictNullHandling
              ? e.strictNullHandling
              : a.strictNullHandling,
        };
      };
    e.exports = function (e, t) {
      var r = d(t);
      if ("" === e || null === e || void 0 === e)
        return r.plainObjects ? Object.create(null) : {};
      for (
        var i = "string" == typeof e ? u(e, r) : e,
          o = r.plainObjects ? Object.create(null) : {},
          a = Object.keys(i),
          s = 0;
        s < a.length;
        ++s
      ) {
        var c = a[s],
          l = f(c, i[c], r, "string" == typeof e);
        o = n.merge(o, l, r);
      }
      return n.compact(o);
    };
  },
  function (e, t, r) {
    "use strict";
    var n = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }),
      Object.defineProperty(t, "createInfiniteHitsSessionStorageCache", {
        enumerable: !0,
        get: function () {
          return i.default;
        },
      });
    var i = n(r(148));
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      if (null == e) return {};
      var r,
        n,
        o = i(e, t);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for (n = 0; n < a.length; n++)
          (r = a[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (o[r] = e[r]));
      }
      return o;
    }
    function i(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    function o(e) {
      return n(e || {}, ["page"]);
    }
    function a() {
      return {
        read: function (e) {
          var t = e.state,
            r = (0, s.safelyRunOnBrowser)(function (e) {
              return e.window.sessionStorage;
            });
          if (!r) return null;
          try {
            var n = JSON.parse(r.getItem(c));
            return n && (0, s.isEqual)(n.state, o(t)) ? n.hits : null;
          } catch (e) {
            if (e instanceof SyntaxError)
              try {
                r.removeItem(c);
              } catch (e) {}
            return null;
          }
        },
        write: function (e) {
          var t = e.state,
            r = e.hits,
            n = (0, s.safelyRunOnBrowser)(function (e) {
              return e.window.sessionStorage;
            });
          if (n)
            try {
              n.setItem(c, JSON.stringify({ state: o(t), hits: r }));
            } catch (e) {}
        },
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = a);
    var s = r(1),
      c = "ais.infiniteHits";
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(150);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(151);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
    var o = r(153);
    Object.keys(o).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return o[e];
          },
        });
    });
    var a = r(154);
    Object.keys(a).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return a[e];
          },
        });
    });
    var s = r(155);
    Object.keys(s).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return s[e];
          },
        });
    });
    var c = r(156);
    Object.keys(c).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return c[e];
          },
        });
    });
    var u = r(157);
    Object.keys(u).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return u[e];
          },
        });
    });
    var l = r(158);
    Object.keys(l).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return l[e];
          },
        });
    });
    var f = r(159);
    Object.keys(f).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return f[e];
          },
        });
    });
    var d = r(160);
    Object.keys(d).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return d[e];
          },
        });
    });
    var p = r(161);
    Object.keys(p).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return p[e];
          },
        });
    });
    var h = r(162);
    Object.keys(h).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return h[e];
          },
        });
    });
    var v = r(163);
    Object.keys(v).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return v[e];
          },
        });
    });
    var m = r(164);
    Object.keys(m).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return m[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(152);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
  },
  function (e, t, r) {
    "use strict";
  },
  function (e, t, r) {
    "use strict";
  },
  function (e, t, r) {
    "use strict";
  },
  function (e, t, r) {
    "use strict";
  },
  function (e, t, r) {
    "use strict";
  },
  function (e, t, r) {
    "use strict";
  },
  function (e, t, r) {
    "use strict";
  },
  function (e, t, r) {
    "use strict";
  },
  function (e, t, r) {
    "use strict";
  },
  function (e, t, r) {
    "use strict";
  },
  function (e, t, r) {
    "use strict";
  },
  function (e, t, r) {
    "use strict";
  },
  function (e, t, r) {
    "use strict";
    var n = r(166),
      i = r(177);
    e.exports = i(n, "Browser (lite)");
  },
  function (e, t, r) {
    "use strict";
    function n(e, t, n) {
      var o = r(21)("algoliasearch"),
        a = r(10),
        s = r(19),
        u = r(20),
        l = "Usage: algoliasearch(applicationID, apiKey, opts)";
      if (!0 !== n._allowEmptyCredentials && !e)
        throw new c.AlgoliaSearchError(
          "Please provide an application ID. " + l
        );
      if (!0 !== n._allowEmptyCredentials && !t)
        throw new c.AlgoliaSearchError("Please provide an API key. " + l);
      (this.applicationID = e),
        (this.apiKey = t),
        (this.hosts = { read: [], write: [] }),
        (n = n || {}),
        (this._timeouts = n.timeouts || {
          connect: 1e3,
          read: 2e3,
          write: 3e4,
        }),
        n.timeout &&
          (this._timeouts.connect =
            this._timeouts.read =
            this._timeouts.write =
              n.timeout);
      var f = n.protocol || "https:";
      if ((/:$/.test(f) || (f += ":"), "http:" !== f && "https:" !== f))
        throw new c.AlgoliaSearchError(
          "protocol must be `http:` or `https:` (was `" + n.protocol + "`)"
        );
      if ((this._checkAppIdData(), n.hosts))
        s(n.hosts)
          ? ((this.hosts.read = a(n.hosts)), (this.hosts.write = a(n.hosts)))
          : ((this.hosts.read = a(n.hosts.read)),
            (this.hosts.write = a(n.hosts.write)));
      else {
        var d = u(this._shuffleResult, function (t) {
            return e + "-" + t + ".algolianet.com";
          }),
          p = (!1 === n.dsn ? "" : "-dsn") + ".algolia.net";
        (this.hosts.read = [this.applicationID + p].concat(d)),
          (this.hosts.write = [this.applicationID + ".algolia.net"].concat(d));
      }
      (this.hosts.read = u(this.hosts.read, i(f))),
        (this.hosts.write = u(this.hosts.write, i(f))),
        (this.extraHeaders = {}),
        (this.cache = n._cache || {}),
        (this._ua = n._ua),
        (this._useCache =
          !(void 0 !== n._useCache && !n._cache) || n._useCache),
        (this._useRequestCache = this._useCache && n._useRequestCache),
        (this._useFallback = void 0 === n.useFallback || n.useFallback),
        (this._setTimeout = n._setTimeout),
        o("init done, %j", this);
    }
    function i(e) {
      return function (t) {
        return e + "//" + t.toLowerCase();
      };
    }
    function o(e) {
      if (void 0 === Array.prototype.toJSON) return JSON.stringify(e);
      var t = Array.prototype.toJSON;
      delete Array.prototype.toJSON;
      var r = JSON.stringify(e);
      return (Array.prototype.toJSON = t), r;
    }
    function a(e) {
      for (var t, r, n = e.length; 0 !== n; )
        (r = Math.floor(Math.random() * n)),
          (n -= 1),
          (t = e[n]),
          (e[n] = e[r]),
          (e[r] = t);
      return e;
    }
    function s(e) {
      var t = {};
      for (var r in e)
        if (Object.prototype.hasOwnProperty.call(e, r)) {
          var n;
          (n =
            "x-algolia-api-key" === r || "x-algolia-application-id" === r
              ? "**hidden for security purposes**"
              : e[r]),
            (t[r] = n);
        }
      return t;
    }
    e.exports = n;
    var c = r(18),
      u = r(167),
      l = r(168),
      f = r(174),
      d =
        (Object({ NODE_ENV: "production" }).RESET_APP_DATA_TIMER &&
          parseInt(
            Object({ NODE_ENV: "production" }).RESET_APP_DATA_TIMER,
            10
          )) ||
        12e4;
    (n.prototype.initIndex = function (e) {
      return new l(this, e);
    }),
      (n.prototype.setExtraHeader = function (e, t) {
        this.extraHeaders[e.toLowerCase()] = t;
      }),
      (n.prototype.getExtraHeader = function (e) {
        return this.extraHeaders[e.toLowerCase()];
      }),
      (n.prototype.unsetExtraHeader = function (e) {
        delete this.extraHeaders[e.toLowerCase()];
      }),
      (n.prototype.addAlgoliaAgent = function (e) {
        var t = "; " + e;
        -1 === this._ua.indexOf(t) && (this._ua += t);
      }),
      (n.prototype._jsonRequest = function (e) {
        function t(r, i) {
          function u(e) {
            var t =
              (e && e.body && e.body.message && e.body.status) ||
              e.statusCode ||
              (e && e.body && 200);
            d(
              "received response: statusCode: %s, computed statusCode: %d, headers: %j",
              e.statusCode,
              t,
              e.headers
            );
            var r = 2 === Math.floor(t / 100),
              n = new Date();
            if (
              (b.push({
                currentHost: S,
                headers: s(f),
                content: a || null,
                contentLength: void 0 !== a ? a.length : null,
                method: i.method,
                timeouts: i.timeouts,
                url: i.url,
                startTime: P,
                endTime: n,
                duration: n - P,
                statusCode: t,
              }),
              r)
            )
              return (
                v._useCache &&
                  !v._useRequestCache &&
                  h &&
                  (h[l] = e.responseText),
                { responseText: e.responseText, body: e.body }
              );
            if (4 !== Math.floor(t / 100)) return (m += 1), O();
            d("unrecoverable error");
            var o = new c.AlgoliaSearchError(e.body && e.body.message, {
              debugData: b,
              statusCode: t,
            });
            return v._promise.reject(o);
          }
          function _(t) {
            d("error: %s, stack: %s", t.message, t.stack);
            var r = new Date();
            return (
              b.push({
                currentHost: S,
                headers: s(f),
                content: a || null,
                contentLength: void 0 !== a ? a.length : null,
                method: i.method,
                timeouts: i.timeouts,
                url: i.url,
                startTime: P,
                endTime: r,
                duration: r - P,
              }),
              t instanceof c.AlgoliaSearchError ||
                (t = new c.Unknown(t && t.message, t)),
              (m += 1),
              t instanceof c.Unknown ||
              t instanceof c.UnparsableJSON ||
              (m >= v.hosts[e.hostType].length && (g || !y))
                ? ((t.debugData = b), v._promise.reject(t))
                : t instanceof c.RequestTimeout
                ? j()
                : O()
            );
          }
          function O() {
            return (
              d("retrying request"), v._incrementHostIndex(e.hostType), t(r, i)
            );
          }
          function j() {
            return (
              d("retrying request with higher timeout"),
              v._incrementHostIndex(e.hostType),
              v._incrementTimeoutMultipler(),
              (i.timeouts = v._getTimeoutsForRequest(e.hostType)),
              t(r, i)
            );
          }
          v._checkAppIdData();
          var P = new Date();
          if (
            (v._useCache && !v._useRequestCache && (l = e.url),
            v._useCache && !v._useRequestCache && a && (l += "_body_" + i.body),
            n(!v._useRequestCache, h, l))
          ) {
            d("serving response from cache");
            var w = h[l];
            return v._promise.resolve({ body: JSON.parse(w), responseText: w });
          }
          if (m >= v.hosts[e.hostType].length)
            return !y || g
              ? (d("could not get any response"),
                v._promise.reject(
                  new c.AlgoliaSearchError(
                    "Cannot connect to the AlgoliaSearch API. Send an email to support@algolia.com to report and resolve the issue. Application id was: " +
                      v.applicationID,
                    { debugData: b }
                  )
                ))
              : (d("switching to fallback"),
                (m = 0),
                (i.method = e.fallback.method),
                (i.url = e.fallback.url),
                (i.jsonBody = e.fallback.body),
                i.jsonBody && (i.body = o(i.jsonBody)),
                (f = v._computeRequestHeaders({
                  additionalUA: p,
                  headers: e.headers,
                })),
                (i.timeouts = v._getTimeoutsForRequest(e.hostType)),
                v._setHostIndexByType(0, e.hostType),
                (g = !0),
                t(v._request.fallback, i));
          var S = v._getHostByType(e.hostType),
            E = S + i.url,
            R = {
              body: i.body,
              jsonBody: i.jsonBody,
              method: i.method,
              headers: f,
              timeouts: i.timeouts,
              debug: d,
              forceAuthHeaders: i.forceAuthHeaders,
            };
          return (
            d(
              "method: %s, url: %s, headers: %j, timeouts: %d",
              R.method,
              E,
              R.headers,
              R.timeouts
            ),
            r === v._request.fallback && d("using fallback"),
            r.call(v, E, R).then(u, _)
          );
        }
        function n(e, t, r) {
          return v._useCache && e && t && void 0 !== t[r];
        }
        function i(t, r) {
          if (
            (n(v._useRequestCache, h, l) &&
              t.catch(function () {
                delete h[l];
              }),
            "function" != typeof e.callback)
          )
            return t.then(r);
          t.then(
            function (t) {
              u(function () {
                e.callback(null, r(t));
              }, v._setTimeout || setTimeout);
            },
            function (t) {
              u(function () {
                e.callback(t);
              }, v._setTimeout || setTimeout);
            }
          );
        }
        this._checkAppIdData();
        var a,
          l,
          f,
          d = r(21)("algoliasearch:" + e.url),
          p = e.additionalUA || "",
          h = e.cache,
          v = this,
          m = 0,
          g = !1,
          y = v._useFallback && v._request.fallback && e.fallback;
        this.apiKey.length > 500 &&
        void 0 !== e.body &&
        (void 0 !== e.body.params || void 0 !== e.body.requests)
          ? ((e.body.apiKey = this.apiKey),
            (f = this._computeRequestHeaders({
              additionalUA: p,
              withApiKey: !1,
              headers: e.headers,
            })))
          : (f = this._computeRequestHeaders({
              additionalUA: p,
              headers: e.headers,
            })),
          void 0 !== e.body && (a = o(e.body)),
          d("request start");
        var b = [];
        if (
          (v._useCache && v._useRequestCache && (l = e.url),
          v._useCache && v._useRequestCache && a && (l += "_body_" + a),
          n(v._useRequestCache, h, l))
        ) {
          d("serving request from cache");
          var _ = h[l];
          return i(
            "function" != typeof _.then
              ? v._promise.resolve({ responseText: _ })
              : _,
            function (e) {
              return JSON.parse(e.responseText);
            }
          );
        }
        var O = t(v._request, {
          url: e.url,
          method: e.method,
          body: a,
          jsonBody: e.body,
          timeouts: v._getTimeoutsForRequest(e.hostType),
          forceAuthHeaders: e.forceAuthHeaders,
        });
        return (
          v._useCache && v._useRequestCache && h && (h[l] = O),
          i(O, function (e) {
            return e.body;
          })
        );
      }),
      (n.prototype._getSearchParams = function (e, t) {
        if (void 0 === e || null === e) return t;
        for (var r in e)
          null !== r &&
            void 0 !== e[r] &&
            e.hasOwnProperty(r) &&
            ((t += "" === t ? "" : "&"),
            (t +=
              r +
              "=" +
              encodeURIComponent(
                "[object Array]" === Object.prototype.toString.call(e[r])
                  ? o(e[r])
                  : e[r]
              )));
        return t;
      }),
      (n.prototype._computeRequestHeaders = function (e) {
        var t = r(9),
          n = e.additionalUA ? this._ua + "; " + e.additionalUA : this._ua,
          i = {
            "x-algolia-agent": n,
            "x-algolia-application-id": this.applicationID,
          };
        return (
          !1 !== e.withApiKey && (i["x-algolia-api-key"] = this.apiKey),
          this.userToken && (i["x-algolia-usertoken"] = this.userToken),
          this.securityTags && (i["x-algolia-tagfilters"] = this.securityTags),
          t(this.extraHeaders, function (e, t) {
            i[t] = e;
          }),
          e.headers &&
            t(e.headers, function (e, t) {
              i[t] = e;
            }),
          i
        );
      }),
      (n.prototype.search = function (e, t, n) {
        var i = r(19),
          o = r(20);
        if (!i(e))
          throw new Error("Usage: client.search(arrayOfQueries[, callback])");
        "function" == typeof t ? ((n = t), (t = {})) : void 0 === t && (t = {});
        var a = this,
          s = {
            requests: o(e, function (e) {
              var t = "";
              return (
                void 0 !== e.query &&
                  (t += "query=" + encodeURIComponent(e.query)),
                {
                  indexName: e.indexName,
                  params: a._getSearchParams(e.params, t),
                }
              );
            }),
          },
          c = o(s.requests, function (e, t) {
            return (
              t +
              "=" +
              encodeURIComponent(
                "/1/indexes/" + encodeURIComponent(e.indexName) + "?" + e.params
              )
            );
          }).join("&");
        return (
          void 0 !== t.strategy && (s.strategy = t.strategy),
          this._jsonRequest({
            cache: this.cache,
            method: "POST",
            url: "/1/indexes/*/queries",
            body: s,
            hostType: "read",
            fallback: {
              method: "GET",
              url: "/1/indexes/*",
              body: { params: c },
            },
            callback: n,
          })
        );
      }),
      (n.prototype.searchForFacetValues = function (e) {
        var t = r(19),
          n = r(20),
          i =
            "Usage: client.searchForFacetValues([{indexName, params: {facetName, facetQuery, ...params}}, ...queries])";
        if (!t(e)) throw new Error(i);
        var o = this;
        return o._promise.all(
          n(e, function (e) {
            if (
              !e ||
              void 0 === e.indexName ||
              void 0 === e.params.facetName ||
              void 0 === e.params.facetQuery
            )
              throw new Error(i);
            var t = r(10),
              n = r(64),
              a = e.indexName,
              s = e.params,
              c = s.facetName,
              u = n(t(s), function (e) {
                return "facetName" === e;
              }),
              l = o._getSearchParams(u, "");
            return o._jsonRequest({
              cache: o.cache,
              method: "POST",
              url:
                "/1/indexes/" +
                encodeURIComponent(a) +
                "/facets/" +
                encodeURIComponent(c) +
                "/query",
              hostType: "read",
              body: { params: l },
            });
          })
        );
      }),
      (n.prototype.setSecurityTags = function (e) {
        if ("[object Array]" === Object.prototype.toString.call(e)) {
          for (var t = [], r = 0; r < e.length; ++r)
            if ("[object Array]" === Object.prototype.toString.call(e[r])) {
              for (var n = [], i = 0; i < e[r].length; ++i) n.push(e[r][i]);
              t.push("(" + n.join(",") + ")");
            } else t.push(e[r]);
          e = t.join(",");
        }
        this.securityTags = e;
      }),
      (n.prototype.setUserToken = function (e) {
        this.userToken = e;
      }),
      (n.prototype.clearCache = function () {
        this.cache = {};
      }),
      (n.prototype.setRequestTimeout = function (e) {
        e &&
          (this._timeouts.connect =
            this._timeouts.read =
            this._timeouts.write =
              e);
      }),
      (n.prototype.setTimeouts = function (e) {
        this._timeouts = e;
      }),
      (n.prototype.getTimeouts = function () {
        return this._timeouts;
      }),
      (n.prototype._getAppIdData = function () {
        var e = f.get(this.applicationID);
        return null !== e && this._cacheAppIdData(e), e;
      }),
      (n.prototype._setAppIdData = function (e) {
        return (
          (e.lastChange = new Date().getTime()),
          this._cacheAppIdData(e),
          f.set(this.applicationID, e)
        );
      }),
      (n.prototype._checkAppIdData = function () {
        var e = this._getAppIdData(),
          t = new Date().getTime();
        return null === e || t - e.lastChange > d
          ? this._resetInitialAppIdData(e)
          : e;
      }),
      (n.prototype._resetInitialAppIdData = function (e) {
        var t = e || {};
        return (
          (t.hostIndexes = { read: 0, write: 0 }),
          (t.timeoutMultiplier = 1),
          (t.shuffleResult = t.shuffleResult || a([1, 2, 3])),
          this._setAppIdData(t)
        );
      }),
      (n.prototype._cacheAppIdData = function (e) {
        (this._hostIndexes = e.hostIndexes),
          (this._timeoutMultiplier = e.timeoutMultiplier),
          (this._shuffleResult = e.shuffleResult);
      }),
      (n.prototype._partialAppIdDataUpdate = function (e) {
        var t = r(9),
          n = this._getAppIdData();
        return (
          t(e, function (e, t) {
            n[t] = e;
          }),
          this._setAppIdData(n)
        );
      }),
      (n.prototype._getHostByType = function (e) {
        return this.hosts[e][this._getHostIndexByType(e)];
      }),
      (n.prototype._getTimeoutMultiplier = function () {
        return this._timeoutMultiplier;
      }),
      (n.prototype._getHostIndexByType = function (e) {
        return this._hostIndexes[e];
      }),
      (n.prototype._setHostIndexByType = function (e, t) {
        var n = r(10),
          i = n(this._hostIndexes);
        return (i[t] = e), this._partialAppIdDataUpdate({ hostIndexes: i }), e;
      }),
      (n.prototype._incrementHostIndex = function (e) {
        return this._setHostIndexByType(
          (this._getHostIndexByType(e) + 1) % this.hosts[e].length,
          e
        );
      }),
      (n.prototype._incrementTimeoutMultipler = function () {
        var e = Math.max(this._timeoutMultiplier + 1, 4);
        return this._partialAppIdDataUpdate({ timeoutMultiplier: e });
      }),
      (n.prototype._getTimeoutsForRequest = function (e) {
        return {
          connect: this._timeouts.connect * this._timeoutMultiplier,
          complete: this._timeouts[e] * this._timeoutMultiplier,
        };
      });
  },
  function (e, t, r) {
    "use strict";
    e.exports = function (e, t) {
      t(e, 0);
    };
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      (this.indexName = t),
        (this.as = e),
        (this.typeAheadArgs = null),
        (this.typeAheadValueOption = null),
        (this.cache = {});
    }
    var i = r(0),
      o = i(r(4)),
      a = r(63),
      s = r(169),
      c = r(170);
    (e.exports = n),
      (n.prototype.clearCache = function () {
        this.cache = {};
      }),
      (n.prototype.search = a("query")),
      (n.prototype.similarSearch = s(
        a("similarQuery"),
        c(
          "index.similarSearch(query[, callback])",
          "index.search({ similarQuery: query }[, callback])"
        )
      )),
      (n.prototype.browse = function (e, t, n) {
        var i,
          a,
          s = r(171),
          c = this;
        0 === arguments.length ||
        (1 === arguments.length && "function" == typeof arguments[0])
          ? ((i = 0), (n = arguments[0]), (e = void 0))
          : "number" == typeof arguments[0]
          ? ((i = arguments[0]),
            "number" == typeof arguments[1]
              ? (a = arguments[1])
              : "function" == typeof arguments[1] &&
                ((n = arguments[1]), (a = void 0)),
            (e = void 0),
            (t = void 0))
          : "object" === (0, o.default)(arguments[0])
          ? ("function" == typeof arguments[1] && (n = arguments[1]),
            (t = arguments[0]),
            (e = void 0))
          : "string" == typeof arguments[0] &&
            "function" == typeof arguments[1] &&
            ((n = arguments[1]), (t = void 0)),
          (t = s({}, t || {}, { page: i, hitsPerPage: a, query: e }));
        var u = this.as._getSearchParams(t, "");
        return this.as._jsonRequest({
          method: "POST",
          url: "/1/indexes/" + encodeURIComponent(c.indexName) + "/browse",
          body: { params: u },
          hostType: "read",
          callback: n,
        });
      }),
      (n.prototype.browseFrom = function (e, t) {
        return this.as._jsonRequest({
          method: "POST",
          url: "/1/indexes/" + encodeURIComponent(this.indexName) + "/browse",
          body: { cursor: e },
          hostType: "read",
          callback: t,
        });
      }),
      (n.prototype.searchForFacetValues = function (e, t) {
        var n = r(10),
          i = r(64);
        if (void 0 === e.facetName || void 0 === e.facetQuery)
          throw new Error(
            "Usage: index.searchForFacetValues({facetName, facetQuery, ...params}[, callback])"
          );
        var o = e.facetName,
          a = i(n(e), function (e) {
            return "facetName" === e;
          }),
          s = this.as._getSearchParams(a, "");
        return this.as._jsonRequest({
          method: "POST",
          url:
            "/1/indexes/" +
            encodeURIComponent(this.indexName) +
            "/facets/" +
            encodeURIComponent(o) +
            "/query",
          hostType: "read",
          body: { params: s },
          callback: t,
        });
      }),
      (n.prototype.searchFacet = s(function (e, t) {
        return this.searchForFacetValues(e, t);
      }, c(
        "index.searchFacet(params[, callback])",
        "index.searchForFacetValues(params[, callback])"
      ))),
      (n.prototype._search = function (e, t, r, n) {
        return this.as._jsonRequest({
          cache: this.cache,
          method: "POST",
          url:
            t || "/1/indexes/" + encodeURIComponent(this.indexName) + "/query",
          body: { params: e },
          hostType: "read",
          fallback: {
            method: "GET",
            url: "/1/indexes/" + encodeURIComponent(this.indexName),
            body: { params: e },
          },
          callback: r,
          additionalUA: n,
        });
      }),
      (n.prototype.getObject = function (e, t, r) {
        var n = this;
        (1 !== arguments.length && "function" != typeof t) ||
          ((r = t), (t = void 0));
        var i = "";
        if (void 0 !== t) {
          i = "?attributes=";
          for (var o = 0; o < t.length; ++o) 0 !== o && (i += ","), (i += t[o]);
        }
        return this.as._jsonRequest({
          method: "GET",
          url:
            "/1/indexes/" +
            encodeURIComponent(n.indexName) +
            "/" +
            encodeURIComponent(e) +
            i,
          hostType: "read",
          callback: r,
        });
      }),
      (n.prototype.getObjects = function (e, t, n) {
        var i = r(19),
          o = r(20);
        if (!i(e))
          throw new Error(
            "Usage: index.getObjects(arrayOfObjectIDs[, callback])"
          );
        var a = this;
        (1 !== arguments.length && "function" != typeof t) ||
          ((n = t), (t = void 0));
        var s = {
          requests: o(e, function (e) {
            var r = { indexName: a.indexName, objectID: e };
            return t && (r.attributesToRetrieve = t.join(",")), r;
          }),
        };
        return this.as._jsonRequest({
          method: "POST",
          url: "/1/indexes/*/objects",
          hostType: "read",
          body: s,
          callback: n,
        });
      }),
      (n.prototype.as = null),
      (n.prototype.indexName = null),
      (n.prototype.typeAheadArgs = null),
      (n.prototype.typeAheadValueOption = null);
  },
  function (e, t, r) {
    "use strict";
    e.exports = function (e, t) {
      function r() {
        return n || (console.warn(t), (n = !0)), e.apply(this, arguments);
      }
      var n = !1;
      return r;
    };
  },
  function (e, t, r) {
    "use strict";
    e.exports = function (e, t) {
      return (
        "algoliasearch: `" +
        e +
        "` was replaced by `" +
        t +
        "`. Please see https://github.com/algolia/algoliasearch-client-javascript/wiki/Deprecated#" +
        e.toLowerCase().replace(/[\.\(\)]/g, "")
      );
    };
  },
  function (e, t, r) {
    "use strict";
    var n = r(0),
      i = n(r(4)),
      o = r(9);
    e.exports = function e(t) {
      var r = Array.prototype.slice.call(arguments);
      return (
        o(r, function (r) {
          for (var n in r)
            r.hasOwnProperty(n) &&
              ("object" === (0, i.default)(t[n]) &&
              "object" === (0, i.default)(r[n])
                ? (t[n] = e({}, t[n], r[n]))
                : void 0 !== r[n] && (t[n] = r[n]));
        }),
        t
      );
    };
  },
  function (e, t, r) {
    "use strict";
    var n = r(0),
      i = n(r(4)),
      o = Object.prototype.hasOwnProperty,
      a = Object.prototype.toString,
      s = Array.prototype.slice,
      c = r(173),
      u = Object.prototype.propertyIsEnumerable,
      l = !u.call({ toString: null }, "toString"),
      f = u.call(function () {}, "prototype"),
      d = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor",
      ],
      p = function (e) {
        var t = e.constructor;
        return t && t.prototype === e;
      },
      h = {
        $console: !0,
        $external: !0,
        $frame: !0,
        $frameElement: !0,
        $frames: !0,
        $innerHeight: !0,
        $innerWidth: !0,
        $outerHeight: !0,
        $outerWidth: !0,
        $pageXOffset: !0,
        $pageYOffset: !0,
        $parent: !0,
        $scrollLeft: !0,
        $scrollTop: !0,
        $scrollX: !0,
        $scrollY: !0,
        $self: !0,
        $webkitIndexedDB: !0,
        $webkitStorageInfo: !0,
        $window: !0,
      },
      v = (function () {
        if ("undefined" == typeof window) return !1;
        for (var e in window)
          try {
            if (
              !h["$" + e] &&
              o.call(window, e) &&
              null !== window[e] &&
              "object" === (0, i.default)(window[e])
            )
              try {
                p(window[e]);
              } catch (e) {
                return !0;
              }
          } catch (e) {
            return !0;
          }
        return !1;
      })(),
      m = function (e) {
        if ("undefined" == typeof window || !v) return p(e);
        try {
          return p(e);
        } catch (e) {
          return !1;
        }
      },
      g = function (e) {
        var t = null !== e && "object" === (0, i.default)(e),
          r = "[object Function]" === a.call(e),
          n = c(e),
          s = t && "[object String]" === a.call(e),
          u = [];
        if (!t && !r && !n)
          throw new TypeError("Object.keys called on a non-object");
        var p = f && r;
        if (s && e.length > 0 && !o.call(e, 0))
          for (var h = 0; h < e.length; ++h) u.push(String(h));
        if (n && e.length > 0)
          for (var v = 0; v < e.length; ++v) u.push(String(v));
        else
          for (var g in e)
            (p && "prototype" === g) || !o.call(e, g) || u.push(String(g));
        if (l)
          for (var y = m(e), b = 0; b < d.length; ++b)
            (y && "constructor" === d[b]) || !o.call(e, d[b]) || u.push(d[b]);
        return u;
      };
    (g.shim = function () {
      if (Object.keys) {
        if (
          !(function () {
            return 2 === (Object.keys(arguments) || "").length;
          })(1, 2)
        ) {
          var e = Object.keys;
          Object.keys = function (t) {
            return e(c(t) ? s.call(t) : t);
          };
        }
      } else Object.keys = g;
      return Object.keys || g;
    }),
      (e.exports = g);
  },
  function (e, t, r) {
    "use strict";
    var n = r(0),
      i = n(r(4)),
      o = Object.prototype.toString;
    e.exports = function (e) {
      var t = o.call(e),
        r = "[object Arguments]" === t;
      return (
        r ||
          (r =
            "[object Array]" !== t &&
            null !== e &&
            "object" === (0, i.default)(e) &&
            "number" == typeof e.length &&
            e.length >= 0 &&
            "[object Function]" === o.call(e.callee)),
        r
      );
    };
  },
  function (e, t, r) {
    "use strict";
    (function (t) {
      function n(e, t) {
        return c("localStorage failed with", t), a(), (s = l), s.get(e);
      }
      function i(e, t) {
        return 1 === arguments.length ? s.get(e) : s.set(e, t);
      }
      function o() {
        try {
          return (
            "localStorage" in t &&
            null !== t.localStorage &&
            (t.localStorage[u] || t.localStorage.setItem(u, JSON.stringify({})),
            !0)
          );
        } catch (e) {
          return !1;
        }
      }
      function a() {
        try {
          t.localStorage.removeItem(u);
        } catch (e) {}
      }
      var s,
        c = r(21)("algoliasearch:src/hostIndexState.js"),
        u = "algoliasearch-client-js",
        l = {
          state: {},
          set: function (e, t) {
            return (this.state[e] = t), this.state[e];
          },
          get: function (e) {
            return this.state[e] || null;
          },
        },
        f = {
          set: function (e, r) {
            l.set(e, r);
            try {
              var i = JSON.parse(t.localStorage[u]);
              return (i[e] = r), (t.localStorage[u] = JSON.stringify(i)), i[e];
            } catch (t) {
              return n(e, t);
            }
          },
          get: function (e) {
            try {
              return JSON.parse(t.localStorage[u])[e] || null;
            } catch (t) {
              return n(e, t);
            }
          },
        };
      (s = o() ? f : l),
        (e.exports = { get: i, set: i, supportsLocalStorage: o });
    }.call(t, r(34)));
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var r,
        n = 0;
      for (r in e) (n = (n << 5) - n + e.charCodeAt(r)), (n |= 0);
      return t.colors[Math.abs(n) % t.colors.length];
    }
    function i(e) {
      function r() {
        if (r.enabled) {
          var e = r,
            n = +new Date(),
            i = n - (u || n);
          (e.diff = i), (e.prev = u), (e.curr = n), (u = n);
          for (var o = new Array(arguments.length), a = 0; a < o.length; a++)
            o[a] = arguments[a];
          (o[0] = t.coerce(o[0])), "string" != typeof o[0] && o.unshift("%O");
          var s = 0;
          (o[0] = o[0].replace(/%([a-zA-Z%])/g, function (r, n) {
            if ("%%" === r) return r;
            s++;
            var i = t.formatters[n];
            if ("function" == typeof i) {
              var a = o[s];
              (r = i.call(e, a)), o.splice(s, 1), s--;
            }
            return r;
          })),
            t.formatArgs.call(e, o),
            (r.log || t.log || console.log.bind(console)).apply(e, o);
        }
      }
      return (
        (r.namespace = e),
        (r.enabled = t.enabled(e)),
        (r.useColors = t.useColors()),
        (r.color = n(e)),
        "function" == typeof t.init && t.init(r),
        r
      );
    }
    function o(e) {
      t.save(e), (t.names = []), (t.skips = []);
      for (
        var r = ("string" == typeof e ? e : "").split(/[\s,]+/),
          n = r.length,
          i = 0;
        i < n;
        i++
      )
        r[i] &&
          ((e = r[i].replace(/\*/g, ".*?")),
          "-" === e[0]
            ? t.skips.push(new RegExp("^" + e.substr(1) + "$"))
            : t.names.push(new RegExp("^" + e + "$")));
    }
    function a() {
      t.enable("");
    }
    function s(e) {
      var r, n;
      for (r = 0, n = t.skips.length; r < n; r++)
        if (t.skips[r].test(e)) return !1;
      for (r = 0, n = t.names.length; r < n; r++)
        if (t.names[r].test(e)) return !0;
      return !1;
    }
    function c(e) {
      return e instanceof Error ? e.stack || e.message : e;
    }
    (t = e.exports = i.debug = i.default = i),
      (t.coerce = c),
      (t.disable = a),
      (t.enable = o),
      (t.enabled = s),
      (t.humanize = r(176)),
      (t.names = []),
      (t.skips = []),
      (t.formatters = {});
    var u;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      if (((e = String(e)), !(e.length > 100))) {
        var t =
          /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
            e
          );
        if (t) {
          var r = parseFloat(t[1]);
          switch ((t[2] || "ms").toLowerCase()) {
            case "years":
            case "year":
            case "yrs":
            case "yr":
            case "y":
              return r * p;
            case "days":
            case "day":
            case "d":
              return r * d;
            case "hours":
            case "hour":
            case "hrs":
            case "hr":
            case "h":
              return r * f;
            case "minutes":
            case "minute":
            case "mins":
            case "min":
            case "m":
              return r * l;
            case "seconds":
            case "second":
            case "secs":
            case "sec":
            case "s":
              return r * u;
            case "milliseconds":
            case "millisecond":
            case "msecs":
            case "msec":
            case "ms":
              return r;
            default:
              return;
          }
        }
      }
    }
    function i(e) {
      return e >= d
        ? Math.round(e / d) + "d"
        : e >= f
        ? Math.round(e / f) + "h"
        : e >= l
        ? Math.round(e / l) + "m"
        : e >= u
        ? Math.round(e / u) + "s"
        : e + "ms";
    }
    function o(e) {
      return (
        a(e, d, "day") ||
        a(e, f, "hour") ||
        a(e, l, "minute") ||
        a(e, u, "second") ||
        e + " ms"
      );
    }
    function a(e, t, r) {
      if (!(e < t))
        return e < 1.5 * t
          ? Math.floor(e / t) + " " + r
          : Math.ceil(e / t) + " " + r + "s";
    }
    var s = r(0),
      c = s(r(4)),
      u = 1e3,
      l = 60 * u,
      f = 60 * l,
      d = 24 * f,
      p = 365.25 * d;
    e.exports = function (e, t) {
      t = t || {};
      var r = (0, c.default)(e);
      if ("string" === r && e.length > 0) return n(e);
      if ("number" === r && !1 === isNaN(e)) return t.long ? o(e) : i(e);
      throw new Error(
        "val is not a non-empty string or a valid number. val=" +
          JSON.stringify(e)
      );
    };
  },
  function (e, t, r) {
    "use strict";
    var n = r(178),
      i = n.Promise || r(179).Promise;
    e.exports = function (e, t) {
      function o(e, t, n) {
        return (n = r(10)(n || {})), (n._ua = n._ua || o.ua), new a(e, t, n);
      }
      function a() {
        e.apply(this, arguments);
      }
      var s = r(62),
        c = r(18),
        u = r(181),
        l = r(182),
        f = r(183);
      (t = t || ""),
        (o.version = r(186)),
        (o.ua = "Algolia for JavaScript (" + o.version + "); " + t),
        (o.initPlaces = f(o)),
        (n.__algolia = { debug: r(21), algoliasearch: o });
      var d = {
        hasXMLHttpRequest: "XMLHttpRequest" in n,
        hasXDomainRequest: "XDomainRequest" in n,
      };
      return (
        d.hasXMLHttpRequest &&
          (d.cors = "withCredentials" in new XMLHttpRequest()),
        s(a, e),
        (a.prototype._request = function (e, t) {
          return new i(function (r, n) {
            function i() {
              if (!h) {
                clearTimeout(p);
                var e;
                try {
                  e = {
                    body: JSON.parse(m.responseText),
                    responseText: m.responseText,
                    statusCode: m.status,
                    headers:
                      (m.getAllResponseHeaders && m.getAllResponseHeaders()) ||
                      {},
                  };
                } catch (t) {
                  e = new c.UnparsableJSON({ more: m.responseText });
                }
                e instanceof c.UnparsableJSON ? n(e) : r(e);
              }
            }
            function o(e) {
              h || (clearTimeout(p), n(new c.Network({ more: e })));
            }
            function a() {
              (h = !0), m.abort(), n(new c.RequestTimeout());
            }
            function s() {
              (g = !0),
                clearTimeout(p),
                (p = setTimeout(a, t.timeouts.complete));
            }
            function l() {
              g || s();
            }
            function f() {
              !g && m.readyState > 1 && s();
            }
            if (!d.cors && !d.hasXDomainRequest)
              return void n(new c.Network("CORS not supported"));
            e = u(e, t.headers);
            var p,
              h,
              v = t.body,
              m = d.cors ? new XMLHttpRequest() : new XDomainRequest(),
              g = !1;
            (p = setTimeout(a, t.timeouts.connect)),
              (m.onprogress = l),
              "onreadystatechange" in m && (m.onreadystatechange = f),
              (m.onload = i),
              (m.onerror = o),
              m instanceof XMLHttpRequest
                ? (m.open(t.method, e, !0),
                  t.forceAuthHeaders &&
                    (m.setRequestHeader(
                      "x-algolia-application-id",
                      t.headers["x-algolia-application-id"]
                    ),
                    m.setRequestHeader(
                      "x-algolia-api-key",
                      t.headers["x-algolia-api-key"]
                    )))
                : m.open(t.method, e),
              d.cors &&
                (v &&
                  ("POST" === t.method
                    ? m.setRequestHeader(
                        "content-type",
                        "application/x-www-form-urlencoded"
                      )
                    : m.setRequestHeader("content-type", "application/json")),
                m.setRequestHeader("accept", "application/json")),
              v ? m.send(v) : m.send();
          });
        }),
        (a.prototype._request.fallback = function (e, t) {
          return (
            (e = u(e, t.headers)),
            new i(function (r, n) {
              l(e, t, function (e, t) {
                if (e) return void n(e);
                r(t);
              });
            })
          );
        }),
        (a.prototype._promise = {
          reject: function (e) {
            return i.reject(e);
          },
          resolve: function (e) {
            return i.resolve(e);
          },
          delay: function (e) {
            return new i(function (t) {
              setTimeout(t, e);
            });
          },
          all: function (e) {
            return i.all(e);
          },
        }),
        o
      );
    };
  },
  function (e, t, r) {
    "use strict";
    (function (t) {
      var r;
      (r =
        "undefined" != typeof window
          ? window
          : void 0 !== t
          ? t
          : "undefined" != typeof self
          ? self
          : {}),
        (e.exports = r);
    }.call(t, r(34)));
  },
  function (e, t, r) {
    "use strict";
    (function (n, i) {
      var o,
        a,
        s = r(0),
        c = s(r(4));
      !(function (n, i) {
        "object" === (0, c.default)(t) && void 0 !== e
          ? (e.exports = i())
          : ((o = i),
            void 0 !== (a = "function" == typeof o ? o.call(t, r, t, e) : o) &&
              (e.exports = a));
      })(0, function () {
        function e(e) {
          var t = (0, c.default)(e);
          return null !== e && ("object" === t || "function" === t);
        }
        function t(e) {
          return "function" == typeof e;
        }
        function o(e) {
          $ = e;
        }
        function a(e) {
          G = e;
        }
        function s() {
          return void 0 !== Q
            ? function () {
                Q(l);
              }
            : u();
        }
        function u() {
          var e = setTimeout;
          return function () {
            return e(l, 1);
          };
        }
        function l() {
          for (var e = 0; e < V; e += 2)
            (0, Z[e])(Z[e + 1]), (Z[e] = void 0), (Z[e + 1] = void 0);
          V = 0;
        }
        function f(e, t) {
          var r = arguments,
            n = this,
            i = new this.constructor(p);
          void 0 === i[te] && M(i);
          var o = n._state;
          return (
            o
              ? (function () {
                  var e = r[o - 1];
                  G(function () {
                    return k(o, i, e, n._result);
                  });
                })()
              : S(n, i, e, t),
            i
          );
        }
        function d(e) {
          var t = this;
          if (e && "object" === (0, c.default)(e) && e.constructor === t)
            return e;
          var r = new t(p);
          return O(r, e), r;
        }
        function p() {}
        function h() {
          return new TypeError("You cannot resolve a promise with itself");
        }
        function v() {
          return new TypeError(
            "A promises callback cannot return that same promise."
          );
        }
        function m(e) {
          try {
            return e.then;
          } catch (e) {
            return (oe.error = e), oe;
          }
        }
        function g(e, t, r, n) {
          try {
            e.call(t, r, n);
          } catch (e) {
            return e;
          }
        }
        function y(e, t, r) {
          G(function (e) {
            var n = !1,
              i = g(
                r,
                t,
                function (r) {
                  n || ((n = !0), t !== r ? O(e, r) : P(e, r));
                },
                function (t) {
                  n || ((n = !0), w(e, t));
                },
                "Settle: " + (e._label || " unknown promise")
              );
            !n && i && ((n = !0), w(e, i));
          }, e);
        }
        function b(e, t) {
          t._state === ne
            ? P(e, t._result)
            : t._state === ie
            ? w(e, t._result)
            : S(
                t,
                void 0,
                function (t) {
                  return O(e, t);
                },
                function (t) {
                  return w(e, t);
                }
              );
        }
        function _(e, r, n) {
          r.constructor === e.constructor &&
          n === f &&
          r.constructor.resolve === d
            ? b(e, r)
            : n === oe
            ? (w(e, oe.error), (oe.error = null))
            : void 0 === n
            ? P(e, r)
            : t(n)
            ? y(e, r, n)
            : P(e, r);
        }
        function O(t, r) {
          t === r ? w(t, h()) : e(r) ? _(t, r, m(r)) : P(t, r);
        }
        function j(e) {
          e._onerror && e._onerror(e._result), E(e);
        }
        function P(e, t) {
          e._state === re &&
            ((e._result = t),
            (e._state = ne),
            0 !== e._subscribers.length && G(E, e));
        }
        function w(e, t) {
          e._state === re && ((e._state = ie), (e._result = t), G(j, e));
        }
        function S(e, t, r, n) {
          var i = e._subscribers,
            o = i.length;
          (e._onerror = null),
            (i[o] = t),
            (i[o + ne] = r),
            (i[o + ie] = n),
            0 === o && e._state && G(E, e);
        }
        function E(e) {
          var t = e._subscribers,
            r = e._state;
          if (0 !== t.length) {
            for (
              var n = void 0, i = void 0, o = e._result, a = 0;
              a < t.length;
              a += 3
            )
              (n = t[a]), (i = t[a + r]), n ? k(r, n, i, o) : i(o);
            e._subscribers.length = 0;
          }
        }
        function R() {
          this.error = null;
        }
        function x(e, t) {
          try {
            return e(t);
          } catch (e) {
            return (ae.error = e), ae;
          }
        }
        function k(e, r, n, i) {
          var o = t(n),
            a = void 0,
            s = void 0,
            c = void 0,
            u = void 0;
          if (o) {
            if (
              ((a = x(n, i)),
              a === ae ? ((u = !0), (s = a.error), (a.error = null)) : (c = !0),
              r === a)
            )
              return void w(r, v());
          } else (a = i), (c = !0);
          r._state !== re ||
            (o && c
              ? O(r, a)
              : u
              ? w(r, s)
              : e === ne
              ? P(r, a)
              : e === ie && w(r, a));
        }
        function I(e, t) {
          try {
            t(
              function (t) {
                O(e, t);
              },
              function (t) {
                w(e, t);
              }
            );
          } catch (t) {
            w(e, t);
          }
        }
        function A() {
          return se++;
        }
        function M(e) {
          (e[te] = se++),
            (e._state = void 0),
            (e._result = void 0),
            (e._subscribers = []);
        }
        function C(e, t) {
          (this._instanceConstructor = e),
            (this.promise = new e(p)),
            this.promise[te] || M(this.promise),
            W(t)
              ? ((this.length = t.length),
                (this._remaining = t.length),
                (this._result = new Array(this.length)),
                0 === this.length
                  ? P(this.promise, this._result)
                  : ((this.length = this.length || 0),
                    this._enumerate(t),
                    0 === this._remaining && P(this.promise, this._result)))
              : w(this.promise, T());
        }
        function T() {
          return new Error("Array Methods must be provided an Array");
        }
        function N(e) {
          return new C(this, e).promise;
        }
        function D(e) {
          var t = this;
          return new t(
            W(e)
              ? function (r, n) {
                  for (var i = e.length, o = 0; o < i; o++)
                    t.resolve(e[o]).then(r, n);
                }
              : function (e, t) {
                  return t(new TypeError("You must pass an array to race."));
                }
          );
        }
        function F(e) {
          var t = this,
            r = new t(p);
          return w(r, e), r;
        }
        function H() {
          throw new TypeError(
            "You must pass a resolver function as the first argument to the promise constructor"
          );
        }
        function L() {
          throw new TypeError(
            "Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function."
          );
        }
        function U(e) {
          (this[te] = A()),
            (this._result = this._state = void 0),
            (this._subscribers = []),
            p !== e &&
              ("function" != typeof e && H(),
              this instanceof U ? I(this, e) : L());
        }
        function q() {
          var e = void 0;
          if (void 0 !== i) e = i;
          else if ("undefined" != typeof self) e = self;
          else
            try {
              e = Function("return this")();
            } catch (e) {
              throw new Error(
                "polyfill failed because global object is unavailable in this environment"
              );
            }
          var t = e.Promise;
          if (t) {
            var r = null;
            try {
              r = Object.prototype.toString.call(t.resolve());
            } catch (e) {}
            if ("[object Promise]" === r && !t.cast) return;
          }
          e.Promise = U;
        }
        var B = void 0;
        B = Array.isArray
          ? Array.isArray
          : function (e) {
              return "[object Array]" === Object.prototype.toString.call(e);
            };
        var W = B,
          V = 0,
          Q = void 0,
          $ = void 0,
          G = function (e, t) {
            (Z[V] = e), (Z[V + 1] = t), 2 === (V += 2) && ($ ? $(l) : ee());
          },
          K = "undefined" != typeof window ? window : void 0,
          J = K || {},
          z = J.MutationObserver || J.WebKitMutationObserver,
          Y =
            "undefined" == typeof self &&
            void 0 !== n &&
            "[object process]" === {}.toString.call(n),
          X =
            "undefined" != typeof Uint8ClampedArray &&
            "undefined" != typeof importScripts &&
            "undefined" != typeof MessageChannel,
          Z = new Array(1e3),
          ee = void 0;
        ee = Y
          ? (function () {
              return function () {
                return n.nextTick(l);
              };
            })()
          : z
          ? (function () {
              var e = 0,
                t = new z(l),
                r = document.createTextNode("");
              return (
                t.observe(r, { characterData: !0 }),
                function () {
                  r.data = e = ++e % 2;
                }
              );
            })()
          : X
          ? (function () {
              var e = new MessageChannel();
              return (
                (e.port1.onmessage = l),
                function () {
                  return e.port2.postMessage(0);
                }
              );
            })()
          : void 0 === K
          ? (function () {
              try {
                var e = r(180);
                return (Q = e.runOnLoop || e.runOnContext), s();
              } catch (e) {
                return u();
              }
            })()
          : u();
        var te = Math.random().toString(36).substring(16),
          re = void 0,
          ne = 1,
          ie = 2,
          oe = new R(),
          ae = new R(),
          se = 0;
        return (
          (C.prototype._enumerate = function (e) {
            for (var t = 0; this._state === re && t < e.length; t++)
              this._eachEntry(e[t], t);
          }),
          (C.prototype._eachEntry = function (e, t) {
            var r = this._instanceConstructor,
              n = r.resolve;
            if (n === d) {
              var i = m(e);
              if (i === f && e._state !== re)
                this._settledAt(e._state, t, e._result);
              else if ("function" != typeof i)
                this._remaining--, (this._result[t] = e);
              else if (r === U) {
                var o = new r(p);
                _(o, e, i), this._willSettleAt(o, t);
              } else
                this._willSettleAt(
                  new r(function (t) {
                    return t(e);
                  }),
                  t
                );
            } else this._willSettleAt(n(e), t);
          }),
          (C.prototype._settledAt = function (e, t, r) {
            var n = this.promise;
            n._state === re &&
              (this._remaining--, e === ie ? w(n, r) : (this._result[t] = r)),
              0 === this._remaining && P(n, this._result);
          }),
          (C.prototype._willSettleAt = function (e, t) {
            var r = this;
            S(
              e,
              void 0,
              function (e) {
                return r._settledAt(ne, t, e);
              },
              function (e) {
                return r._settledAt(ie, t, e);
              }
            );
          }),
          (U.all = N),
          (U.race = D),
          (U.resolve = d),
          (U.reject = F),
          (U._setScheduler = o),
          (U._setAsap = a),
          (U._asap = G),
          (U.prototype = {
            constructor: U,
            then: f,
            catch: function (e) {
              return this.then(null, e);
            },
          }),
          (U.polyfill = q),
          (U.Promise = U),
          U
        );
      });
    }.call(t, r(65), r(34)));
  },
  function (e, t) {},
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      return /\?/.test(e) ? (e += "&") : (e += "?"), e + i(t);
    }
    e.exports = n;
    var i = r(66);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t, r) {
      function n() {
        t.debug("JSONP: success"),
          m ||
            d ||
            ((m = !0),
            f ||
              (t.debug(
                "JSONP: Fail. Script loaded but did not call the callback"
              ),
              s(),
              r(new i.JSONPScriptFail())));
      }
      function a() {
        ("loaded" !== this.readyState && "complete" !== this.readyState) || n();
      }
      function s() {
        clearTimeout(g),
          (h.onload = null),
          (h.onreadystatechange = null),
          (h.onerror = null),
          p.removeChild(h);
      }
      function c() {
        try {
          delete window[v], delete window[v + "_loaded"];
        } catch (e) {
          window[v] = window[v + "_loaded"] = void 0;
        }
      }
      function u() {
        t.debug("JSONP: Script timeout"),
          (d = !0),
          s(),
          r(new i.RequestTimeout());
      }
      function l() {
        t.debug("JSONP: Script error"),
          m || d || (s(), r(new i.JSONPScriptError()));
      }
      if ("GET" !== t.method)
        return void r(
          new Error(
            "Method " + t.method + " " + e + " is not supported by JSONP."
          )
        );
      t.debug("JSONP: start");
      var f = !1,
        d = !1;
      o += 1;
      var p = document.getElementsByTagName("head")[0],
        h = document.createElement("script"),
        v = "algoliaJSONP_" + o,
        m = !1;
      (window[v] = function (e) {
        if ((c(), d)) return void t.debug("JSONP: Late answer, ignoring");
        (f = !0), s(), r(null, { body: e, responseText: JSON.stringify(e) });
      }),
        (e += "&callback=" + v),
        t.jsonBody && t.jsonBody.params && (e += "&" + t.jsonBody.params);
      var g = setTimeout(u, t.timeouts.complete);
      (h.onreadystatechange = a),
        (h.onload = n),
        (h.onerror = l),
        (h.async = !0),
        (h.defer = !0),
        (h.src = e),
        p.appendChild(h);
    }
    e.exports = n;
    var i = r(18),
      o = 0;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return function (t, n, i) {
        var c = r(10);
        (i = (i && c(i)) || {}),
          (i.hosts = i.hosts || [
            "places-dsn.algolia.net",
            "places-1.algolianet.com",
            "places-2.algolianet.com",
            "places-3.algolianet.com",
          ]),
          (0 !== arguments.length &&
            "object" !== (0, o.default)(t) &&
            void 0 !== t) ||
            ((t = ""), (n = ""), (i._allowEmptyCredentials = !0));
        var u = e(t, n, i),
          l = u.initIndex("places");
        return (
          (l.search = s("query", "/1/places/query")),
          (l.reverse = function (e, t) {
            var r = a.encode(e);
            return this.as._jsonRequest({
              method: "GET",
              url: "/1/places/reverse?" + r,
              hostType: "read",
              callback: t,
            });
          }),
          (l.getObject = function (e, t) {
            return this.as._jsonRequest({
              method: "GET",
              url: "/1/places/" + encodeURIComponent(e),
              hostType: "read",
              callback: t,
            });
          }),
          l
        );
      };
    }
    var i = r(0),
      o = i(r(4));
    e.exports = n;
    var a = r(184),
      s = r(63);
  },
  function (e, t, r) {
    "use strict";
    (t.decode = t.parse = r(185)), (t.encode = t.stringify = r(66));
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }
    e.exports = function (e, t, r, o) {
      (t = t || "&"), (r = r || "=");
      var a = {};
      if ("string" != typeof e || 0 === e.length) return a;
      var s = /\+/g;
      e = e.split(t);
      var c = 1e3;
      o && "number" == typeof o.maxKeys && (c = o.maxKeys);
      var u = e.length;
      c > 0 && u > c && (u = c);
      for (var l = 0; l < u; ++l) {
        var f,
          d,
          p,
          h,
          v = e[l].replace(s, "%20"),
          m = v.indexOf(r);
        m >= 0
          ? ((f = v.substr(0, m)), (d = v.substr(m + 1)))
          : ((f = v), (d = "")),
          (p = decodeURIComponent(f)),
          (h = decodeURIComponent(d)),
          n(a, p) ? (i(a[p]) ? a[p].push(h) : (a[p] = [a[p], h])) : (a[p] = h);
      }
      return a;
    };
    var i =
      Array.isArray ||
      function (e) {
        return "[object Array]" === Object.prototype.toString.call(e);
      };
  },
  function (e, t, r) {
    "use strict";
    e.exports = "3.35.1";
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      if (null == e) return {};
      var r,
        n,
        o = i(e, t);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for (n = 0; n < a.length; n++)
          (r = a[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (o[r] = e[r]));
      }
      return o;
    }
    function i(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    function o(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function a(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? o(Object(r), !0).forEach(function (t) {
              s(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : o(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function s(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function c(e) {
      function t() {
        (0, _.setProperties)(H.value.panel, {
          style: M.value
            ? {}
            : (0, g.getPanelPlacementStyle)({
                panelPlacement: A.value.renderer.panelPlacement,
                container: H.value.root,
                form: H.value.form,
                environment: A.value.core.environment,
              }),
        });
      }
      function r(e) {
        T.current = e;
        var t = {
            autocomplete: C.value,
            autocompleteScopeApi: D,
            classNames: A.value.renderer.classNames,
            components: A.value.renderer.components,
            container: A.value.renderer.container,
            html: F.value,
            dom: H.value,
            panelContainer: M.value
              ? H.value.detachedContainer
              : A.value.renderer.panelContainer,
            propGetters: N,
            state: T.current,
            renderer: A.value.renderer.renderer,
          },
          r =
            (!(0, f.getItemsCount)(e) &&
              !x.current &&
              A.value.renderer.renderNoResults) ||
            A.value.renderer.render;
        (0, y.renderSearchBox)(t), (0, y.renderPanel)(r, t);
      }
      function i() {
        P();
      }
      function o() {
        var e =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        P();
        var t = A.value.renderer,
          i = t.components,
          o = n(t, O);
        (k.current = (0, _.mergeDeep)(
          o,
          A.value.core,
          {
            components: (0, _.pickBy)(i, function (e) {
              return !e.value.hasOwnProperty("__autocomplete_componentName");
            }),
            initialState: T.current,
          },
          e
        )),
          R(),
          w(),
          C.value.refresh().then(function () {
            r(T.current);
          });
      }
      function c(e) {
        requestAnimationFrame(function () {
          var t = A.value.core.environment.document.body.contains(
            H.value.detachedOverlay
          );
          e !== t &&
            (e
              ? (A.value.core.environment.document.body.appendChild(
                  H.value.detachedOverlay
                ),
                A.value.core.environment.document.body.classList.add(
                  "aa-Detached"
                ),
                H.value.input.focus())
              : (A.value.core.environment.document.body.removeChild(
                  H.value.detachedOverlay
                ),
                A.value.core.environment.document.body.classList.remove(
                  "aa-Detached"
                ),
                C.value.setQuery(""),
                C.value.refresh()));
        });
      }
      var u = (0, h.createEffectWrapper)(),
        j = u.runEffect,
        P = u.cleanupEffects,
        w = u.runEffects,
        S = (0, v.createReactiveWrapper)(),
        E = S.reactive,
        R = S.runReactives,
        x = (0, f.createRef)(!1),
        k = (0, f.createRef)(e),
        I = (0, f.createRef)(void 0),
        A = E(function () {
          return (0, m.getDefaultOptions)(k.current);
        }),
        M = E(function () {
          return A.value.core.environment.matchMedia(
            A.value.renderer.detachedMediaQuery
          ).matches;
        }),
        C = E(function () {
          return (0, l.createAutocomplete)(
            a(
              a({}, A.value.core),
              {},
              {
                onStateChange: function (e) {
                  var t, r, n;
                  (x.current = e.state.collections.some(function (e) {
                    return e.source.templates.noResults;
                  })),
                    null === (t = I.current) || void 0 === t || t.call(I, e),
                    null === (r = (n = A.value.core).onStateChange) ||
                      void 0 === r ||
                      r.call(n, e);
                },
                shouldPanelOpen:
                  k.current.shouldPanelOpen ||
                  function (e) {
                    var t = e.state;
                    if (M.value) return !0;
                    var r = (0, f.getItemsCount)(t) > 0;
                    if (!A.value.core.openOnFocus && !t.query) return r;
                    var n = Boolean(
                      x.current || A.value.renderer.renderNoResults
                    );
                    return (!r && n) || r;
                  },
                __autocomplete_metadata: {
                  userAgents: b.userAgents,
                  options: e,
                },
              }
            )
          );
        }),
        T = (0, f.createRef)(
          a(
            {
              collections: [],
              completion: null,
              context: {},
              isOpen: !1,
              query: "",
              activeItemId: null,
              status: "idle",
            },
            A.value.core.initialState
          )
        ),
        N = {
          getEnvironmentProps: A.value.renderer.getEnvironmentProps,
          getFormProps: A.value.renderer.getFormProps,
          getInputProps: A.value.renderer.getInputProps,
          getItemProps: A.value.renderer.getItemProps,
          getLabelProps: A.value.renderer.getLabelProps,
          getListProps: A.value.renderer.getListProps,
          getPanelProps: A.value.renderer.getPanelProps,
          getRootProps: A.value.renderer.getRootProps,
        },
        D = {
          setActiveItemId: C.value.setActiveItemId,
          setQuery: C.value.setQuery,
          setCollections: C.value.setCollections,
          setIsOpen: C.value.setIsOpen,
          setStatus: C.value.setStatus,
          setContext: C.value.setContext,
          refresh: C.value.refresh,
        },
        F = E(function () {
          return d.default.bind(A.value.renderer.renderer.createElement);
        }),
        H = E(function () {
          return (0,
          p.createAutocompleteDom)({ autocomplete: C.value, autocompleteScopeApi: D, classNames: A.value.renderer.classNames, environment: A.value.core.environment, isDetached: M.value, placeholder: A.value.core.placeholder, propGetters: N, setIsModalOpen: c, state: T.current, translations: A.value.renderer.translations });
        });
      return (
        j(function () {
          var e = C.value.getEnvironmentProps({
            formElement: H.value.form,
            panelElement: H.value.panel,
            inputElement: H.value.input,
          });
          return (
            (0, _.setProperties)(A.value.core.environment, e),
            function () {
              (0, _.setProperties)(
                A.value.core.environment,
                Object.keys(e).reduce(function (e, t) {
                  return a(a({}, e), {}, s({}, t, void 0));
                }, {})
              );
            }
          );
        }),
        j(function () {
          var e = M.value
              ? A.value.core.environment.document.body
              : A.value.renderer.panelContainer,
            t = M.value ? H.value.detachedOverlay : H.value.panel;
          return (
            M.value && T.current.isOpen && c(!0),
            r(T.current),
            function () {
              e.contains(t) && e.removeChild(t);
            }
          );
        }),
        j(function () {
          var e = A.value.renderer.container;
          return (
            e.appendChild(H.value.root),
            function () {
              e.removeChild(H.value.root);
            }
          );
        }),
        j(function () {
          var e = (0, f.debounce)(function (e) {
            r(e.state);
          }, 0);
          return (
            (I.current = function (r) {
              var n = r.state,
                i = r.prevState;
              M.value && i.isOpen !== n.isOpen && c(n.isOpen),
                M.value || !n.isOpen || i.isOpen || t(),
                n.query !== i.query &&
                  A.value.core.environment.document
                    .querySelectorAll(".aa-Panel--scrollable")
                    .forEach(function (e) {
                      0 !== e.scrollTop && (e.scrollTop = 0);
                    }),
                e({ state: n });
            }),
            function () {
              I.current = void 0;
            }
          );
        }),
        j(function () {
          var e = (0, f.debounce)(function () {
            var e = M.value;
            (M.value = A.value.core.environment.matchMedia(
              A.value.renderer.detachedMediaQuery
            ).matches),
              e !== M.value ? o({}) : requestAnimationFrame(t);
          }, 20);
          return (
            A.value.core.environment.addEventListener("resize", e),
            function () {
              A.value.core.environment.removeEventListener("resize", e);
            }
          );
        }),
        j(function () {
          function e(e) {
            H.value.detachedContainer.classList.toggle(
              "aa-DetachedContainer--modal",
              e
            );
          }
          function t(t) {
            e(t.matches);
          }
          if (!M.value) return function () {};
          var r = A.value.core.environment.matchMedia(
            getComputedStyle(
              A.value.core.environment.document.documentElement
            ).getPropertyValue("--aa-detached-modal-media-query")
          );
          e(r.matches);
          var n = Boolean(r.addEventListener);
          return (
            n ? r.addEventListener("change", t) : r.addListener(t),
            function () {
              n ? r.removeEventListener("change", t) : r.removeListener(t);
            }
          );
        }),
        j(function () {
          return requestAnimationFrame(t), function () {};
        }),
        a(a({}, D), {}, { update: o, destroy: i })
      );
    }
    var u = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.autocomplete = c);
    var l = r(188),
      f = r(5),
      d = u(r(70)),
      p = r(237),
      h = r(248),
      v = r(249),
      m = r(250),
      g = r(267),
      y = r(268),
      b = r(80),
      _ = r(11),
      O = ["components"];
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(189);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(69);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
    var o = r(223);
    Object.keys(o).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return o[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e) {
      function t(e) {
        var t = e.prevState,
          n = e.state;
        o.onStateChange(i({ prevState: t, state: n, refresh: r }, v));
      }
      function r() {
        return (0, p.onInput)(
          i(
            {
              event: new Event("input"),
              nextState: { isOpen: a.getState().isOpen },
              props: o,
              query: a.getState().query,
              refresh: r,
              store: a,
            },
            v
          )
        );
      }
      (0, s.checkOptions)(e);
      var n = [],
        o = (0, l.getDefaultProps)(e, n),
        a = (0, c.createStore)(h.stateReducer, o, t),
        v = (0, u.getAutocompleteSetters)({ store: a }),
        m = (0, f.getPropGetters)(i({ props: o, refresh: r, store: a }, v));
      return (
        o.plugins.forEach(function (e) {
          var t;
          return null === (t = e.subscribe) || void 0 === t
            ? void 0
            : t.call(
                e,
                i(
                  i({}, v),
                  {},
                  {
                    refresh: r,
                    onSelect: function (e) {
                      n.push({ onSelect: e });
                    },
                    onActive: function (e) {
                      n.push({ onActive: e });
                    },
                  }
                )
              );
        }),
        (0, d.injectMetadata)({
          metadata: (0, d.getMetadata)({ plugins: o.plugins, options: e }),
          environment: o.environment,
        }),
        i(i({ refresh: r }, m), v)
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createAutocomplete = a);
    var s = r(190),
      c = r(205),
      u = r(215),
      l = r(69),
      f = r(216),
      d = r(220),
      p = r(35),
      h = r(221);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {}
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.checkOptions = n),
      r(5);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return { current: e };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.createRef = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = void 0;
      return function () {
        for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
          i[o] = arguments[o];
        r && clearTimeout(r),
          (r = setTimeout(function () {
            return e.apply(void 0, i);
          }, t));
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.debounce = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return (
        arguments.length > 1 && void 0 !== arguments[1]
          ? arguments[1]
          : new Set(),
        e
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.decycle = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return e.reduce(function (e, t) {
        return e.concat(t);
      }, []);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.flatten = n);
  },
  function (e, t, r) {
    "use strict";
    function n() {
      return "autocomplete-".concat(i++);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.generateAutocompleteId = n);
    var i = 0;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      return t.reduce(function (e, t) {
        return e && e[t];
      }, e);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getAttributeValueByPath = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return 0 === e.collections.length
        ? 0
        : e.collections.reduce(function (e, t) {
            return e + t.items.length;
          }, 0);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getItemsCount = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {}
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.invariant = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return e !== Object(e);
    }
    function i(e, t) {
      if (e === t) return !0;
      if (n(e) || n(t) || "function" == typeof e || "function" == typeof t)
        return e === t;
      if (Object.keys(e).length !== Object.keys(t).length) return !1;
      for (var r = 0, o = Object.keys(e); r < o.length; r++) {
        var a = o[r];
        if (!(a in t)) return !1;
        if (!i(e[a], t[a])) return !1;
      }
      return !0;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.isEqual = i);
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.noop = void 0);
    var n = function () {};
    t.noop = n;
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.userAgents = void 0);
    var n = r(68),
      i = [{ segment: "autocomplete-core", version: n.version }];
    t.userAgents = i;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {}
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.warn = n),
      (t.warnCache = void 0);
    var i = { current: {} };
    t.warnCache = i;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e, t, r) {
      var n = t.initialState;
      return {
        getState: function () {
          return n;
        },
        dispatch: function (o, a) {
          var s = i({}, n);
          (n = e(n, { type: o, props: t, payload: a })),
            r({ state: n, prevState: s });
        },
        pendingRequests: (0, s.createCancelablePromiseList)(),
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.createStore = a);
    var s = r(7);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = t;
      return {
        then: function (t, i) {
          return n(e.then(a(t, r, e), a(i, r, e)), r);
        },
        catch: function (t) {
          return n(e.catch(a(t, r, e)), r);
        },
        finally: function (t) {
          return (
            t && r.onCancelList.push(t),
            n(
              e.finally(
                a(
                  t &&
                    function () {
                      return (r.onCancelList = []), t();
                    },
                  r,
                  e
                )
              ),
              r
            )
          );
        },
        cancel: function () {
          r.isCanceled = !0;
          var e = r.onCancelList;
          (r.onCancelList = []),
            e.forEach(function (e) {
              e();
            });
        },
        isCanceled: function () {
          return !0 === r.isCanceled;
        },
      };
    }
    function i(e) {
      return n(
        new Promise(function (t, r) {
          return e(t, r);
        }),
        { isCanceled: !1, onCancelList: [] }
      );
    }
    function o(e) {
      return n(e, { isCanceled: !1, onCancelList: [] });
    }
    function a(e, t, r) {
      return e
        ? function (r) {
            return t.isCanceled ? r : e(r);
          }
        : r;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createCancelablePromise = i),
      (t.cancelable = o),
      (i.resolve = function (e) {
        return o(Promise.resolve(e));
      }),
      (i.reject = function (e) {
        return o(Promise.reject(e));
      });
  },
  function (e, t, r) {
    "use strict";
    function n() {
      var e = [];
      return {
        add: function (t) {
          return (
            e.push(t),
            t.finally(function () {
              e = e.filter(function (e) {
                return e !== t;
              });
            })
          );
        },
        cancelAll: function () {
          e.forEach(function (e) {
            return e.cancel();
          });
        },
        isEmpty: function () {
          return 0 === e.length;
        },
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createCancelablePromiseList = n);
  },
  function (e, t, r) {
    "use strict";
    function n() {
      var e = -1,
        t = -1,
        r = void 0;
      return function (n) {
        e++;
        var i = e;
        return Promise.resolve(n).then(function (e) {
          return r && i < t ? r : ((t = i), (r = e), e);
        });
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createConcurrentSafePromise = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t, r, n) {
      if (!r) return null;
      if (e < 0 && (null === t || (null !== n && 0 === t))) return r + e;
      var i = (null === t ? -1 : t) + e;
      return i <= -1 || i >= r ? (null === n ? null : 0) : i;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getNextActiveItemId = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e) {
      "@babel/helpers - typeof";
      return (a =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    function s(e, t) {
      var r = [];
      return Promise.resolve(e(t)).then(function (e) {
        return (
          (0, c.invariant)(Array.isArray(e), function () {
            return "The `getSources` function must return an array of sources but returned type "
              .concat(JSON.stringify(a(e)), ":\n\n")
              .concat(JSON.stringify((0, c.decycle)(e), null, 2));
          }),
          Promise.all(
            e
              .filter(function (e) {
                return Boolean(e);
              })
              .map(function (e) {
                if (
                  ((0, c.invariant)(
                    "string" == typeof e.sourceId,
                    "A source must provide a `sourceId` string."
                  ),
                  r.includes(e.sourceId))
                )
                  throw new Error(
                    "[Autocomplete] The `sourceId` ".concat(
                      JSON.stringify(e.sourceId),
                      " is not unique."
                    )
                  );
                r.push(e.sourceId);
                var t = i(
                  {
                    getItemInputValue: function (e) {
                      return e.state.query;
                    },
                    getItemUrl: function () {},
                    onSelect: function (e) {
                      (0, e.setIsOpen)(!1);
                    },
                    onActive: c.noop,
                  },
                  e
                );
                return Promise.resolve(t);
              })
          )
        );
      });
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getNormalizedSources = s);
    var c = r(5);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t = e.collections
          .map(function (e) {
            return e.items.length;
          })
          .reduce(function (e, t, r) {
            var n = e[r - 1] || 0,
              i = n + t;
            return e.push(i), e;
          }, []),
        r = t.reduce(function (t, r) {
          return r <= e.activeItemId ? t + 1 : t;
        }, 0);
      return e.collections[r];
    }
    function i(e) {
      for (
        var t = e.state, r = e.collection, n = !1, i = 0, o = 0;
        !1 === n;

      ) {
        var a = t.collections[i];
        if (a === r) {
          n = !0;
          break;
        }
        (o += a.items.length), i++;
      }
      return t.activeItemId - o;
    }
    function o(e) {
      var t = n(e);
      if (!t) return null;
      var r = t.items[i({ state: e, collection: t })],
        o = t.source;
      return {
        item: r,
        itemInputValue: o.getItemInputValue({ item: r, state: e }),
        itemUrl: o.getItemUrl({ item: r, state: e }),
        source: o,
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getActiveItem = o);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      return e === t || e.contains(t);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.isOrContainsNode = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return Boolean(e && e.match(i));
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.isSamsung = n);
    var i = /((gt|sm)-|galaxy nexus)|samsung[- ]/i;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e) {
      var t = e.map(function (e) {
        var t;
        return i(
          i({}, e),
          {},
          {
            hits:
              null === (t = e.hits) || void 0 === t
                ? void 0
                : t.map(function (t) {
                    return i(
                      i({}, t),
                      {},
                      {
                        __autocomplete_indexName: e.index,
                        __autocomplete_queryID: e.queryID,
                      }
                    );
                  }),
          }
        );
      });
      return {
        results: t,
        hits: t
          .map(function (e) {
            return e.hits;
          })
          .filter(Boolean),
        facetHits: t
          .map(function (e) {
            var t;
            return null === (t = e.facetHits) || void 0 === t
              ? void 0
              : t.map(function (e) {
                  return {
                    label: e.value,
                    count: e.count,
                    _highlightResult: { label: { value: e.highlighted } },
                  };
                });
          })
          .filter(Boolean),
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.mapToAlgoliaResponse = a);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e) {
      var t = e.store;
      return {
        setActiveItemId: function (e) {
          t.dispatch("setActiveItemId", e);
        },
        setQuery: function (e) {
          t.dispatch("setQuery", e);
        },
        setCollections: function (e) {
          var r = 0,
            n = e.map(function (e) {
              return i(
                i({}, e),
                {},
                {
                  items: (0, s.flatten)(e.items).map(function (e) {
                    return i(i({}, e), {}, { __autocomplete_id: r++ });
                  }),
                }
              );
            });
          t.dispatch("setCollections", n);
        },
        setIsOpen: function (e) {
          t.dispatch("setIsOpen", e);
        },
        setStatus: function (e) {
          t.dispatch("setStatus", e);
        },
        setContext: function (e) {
          t.dispatch("setContext", e);
        },
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getAutocompleteSetters = a);
    var s = r(5);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = s(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (n = 0; n < o.length; n++)
          (r = o[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function s(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    function c(e) {
      var t = e.props,
        r = e.refresh,
        n = e.store,
        o = a(e, d),
        s = function (e) {
          var r = e.inputElement,
            o = e.formElement,
            s = e.panelElement,
            c = a(e, p);
          return i(
            {
              onTouchStart: function (e) {
                (!n.getState().isOpen && n.pendingRequests.isEmpty()) ||
                  e.target === r ||
                  (!1 ===
                    [o, s].some(function (t) {
                      return (0, f.isOrContainsNode)(t, e.target);
                    }) &&
                    (n.dispatch("blur", null),
                    t.debug || n.pendingRequests.cancelAll()));
              },
              onTouchMove: function (e) {
                !1 !== n.getState().isOpen &&
                  r === t.environment.document.activeElement &&
                  e.target !== r &&
                  r.blur();
              },
            },
            c
          );
        },
        c = function (e) {
          return i(
            {
              role: "combobox",
              "aria-expanded": n.getState().isOpen,
              "aria-haspopup": "listbox",
              "aria-owns": n.getState().isOpen
                ? "".concat(t.id, "-list")
                : void 0,
              "aria-labelledby": "".concat(t.id, "-label"),
            },
            e
          );
        },
        g = function (e) {
          var s = (e.inputElement, a(e, h));
          return i(
            {
              action: "",
              noValidate: !0,
              role: "search",
              onSubmit: function (a) {
                var s;
                a.preventDefault(),
                  t.onSubmit(
                    i({ event: a, refresh: r, state: n.getState() }, o)
                  ),
                  n.dispatch("submit", null),
                  null === (s = e.inputElement) || void 0 === s || s.blur();
              },
              onReset: function (a) {
                var s;
                a.preventDefault(),
                  t.onReset(
                    i({ event: a, refresh: r, state: n.getState() }, o)
                  ),
                  n.dispatch("reset", null),
                  null === (s = e.inputElement) || void 0 === s || s.focus();
              },
            },
            s
          );
        },
        y = function (e) {
          function s(e) {
            (t.openOnFocus || Boolean(n.getState().query)) &&
              (0, u.onInput)(
                i(
                  {
                    event: e,
                    props: t,
                    query: n.getState().completion || n.getState().query,
                    refresh: r,
                    store: n,
                  },
                  o
                )
              ),
              n.dispatch("focus", null);
          }
          var c,
            d = "ontouchstart" in t.environment,
            p = e || {},
            h = p.maxLength,
            m = void 0 === h ? 512 : h,
            g = a(p, v),
            y = (0, f.getActiveItem)(n.getState()),
            b =
              null === (c = t.environment.navigator) || void 0 === c
                ? void 0
                : c.userAgent,
            _ = (0, f.isSamsung)(b),
            O = null !== y && void 0 !== y && y.itemUrl && !_ ? "go" : "search";
          return i(
            {
              "aria-autocomplete": "both",
              "aria-activedescendant":
                n.getState().isOpen && null !== n.getState().activeItemId
                  ? "".concat(t.id, "-item-").concat(n.getState().activeItemId)
                  : void 0,
              "aria-controls": n.getState().isOpen
                ? "".concat(t.id, "-list")
                : void 0,
              "aria-labelledby": "".concat(t.id, "-label"),
              value: n.getState().completion || n.getState().query,
              id: "".concat(t.id, "-input"),
              autoComplete: "off",
              autoCorrect: "off",
              autoCapitalize: "off",
              enterKeyHint: O,
              spellCheck: "false",
              autoFocus: t.autoFocus,
              placeholder: t.placeholder,
              maxLength: m,
              type: "search",
              onChange: function (e) {
                (0, u.onInput)(
                  i(
                    {
                      event: e,
                      props: t,
                      query: e.currentTarget.value.slice(0, m),
                      refresh: r,
                      store: n,
                    },
                    o
                  )
                );
              },
              onKeyDown: function (e) {
                (0, l.onKeyDown)(
                  i({ event: e, props: t, refresh: r, store: n }, o)
                );
              },
              onFocus: s,
              onBlur: function () {
                d ||
                  (n.dispatch("blur", null),
                  t.debug || n.pendingRequests.cancelAll());
              },
              onClick: function (r) {
                e.inputElement !== t.environment.document.activeElement ||
                  n.getState().isOpen ||
                  s(r);
              },
            },
            g
          );
        },
        b = function (e) {
          return i(
            {
              htmlFor: "".concat(t.id, "-input"),
              id: "".concat(t.id, "-label"),
            },
            e
          );
        },
        _ = function (e) {
          return i(
            {
              role: "listbox",
              "aria-labelledby": "".concat(t.id, "-label"),
              id: "".concat(t.id, "-list"),
            },
            e
          );
        };
      return {
        getEnvironmentProps: s,
        getRootProps: c,
        getFormProps: g,
        getLabelProps: b,
        getInputProps: y,
        getPanelProps: function (e) {
          return i(
            {
              onMouseDown: function (e) {
                e.preventDefault();
              },
              onMouseLeave: function () {
                n.dispatch("mouseleave", null);
              },
            },
            e
          );
        },
        getListProps: _,
        getItemProps: function (e) {
          var s = e.item,
            c = e.source,
            l = a(e, m);
          return i(
            {
              id: "".concat(t.id, "-item-").concat(s.__autocomplete_id),
              role: "option",
              "aria-selected":
                n.getState().activeItemId === s.__autocomplete_id,
              onMouseMove: function (e) {
                if (s.__autocomplete_id !== n.getState().activeItemId) {
                  n.dispatch("mousemove", s.__autocomplete_id);
                  var t = (0, f.getActiveItem)(n.getState());
                  if (null !== n.getState().activeItemId && t) {
                    var a = t.item,
                      c = t.itemInputValue,
                      u = t.itemUrl,
                      l = t.source;
                    l.onActive(
                      i(
                        {
                          event: e,
                          item: a,
                          itemInputValue: c,
                          itemUrl: u,
                          refresh: r,
                          source: l,
                          state: n.getState(),
                        },
                        o
                      )
                    );
                  }
                }
              },
              onMouseDown: function (e) {
                e.preventDefault();
              },
              onClick: function (e) {
                var a = c.getItemInputValue({ item: s, state: n.getState() }),
                  l = c.getItemUrl({ item: s, state: n.getState() });
                (l
                  ? Promise.resolve()
                  : (0, u.onInput)(
                      i(
                        {
                          event: e,
                          nextState: { isOpen: !1 },
                          props: t,
                          query: a,
                          refresh: r,
                          store: n,
                        },
                        o
                      )
                    )
                ).then(function () {
                  c.onSelect(
                    i(
                      {
                        event: e,
                        item: s,
                        itemInputValue: a,
                        itemUrl: l,
                        refresh: r,
                        source: c,
                        state: n.getState(),
                      },
                      o
                    )
                  );
                });
              },
            },
            l
          );
        },
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getPropGetters = c);
    var u = r(35),
      l = r(219),
      f = r(7),
      d = ["props", "refresh", "store"],
      p = ["inputElement", "formElement", "panelElement"],
      h = ["inputElement"],
      v = ["inputElement", "maxLength"],
      m = ["item", "source"];
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e) {
      var t = e.collections,
        r = e.props,
        n = e.state,
        a = t.reduce(function (e, t) {
          return i(
            i({}, e),
            {},
            o(
              {},
              t.source.sourceId,
              i(
                i({}, t.source),
                {},
                {
                  getItems: function () {
                    return (0, s.flatten)(t.items);
                  },
                }
              )
            )
          );
        }, {}),
        c = r.reshape({
          sources: Object.values(a),
          sourcesBySourceId: a,
          state: n,
        });
      return (0, s.flatten)(c)
        .filter(Boolean)
        .map(function (e) {
          return { source: e, items: e.getItems() };
        });
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.reshape = a);
    var s = r(5);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      "@babel/helpers - typeof";
      return (n =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    function i(e) {
      return c(e) || s(e) || a(e) || o();
    }
    function o() {
      throw new TypeError(
        "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function a(e, t) {
      if (e) {
        if ("string" == typeof e) return u(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? u(e, t)
            : void 0
        );
      }
    }
    function s(e) {
      if (
        ("undefined" != typeof Symbol && null != e[Symbol.iterator]) ||
        null != e["@@iterator"]
      )
        return Array.from(e);
    }
    function c(e) {
      if (Array.isArray(e)) return u(e);
    }
    function u(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function l(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function f(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? l(Object(r), !0).forEach(function (t) {
              d(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : l(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function d(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function p(e) {
      return Boolean(e.execute);
    }
    function h(e) {
      return Boolean(null === e || void 0 === e ? void 0 : e.execute);
    }
    function v(e, t) {
      return h(e)
        ? f(
            f({}, e),
            {},
            {
              requests: e.queries.map(function (r) {
                return {
                  query: r,
                  sourceId: t,
                  transformResponse: e.transformResponse,
                };
              }),
            }
          )
        : { items: e, sourceId: t };
    }
    function m(e) {
      var t = e.reduce(function (e, t) {
          if (!p(t)) return e.push(t), e;
          var r = t.searchClient,
            n = t.execute,
            o = t.requesterId,
            a = t.requests,
            s = e.find(function (e) {
              return (
                p(t) &&
                p(e) &&
                e.searchClient === r &&
                Boolean(o) &&
                e.requesterId === o
              );
            });
          if (s) {
            var c;
            (c = s.items).push.apply(c, i(a));
          } else {
            var u = { execute: n, requesterId: o, items: a, searchClient: r };
            e.push(u);
          }
          return e;
        }, []),
        r = t.map(function (e) {
          if (!p(e)) return Promise.resolve(e);
          var t = e,
            r = t.execute,
            n = t.items;
          return r({ searchClient: t.searchClient, requests: n });
        });
      return Promise.all(r).then(function (e) {
        return (0, y.flatten)(e);
      });
    }
    function g(e, t) {
      return t.map(function (t) {
        var r = e.filter(function (e) {
            return e.sourceId === t.sourceId;
          }),
          i = r.map(function (e) {
            return e.items;
          }),
          o = r[0].transformResponse,
          a = o ? o((0, b.mapToAlgoliaResponse)(i)) : i;
        return (
          (0, y.invariant)(Array.isArray(a), function () {
            return 'The `getItems` function from source "'
              .concat(
                t.sourceId,
                '" must return an array of items but returned type '
              )
              .concat(JSON.stringify(n(a)), ":\n\n")
              .concat(
                JSON.stringify((0, y.decycle)(a), null, 2),
                ".\n\nSee: https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/#param-getitems"
              );
          }),
          (0, y.invariant)(
            a.every(Boolean),
            'The `getItems` function from source "'
              .concat(
                t.sourceId,
                '" must return an array of items but returned '
              )
              .concat(
                JSON.stringify(void 0),
                ".\n\nDid you forget to return items?\n\nSee: https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/#param-getitems"
              )
          ),
          { source: t, items: a }
        );
      });
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.preResolve = v),
      (t.resolve = m),
      (t.postResolve = g);
    var y = r(5),
      b = r(7);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = s(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (n = 0; n < o.length; n++)
          (r = o[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function s(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    function c(e) {
      var t = e.event,
        r = e.props,
        n = e.refresh,
        o = e.store,
        s = a(e, f);
      if ("ArrowUp" === t.key || "ArrowDown" === t.key) {
        var c = function () {
            var e = r.environment.document.getElementById(
              "".concat(r.id, "-item-").concat(o.getState().activeItemId)
            );
            e &&
              (e.scrollIntoViewIfNeeded
                ? e.scrollIntoViewIfNeeded(!1)
                : e.scrollIntoView(!1));
          },
          d = function () {
            var e = (0, l.getActiveItem)(o.getState());
            if (null !== o.getState().activeItemId && e) {
              var r = e.item,
                a = e.itemInputValue,
                c = e.itemUrl,
                u = e.source;
              u.onActive(
                i(
                  {
                    event: t,
                    item: r,
                    itemInputValue: a,
                    itemUrl: c,
                    refresh: n,
                    source: u,
                    state: o.getState(),
                  },
                  s
                )
              );
            }
          };
        t.preventDefault(),
          !1 === o.getState().isOpen &&
          (r.openOnFocus || Boolean(o.getState().query))
            ? (0, u.onInput)(
                i(
                  {
                    event: t,
                    props: r,
                    query: o.getState().query,
                    refresh: n,
                    store: o,
                  },
                  s
                )
              ).then(function () {
                o.dispatch(t.key, { nextActiveItemId: r.defaultActiveItemId }),
                  d(),
                  setTimeout(c, 0);
              })
            : (o.dispatch(t.key, {}), d(), c());
      } else if ("Escape" === t.key)
        t.preventDefault(),
          o.dispatch(t.key, null),
          o.pendingRequests.cancelAll();
      else if ("Enter" === t.key) {
        if (
          null === o.getState().activeItemId ||
          o.getState().collections.every(function (e) {
            return 0 === e.items.length;
          })
        )
          return;
        t.preventDefault();
        var p = (0, l.getActiveItem)(o.getState()),
          h = p.item,
          v = p.itemInputValue,
          m = p.itemUrl,
          g = p.source;
        if (t.metaKey || t.ctrlKey)
          void 0 !== m &&
            (g.onSelect(
              i(
                {
                  event: t,
                  item: h,
                  itemInputValue: v,
                  itemUrl: m,
                  refresh: n,
                  source: g,
                  state: o.getState(),
                },
                s
              )
            ),
            r.navigator.navigateNewTab({
              itemUrl: m,
              item: h,
              state: o.getState(),
            }));
        else if (t.shiftKey)
          void 0 !== m &&
            (g.onSelect(
              i(
                {
                  event: t,
                  item: h,
                  itemInputValue: v,
                  itemUrl: m,
                  refresh: n,
                  source: g,
                  state: o.getState(),
                },
                s
              )
            ),
            r.navigator.navigateNewWindow({
              itemUrl: m,
              item: h,
              state: o.getState(),
            }));
        else if (t.altKey);
        else {
          if (void 0 !== m)
            return (
              g.onSelect(
                i(
                  {
                    event: t,
                    item: h,
                    itemInputValue: v,
                    itemUrl: m,
                    refresh: n,
                    source: g,
                    state: o.getState(),
                  },
                  s
                )
              ),
              void r.navigator.navigate({
                itemUrl: m,
                item: h,
                state: o.getState(),
              })
            );
          (0, u.onInput)(
            i(
              {
                event: t,
                nextState: { isOpen: !1 },
                props: r,
                query: v,
                refresh: n,
                store: o,
              },
              s
            )
          ).then(function () {
            g.onSelect(
              i(
                {
                  event: t,
                  item: h,
                  itemInputValue: v,
                  itemUrl: m,
                  refresh: n,
                  source: g,
                  state: o.getState(),
                },
                s
              )
            );
          });
        }
      }
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.onKeyDown = c);
    var u = r(35),
      l = r(7),
      f = ["event", "props", "refresh", "store"];
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e) {
      var t,
        r,
        n,
        a,
        s = e.plugins,
        u = e.options,
        l =
          null ===
            (t = ((null === (r = u.__autocomplete_metadata) || void 0 === r
              ? void 0
              : r.userAgents) || [])[0]) || void 0 === t
            ? void 0
            : t.segment,
        f = l
          ? o(
              {},
              l,
              Object.keys(
                (null === (n = u.__autocomplete_metadata) || void 0 === n
                  ? void 0
                  : n.options) || {}
              )
            )
          : {};
      return {
        plugins: s.map(function (e) {
          return {
            name: e.name,
            options: Object.keys(e.__autocomplete_pluginOptions || []),
          };
        }),
        options: i({ "autocomplete-core": Object.keys(u) }, f),
        ua: c.userAgents.concat(
          (null === (a = u.__autocomplete_metadata) || void 0 === a
            ? void 0
            : a.userAgents) || []
        ),
      };
    }
    function s(e) {
      var t,
        r = e.metadata,
        n = e.environment;
      if (
        null === (t = n.navigator) || void 0 === t
          ? void 0
          : t.userAgent.includes("Algolia Crawler")
      ) {
        var i = n.document.createElement("meta"),
          o = n.document.querySelector("head");
        (i.name = "algolia:metadata"),
          setTimeout(function () {
            (i.content = JSON.stringify(r)), o.appendChild(i);
          }, 0);
      }
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getMetadata = a),
      (t.injectMetadata = s);
    var c = r(5);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.stateReducer = void 0);
    var a = r(5),
      s = r(222),
      c = r(7),
      u = function (e, t) {
        switch (t.type) {
          case "setActiveItemId":
            return i(i({}, e), {}, { activeItemId: t.payload });
          case "setQuery":
            return i(i({}, e), {}, { query: t.payload, completion: null });
          case "setCollections":
            return i(i({}, e), {}, { collections: t.payload });
          case "setIsOpen":
            return i(i({}, e), {}, { isOpen: t.payload });
          case "setStatus":
            return i(i({}, e), {}, { status: t.payload });
          case "setContext":
            return i(i({}, e), {}, { context: i(i({}, e.context), t.payload) });
          case "ArrowDown":
            var r = i(
              i({}, e),
              {},
              {
                activeItemId: t.payload.hasOwnProperty("nextActiveItemId")
                  ? t.payload.nextActiveItemId
                  : (0, c.getNextActiveItemId)(
                      1,
                      e.activeItemId,
                      (0, a.getItemsCount)(e),
                      t.props.defaultActiveItemId
                    ),
              }
            );
            return i(
              i({}, r),
              {},
              { completion: (0, s.getCompletion)({ state: r }) }
            );
          case "ArrowUp":
            var n = i(
              i({}, e),
              {},
              {
                activeItemId: (0, c.getNextActiveItemId)(
                  -1,
                  e.activeItemId,
                  (0, a.getItemsCount)(e),
                  t.props.defaultActiveItemId
                ),
              }
            );
            return i(
              i({}, n),
              {},
              { completion: (0, s.getCompletion)({ state: n }) }
            );
          case "Escape":
            return e.isOpen
              ? i(
                  i({}, e),
                  {},
                  { activeItemId: null, isOpen: !1, completion: null }
                )
              : i(
                  i({}, e),
                  {},
                  {
                    activeItemId: null,
                    query: "",
                    status: "idle",
                    collections: [],
                  }
                );
          case "submit":
            return i(
              i({}, e),
              {},
              { activeItemId: null, isOpen: !1, status: "idle" }
            );
          case "reset":
            return i(
              i({}, e),
              {},
              {
                activeItemId:
                  !0 === t.props.openOnFocus
                    ? t.props.defaultActiveItemId
                    : null,
                status: "idle",
                query: "",
              }
            );
          case "focus":
            return i(
              i({}, e),
              {},
              {
                activeItemId: t.props.defaultActiveItemId,
                isOpen:
                  (t.props.openOnFocus || Boolean(e.query)) &&
                  t.props.shouldPanelOpen({ state: e }),
              }
            );
          case "blur":
            return t.props.debug
              ? e
              : i(i({}, e), {}, { isOpen: !1, activeItemId: null });
          case "mousemove":
            return i(i({}, e), {}, { activeItemId: t.payload });
          case "mouseleave":
            return i(
              i({}, e),
              {},
              { activeItemId: t.props.defaultActiveItemId }
            );
          default:
            return (
              (0, a.invariant)(
                !1,
                "The reducer action ".concat(
                  JSON.stringify(t.type),
                  " is not supported."
                )
              ),
              e
            );
        }
      };
    t.stateReducer = u;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t,
        r = e.state;
      return !1 === r.isOpen || null === r.activeItemId
        ? null
        : (null === (t = (0, i.getActiveItem)(r)) || void 0 === t
            ? void 0
            : t.itemInputValue) || null;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getCompletion = n);
    var i = r(7);
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(224);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(225);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
    var o = r(226);
    Object.keys(o).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return o[e];
          },
        });
    });
    var a = r(227);
    Object.keys(a).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return a[e];
          },
        });
    });
    var s = r(228);
    Object.keys(s).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return s[e];
          },
        });
    });
    var c = r(229);
    Object.keys(c).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return c[e];
          },
        });
    });
    var u = r(230);
    Object.keys(u).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return u[e];
          },
        });
    });
    var l = r(231);
    Object.keys(l).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return l[e];
          },
        });
    });
    var f = r(232);
    Object.keys(f).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return f[e];
          },
        });
    });
    var d = r(233);
    Object.keys(d).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return d[e];
          },
        });
    });
    var p = r(234);
    Object.keys(p).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return p[e];
          },
        });
    });
    var h = r(235);
    Object.keys(h).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return h[e];
          },
        });
    });
    var v = r(236);
    Object.keys(v).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return v[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e) {
      var t = e.autocomplete,
        r = e.autocompleteScopeApi,
        n = e.classNames,
        o = e.environment,
        a = e.isDetached,
        u = e.placeholder,
        l = void 0 === u ? "Search" : u,
        f = e.propGetters,
        d = e.setIsModalOpen,
        p = e.state,
        h = e.translations,
        v = (0, c.getCreateDomElement)(o),
        m = f.getRootProps(i({ state: p, props: t.getRootProps({}) }, r)),
        g = v("div", i({ class: n.root }, m)),
        y = v("div", {
          class: n.detachedContainer,
          onMouseDown: function (e) {
            e.stopPropagation();
          },
        }),
        b = v("div", {
          class: n.detachedOverlay,
          children: [y],
          onMouseDown: function () {
            d(!1), t.setIsOpen(!1);
          },
        }),
        _ = f.getLabelProps(i({ state: p, props: t.getLabelProps({}) }, r)),
        O = v("button", {
          class: n.submitButton,
          type: "submit",
          title: h.submitButtonTitle,
          children: [(0, s.SearchIcon)({ environment: o })],
        }),
        j = v("label", i({ class: n.label, children: [O] }, _)),
        P = v("button", {
          class: n.clearButton,
          type: "reset",
          title: h.clearButtonTitle,
          children: [(0, s.ClearIcon)({ environment: o })],
        }),
        w = v("div", {
          class: n.loadingIndicator,
          children: [(0, s.LoadingIcon)({ environment: o })],
        }),
        S = (0, s.Input)({
          class: n.input,
          environment: o,
          state: p,
          getInputProps: f.getInputProps,
          getInputPropsCore: t.getInputProps,
          autocompleteScopeApi: r,
          onDetachedEscape: a
            ? function () {
                t.setIsOpen(!1), d(!1);
              }
            : void 0,
        }),
        E = v("div", { class: n.inputWrapperPrefix, children: [j, w] }),
        R = v("div", { class: n.inputWrapperSuffix, children: [P] }),
        x = v("div", { class: n.inputWrapper, children: [S] }),
        k = f.getFormProps(
          i({ state: p, props: t.getFormProps({ inputElement: S }) }, r)
        ),
        I = v("form", i({ class: n.form, children: [E, x, R] }, k)),
        A = f.getPanelProps(i({ state: p, props: t.getPanelProps({}) }, r)),
        M = v("div", i({ class: n.panel }, A));
      if (a) {
        var C = v("div", {
            class: n.detachedSearchButtonIcon,
            children: [(0, s.SearchIcon)({ environment: o })],
          }),
          T = v("div", {
            class: n.detachedSearchButtonPlaceholder,
            textContent: l,
          }),
          N = v("button", {
            type: "button",
            class: n.detachedSearchButton,
            onClick: function () {
              d(!0);
            },
            children: [C, T],
          }),
          D = v("button", {
            type: "button",
            class: n.detachedCancelButton,
            textContent: h.detachedCancelButtonText,
            onTouchStart: function (e) {
              e.stopPropagation();
            },
            onClick: function () {
              t.setIsOpen(!1), d(!1);
            },
          }),
          F = v("div", { class: n.detachedFormContainer, children: [I, D] });
        y.appendChild(F), g.appendChild(N);
      } else g.appendChild(I);
      return {
        detachedContainer: y,
        detachedOverlay: b,
        inputWrapper: x,
        input: S,
        root: g,
        form: I,
        label: j,
        submitButton: O,
        clearButton: P,
        loadingIndicator: w,
        panel: M,
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createAutocompleteDom = a);
    var s = r(238),
      c = r(71);
    r(11);
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(239);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(240);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
    var o = r(246);
    Object.keys(o).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return o[e];
          },
        });
    });
    var a = r(247);
    Object.keys(a).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return a[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.ClearIcon = void 0);
    var n = function (e) {
      var t = e.environment,
        r = t.document.createElementNS("http://www.w3.org/2000/svg", "svg");
      r.setAttribute("class", "icon icon--close search-form__icon"),
        r.setAttribute("viewBox", "0 0 16 16"),
        r.setAttribute("width", "16"),
        r.setAttribute("height", "16"),
        r.setAttribute("fill", "currentColor");
      var n = t.document.createElementNS("http://www.w3.org/2000/svg", "path");
      return (
        n.setAttribute(
          "d",
          "M14.783 13.778a.712.712 0 0 1-.5 1.222.712.712 0 0 1-.505-.217L8 9.005l-5.778 5.778a.712.712 0 1 1-1.005-1.005L6.995 8 1.217 2.222a.71.71 0 0 1 1.005-1.005L8 6.995l5.778-5.778a.711.711 0 1 1 1.005 1.005L9.005 8l5.778 5.778Z"
        ),
        r.appendChild(n),
        r
      );
    };
    t.ClearIcon = n;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = s(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (n = 0; n < o.length; n++)
          (r = o[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function s(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.Input = void 0);
    var c = r(71),
      u = r(11),
      l = [
        "autocompleteScopeApi",
        "environment",
        "classNames",
        "getInputProps",
        "getInputPropsCore",
        "onDetachedEscape",
        "state",
      ],
      f = function (e) {
        var t = e.autocompleteScopeApi,
          r = e.environment,
          n = (e.classNames, e.getInputProps),
          o = e.getInputPropsCore,
          s = e.onDetachedEscape,
          f = e.state,
          d = a(e, l),
          p = (0, c.getCreateDomElement)(r),
          h = p("input", d),
          v = n(
            i({ state: f, props: o({ inputElement: h }), inputElement: h }, t)
          );
        return (
          (0, u.setProperties)(
            h,
            i(
              i({}, v),
              {},
              {
                onKeyDown: function (e) {
                  if (s && "Escape" === e.key)
                    return e.preventDefault(), void s();
                  v.onKeyDown(e);
                },
              }
            )
          ),
          h
        );
      };
    t.Input = f;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      if ("string" == typeof t) {
        var r = e.document.querySelector(t);
        return (
          (0, i.invariant)(
            null !== r,
            "The element ".concat(JSON.stringify(t), " is not in the document.")
          ),
          r
        );
      }
      return t;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getHTMLElement = n);
    var i = r(5);
  },
  function (e, t, r) {
    "use strict";
    function n() {
      for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
        t[r] = arguments[r];
      return t.reduce(function (e, t) {
        return (
          Object.keys(t).forEach(function (r) {
            var n = e[r],
              i = t[r];
            n !== i && (e[r] = [n, i].filter(Boolean).join(" "));
          }),
          e
        );
      }, {});
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.mergeClassNames = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return s(e) || a(e) || o(e) || i();
    }
    function i() {
      throw new TypeError(
        "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function o(e, t) {
      if (e) {
        if ("string" == typeof e) return c(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? c(e, t)
            : void 0
        );
      }
    }
    function a(e) {
      if (
        ("undefined" != typeof Symbol && null != e[Symbol.iterator]) ||
        null != e["@@iterator"]
      )
        return Array.from(e);
    }
    function s(e) {
      if (Array.isArray(e)) return c(e);
    }
    function c(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function u(e) {
      "@babel/helpers - typeof";
      return (u =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    function l() {
      for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
        t[r] = arguments[r];
      return t.reduce(function (e, t) {
        return (
          Object.keys(t).forEach(function (r) {
            var i = e[r],
              o = t[r];
            Array.isArray(i) && Array.isArray(o)
              ? (e[r] = i.concat.apply(i, n(o)))
              : f(i) && f(o)
              ? (e[r] = l(i, o))
              : (e[r] = o);
          }),
          e
        );
      }, {});
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.mergeDeep = l);
    var f = function (e) {
      return (
        e &&
        "object" === u(e) &&
        "[object Object]" === Object.prototype.toString.call(e)
      );
    };
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e, t) {
      return f(e) || l(e, t) || c(e, t) || s();
    }
    function s() {
      throw new TypeError(
        "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function c(e, t) {
      if (e) {
        if ("string" == typeof e) return u(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? u(e, t)
            : void 0
        );
      }
    }
    function u(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function l(e, t) {
      var r =
        null == e
          ? null
          : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
            e["@@iterator"];
      if (null != r) {
        var n,
          i,
          o = [],
          a = !0,
          s = !1;
        try {
          for (
            r = r.call(e);
            !(a = (n = r.next()).done) &&
            (o.push(n.value), !t || o.length !== t);
            a = !0
          );
        } catch (e) {
          (s = !0), (i = e);
        } finally {
          try {
            a || null == r.return || r.return();
          } finally {
            if (s) throw i;
          }
        }
        return o;
      }
    }
    function f(e) {
      if (Array.isArray(e)) return e;
    }
    function d(e, t) {
      return Object.entries(e).reduce(function (e, r) {
        var n = a(r, 2),
          s = n[0],
          c = n[1];
        return t({ key: s, value: c }) ? i(i({}, e), {}, o({}, s, c)) : e;
      }, {});
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.pickBy = d);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t, r) {
      e[t] = null === r ? "" : "number" != typeof r ? r : r + "px";
    }
    function i(e) {
      this._listeners[e.type](e);
    }
    function o(e, t, r) {
      var o,
        a,
        s = e[t];
      if ("style" === t)
        if ("string" == typeof r) e.style = r;
        else if (null === r) e.style = "";
        else for (t in r) (s && r[t] === s[t]) || n(e.style, t, r[t]);
      else
        "o" === t[0] && "n" === t[1]
          ? ((o = t !== (t = t.replace(/Capture$/, ""))),
            (a = t.toLowerCase()),
            (a in e || u.includes(a)) && (t = a),
            (t = t.slice(2)),
            e._listeners || (e._listeners = {}),
            (e._listeners[t] = r),
            r
              ? s || e.addEventListener(t, i, o)
              : e.removeEventListener(t, i, o))
          : "list" !== t &&
            "tagName" !== t &&
            "form" !== t &&
            "type" !== t &&
            "size" !== t &&
            "download" !== t &&
            "href" !== t &&
            t in e
          ? (e[t] = null == r ? "" : r)
          : "function" != typeof r &&
            "dangerouslySetInnerHTML" !== t &&
            (null == r || (!1 === r && !/^ar/.test(t))
              ? e.removeAttribute(t)
              : e.setAttribute(t, r));
    }
    function a(e) {
      switch (e) {
        case "onChange":
          return "onInput";
        default:
          return e;
      }
    }
    function s(e, t) {
      for (var r in t) o(e, a(r), t[r]);
    }
    function c(e, t) {
      for (var r in t) ("o" === r[0] && "n" === r[1]) || o(e, a(r), t[r]);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.setProperty = o),
      (t.setProperties = s),
      (t.setPropertiesWithoutEvents = c);
    var u = ["ontouchstart", "ontouchend", "ontouchmove", "ontouchcancel"];
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.LoadingIcon = void 0);
    var n = function (e) {
      var t = e.environment,
        r = t.document.createElementNS("http://www.w3.org/2000/svg", "svg");
      return (
        r.setAttribute("class", "aa-LoadingIcon"),
        r.setAttribute("viewBox", "0 0 100 100"),
        r.setAttribute("width", "20"),
        r.setAttribute("height", "20"),
        (r.innerHTML =
          '<circle\n  cx="50"\n  cy="50"\n  fill="none"\n  r="35"\n  stroke="currentColor"\n  stroke-dasharray="164.93361431346415 56.97787143782138"\n  stroke-width="6"\n>\n  <animateTransform\n    attributeName="transform"\n    type="rotate"\n    repeatCount="indefinite"\n    dur="1s"\n    values="0 50 50;90 50 50;180 50 50;360 50 50"\n    keyTimes="0;0.40;0.65;1"\n  />\n</circle>'),
        r
      );
    };
    t.LoadingIcon = n;
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.SearchIcon = void 0);
    var n = function (e) {
      var t = e.environment,
        r = t.document.createElementNS("http://www.w3.org/2000/svg", "svg");
      r.setAttribute("class", "icon icon--submit search-form__icon"),
        r.setAttribute("viewBox", "0 0 16 16"),
        r.setAttribute("width", "16"),
        r.setAttribute("height", "16"),
        r.setAttribute("fill", "currentColor");
      var n = t.document.createElementNS("http://www.w3.org/2000/svg", "path");
      return (
        n.setAttribute(
          "d",
          "M6.18165 0.138824C2.77724 0.138824 0 2.91585 0 6.32051C0 9.72517 2.77699 12.5022 6.18165 12.5022C7.59651 12.5022 8.90158 12.0235 9.94541 11.2185L13.79 15.0631C14.1015 15.3746 14.6126 15.3746 14.9241 15.0631C15.2356 14.7516 15.2356 14.2467 14.9241 13.9353L11.0731 10.0906C11.8797 9.04628 12.363 7.73715 12.363 6.32047C12.363 2.91592 9.58606 0.138824 6.1814 0.138824H6.18165ZM6.18165 1.73401C8.72393 1.73401 10.7678 3.77797 10.7678 6.32012C10.7678 8.8624 8.72379 10.9062 6.18165 10.9062C3.6395 10.9062 1.59554 8.86226 1.59554 6.32012C1.59554 3.77783 3.6395 1.73401 6.18165 1.73401Z"
        ),
        r.appendChild(n),
        r
      );
    };
    t.SearchIcon = n;
  },
  function (e, t, r) {
    "use strict";
    function n() {
      function e(e) {
        t.push(e);
        var n = e();
        r.push(n);
      }
      var t = [],
        r = [];
      return {
        runEffect: e,
        cleanupEffects: function () {
          var e = r;
          (r = []),
            e.forEach(function (e) {
              e();
            });
        },
        runEffects: function () {
          var r = t;
          (t = []),
            r.forEach(function (t) {
              e(t);
            });
        },
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createEffectWrapper = n);
  },
  function (e, t, r) {
    "use strict";
    function n() {
      var e = [];
      return {
        reactive: function (t) {
          var r = t(),
            n = {
              _fn: t,
              _ref: { current: r },
              get value() {
                return this._ref.current;
              },
              set value(e) {
                this._ref.current = e;
              },
            };
          return e.push(n), n;
        },
        runReactives: function () {
          e.forEach(function (e) {
            e._ref.current = e._fn();
          });
        },
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createReactiveWrapper = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = s(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (n = 0; n < o.length; n++)
          (r = o[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function s(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    function c(e) {
      var t,
        r = e.classNames,
        n = e.container,
        o = e.getEnvironmentProps,
        s = e.getFormProps,
        c = e.getInputProps,
        l = e.getItemProps,
        g = e.getLabelProps,
        y = e.getListProps,
        b = e.getPanelProps,
        _ = e.getRootProps,
        O = e.panelContainer,
        j = e.panelPlacement,
        P = e.render,
        w = e.renderNoResults,
        S = e.renderer,
        E = e.detachedMediaQuery,
        R = e.components,
        x = e.translations,
        k = a(e, p),
        I = "undefined" != typeof window ? window : {},
        A = (0, d.getHTMLElement)(I, n);
      (0, u.invariant)(
        "INPUT" !== A.tagName,
        "The `container` option does not support `input` elements. You need to change the container to a `div`."
      );
      var M = i(i({}, m), S),
        C = {
          Highlight: (0, f.createHighlightComponent)(M),
          ReverseHighlight: (0, f.createReverseHighlightComponent)(M),
          ReverseSnippet: (0, f.createReverseSnippetComponent)(M),
          Snippet: (0, f.createSnippetComponent)(M),
        },
        T = {
          clearButtonTitle: "Clear",
          detachedCancelButtonText: "Cancel",
          submitButtonTitle: "Submit",
        };
      return {
        renderer: {
          classNames: (0, d.mergeClassNames)(
            h,
            null !== r && void 0 !== r ? r : {}
          ),
          container: A,
          getEnvironmentProps:
            null !== o && void 0 !== o
              ? o
              : function (e) {
                  return e.props;
                },
          getFormProps:
            null !== s && void 0 !== s
              ? s
              : function (e) {
                  return e.props;
                },
          getInputProps:
            null !== c && void 0 !== c
              ? c
              : function (e) {
                  return e.props;
                },
          getItemProps:
            null !== l && void 0 !== l
              ? l
              : function (e) {
                  return e.props;
                },
          getLabelProps:
            null !== g && void 0 !== g
              ? g
              : function (e) {
                  return e.props;
                },
          getListProps:
            null !== y && void 0 !== y
              ? y
              : function (e) {
                  return e.props;
                },
          getPanelProps:
            null !== b && void 0 !== b
              ? b
              : function (e) {
                  return e.props;
                },
          getRootProps:
            null !== _ && void 0 !== _
              ? _
              : function (e) {
                  return e.props;
                },
          panelContainer: O ? (0, d.getHTMLElement)(I, O) : I.document.body,
          panelPlacement:
            null !== j && void 0 !== j ? j : "input-wrapper-width",
          render: null !== P && void 0 !== P ? P : v,
          renderNoResults: w,
          renderer: M,
          detachedMediaQuery:
            null !== E && void 0 !== E
              ? E
              : getComputedStyle(I.document.documentElement).getPropertyValue(
                  "--aa-detached-media-query"
                ),
          components: i(i({}, C), R),
          translations: i(i({}, T), x),
        },
        core: i(
          i({}, k),
          {},
          {
            id:
              null !== (t = k.id) && void 0 !== t
                ? t
                : (0, u.generateAutocompleteId)(),
            environment: I,
          }
        ),
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getDefaultOptions = c);
    var u = r(5),
      l = r(251),
      f = r(252),
      d = r(11),
      p = [
        "classNames",
        "container",
        "getEnvironmentProps",
        "getFormProps",
        "getInputProps",
        "getItemProps",
        "getLabelProps",
        "getListProps",
        "getPanelProps",
        "getRootProps",
        "panelContainer",
        "panelPlacement",
        "render",
        "renderNoResults",
        "renderer",
        "detachedMediaQuery",
        "components",
        "translations",
      ],
      h = {
        clearButton: "aa-ClearButton",
        detachedCancelButton: "aa-DetachedCancelButton",
        detachedContainer: "aa-DetachedContainer",
        detachedFormContainer: "aa-DetachedFormContainer",
        detachedOverlay: "aa-DetachedOverlay",
        detachedSearchButton: "aa-DetachedSearchButton",
        detachedSearchButtonIcon: "aa-DetachedSearchButtonIcon",
        detachedSearchButtonPlaceholder: "aa-DetachedSearchButtonPlaceholder",
        form: "aa-Form",
        input: "aa-Input",
        inputWrapper: "aa-InputWrapper",
        inputWrapperPrefix: "aa-InputWrapperPrefix",
        inputWrapperSuffix: "aa-InputWrapperSuffix",
        item: "aa-Item",
        label: "aa-Label",
        list: "aa-List",
        loadingIndicator: "aa-LoadingIndicator",
        panel: "aa-Panel",
        panelLayout: "aa-PanelLayout aa-Panel--scrollable",
        root: "aa-Autocomplete",
        source: "aa-Source",
        sourceFooter: "aa-SourceFooter",
        sourceHeader: "aa-SourceHeader",
        sourceNoResults: "aa-SourceNoResults",
        submitButton: "aa-SubmitButton",
      },
      v = function (e, t) {
        var r = e.children;
        (0, e.render)(r, t);
      },
      m = {
        createElement: l.createElement,
        Fragment: l.Fragment,
        render: l.render,
      };
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      for (var r in t) e[r] = t[r];
      return e;
    }
    function i(e) {
      var t = e.parentNode;
      t && t.removeChild(e);
    }
    function o(e, t, r) {
      var n,
        i,
        o,
        s = {};
      for (o in t)
        "key" == o ? (n = t[o]) : "ref" == o ? (i = t[o]) : (s[o] = t[o]);
      if (
        (arguments.length > 2 &&
          (s.children = arguments.length > 3 ? C.call(arguments, 2) : r),
        "function" == typeof e && null != e.defaultProps)
      )
        for (o in e.defaultProps) void 0 === s[o] && (s[o] = e.defaultProps[o]);
      return a(e, s, n, i, null);
    }
    function a(e, t, r, n, i) {
      var o = {
        type: e,
        props: t,
        key: r,
        ref: n,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == i ? ++N : i,
      };
      return null == i && null != T.vnode && T.vnode(o), o;
    }
    function s() {
      return { current: null };
    }
    function c(e) {
      return e.children;
    }
    function u(e, t) {
      (this.props = e), (this.context = t);
    }
    function l(e, t) {
      if (null == t) return e.__ ? l(e.__, e.__.__k.indexOf(e) + 1) : null;
      for (var r; t < e.__k.length; t++)
        if (null != (r = e.__k[t]) && null != r.__e) return r.__e;
      return "function" == typeof e.type ? l(e) : null;
    }
    function f(e) {
      var t, r;
      if (null != (e = e.__) && null != e.__c) {
        for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)
          if (null != (r = e.__k[t]) && null != r.__e) {
            e.__e = e.__c.base = r.__e;
            break;
          }
        return f(e);
      }
    }
    function d(e) {
      ((!e.__d && (e.__d = !0) && F.push(e) && !p.__r++) ||
        H !== T.debounceRendering) &&
        ((H = T.debounceRendering) || setTimeout)(p);
    }
    function p() {
      for (var e; (p.__r = F.length); )
        (e = F.sort(function (e, t) {
          return e.__v.__b - t.__v.__b;
        })),
          (F = []),
          e.some(function (e) {
            var t, r, i, o, a, s;
            e.__d &&
              ((a = (o = (t = e).__v).__e),
              (s = t.__P) &&
                ((r = []),
                ((i = n({}, o)).__v = o.__v + 1),
                P(
                  s,
                  o,
                  i,
                  t.__n,
                  void 0 !== s.ownerSVGElement,
                  null != o.__h ? [a] : null,
                  r,
                  null == a ? l(o) : a,
                  o.__h
                ),
                w(r, o),
                o.__e != a && f(o)));
          });
    }
    function h(e, t, r, n, i, o, s, u, f, d) {
      var p,
        h,
        m,
        y,
        b,
        _,
        O,
        j = (n && n.__k) || q,
        w = j.length;
      for (r.__k = [], p = 0; p < t.length; p++)
        if (
          null !=
          (y = r.__k[p] =
            null == (y = t[p]) || "boolean" == typeof y
              ? null
              : "string" == typeof y ||
                "number" == typeof y ||
                "bigint" == typeof y
              ? a(null, y, null, null, y)
              : Array.isArray(y)
              ? a(c, { children: y }, null, null, null)
              : y.__b > 0
              ? a(y.type, y.props, y.key, null, y.__v)
              : y)
        ) {
          if (
            ((y.__ = r),
            (y.__b = r.__b + 1),
            null === (m = j[p]) || (m && y.key == m.key && y.type === m.type))
          )
            j[p] = void 0;
          else
            for (h = 0; h < w; h++) {
              if ((m = j[h]) && y.key == m.key && y.type === m.type) {
                j[h] = void 0;
                break;
              }
              m = null;
            }
          P(e, y, (m = m || U), i, o, s, u, f, d),
            (b = y.__e),
            (h = y.ref) &&
              m.ref != h &&
              (O || (O = []),
              m.ref && O.push(m.ref, null, y),
              O.push(h, y.__c || b, y)),
            null != b
              ? (null == _ && (_ = b),
                "function" == typeof y.type && y.__k === m.__k
                  ? (y.__d = f = v(y, f, e))
                  : (f = g(e, y, m, j, b, f)),
                "function" == typeof r.type && (r.__d = f))
              : f && m.__e == f && f.parentNode != e && (f = l(m));
        }
      for (r.__e = _, p = w; p--; )
        null != j[p] &&
          ("function" == typeof r.type &&
            null != j[p].__e &&
            j[p].__e == r.__d &&
            (r.__d = l(n, p + 1)),
          R(j[p], j[p]));
      if (O) for (p = 0; p < O.length; p++) E(O[p], O[++p], O[++p]);
    }
    function v(e, t, r) {
      for (var n, i = e.__k, o = 0; i && o < i.length; o++)
        (n = i[o]) &&
          ((n.__ = e),
          (t =
            "function" == typeof n.type
              ? v(n, t, r)
              : g(r, n, n, i, n.__e, t)));
      return t;
    }
    function m(e, t) {
      return (
        (t = t || []),
        null == e ||
          "boolean" == typeof e ||
          (Array.isArray(e)
            ? e.some(function (e) {
                m(e, t);
              })
            : t.push(e)),
        t
      );
    }
    function g(e, t, r, n, i, o) {
      var a, s, c;
      if (void 0 !== t.__d) (a = t.__d), (t.__d = void 0);
      else if (null == r || i != o || null == i.parentNode)
        e: if (null == o || o.parentNode !== e) e.appendChild(i), (a = null);
        else {
          for (s = o, c = 0; (s = s.nextSibling) && c < n.length; c += 2)
            if (s == i) break e;
          e.insertBefore(i, o), (a = o);
        }
      return void 0 !== a ? a : i.nextSibling;
    }
    function y(e, t, r, n, i) {
      var o;
      for (o in r)
        "children" === o || "key" === o || o in t || _(e, o, null, r[o], n);
      for (o in t)
        (i && "function" != typeof t[o]) ||
          "children" === o ||
          "key" === o ||
          "value" === o ||
          "checked" === o ||
          r[o] === t[o] ||
          _(e, o, t[o], r[o], n);
    }
    function b(e, t, r) {
      "-" === t[0]
        ? e.setProperty(t, r)
        : (e[t] =
            null == r ? "" : "number" != typeof r || B.test(t) ? r : r + "px");
    }
    function _(e, t, r, n, i) {
      var o;
      e: if ("style" === t)
        if ("string" == typeof r) e.style.cssText = r;
        else {
          if (("string" == typeof n && (e.style.cssText = n = ""), n))
            for (t in n) (r && t in r) || b(e.style, t, "");
          if (r) for (t in r) (n && r[t] === n[t]) || b(e.style, t, r[t]);
        }
      else if ("o" === t[0] && "n" === t[1])
        (o = t !== (t = t.replace(/Capture$/, ""))),
          (t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2)),
          e.l || (e.l = {}),
          (e.l[t + o] = r),
          r
            ? n || e.addEventListener(t, o ? j : O, o)
            : e.removeEventListener(t, o ? j : O, o);
      else if ("dangerouslySetInnerHTML" !== t) {
        if (i) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if (
          "href" !== t &&
          "list" !== t &&
          "form" !== t &&
          "tabIndex" !== t &&
          "download" !== t &&
          t in e
        )
          try {
            e[t] = null == r ? "" : r;
            break e;
          } catch (e) {}
        "function" == typeof r ||
          (null != r && (!1 !== r || ("a" === t[0] && "r" === t[1]))
            ? e.setAttribute(t, r)
            : e.removeAttribute(t));
      }
    }
    function O(e) {
      this.l[e.type + !1](T.event ? T.event(e) : e);
    }
    function j(e) {
      this.l[e.type + !0](T.event ? T.event(e) : e);
    }
    function P(e, t, r, i, o, a, s, l, f) {
      var d,
        p,
        v,
        m,
        g,
        y,
        b,
        _,
        O,
        j,
        P,
        w,
        E,
        R = t.type;
      if (void 0 !== t.constructor) return null;
      null != r.__h &&
        ((f = r.__h), (l = t.__e = r.__e), (t.__h = null), (a = [l])),
        (d = T.__b) && d(t);
      try {
        e: if ("function" == typeof R) {
          if (
            ((_ = t.props),
            (O = (d = R.contextType) && i[d.__c]),
            (j = d ? (O ? O.props.value : d.__) : i),
            r.__c
              ? (b = (p = t.__c = r.__c).__ = p.__E)
              : ("prototype" in R && R.prototype.render
                  ? (t.__c = p = new R(_, j))
                  : ((t.__c = p = new u(_, j)),
                    (p.constructor = R),
                    (p.render = x)),
                O && O.sub(p),
                (p.props = _),
                p.state || (p.state = {}),
                (p.context = j),
                (p.__n = i),
                (v = p.__d = !0),
                (p.__h = [])),
            null == p.__s && (p.__s = p.state),
            null != R.getDerivedStateFromProps &&
              (p.__s == p.state && (p.__s = n({}, p.__s)),
              n(p.__s, R.getDerivedStateFromProps(_, p.__s))),
            (m = p.props),
            (g = p.state),
            v)
          )
            null == R.getDerivedStateFromProps &&
              null != p.componentWillMount &&
              p.componentWillMount(),
              null != p.componentDidMount && p.__h.push(p.componentDidMount);
          else {
            if (
              (null == R.getDerivedStateFromProps &&
                _ !== m &&
                null != p.componentWillReceiveProps &&
                p.componentWillReceiveProps(_, j),
              (!p.__e &&
                null != p.shouldComponentUpdate &&
                !1 === p.shouldComponentUpdate(_, p.__s, j)) ||
                t.__v === r.__v)
            ) {
              (p.props = _),
                (p.state = p.__s),
                t.__v !== r.__v && (p.__d = !1),
                (p.__v = t),
                (t.__e = r.__e),
                (t.__k = r.__k),
                t.__k.forEach(function (e) {
                  e && (e.__ = t);
                }),
                p.__h.length && s.push(p);
              break e;
            }
            null != p.componentWillUpdate && p.componentWillUpdate(_, p.__s, j),
              null != p.componentDidUpdate &&
                p.__h.push(function () {
                  p.componentDidUpdate(m, g, y);
                });
          }
          if (
            ((p.context = j),
            (p.props = _),
            (p.__v = t),
            (p.__P = e),
            (P = T.__r),
            (w = 0),
            "prototype" in R && R.prototype.render)
          )
            (p.state = p.__s),
              (p.__d = !1),
              P && P(t),
              (d = p.render(p.props, p.state, p.context));
          else
            do {
              (p.__d = !1),
                P && P(t),
                (d = p.render(p.props, p.state, p.context)),
                (p.state = p.__s);
            } while (p.__d && ++w < 25);
          (p.state = p.__s),
            null != p.getChildContext && (i = n(n({}, i), p.getChildContext())),
            v ||
              null == p.getSnapshotBeforeUpdate ||
              (y = p.getSnapshotBeforeUpdate(m, g)),
            (E =
              null != d && d.type === c && null == d.key
                ? d.props.children
                : d),
            h(e, Array.isArray(E) ? E : [E], t, r, i, o, a, s, l, f),
            (p.base = t.__e),
            (t.__h = null),
            p.__h.length && s.push(p),
            b && (p.__E = p.__ = null),
            (p.__e = !1);
        } else
          null == a && t.__v === r.__v
            ? ((t.__k = r.__k), (t.__e = r.__e))
            : (t.__e = S(r.__e, t, r, i, o, a, s, f));
        (d = T.diffed) && d(t);
      } catch (e) {
        (t.__v = null),
          (f || null != a) &&
            ((t.__e = l), (t.__h = !!f), (a[a.indexOf(l)] = null)),
          T.__e(e, t, r);
      }
    }
    function w(e, t) {
      T.__c && T.__c(t, e),
        e.some(function (t) {
          try {
            (e = t.__h),
              (t.__h = []),
              e.some(function (e) {
                e.call(t);
              });
          } catch (e) {
            T.__e(e, t.__v);
          }
        });
    }
    function S(e, t, r, n, o, a, s, c) {
      var u,
        f,
        d,
        p = r.props,
        v = t.props,
        m = t.type,
        g = 0;
      if (("svg" === m && (o = !0), null != a))
        for (; g < a.length; g++)
          if (
            (u = a[g]) &&
            "setAttribute" in u == !!m &&
            (m ? u.localName === m : 3 === u.nodeType)
          ) {
            (e = u), (a[g] = null);
            break;
          }
      if (null == e) {
        if (null === m) return document.createTextNode(v);
        (e = o
          ? document.createElementNS("http://www.w3.org/2000/svg", m)
          : document.createElement(m, v.is && v)),
          (a = null),
          (c = !1);
      }
      if (null === m) p === v || (c && e.data === v) || (e.data = v);
      else {
        if (
          ((a = a && C.call(e.childNodes)),
          (f = (p = r.props || U).dangerouslySetInnerHTML),
          (d = v.dangerouslySetInnerHTML),
          !c)
        ) {
          if (null != a)
            for (p = {}, g = 0; g < e.attributes.length; g++)
              p[e.attributes[g].name] = e.attributes[g].value;
          (d || f) &&
            ((d && ((f && d.__html == f.__html) || d.__html === e.innerHTML)) ||
              (e.innerHTML = (d && d.__html) || ""));
        }
        if ((y(e, v, p, o, c), d)) t.__k = [];
        else if (
          ((g = t.props.children),
          h(
            e,
            Array.isArray(g) ? g : [g],
            t,
            r,
            n,
            o && "foreignObject" !== m,
            a,
            s,
            a ? a[0] : r.__k && l(r, 0),
            c
          ),
          null != a)
        )
          for (g = a.length; g--; ) null != a[g] && i(a[g]);
        c ||
          ("value" in v &&
            void 0 !== (g = v.value) &&
            (g !== e.value ||
              ("progress" === m && !g) ||
              ("option" === m && g !== p.value)) &&
            _(e, "value", g, p.value, !1),
          "checked" in v &&
            void 0 !== (g = v.checked) &&
            g !== e.checked &&
            _(e, "checked", g, p.checked, !1));
      }
      return e;
    }
    function E(e, t, r) {
      try {
        "function" == typeof e ? e(t) : (e.current = t);
      } catch (e) {
        T.__e(e, r);
      }
    }
    function R(e, t, r) {
      var n, o;
      if (
        (T.unmount && T.unmount(e),
        (n = e.ref) && ((n.current && n.current !== e.__e) || E(n, null, t)),
        null != (n = e.__c))
      ) {
        if (n.componentWillUnmount)
          try {
            n.componentWillUnmount();
          } catch (e) {
            T.__e(e, t);
          }
        n.base = n.__P = null;
      }
      if ((n = e.__k))
        for (o = 0; o < n.length; o++)
          n[o] && R(n[o], t, "function" != typeof e.type);
      r || null == e.__e || i(e.__e), (e.__e = e.__d = void 0);
    }
    function x(e, t, r) {
      return this.constructor(e, r);
    }
    function k(e, t, r) {
      var n, i, a;
      T.__ && T.__(e, t),
        (i = (n = "function" == typeof r) ? null : (r && r.__k) || t.__k),
        (a = []),
        P(
          t,
          (e = ((!n && r) || t).__k = o(c, null, [e])),
          i || U,
          U,
          void 0 !== t.ownerSVGElement,
          !n && r ? [r] : i ? null : t.firstChild ? C.call(t.childNodes) : null,
          a,
          !n && r ? r : i ? i.__e : t.firstChild,
          n
        ),
        w(a, e);
    }
    function I(e, t) {
      k(e, t, I);
    }
    function A(e, t, r) {
      var i,
        o,
        s,
        c = n({}, e.props);
      for (s in t)
        "key" == s ? (i = t[s]) : "ref" == s ? (o = t[s]) : (c[s] = t[s]);
      return (
        arguments.length > 2 &&
          (c.children = arguments.length > 3 ? C.call(arguments, 2) : r),
        a(e.type, c, i || e.key, o || e.ref, null)
      );
    }
    function M(e, t) {
      var r = {
        __c: (t = "__cC" + L++),
        __: e,
        Consumer: function (e, t) {
          return e.children(t);
        },
        Provider: function (e) {
          var r, n;
          return (
            this.getChildContext ||
              ((r = []),
              ((n = {})[t] = this),
              (this.getChildContext = function () {
                return n;
              }),
              (this.shouldComponentUpdate = function (e) {
                this.props.value !== e.value && r.some(d);
              }),
              (this.sub = function (e) {
                r.push(e);
                var t = e.componentWillUnmount;
                e.componentWillUnmount = function () {
                  r.splice(r.indexOf(e), 1), t && t.call(e);
                };
              })),
            e.children
          );
        },
      };
      return (r.Provider.__ = r.Consumer.contextType = r);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.render = k),
      (t.hydrate = I),
      (t.h = t.createElement = o),
      (t.Fragment = c),
      (t.createRef = s),
      (t.Component = u),
      (t.cloneElement = A),
      (t.createContext = M),
      (t.toChildArray = m),
      (t.options = t.isValidElement = void 0);
    var C,
      T,
      N,
      D,
      F,
      H,
      L,
      U = {},
      q = [],
      B = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
    (t.isValidElement = D),
      (t.options = T),
      (C = q.slice),
      (t.options = T =
        {
          __e: function (e, t, r, n) {
            for (var i, o, a; (t = t.__); )
              if ((i = t.__c) && !i.__)
                try {
                  if (
                    ((o = i.constructor) &&
                      null != o.getDerivedStateFromError &&
                      (i.setState(o.getDerivedStateFromError(e)), (a = i.__d)),
                    null != i.componentDidCatch &&
                      (i.componentDidCatch(e, n || {}), (a = i.__d)),
                    a)
                  )
                    return (i.__E = i);
                } catch (t) {
                  e = t;
                }
            throw e;
          },
        }),
      (N = 0),
      (t.isValidElement = D =
        function (e) {
          return null != e && void 0 === e.constructor;
        }),
      (u.prototype.setState = function (e, t) {
        var r;
        (r =
          null != this.__s && this.__s !== this.state
            ? this.__s
            : (this.__s = n({}, this.state))),
          "function" == typeof e && (e = e(n({}, r), this.props)),
          e && n(r, e),
          null != e && this.__v && (t && this.__h.push(t), d(this));
      }),
      (u.prototype.forceUpdate = function (e) {
        this.__v && ((this.__e = !0), e && this.__h.push(e), d(this));
      }),
      (u.prototype.render = c),
      (F = []),
      (p.__r = 0),
      (L = 0);
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(253);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(264);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
    var o = r(265);
    Object.keys(o).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return o[e];
          },
        });
    });
    var a = r(266);
    Object.keys(a).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return a[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      function t(e) {
        var t = e.hit,
          o = e.attribute,
          a = e.tagName,
          s = void 0 === a ? "mark" : a;
        return r(
          n,
          {},
          (0, i.parseAlgoliaHitHighlight)({ hit: t, attribute: o }).map(
            function (e, t) {
              return e.isHighlighted ? r(s, { key: t }, e.value) : e.value;
            }
          )
        );
      }
      var r = e.createElement,
        n = e.Fragment;
      return (t.__autocomplete_componentName = "Highlight"), t;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createHighlightComponent = n);
    var i = r(13);
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(255);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(72);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
    var o = r(256);
    Object.keys(o).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return o[e];
          },
        });
    });
    var a = r(258);
    Object.keys(a).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return a[e];
          },
        });
    });
    var s = r(76);
    Object.keys(s).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return s[e];
          },
        });
    });
    var c = r(259);
    Object.keys(c).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return c[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return (0, o.reverseHighlightedParts)((0, i.parseAlgoliaHitHighlight)(e));
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.parseAlgoliaHitReverseHighlight = n);
    var i = r(72),
      o = r(75);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return e && c.test(e)
        ? e.replace(s, function (e) {
            return o[e];
          })
        : e;
    }
    function i(e, t) {
      var r,
        i,
        o = e[t],
        s =
          (null === (r = e[t + 1]) || void 0 === r
            ? void 0
            : r.isHighlighted) || !0,
        c =
          (null === (i = e[t - 1]) || void 0 === i
            ? void 0
            : i.isHighlighted) || !0;
      return a.test(n(o.value)) || c !== s ? o.isHighlighted : c;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.isPartHighlighted = i);
    var o = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'",
      },
      a = new RegExp(/\w/i),
      s = /&(amp|quot|lt|gt|#39);/g,
      c = RegExp(s.source);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return (0, o.reverseHighlightedParts)((0, i.parseAlgoliaHitSnippet)(e));
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.parseAlgoliaHitReverseSnippet = n);
    var i = r(76),
      o = r(75);
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(77);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(261);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
    var o = r(263);
    Object.keys(o).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return o[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e) {
      var t = (0, s.createAlgoliaRequester)({
          transformResponse: function (e) {
            return e.facetHits;
          },
        }),
        r = e.queries.map(function (e) {
          return i(i({}, e), {}, { type: "facet" });
        });
      return t(i(i({}, e), {}, { queries: r }));
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getAlgoliaFacets = a);
    var s = r(78);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = s(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (n = 0; n < o.length; n++)
          (r = o[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function s(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    function c(e) {
      return d(e) || f(e) || l(e) || u();
    }
    function u() {
      throw new TypeError(
        "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function l(e, t) {
      if (e) {
        if ("string" == typeof e) return p(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? p(e, t)
            : void 0
        );
      }
    }
    function f(e) {
      if (
        ("undefined" != typeof Symbol && null != e[Symbol.iterator]) ||
        null != e["@@iterator"]
      )
        return Array.from(e);
    }
    function d(e) {
      if (Array.isArray(e)) return p(e);
    }
    function p(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function h(e) {
      var t = e.searchClient,
        r = e.queries,
        n = e.userAgents,
        o = void 0 === n ? [] : n;
      return (
        "function" == typeof t.addAlgoliaAgent &&
          [].concat(c(v.userAgents), c(o)).forEach(function (e) {
            var r = e.segment,
              n = e.version;
            t.addAlgoliaAgent(r, n);
          }),
        t
          .search(
            r.map(function (e) {
              var t = e.params;
              return i(
                i({}, a(e, g)),
                {},
                {
                  params: i(
                    {
                      hitsPerPage: 5,
                      highlightPreTag: m.HIGHLIGHT_PRE_TAG,
                      highlightPostTag: m.HIGHLIGHT_POST_TAG,
                    },
                    t
                  ),
                }
              );
            })
          )
          .then(function (e) {
            return e.results;
          })
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.fetchAlgoliaResults = h);
    var v = r(5),
      m = r(74),
      g = ["params"];
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getAlgoliaResults = void 0);
    var n = r(78),
      i = (0, n.createAlgoliaRequester)({
        transformResponse: function (e) {
          return e.hits;
        },
      });
    t.getAlgoliaResults = i;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      function t(e) {
        var t = e.hit,
          o = e.attribute,
          a = e.tagName,
          s = void 0 === a ? "mark" : a;
        return r(
          n,
          {},
          (0, i.parseAlgoliaHitReverseHighlight)({ hit: t, attribute: o }).map(
            function (e, t) {
              return e.isHighlighted ? r(s, { key: t }, e.value) : e.value;
            }
          )
        );
      }
      var r = e.createElement,
        n = e.Fragment;
      return (t.__autocomplete_componentName = "ReverseHighlight"), t;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createReverseHighlightComponent = n);
    var i = r(13);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      function t(e) {
        var t = e.hit,
          o = e.attribute,
          a = e.tagName,
          s = void 0 === a ? "mark" : a;
        return r(
          n,
          {},
          (0, i.parseAlgoliaHitReverseSnippet)({ hit: t, attribute: o }).map(
            function (e, t) {
              return e.isHighlighted ? r(s, { key: t }, e.value) : e.value;
            }
          )
        );
      }
      var r = e.createElement,
        n = e.Fragment;
      return (t.__autocomplete_componentName = "ReverseSnippet"), t;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createReverseSnippetComponent = n);
    var i = r(13);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      function t(e) {
        var t = e.hit,
          o = e.attribute,
          a = e.tagName,
          s = void 0 === a ? "mark" : a;
        return r(
          n,
          {},
          (0, i.parseAlgoliaHitSnippet)({ hit: t, attribute: o }).map(function (
            e,
            t
          ) {
            return e.isHighlighted ? r(s, { key: t }, e.value) : e.value;
          })
        );
      }
      var r = e.createElement,
        n = e.Fragment;
      return (t.__autocomplete_componentName = "Snippet"), t;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createSnippetComponent = n);
    var i = r(13);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t = e.panelPlacement,
        r = e.container,
        n = e.form,
        i = e.environment,
        o = r.getBoundingClientRect(),
        a =
          i.pageYOffset ||
          i.document.documentElement.scrollTop ||
          i.document.body.scrollTop ||
          0,
        s = a + o.top + o.height;
      switch (t) {
        case "start":
          return { top: s, left: o.left };
        case "end":
          return {
            top: s,
            right: i.document.documentElement.clientWidth - (o.left + o.width),
          };
        case "full-width":
          return {
            top: s,
            left: 0,
            right: 0,
            width: "unset",
            maxWidth: "unset",
          };
        case "input-wrapper-width":
          var c = n.getBoundingClientRect();
          return {
            top: s,
            left: c.left,
            right: i.document.documentElement.clientWidth - (c.left + c.width),
            width: "unset",
            maxWidth: "unset",
          };
        default:
          throw new Error(
            "[Autocomplete] The `panelPlacement` value ".concat(
              JSON.stringify(t),
              " is not valid."
            )
          );
      }
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getPanelPlacementStyle = n);
  },
  function (e, t, r) {
    "use strict";
    function n() {
      return (
        (n =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r)
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          }),
        n.apply(this, arguments)
      );
    }
    function i(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function o(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? i(Object(r), !0).forEach(function (t) {
              a(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : i(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function a(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function s(e) {
      var t = e.autocomplete,
        r = e.autocompleteScopeApi,
        n = e.dom,
        i = e.propGetters,
        a = e.state;
      (0, u.setPropertiesWithoutEvents)(
        n.root,
        i.getRootProps(o({ state: a, props: t.getRootProps({}) }, r))
      ),
        (0, u.setPropertiesWithoutEvents)(
          n.input,
          i.getInputProps(
            o(
              {
                state: a,
                props: t.getInputProps({ inputElement: n.input }),
                inputElement: n.input,
              },
              r
            )
          )
        ),
        (0, u.setProperties)(n.label, { hidden: "stalled" === a.status }),
        (0, u.setProperties)(n.loadingIndicator, {
          hidden: "stalled" !== a.status,
        }),
        (0, u.setProperties)(n.clearButton, { hidden: !a.query });
    }
    function c(e, t) {
      var r = t.autocomplete,
        i = t.autocompleteScopeApi,
        a = t.classNames,
        s = t.html,
        c = t.dom,
        u = t.panelContainer,
        l = t.propGetters,
        f = t.state,
        d = t.components,
        p = t.renderer;
      if (!f.isOpen)
        return void (u.contains(c.panel) && u.removeChild(c.panel));
      u.contains(c.panel) || "loading" === f.status || u.appendChild(c.panel),
        c.panel.classList.toggle("aa-Panel--stalled", "stalled" === f.status);
      var h = f.collections
          .filter(function (e) {
            var t = e.source,
              r = e.items;
            return t.templates.noResults || r.length > 0;
          })
          .map(function (e, t) {
            var c = e.source,
              u = e.items;
            return p.createElement(
              "section",
              {
                key: t,
                className: a.source,
                "data-autocomplete-source-id": c.sourceId,
              },
              c.templates.header &&
                p.createElement(
                  "div",
                  { className: a.sourceHeader },
                  c.templates.header({
                    components: d,
                    createElement: p.createElement,
                    Fragment: p.Fragment,
                    items: u,
                    source: c,
                    state: f,
                    html: s,
                  })
                ),
              c.templates.noResults && 0 === u.length
                ? p.createElement(
                    "div",
                    { className: a.sourceNoResults },
                    c.templates.noResults({
                      components: d,
                      createElement: p.createElement,
                      Fragment: p.Fragment,
                      source: c,
                      state: f,
                      html: s,
                    })
                  )
                : p.createElement(
                    "ul",
                    n(
                      { className: a.list },
                      l.getListProps(
                        o({ state: f, props: r.getListProps({}) }, i)
                      )
                    ),
                    u.map(function (e) {
                      var t = r.getItemProps({ item: e, source: c });
                      return p.createElement(
                        "li",
                        n(
                          { key: t.id, className: a.item },
                          l.getItemProps(o({ state: f, props: t }, i))
                        ),
                        c.templates.item({
                          components: d,
                          createElement: p.createElement,
                          Fragment: p.Fragment,
                          item: e,
                          state: f,
                          html: s,
                        })
                      );
                    })
                  ),
              c.templates.footer &&
                p.createElement(
                  "div",
                  { className: a.sourceFooter },
                  c.templates.footer({
                    components: d,
                    createElement: p.createElement,
                    Fragment: p.Fragment,
                    items: u,
                    source: c,
                    state: f,
                    html: s,
                  })
                )
            );
          }),
        v = p.createElement(
          p.Fragment,
          null,
          p.createElement("div", { className: a.panelLayout }, h),
          p.createElement("div", { className: "aa-GradientBottom" })
        ),
        m = h.reduce(function (e, t) {
          return (e[t.props["data-autocomplete-source-id"]] = t), e;
        }, {});
      e(
        o(
          o({ children: v, state: f, sections: h, elements: m }, p),
          {},
          { components: d, html: s },
          i
        ),
        c.panel
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.renderSearchBox = s),
      (t.renderPanel = c);
    var u = r(11);
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(270);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(271);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e) {
      var t = (0, s.createAlgoliaRequester)({
          transformResponse: function (e) {
            return e.facetHits;
          },
        }),
        r = e.queries.map(function (e) {
          return i(i({}, e), {}, { type: "facet" });
        });
      return t(i(i({}, e), {}, { queries: r }));
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getAlgoliaFacets = a);
    var s = r(81);
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getAlgoliaResults = void 0);
    var n = r(81),
      i = (0, n.createAlgoliaRequester)({
        transformResponse: function (e) {
          return e.hits;
        },
      });
    t.getAlgoliaResults = i;
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(273);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(274);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
    var o = r(275);
    Object.keys(o).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return o[e];
          },
        });
    });
    var a = r(276);
    Object.keys(a).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return a[e];
          },
        });
    });
    var s = r(277);
    Object.keys(s).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return s[e];
          },
        });
    });
    var c = r(278);
    Object.keys(c).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return c[e];
          },
        });
    });
    var u = r(279);
    Object.keys(u).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return u[e];
          },
        });
    });
    var l = r(280);
    Object.keys(l).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return l[e];
          },
        });
    });
    var f = r(281);
    Object.keys(f).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return f[e];
          },
        });
    });
    var d = r(282);
    Object.keys(d).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return d[e];
          },
        });
    });
    var p = r(283);
    Object.keys(p).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return p[e];
          },
        });
    });
    var h = r(284);
    Object.keys(h).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return h[e];
          },
        });
    });
    var v = r(285);
    Object.keys(v).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return v[e];
          },
        });
    });
    var m = r(286);
    Object.keys(m).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return m[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(288);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(82);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e, t) {
      var r =
        ("undefined" != typeof Symbol && e[Symbol.iterator]) || e["@@iterator"];
      if (!r) {
        if (
          Array.isArray(e) ||
          (r = s(e)) ||
          (t && e && "number" == typeof e.length)
        ) {
          r && (e = r);
          var n = 0,
            i = function () {};
          return {
            s: i,
            n: function () {
              return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
            },
            e: function (e) {
              throw e;
            },
            f: i,
          };
        }
        throw new TypeError(
          "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
        );
      }
      var o,
        a = !0,
        c = !1;
      return {
        s: function () {
          r = r.call(e);
        },
        n: function () {
          var e = r.next();
          return (a = e.done), e;
        },
        e: function (e) {
          (c = !0), (o = e);
        },
        f: function () {
          try {
            a || null == r.return || r.return();
          } finally {
            if (c) throw o;
          }
        },
      };
    }
    function s(e, t) {
      if (e) {
        if ("string" == typeof e) return c(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? c(e, t)
            : void 0
        );
      }
    }
    function c(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function u(e) {
      var t = l(e),
        r = t.searchClient,
        n = t.indexName,
        o = t.getSearchParams,
        s = t.transformSource,
        c = t.categoryAttribute,
        u = t.itemsWithCategories,
        h = t.categoriesPerItem;
      return {
        name: "aa.querySuggestionsPlugin",
        getSources: function (e) {
          function t(e) {
            v("".concat(e.query, " ")), m();
          }
          var l = e.query,
            v = e.setQuery,
            m = e.refresh,
            g = e.state;
          return [
            s({
              source: {
                sourceId: "querySuggestionsPlugin",
                getItemInputValue: function (e) {
                  return e.item.query;
                },
                getItems: function () {
                  return (0, f.getAlgoliaResults)({
                    searchClient: r,
                    queries: [
                      { indexName: n, query: l, params: o({ state: g }) },
                    ],
                    transformResponse: function (e) {
                      var t = e.hits,
                        r = t[0];
                      return l && c
                        ? r.reduce(function (e, t, r) {
                            var n = [t];
                            if (r <= u - 1) {
                              var o,
                                s = (0, d.getAttributeValueByPath)(
                                  t,
                                  Array.isArray(c) ? c : [c]
                                )
                                  .map(function (e) {
                                    return e.value;
                                  })
                                  .slice(0, h),
                                l = a(s);
                              try {
                                for (l.s(); !(o = l.n()).done; ) {
                                  var f = o.value;
                                  n.push(
                                    i({ __autocomplete_qsCategory: f }, t)
                                  );
                                }
                              } catch (e) {
                                l.e(e);
                              } finally {
                                l.f();
                              }
                            }
                            return e.push.apply(e, n), e;
                          }, [])
                        : r;
                    },
                  });
                },
                templates: (0, p.getTemplates)({ onTapAhead: t }),
              },
              onTapAhead: t,
              state: g,
            }),
          ];
        },
        __autocomplete_pluginOptions: e,
      };
    }
    function l(e) {
      return i(
        {
          getSearchParams: function () {
            return {};
          },
          transformSource: function (e) {
            return e.source;
          },
          itemsWithCategories: 1,
          categoriesPerItem: 1,
        },
        e
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createQuerySuggestionsPlugin = u);
    var f = r(67),
      d = r(5),
      p = r(82);
  },
  function (e, t, r) {
    "use strict";
    var n = r(290);
    (e.exports = n.default),
      Object.keys(n).forEach(function (t) {
        "default" !== t && (e.exports[t] = n[t]);
      });
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = {};
      for (var n in e)
        Object.prototype.hasOwnProperty.call(e, n) &&
          t.indexOf(n) < 0 &&
          (r[n] = e[n]);
      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var i = 0;
        for (n = Object.getOwnPropertySymbols(e); i < n.length; i++)
          t.indexOf(n[i]) < 0 &&
            Object.prototype.propertyIsEnumerable.call(e, n[i]) &&
            (r[n[i]] = e[n[i]]);
      }
      return r;
    }
    function i(e) {
      return function (t) {
        var r = this;
        if (!this._userHasOptedOut) {
          if (!this._hasCredentials)
            throw new Error(
              "Before calling any methods on the analytics, you first need to call the 'init' function with appId and apiKey parameters"
            );
          var i = t.map(function (e) {
            var t,
              i,
              o = e.filters,
              a = n(e, ["filters"]),
              s = Object.assign(Object.assign({}, a), {
                userToken:
                  ((i =
                    null === (t = e) || void 0 === t ? void 0 : t.userToken),
                  null !== i && void 0 !== i ? i : r._userToken),
              });
            return I(o) || (s.filters = o.map(encodeURIComponent)), s;
          });
          return o(
            e,
            this._appId,
            this._apiKey,
            this._ua,
            this._endpointOrigin,
            i
          );
        }
      };
    }
    function o(e, t, r, n, i, o) {
      return e(
        i +
          "/1/events?X-Algolia-Application-Id=" +
          t +
          "&X-Algolia-API-Key=" +
          r +
          "&X-Algolia-Agent=" +
          encodeURIComponent(n.join("; ")),
        { events: o }
      );
    }
    function a(e) {
      -1 === this._ua.indexOf(e) && this._ua.push(e);
    }
    function s(e) {
      var t;
      if (!e)
        throw new Error(
          "Init function should be called with an object argument containing your apiKey and appId"
        );
      if (I(e.apiKey) || !A(e.apiKey))
        throw new Error(
          "apiKey is missing, please provide it so we can authenticate the application"
        );
      if (I(e.appId) || !A(e.appId))
        throw new Error(
          "appId is missing, please provide it, so we can properly attribute data to your application"
        );
      if (!I(e.region) && -1 === N.indexOf(e.region))
        throw new Error(
          "optional region is incorrect, please provide either one of: " +
            N.join(", ") +
            "."
        );
      if (
        !(
          I(e.cookieDuration) ||
          (M(e.cookieDuration) &&
            isFinite(e.cookieDuration) &&
            Math.floor(e.cookieDuration) === e.cookieDuration)
        )
      )
        throw new Error(
          "optional cookieDuration is incorrect, expected an integer."
        );
      (this._apiKey = e.apiKey),
        (this._appId = e.appId),
        (this._userHasOptedOut = !!e.userHasOptedOut),
        (this._region = e.region),
        (this._endpointOrigin = e.region
          ? "https://insights." + e.region + ".algolia.io"
          : "https://insights.algolia.io"),
        (this._useCookie = null !== (t = e.useCookie) && void 0 !== t && t),
        (this._cookieDuration = e.cookieDuration ? e.cookieDuration : 6 * D),
        (this._hasCredentials = !0),
        (this._ua = [].concat(T)),
        e.userToken
          ? this.setUserToken(e.userToken)
          : this._userToken ||
            this._userHasOptedOut ||
            !this._useCookie ||
            this.setAnonymousUserToken();
    }
    function c(e) {
      C(e) && e(this.version);
    }
    function u(e, t) {
      return t.map(function (t) {
        return Object.assign({ eventType: e }, t);
      });
    }
    function l() {
      for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
      return this.sendEvents(u("click", e));
    }
    function f() {
      for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
      return this.sendEvents(u("click", e));
    }
    function d() {
      for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
      return this.sendEvents(u("click", e));
    }
    function p() {
      for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
      return this.sendEvents(u("conversion", e));
    }
    function h() {
      for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
      return this.sendEvents(u("conversion", e));
    }
    function v() {
      for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
      return this.sendEvents(u("conversion", e));
    }
    function m() {
      for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
      return this.sendEvents(u("view", e));
    }
    function g() {
      for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
      return this.sendEvents(u("view", e));
    }
    function y() {
      if (R()) {
        var e = U(H);
        e && "" !== e && 0 === e.indexOf("anonymous-")
          ? this.setUserToken(e)
          : (this.setUserToken("anonymous-" + F()),
            L(H, this._userToken, this._cookieDuration));
      }
    }
    function b(e) {
      (this._userToken = e),
        C(this._onUserTokenChangeCallback) &&
          this._onUserTokenChangeCallback(this._userToken);
    }
    function _(e, t) {
      return C(t) && t(null, this._userToken), this._userToken;
    }
    function O(e, t) {
      (this._onUserTokenChangeCallback = e),
        t &&
          t.immediate &&
          C(this._onUserTokenChangeCallback) &&
          this._onUserTokenChangeCallback(this._userToken);
    }
    function j(e) {
      return function (t) {
        for (var r = [], n = arguments.length - 1; n-- > 0; )
          r[n] = arguments[n + 1];
        t && C(e[t])
          ? e[t].apply(e, r)
          : console.warn("The method `" + t + "` doesn't exist.");
      };
    }
    function P() {
      if (x()) return B;
      if (k()) return W;
      throw new Error(
        "Could not find a supported HTTP request client in this environment."
      );
    }
    function w(e) {
      var t = e.AlgoliaAnalyticsObject;
      if (t) {
        var r = j(this),
          n = e[t];
        n.queue = n.queue || [];
        var i = n.queue;
        i.forEach(function (e) {
          var t = [].slice.call(e),
            n = t[0],
            i = t.slice(1);
          r.apply(void 0, [n].concat(i));
        }),
          (i.push = function (e) {
            var t = [].slice.call(e),
              n = t[0],
              i = t.slice(1);
            r.apply(void 0, [n].concat(i));
          });
      }
    }
    var S = r(0),
      E = S(r(4));
    Object.defineProperty(t, "__esModule", { value: !0 });
    var R = function () {
        try {
          return Boolean(navigator.cookieEnabled);
        } catch (e) {
          return !1;
        }
      },
      x = function () {
        try {
          return Boolean(navigator.sendBeacon);
        } catch (e) {
          return !1;
        }
      },
      k = function () {
        try {
          return Boolean(XMLHttpRequest);
        } catch (e) {
          return !1;
        }
      },
      I = function (e) {
        return void 0 === e;
      },
      A = function (e) {
        return "string" == typeof e;
      },
      M = function (e) {
        return "number" == typeof e;
      },
      C = function (e) {
        return "function" == typeof e;
      },
      T = ["insights-js (2.2.1)", "insights-js-browser-cjs (2.2.1)"],
      N = ["de", "us"],
      D = 2592e6,
      F = function () {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/g,
          function (e) {
            var t = (16 * Math.random()) | 0;
            return ("x" === e ? t : (3 & t) | 8).toString(16);
          }
        );
      },
      H = "_ALGOLIA",
      L = function (e, t, r) {
        var n = new Date();
        n.setTime(n.getTime() + r);
        var i = "expires=" + n.toUTCString();
        document.cookie = e + "=" + t + ";" + i + ";path=/";
      },
      U = function (e) {
        for (
          var t = e + "=", r = document.cookie.split(";"), n = 0;
          n < r.length;
          n++
        ) {
          for (var i = r[n]; " " === i.charAt(0); ) i = i.substring(1);
          if (0 === i.indexOf(t)) return i.substring(t.length, i.length);
        }
        return "";
      };
    (function () {
      var e, t, r, n;
      Object.keys ||
        (Object.keys =
          ((e = Object.prototype.hasOwnProperty),
          (t = !{ toString: null }.propertyIsEnumerable("toString")),
          (n = (r = [
            "toString",
            "toLocaleString",
            "valueOf",
            "hasOwnProperty",
            "isPrototypeOf",
            "propertyIsEnumerable",
            "constructor",
          ]).length),
          function (i) {
            if (
              "function" != typeof i &&
              ("object" != (0, E.default)(i) || null === i)
            )
              throw new TypeError("Object.keys called on non-object");
            var o,
              a,
              s = [];
            for (o in i) e.call(i, o) && s.push(o);
            if (t) for (a = 0; a < n; a++) e.call(i, r[a]) && s.push(r[a]);
            return s;
          }));
    })(),
      (function () {
        "function" != typeof Object.assign &&
          (Object.assign = function (e, t) {
            var r = arguments;
            if (null == e)
              throw new TypeError("Cannot convert undefined or null to object");
            for (var n = Object(e), i = 1; i < arguments.length; i++) {
              var o = r[i];
              if (null != o)
                for (var a in o)
                  Object.prototype.hasOwnProperty.call(o, a) && (n[a] = o[a]);
            }
            return n;
          });
      })();
    var q = function (e) {
        var t = e.requestFn;
        (this._ua = []),
          (this.version = "2.2.1"),
          (this._hasCredentials = !1),
          (this.sendEvents = i(t).bind(this)),
          (this.init = s.bind(this)),
          (this.addAlgoliaAgent = a.bind(this)),
          (this.setUserToken = b.bind(this)),
          (this.setAnonymousUserToken = y.bind(this)),
          (this.getUserToken = _.bind(this)),
          (this.onUserTokenChange = O.bind(this)),
          (this.clickedObjectIDsAfterSearch = l.bind(this)),
          (this.clickedObjectIDs = f.bind(this)),
          (this.clickedFilters = d.bind(this)),
          (this.convertedObjectIDsAfterSearch = p.bind(this)),
          (this.convertedObjectIDs = h.bind(this)),
          (this.convertedFilters = v.bind(this)),
          (this.viewedObjectIDs = m.bind(this)),
          (this.viewedFilters = g.bind(this)),
          (this.getVersion = c.bind(this));
      },
      B = function (e, t) {
        var r = JSON.stringify(t);
        if (!navigator.sendBeacon(e, r)) return W(e, t);
      },
      W = function (e, t) {
        var r = JSON.stringify(t),
          n = new XMLHttpRequest();
        n.open("POST", e), n.send(r);
      },
      V = (function (e) {
        return j(new q({ requestFn: e }));
      })(P());
    (t.AlgoliaAnalytics = q),
      (t.default = V),
      (t.getFunctionalInterface = j),
      (t.getRequesterForBrowser = P),
      (t.processQueue = w);
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(292);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return s(e) || a(e) || o(e) || i();
    }
    function i() {
      throw new TypeError(
        "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function o(e, t) {
      if (e) {
        if ("string" == typeof e) return c(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? c(e, t)
            : void 0
        );
      }
    }
    function a(e) {
      if (
        ("undefined" != typeof Symbol && null != e[Symbol.iterator]) ||
        null != e["@@iterator"]
      )
        return Array.from(e);
    }
    function s(e) {
      if (Array.isArray(e)) return c(e);
    }
    function c(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function u(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function l(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? u(Object(r), !0).forEach(function (t) {
              f(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : u(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function f(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function d(e) {
      var t = p(e),
        r = t.insightsClient,
        i = t.onItemsChange,
        o = t.onSelect,
        a = t.onActive,
        s = (0, m.createSearchInsightsApi)(r),
        c = (0, h.createRef)([]),
        u = (0, h.debounce)(function (e) {
          var t = e.state;
          if (t.isOpen) {
            var r = t.collections
              .reduce(function (e, t) {
                return [].concat(n(e), n(t.items));
              }, [])
              .filter(y.isAlgoliaInsightsHit);
            (0, h.isEqual)(
              c.current.map(function (e) {
                return e.objectID;
              }),
              r.map(function (e) {
                return e.objectID;
              })
            ) ||
              ((c.current = r),
              r.length > 0 &&
                b({ onItemsChange: i, items: r, insights: s, state: t }));
          }
        }, 0);
      return {
        name: "aa.algoliaInsightsPlugin",
        subscribe: function (e) {
          var t = e.setContext,
            r = e.onSelect,
            n = e.onActive;
          t({ algoliaInsightsPlugin: { insights: s } }),
            r(function (e) {
              var t = e.item,
                r = e.state,
                n = e.event;
              (0, y.isAlgoliaInsightsHit)(t) &&
                o({
                  state: r,
                  event: n,
                  insights: s,
                  item: t,
                  insightsEvents: [
                    l(
                      { eventName: "Item Selected" },
                      (0, v.createClickedEvent)({ item: t, items: c.current })
                    ),
                  ],
                });
            }),
            n(function (e) {
              var t = e.item,
                r = e.state,
                n = e.event;
              (0, y.isAlgoliaInsightsHit)(t) &&
                a({
                  state: r,
                  event: n,
                  insights: s,
                  item: t,
                  insightsEvents: [
                    l(
                      { eventName: "Item Active" },
                      (0, v.createClickedEvent)({ item: t, items: c.current })
                    ),
                  ],
                });
            });
        },
        onStateChange: function (e) {
          var t = e.state;
          u({ state: t });
        },
        __autocomplete_pluginOptions: e,
      };
    }
    function p(e) {
      return l(
        {
          onItemsChange: function (e) {
            var t = e.insights,
              r = e.insightsEvents;
            t.viewedObjectIDs.apply(t, n(r));
          },
          onSelect: function (e) {
            var t = e.insights,
              r = e.insightsEvents;
            t.clickedObjectIDsAfterSearch.apply(t, n(r));
          },
          onActive: h.noop,
        },
        e
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createAlgoliaInsightsPlugin = d);
    var h = r(293),
      v = r(308),
      m = r(309),
      g = r(310),
      y = r(311),
      b = (0, h.debounce)(function (e) {
        var t = e.onItemsChange,
          r = e.items,
          n = e.insights,
          i = e.state;
        t({
          insights: n,
          insightsEvents: (0, g.createViewedEvents)({ items: r }).map(function (
            e
          ) {
            return l({ eventName: "Items Viewed" }, e);
          }),
          state: i,
        });
      }, 400);
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(294);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(295);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
    var o = r(296);
    Object.keys(o).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return o[e];
          },
        });
    });
    var a = r(297);
    Object.keys(a).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return a[e];
          },
        });
    });
    var s = r(298);
    Object.keys(s).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return s[e];
          },
        });
    });
    var c = r(299);
    Object.keys(c).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return c[e];
          },
        });
    });
    var u = r(300);
    Object.keys(u).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return u[e];
          },
        });
    });
    var l = r(301);
    Object.keys(l).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return l[e];
          },
        });
    });
    var f = r(302);
    Object.keys(f).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return f[e];
          },
        });
    });
    var d = r(303);
    Object.keys(d).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return d[e];
          },
        });
    });
    var p = r(304);
    Object.keys(p).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return p[e];
          },
        });
    });
    var h = r(305);
    Object.keys(h).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return h[e];
          },
        });
    });
    var v = r(306);
    Object.keys(v).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return v[e];
          },
        });
    });
    var m = r(83);
    Object.keys(m).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return m[e];
          },
        });
    });
    var g = r(307);
    Object.keys(g).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return g[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return { current: e };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.createRef = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = void 0;
      return function () {
        for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
          i[o] = arguments[o];
        r && clearTimeout(r),
          (r = setTimeout(function () {
            return e.apply(void 0, i);
          }, t));
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.debounce = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return (
        arguments.length > 1 && void 0 !== arguments[1]
          ? arguments[1]
          : new Set(),
        e
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.decycle = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return e.reduce(function (e, t) {
        return e.concat(t);
      }, []);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.flatten = n);
  },
  function (e, t, r) {
    "use strict";
    function n() {
      return "autocomplete-".concat(i++);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.generateAutocompleteId = n);
    var i = 0;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      return t.reduce(function (e, t) {
        return e && e[t];
      }, e);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getAttributeValueByPath = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return 0 === e.collections.length
        ? 0
        : e.collections.reduce(function (e, t) {
            return e + t.items.length;
          }, 0);
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.getItemsCount = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {}
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.invariant = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return e !== Object(e);
    }
    function i(e, t) {
      if (e === t) return !0;
      if (n(e) || n(t) || "function" == typeof e || "function" == typeof t)
        return e === t;
      if (Object.keys(e).length !== Object.keys(t).length) return !1;
      for (var r = 0, o = Object.keys(e); r < o.length; r++) {
        var a = o[r];
        if (!(a in t)) return !1;
        if (!i(e[a], t[a])) return !1;
      }
      return !0;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.isEqual = i);
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.noop = void 0);
    var n = function () {};
    t.noop = n;
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.userAgents = void 0);
    var n = r(83),
      i = [{ segment: "autocomplete-core", version: n.version }];
    t.userAgents = i;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {}
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.warn = n),
      (t.warnCache = void 0);
    var i = { current: {} };
    t.warnCache = i;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t = e.item,
        r = e.items;
      return {
        index: t.__autocomplete_indexName,
        objectIDs: [t.objectID],
        positions: [
          1 +
            r.findIndex(function (e) {
              return e.objectID === t.objectID;
            }),
        ],
        queryID: t.__autocomplete_queryID,
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createClickedEvent = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return {
        init: function (t, r) {
          e("init", { appId: t, apiKey: r });
        },
        setUserToken: function (t) {
          e("setUserToken", t);
        },
        clickedObjectIDsAfterSearch: function () {
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
            r[n] = arguments[n];
          r.length > 0 &&
            e.apply(void 0, ["clickedObjectIDsAfterSearch"].concat(r));
        },
        clickedObjectIDs: function () {
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
            r[n] = arguments[n];
          r.length > 0 && e.apply(void 0, ["clickedObjectIDs"].concat(r));
        },
        clickedFilters: function () {
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
            r[n] = arguments[n];
          r.length > 0 && e.apply(void 0, ["clickedFilters"].concat(r));
        },
        convertedObjectIDsAfterSearch: function () {
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
            r[n] = arguments[n];
          r.length > 0 &&
            e.apply(void 0, ["convertedObjectIDsAfterSearch"].concat(r));
        },
        convertedObjectIDs: function () {
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
            r[n] = arguments[n];
          r.length > 0 && e.apply(void 0, ["convertedObjectIDs"].concat(r));
        },
        convertedFilters: function () {
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
            r[n] = arguments[n];
          r.length > 0 && e.apply(void 0, ["convertedFilters"].concat(r));
        },
        viewedObjectIDs: function () {
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
            r[n] = arguments[n];
          r.length > 0 && e.apply(void 0, ["viewedObjectIDs"].concat(r));
        },
        viewedFilters: function () {
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
            r[n] = arguments[n];
          r.length > 0 && e.apply(void 0, ["viewedFilters"].concat(r));
        },
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createSearchInsightsApi = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t = e.items,
        r = t.reduce(function (e, t) {
          var r;
          return (
            (e[t.__autocomplete_indexName] = (
              null !== (r = e[t.__autocomplete_indexName]) && void 0 !== r
                ? r
                : []
            ).concat(t.objectID)),
            e
          );
        }, {});
      return Object.keys(r).map(function (e) {
        return { index: e, objectIDs: r[e] };
      });
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createViewedEvents = n);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return (
        e.objectID && e.__autocomplete_indexName && e.__autocomplete_queryID
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.isAlgoliaInsightsHit = n);
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(313);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(59);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
    var o = r(61);
    Object.keys(o).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return o[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e, t) {
      return f(e) || l(e, t) || c(e, t) || s();
    }
    function s() {
      throw new TypeError(
        "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function c(e, t) {
      if (e) {
        if ("string" == typeof e) return u(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? u(e, t)
            : void 0
        );
      }
    }
    function u(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function l(e, t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
        var r = [],
          n = !0,
          i = !1,
          o = void 0;
        try {
          for (
            var a, s = e[Symbol.iterator]();
            !(n = (a = s.next()).done) &&
            (r.push(a.value), !t || r.length !== t);
            n = !0
          );
        } catch (e) {
          (i = !0), (o = e);
        } finally {
          try {
            n || null == s.return || s.return();
          } finally {
            if (i) throw o;
          }
        }
        return r;
      }
    }
    function f(e) {
      if (Array.isArray(e)) return e;
    }
    function d(e) {
      var t = e || {},
        r = t.insightsClient,
        n = t.insightsInitParams,
        o = t.onEvent;
      if (null !== r && !r)
        throw new Error(
          "The `insightsClient` option is required. To disable, set it to `null`."
        );
      var s = Boolean(r),
        c = null === r ? h.noop : r;
      return function (e) {
        var t = e.instantSearchInstance,
          u = (0, h.getAppIdAndApiKey)(t.client),
          l = a(u, 2),
          f = l[0],
          d = l[1],
          v = void 0,
          m = void 0;
        if (Array.isArray(c.queue)) {
          var g =
              (0, h.find)(c.queue.slice().reverse(), function (e) {
                return "setUserToken" === a(e, 1)[0];
              }) || [],
            y = a(g, 2);
          v = y[1];
        }
        c("getUserToken", null, function (e, t) {
          m = t;
        }),
          c("init", i({ appId: f, apiKey: d }, n));
        var b, _;
        return {
          onStateChange: function () {},
          subscribe: function () {},
          started: function () {
            c("addAlgoliaAgent", "insights-middleware"),
              (_ = t.helper),
              (b = {
                userToken: _.state.userToken,
                clickAnalytics: _.state.clickAnalytics,
              }),
              _.overrideStateWithoutTriggeringChangeEvent(
                i(i({}, _.state), {}, { clickAnalytics: !0 })
              ),
              t.scheduleSearch();
            var e = function (e) {
                _.overrideStateWithoutTriggeringChangeEvent(
                  i(i({}, _.state), {}, { userToken: e })
                ),
                  t.scheduleSearch();
              },
              n = (0, p.getInsightsAnonymousUserTokenInternal)();
            s && n && e(n),
              m ? c("setUserToken", m) : v && c("setUserToken", v),
              c("onUserTokenChange", e, { immediate: !0 }),
              (t.sendEventToInsights = function (e) {
                if (o) o(e, r);
                else if (e.insightsMethod) {
                  var t = Boolean(_.state.userToken);
                  t && c(e.insightsMethod, e.payload);
                }
              });
          },
          unsubscribe: function () {
            c("onUserTokenChange", void 0),
              (t.sendEventToInsights = h.noop),
              _ && b && (_.setState(i(i({}, _.state), b)), t.scheduleSearch());
          },
        };
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createInsightsMiddleware = d);
    var p = r(32),
      h = r(1);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e, t) {
      return f(e) || l(e, t) || c(e, t) || s();
    }
    function s() {
      throw new TypeError(
        "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function c(e, t) {
      if (e) {
        if ("string" == typeof e) return u(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? u(e, t)
            : void 0
        );
      }
    }
    function u(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function l(e, t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
        var r = [],
          n = !0,
          i = !1,
          o = void 0;
        try {
          for (
            var a, s = e[Symbol.iterator]();
            !(n = (a = s.next()).done) &&
            (r.push(a.value), !t || r.length !== t);
            n = !0
          );
        } catch (e) {
          (i = !0), (o = e);
        } finally {
          try {
            n || null == s.return || s.return();
          } finally {
            if (i) throw o;
          }
        }
        return r;
      }
    }
    function f(e) {
      if (Array.isArray(e)) return e;
    }
    var d = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var p = r(2),
      h = d(r(3)),
      v = d(r(315)),
      m = d(r(318)),
      g = r(1),
      y = r(6),
      b = (0, g.createDocumentationMessageGenerator)({ name: "range-slider" }),
      _ = (0, y.component)("RangeSlider"),
      O = function (e) {
        var t = e.containerNode,
          r = e.cssClasses,
          n = e.pips,
          i = e.step,
          o = e.tooltips;
        return function (e, s) {
          var c = e.refine,
            u = e.range,
            l = e.start;
          if (!s) {
            var f = u.min,
              d = u.max,
              h = a(l, 2),
              m = h[0],
              g = h[1],
              y = m === -1 / 0 ? f : m,
              b = g === 1 / 0 ? d : g,
              _ = [y > d ? d : y, b < f ? f : b];
            (0, p.render)(
              (0, p.h)(v.default, {
                cssClasses: r,
                refine: c,
                min: f,
                max: d,
                values: _,
                tooltips: o,
                step: i,
                pips: n,
              }),
              t
            );
          }
        };
      },
      j = function (e) {
        var t = e || {},
          r = t.container,
          n = t.attribute,
          o = t.min,
          a = t.max,
          s = t.cssClasses,
          c = void 0 === s ? {} : s,
          u = t.step,
          l = t.pips,
          f = void 0 === l || l,
          d = t.precision,
          v = void 0 === d ? 0 : d,
          y = t.tooltips,
          j = void 0 === y || y;
        if (!r) throw new Error(b("The `container` option is required."));
        var P = (0, g.getContainerNode)(r),
          w = {
            root: (0, h.default)(_(), c.root),
            disabledRoot: (0, h.default)(
              _({ modifierName: "disabled" }),
              c.disabledRoot
            ),
          },
          S = O({
            containerNode: P,
            step: u,
            pips: f,
            tooltips: j,
            cssClasses: w,
          });
        return i(
          i(
            {},
            (0, m.default)(S, function () {
              return (0, p.render)(null, P);
            })({ attribute: n, min: o, max: a, precision: v })
          ),
          {},
          { $$type: "ais.rangeSlider", $$widgetType: "ais.rangeSlider" }
        );
      },
      P = j;
    t.default = P;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return s(e) || a(e) || o(e) || i();
    }
    function i() {
      throw new TypeError(
        "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function o(e, t) {
      if (e) {
        if ("string" == typeof e) return c(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? c(e, t)
            : void 0
        );
      }
    }
    function a(e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e))
        return Array.from(e);
    }
    function s(e) {
      if (Array.isArray(e)) return c(e);
    }
    function c(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function u() {
      return (
        (u =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r)
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          }),
        u.apply(this, arguments)
      );
    }
    function l(e) {
      "@babel/helpers - typeof";
      return (l =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    function f(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function d(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n);
      }
    }
    function p(e, t, r) {
      return t && d(e.prototype, t), r && d(e, r), e;
    }
    function h(e, t) {
      if ("function" != typeof t && null !== t)
        throw new TypeError(
          "Super expression must either be null or a function"
        );
      (e.prototype = Object.create(t && t.prototype, {
        constructor: { value: e, writable: !0, configurable: !0 },
      })),
        t && v(e, t);
    }
    function v(e, t) {
      return (v =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        })(e, t);
    }
    function m(e) {
      var t = b();
      return function () {
        var r,
          n = _(e);
        if (t) {
          var i = _(this).constructor;
          r = Reflect.construct(n, arguments, i);
        } else r = n.apply(this, arguments);
        return g(this, r);
      };
    }
    function g(e, t) {
      return !t || ("object" !== l(t) && "function" != typeof t) ? y(e) : t;
    }
    function y(e) {
      if (void 0 === e)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return e;
    }
    function b() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return (
          Date.prototype.toString.call(
            Reflect.construct(Date, [], function () {})
          ),
          !0
        );
      } catch (e) {
        return !1;
      }
    }
    function _(e) {
      return (_ = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
    }
    function O(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    var j = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var P = r(2),
      w = j(r(316)),
      S = j(r(3)),
      E = r(1),
      R = j(r(317)),
      x = (function (e) {
        function t() {
          var e;
          f(this, t);
          for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
            i[o] = arguments[o];
          return (
            (e = r.call.apply(r, [this].concat(i))),
            O(y(e), "handleChange", function (t) {
              var r = t.values;
              e.isDisabled || e.props.refine(r);
            }),
            O(y(e), "createHandleComponent", function (e) {
              return function (t) {
                var r = Math.round(100 * parseFloat(t["aria-valuenow"])) / 100,
                  n = "object" === l(e) && e.format ? e.format(r) : r,
                  i = (0, S.default)(t.className, {
                    "rheostat-handle-lower": 0 === t["data-handle-key"],
                    "rheostat-handle-upper": 1 === t["data-handle-key"],
                  });
                return (0,
                P.h)("div", u({}, t, { className: i }), e && (0, P.h)("div", { className: "rheostat-tooltip" }, n));
              };
            }),
            e
          );
        }
        h(t, e);
        var r = m(t);
        return (
          p(t, [
            {
              key: "isDisabled",
              get: function () {
                return this.props.min >= this.props.max;
              },
            },
            {
              key: "computeDefaultPitPoints",
              value: function (e) {
                var t = e.min,
                  r = e.max,
                  i = r - t,
                  o = i / 34;
                return [t].concat(
                  n(
                    (0, E.range)({ end: 33 }).map(function (e) {
                      return t + o * (e + 1);
                    })
                  ),
                  [r]
                );
              },
            },
            {
              key: "computeSnapPoints",
              value: function (e) {
                var t = e.min,
                  r = e.max,
                  i = e.step;
                if (i)
                  return [].concat(
                    n((0, E.range)({ start: t, end: r, step: i })),
                    [r]
                  );
              },
            },
            {
              key: "render",
              value: function () {
                var e = this.props,
                  t = e.tooltips,
                  r = e.step,
                  n = e.pips,
                  i = e.values,
                  o = e.cssClasses,
                  a = this.isDisabled
                    ? { min: this.props.min, max: this.props.max + 0.001 }
                    : this.props,
                  s = a.min,
                  c = a.max,
                  u = this.computeSnapPoints({ min: s, max: c, step: r }),
                  l =
                    !1 === n
                      ? []
                      : this.computeDefaultPitPoints({ min: s, max: c });
                return (0, P.h)(
                  "div",
                  {
                    className: (0, S.default)(
                      o.root,
                      O({}, o.disabledRoot, this.isDisabled)
                    ),
                  },
                  (0, P.h)(w.default, {
                    handle: this.createHandleComponent(t),
                    onChange: this.handleChange,
                    min: s,
                    max: c,
                    pitComponent: R.default,
                    pitPoints: l,
                    snap: !0,
                    snapPoints: u,
                    values: this.isDisabled ? [s, c] : i,
                    disabled: this.isDisabled,
                  })
                );
              },
            },
          ]),
          t
        );
      })(P.Component),
      k = x;
    t.default = k;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      "@babel/helpers - typeof";
      return (n =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    function i(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function o(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n);
      }
    }
    function a(e, t, r) {
      return t && o(e.prototype, t), r && o(e, r), e;
    }
    function s(e, t) {
      if ("function" != typeof t && null !== t)
        throw new TypeError(
          "Super expression must either be null or a function"
        );
      (e.prototype = Object.create(t && t.prototype, {
        constructor: { value: e, writable: !0, configurable: !0 },
      })),
        t && c(e, t);
    }
    function c(e, t) {
      return (c =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        })(e, t);
    }
    function u(e) {
      var t = d();
      return function () {
        var r,
          n = p(e);
        if (t) {
          var i = p(this).constructor;
          r = Reflect.construct(n, arguments, i);
        } else r = n.apply(this, arguments);
        return l(this, r);
      };
    }
    function l(e, t) {
      return !t || ("object" !== n(t) && "function" != typeof t) ? f(e) : t;
    }
    function f(e) {
      if (void 0 === e)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return e;
    }
    function d() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return (
          Date.prototype.toString.call(
            Reflect.construct(Date, [], function () {})
          ),
          !0
        );
      } catch (e) {
        return !1;
      }
    }
    function p(e) {
      return (p = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
    }
    function h(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function v() {
      return (
        (v =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r)
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          }),
        v.apply(this, arguments)
      );
    }
    function m(e, t, r) {
      return ((e - t) / (r - t)) * 100;
    }
    function g(e, t, r) {
      var n = e / 100;
      return 0 === e ? t : 100 === e ? r : Math.round((r - t) * n + t);
    }
    function y(e) {
      return [
        "rheostat",
        "vertical" === e.orientation
          ? "rheostat-vertical"
          : "rheostat-horizontal",
      ]
        .concat(e.className.split(" "))
        .join(" ");
    }
    function b(e) {
      return Number(e.currentTarget.getAttribute("data-handle-key"));
    }
    function _(e) {
      e.stopPropagation(), e.preventDefault();
    }
    function O(e) {
      return (0, j.h)("button", v({}, e, { type: "button" }));
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var j = r(2),
      P = {
        DOWN: 40,
        END: 35,
        ESC: 27,
        HOME: 36,
        LEFT: 37,
        PAGE_DOWN: 34,
        PAGE_UP: 33,
        RIGHT: 39,
        UP: 38,
      },
      w = (0, j.h)("div", { className: "rheostat-background" }),
      S = (function (e) {
        function t(e) {
          var n;
          return (
            i(this, t),
            (n = r.call(this, e)),
            h(f(n), "state", {
              className: y(n.props),
              handlePos: n.props.values.map(function (e) {
                return m(e, n.props.min, n.props.max);
              }),
              handleDimensions: 0,
              mousePos: null,
              sliderBox: {},
              slidingIndex: null,
              values: n.props.values,
            }),
            h(f(n), "rheostat", (0, j.createRef)()),
            (n.getPublicState = n.getPublicState.bind(f(n))),
            (n.getSliderBoundingBox = n.getSliderBoundingBox.bind(f(n))),
            (n.getProgressStyle = n.getProgressStyle.bind(f(n))),
            (n.getMinValue = n.getMinValue.bind(f(n))),
            (n.getMaxValue = n.getMaxValue.bind(f(n))),
            (n.getHandleDimensions = n.getHandleDimensions.bind(f(n))),
            (n.getClosestSnapPoint = n.getClosestSnapPoint.bind(f(n))),
            (n.getSnapPosition = n.getSnapPosition.bind(f(n))),
            (n.getNextPositionForKey = n.getNextPositionForKey.bind(f(n))),
            (n.getNextState = n.getNextState.bind(f(n))),
            (n.handleClick = n.handleClick.bind(f(n))),
            (n.getClosestHandle = n.getClosestHandle.bind(f(n))),
            (n.setStartSlide = n.setStartSlide.bind(f(n))),
            (n.startMouseSlide = n.startMouseSlide.bind(f(n))),
            (n.startTouchSlide = n.startTouchSlide.bind(f(n))),
            (n.handleMouseSlide = n.handleMouseSlide.bind(f(n))),
            (n.handleTouchSlide = n.handleTouchSlide.bind(f(n))),
            (n.handleSlide = n.handleSlide.bind(f(n))),
            (n.endSlide = n.endSlide.bind(f(n))),
            (n.handleKeydown = n.handleKeydown.bind(f(n))),
            (n.validatePosition = n.validatePosition.bind(f(n))),
            (n.validateValues = n.validateValues.bind(f(n))),
            (n.canMove = n.canMove.bind(f(n))),
            (n.fireChangeEvent = n.fireChangeEvent.bind(f(n))),
            (n.slideTo = n.slideTo.bind(f(n))),
            (n.updateNewValues = n.updateNewValues.bind(f(n))),
            n
          );
        }
        s(t, e);
        var r = u(t);
        return (
          a(t, [
            {
              key: "componentWillReceiveProps",
              value: function (e) {
                var t = this.props,
                  r = t.className,
                  n = t.disabled,
                  i = t.min,
                  o = t.max,
                  a = t.orientation,
                  s = this.state,
                  c = s.values,
                  u = s.slidingIndex,
                  l = e.min !== i || e.max !== o,
                  f =
                    c.length !== e.values.length ||
                    c.some(function (t, r) {
                      return e.values[r] !== t;
                    }),
                  d = e.className !== r || e.orientation !== a,
                  p = e.disabled && !n;
                d && this.setState({ className: y(e) }),
                  (l || f) && this.updateNewValues(e),
                  p && null !== u && this.endSlide();
              },
            },
            {
              key: "getPublicState",
              value: function () {
                var e = this.props,
                  t = e.min;
                return { max: e.max, min: t, values: this.state.values };
              },
            },
            {
              key: "getSliderBoundingBox",
              value: function () {
                var e = this.rheostat.current,
                  t = e.getBoundingClientRect();
                return {
                  height: t.height || e.clientHeight,
                  left: t.left,
                  top: t.top,
                  width: t.width || e.clientWidth,
                };
              },
            },
            {
              key: "getProgressStyle",
              value: function (e) {
                var t = this.state.handlePos,
                  r = t[e];
                if (0 === e)
                  return "vertical" === this.props.orientation
                    ? { height: "".concat(r, "%"), top: 0 }
                    : { left: 0, width: "".concat(r, "%") };
                var n = t[e - 1],
                  i = r - n;
                return "vertical" === this.props.orientation
                  ? { height: "".concat(i, "%"), top: "".concat(n, "%") }
                  : { left: "".concat(n, "%"), width: "".concat(i, "%") };
              },
            },
            {
              key: "getMinValue",
              value: function (e) {
                return this.state.values[e - 1]
                  ? Math.max(this.props.min, this.state.values[e - 1])
                  : this.props.min;
              },
            },
            {
              key: "getMaxValue",
              value: function (e) {
                return this.state.values[e + 1]
                  ? Math.min(this.props.max, this.state.values[e + 1])
                  : this.props.max;
              },
            },
            {
              key: "getHandleDimensions",
              value: function (e, t) {
                var r = e.currentTarget || null;
                return r
                  ? "vertical" === this.props.orientation
                    ? ((r.clientHeight / t.height) * 100) / 2
                    : ((r.clientWidth / t.width) * 100) / 2
                  : 0;
              },
            },
            {
              key: "getClosestSnapPoint",
              value: function (e) {
                return this.props.snapPoints.length
                  ? this.props.snapPoints.reduce(function (t, r) {
                      return Math.abs(t - e) < Math.abs(r - e) ? t : r;
                    })
                  : e;
              },
            },
            {
              key: "getSnapPosition",
              value: function (e) {
                if (!this.props.snap) return e;
                var t = this.props,
                  r = t.max,
                  n = t.min,
                  i = g(e, n, r);
                return m(this.getClosestSnapPoint(i), n, r);
              },
            },
            {
              key: "getNextPositionForKey",
              value: function (e, t) {
                var r,
                  n = this.state,
                  i = n.handlePos,
                  o = n.values,
                  a = this.props,
                  s = a.max,
                  c = a.min,
                  u = a.snapPoints,
                  l = this.props.snap,
                  f = o[e],
                  d = i[e],
                  p = d,
                  v = 1;
                s >= 100 ? (d = Math.round(d)) : (v = 100 / (s - c));
                var g = null;
                l && (g = u.indexOf(this.getClosestSnapPoint(o[e])));
                var y =
                  ((r = {}),
                  h(r, P.LEFT, function (e) {
                    return -1 * e;
                  }),
                  h(r, P.RIGHT, function (e) {
                    return e;
                  }),
                  h(r, P.UP, function (e) {
                    return e;
                  }),
                  h(r, P.DOWN, function (e) {
                    return -1 * e;
                  }),
                  h(r, P.PAGE_DOWN, function (e) {
                    return e > 1 ? -e : -10 * e;
                  }),
                  h(r, P.PAGE_UP, function (e) {
                    return e > 1 ? e : 10 * e;
                  }),
                  r);
                if (Object.prototype.hasOwnProperty.call(y, t))
                  (d += y[t](v)),
                    l &&
                      g &&
                      (d > p
                        ? g < u.length - 1 && (f = u[g + 1])
                        : g > 0 && (f = u[g - 1]));
                else if (t === P.HOME) (d = 0), l && (f = u[0]);
                else {
                  if (t !== P.END) return null;
                  (d = 100), l && (f = u[u.length - 1]);
                }
                return l ? m(f, c, s) : d;
              },
            },
            {
              key: "getNextState",
              value: function (e, t) {
                var r = this.state.handlePos,
                  n = this.props,
                  i = n.max,
                  o = n.min,
                  a = this.validatePosition(e, t),
                  s = r.map(function (t, r) {
                    return r === e ? a : t;
                  });
                return {
                  handlePos: s,
                  values: s.map(function (e) {
                    return g(e, o, i);
                  }),
                };
              },
            },
            {
              key: "getClosestHandle",
              value: function (e) {
                var t = this.state.handlePos;
                return t.reduce(function (r, n, i) {
                  return Math.abs(t[i] - e) < Math.abs(t[r] - e) ? i : r;
                }, 0);
              },
            },
            {
              key: "setStartSlide",
              value: function (e, t, r) {
                var n = this.getSliderBoundingBox();
                this.setState({
                  handleDimensions: this.getHandleDimensions(e, n),
                  mousePos: { x: t, y: r },
                  sliderBox: n,
                  slidingIndex: b(e),
                });
              },
            },
            {
              key: "startMouseSlide",
              value: function (e) {
                this.setStartSlide(e, e.clientX, e.clientY),
                  document.addEventListener(
                    "mousemove",
                    this.handleMouseSlide,
                    !1
                  ),
                  document.addEventListener("mouseup", this.endSlide, !1),
                  _(e);
              },
            },
            {
              key: "startTouchSlide",
              value: function (e) {
                if (!(e.changedTouches.length > 1)) {
                  var t = e.changedTouches[0];
                  this.setStartSlide(e, t.clientX, t.clientY),
                    document.addEventListener(
                      "touchmove",
                      this.handleTouchSlide,
                      !1
                    ),
                    document.addEventListener("touchend", this.endSlide, !1),
                    this.props.onSliderDragStart &&
                      this.props.onSliderDragStart(),
                    _(e);
                }
              },
            },
            {
              key: "handleMouseSlide",
              value: function (e) {
                null !== this.state.slidingIndex &&
                  (this.handleSlide(e.clientX, e.clientY), _(e));
              },
            },
            {
              key: "handleTouchSlide",
              value: function (e) {
                if (null !== this.state.slidingIndex) {
                  if (e.changedTouches.length > 1) return void this.endSlide();
                  var t = e.changedTouches[0];
                  this.handleSlide(t.clientX, t.clientY), _(e);
                }
              },
            },
            {
              key: "handleSlide",
              value: function (e, t) {
                var r = this.state,
                  n = r.slidingIndex,
                  i = r.sliderBox,
                  o =
                    "vertical" === this.props.orientation
                      ? ((t - i.top) / i.height) * 100
                      : ((e - i.left) / i.width) * 100;
                this.slideTo(n, o),
                  this.canMove(n, o) &&
                    (this.setState({ mousePos: { x: e, y: t } }),
                    this.props.onSliderDragMove &&
                      this.props.onSliderDragMove());
              },
            },
            {
              key: "endSlide",
              value: function () {
                var e = this,
                  t = this.state.slidingIndex;
                if (
                  (this.setState({ slidingIndex: null }),
                  document.removeEventListener("mouseup", this.endSlide, !1),
                  document.removeEventListener("touchend", this.endSlide, !1),
                  document.removeEventListener(
                    "touchmove",
                    this.handleTouchSlide,
                    !1
                  ),
                  document.removeEventListener(
                    "mousemove",
                    this.handleMouseSlide,
                    !1
                  ),
                  this.props.onSliderDragEnd && this.props.onSliderDragEnd(),
                  this.props.snap)
                ) {
                  var r = this.getSnapPosition(this.state.handlePos[t]);
                  this.slideTo(t, r, function () {
                    return e.fireChangeEvent();
                  });
                } else this.fireChangeEvent();
              },
            },
            {
              key: "handleClick",
              value: function (e) {
                var t = this;
                if (!e.target.getAttribute("data-handle-key")) {
                  var r = this.getSliderBoundingBox(),
                    n =
                      "vertical" === this.props.orientation
                        ? (e.clientY - r.top) / r.height
                        : (e.clientX - r.left) / r.width,
                    i = 100 * n,
                    o = this.getClosestHandle(i),
                    a = this.getSnapPosition(i);
                  this.slideTo(o, a, function () {
                    return t.fireChangeEvent();
                  }),
                    this.props.onClick && this.props.onClick();
                }
              },
            },
            {
              key: "handleKeydown",
              value: function (e) {
                var t = this,
                  r = b(e);
                if (e.keyCode === P.ESC) return void e.currentTarget.blur();
                var n = this.getNextPositionForKey(r, e.keyCode);
                null !== n &&
                  (this.canMove(r, n) &&
                    (this.slideTo(r, n, function () {
                      return t.fireChangeEvent();
                    }),
                    this.props.onKeyPress && this.props.onKeyPress()),
                  _(e));
              },
            },
            {
              key: "validatePosition",
              value: function (e, t) {
                var r = this.state,
                  n = r.handlePos,
                  i = r.handleDimensions;
                return Math.max(
                  Math.min(t, void 0 !== n[e + 1] ? n[e + 1] - i : 100),
                  void 0 !== n[e - 1] ? n[e - 1] + i : 0
                );
              },
            },
            {
              key: "validateValues",
              value: function (e, t) {
                var r = t || this.props,
                  n = r.max,
                  i = r.min;
                return e.map(function (e, t, r) {
                  var o = Math.max(Math.min(e, n), i);
                  return r.length && o < r[t - 1] ? r[t - 1] : o;
                });
              },
            },
            {
              key: "canMove",
              value: function (e, t) {
                var r = this.state,
                  n = r.handlePos,
                  i = r.handleDimensions;
                return !(
                  t < 0 ||
                  t > 100 ||
                  t > (void 0 !== n[e + 1] ? n[e + 1] - i : 1 / 0) ||
                  t < (void 0 !== n[e - 1] ? n[e - 1] + i : -1 / 0)
                );
              },
            },
            {
              key: "fireChangeEvent",
              value: function () {
                var e = this.props.onChange;
                e && e(this.getPublicState());
              },
            },
            {
              key: "slideTo",
              value: function (e, t, r) {
                var n = this,
                  i = this.getNextState(e, t);
                this.setState(i, function () {
                  var e = n.props.onValuesUpdated;
                  e && e(n.getPublicState()), r && r();
                });
              },
            },
            {
              key: "updateNewValues",
              value: function (e) {
                var t = this;
                if (null === this.state.slidingIndex) {
                  var r = e.max,
                    n = e.min,
                    i = e.values,
                    o = this.validateValues(i, e);
                  this.setState(
                    {
                      handlePos: o.map(function (e) {
                        return m(e, n, r);
                      }),
                      values: o,
                    },
                    function () {
                      return t.fireChangeEvent();
                    }
                  );
                }
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  r = t.children,
                  n = t.disabled,
                  i = t.handle,
                  o = t.max,
                  a = t.min,
                  s = t.orientation,
                  c = t.pitComponent,
                  u = t.pitPoints,
                  l = t.progressBar,
                  f = this.state,
                  d = f.className,
                  p = f.handlePos,
                  h = f.values;
                return (0, j.h)(
                  "div",
                  {
                    className: d,
                    ref: this.rheostat,
                    onClick: n ? void 0 : this.handleClick,
                    style: { position: "relative" },
                  },
                  w,
                  p.map(function (t, r) {
                    var o =
                      "vertical" === s
                        ? { top: "".concat(t, "%"), position: "absolute" }
                        : { left: "".concat(t, "%"), position: "absolute" };
                    return (0,
                    j.h)(i, { "aria-valuemax": e.getMaxValue(r), "aria-valuemin": e.getMinValue(r), "aria-valuenow": h[r], "aria-disabled": n, "data-handle-key": r, className: "rheostat-handle", key: "handle-".concat(r), onClick: _, onKeyDown: n ? void 0 : e.handleKeydown, onMouseDown: n ? void 0 : e.startMouseSlide, onTouchStart: n ? void 0 : e.startTouchSlide, role: "slider", style: o, tabIndex: 0 });
                  }),
                  p.map(function (t, r, n) {
                    return 0 === r && n.length > 1
                      ? null
                      : (0, j.h)(l, {
                          className: "rheostat-progress",
                          key: "progress-bar-".concat(r),
                          style: e.getProgressStyle(r),
                        });
                  }),
                  c &&
                    u.map(function (e) {
                      var t = m(e, a, o),
                        r =
                          "vertical" === s
                            ? { top: "".concat(t, "%"), position: "absolute" }
                            : { left: "".concat(t, "%"), position: "absolute" };
                      return (0,
                      j.h)(c, { key: "pit-".concat(e), style: r }, e);
                    }),
                  r
                );
              },
            },
          ]),
          t
        );
      })(j.Component);
    h(S, "defaultProps", {
      className: "",
      children: null,
      disabled: !1,
      handle: O,
      max: 100,
      min: 0,
      onClick: null,
      onChange: null,
      onKeyPress: null,
      onSliderDragEnd: null,
      onSliderDragMove: null,
      onSliderDragStart: null,
      onValuesUpdated: null,
      orientation: "horizontal",
      pitComponent: null,
      pitPoints: [],
      progressBar: "div",
      snap: !1,
      snapPoints: [],
      values: [0],
    });
    var E = S;
    t.default = E;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    var a = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var s = r(2),
      c = a(r(3)),
      u = function (e) {
        var t = e.style,
          r = e.children,
          n = Math.round(parseFloat(t.left)),
          o = [0, 50, 100].includes(n),
          a = r,
          u = Math.round(100 * parseInt(a, 10)) / 100;
        return (0, s.h)(
          "div",
          {
            style: i(i({}, t), {}, { marginLeft: 100 === n ? "-2px" : 0 }),
            className: (0, c.default)(
              "rheostat-marker",
              "rheostat-marker-horizontal",
              { "rheostat-marker-large": o }
            ),
          },
          o && (0, s.h)("div", { className: "rheostat-value" }, u)
        );
      },
      l = u;
    t.default = l;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e, t) {
      return f(e) || l(e, t) || c(e, t) || s();
    }
    function s() {
      throw new TypeError(
        "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function c(e, t) {
      if (e) {
        if ("string" == typeof e) return u(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? u(e, t)
            : void 0
        );
      }
    }
    function u(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function l(e, t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
        var r = [],
          n = !0,
          i = !1,
          o = void 0;
        try {
          for (
            var a, s = e[Symbol.iterator]();
            !(n = (a = s.next()).done) &&
            (r.push(a.value), !t || r.length !== t);
            n = !0
          );
        } catch (e) {
          (i = !0), (o = e);
        } finally {
          try {
            n || null == s.return || s.return();
          } finally {
            if (i) throw o;
          }
        }
        return r;
      }
    }
    function f(e) {
      if (Array.isArray(e)) return e;
    }
    function d(e) {
      var t = e.min,
        r = e.max,
        n = e.precision,
        i = Math.pow(10, n);
      return {
        min: t ? Math.floor(t * i) / i : t,
        max: r ? Math.ceil(r * i) / i : r,
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var p = r(1),
      h = (0, p.createDocumentationMessageGenerator)(
        { name: "range-input", connector: !0 },
        { name: "range-slider", connector: !0 }
      ),
      v = function (e) {
        var t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : p.noop;
        return (
          (0, p.checkRendering)(e, h()),
          function (r) {
            function n(e) {
              var t;
              t = (0, p.isFiniteNumber)(v)
                ? v
                : (0, p.isFiniteNumber)(e.min)
                ? e.min
                : 0;
              var r;
              return (
                (r = (0, p.isFiniteNumber)(m)
                  ? m
                  : (0, p.isFiniteNumber)(e.max)
                  ? e.max
                  : 0),
                d({ min: t, max: r, precision: y })
              );
            }
            function s(e) {
              var t = e.getNumericRefinement(f, ">=") || [],
                r = a(t, 1),
                n = r[0],
                i = e.getNumericRefinement(f, "<=") || [],
                o = a(i, 1),
                s = o[0];
              return [
                (0, p.isFiniteNumber)(n) ? n : -1 / 0,
                (0, p.isFiniteNumber)(s) ? s : 1 / 0,
              ];
            }
            function c(e, t) {
              return function () {
                var r =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : [void 0, void 0],
                  n = a(r, 2),
                  i = n[0],
                  o = n[1],
                  s = O(e, t, i, o);
                s && e.setState(s).search();
              };
            }
            var u = r || {},
              l = u.attribute,
              f = void 0 === l ? "" : l,
              v = u.min,
              m = u.max,
              g = u.precision,
              y = void 0 === g ? 0 : g;
            if (!f) throw new Error(h("The `attribute` option is required."));
            if ((0, p.isFiniteNumber)(v) && (0, p.isFiniteNumber)(m) && v > m)
              throw new Error(h("The `max` option can't be lower than `min`."));
            var b = function (e) {
                return Number(Number(e).toFixed(y));
              },
              _ = {
                from: function (e) {
                  return e.toLocaleString();
                },
                to: function (e) {
                  return b(e).toLocaleString();
                },
              },
              O = function (e, t, r, n) {
                var i,
                  o = e.state,
                  s = t.min,
                  c = t.max,
                  u = o.getNumericRefinement(f, ">=") || [],
                  l = a(u, 1),
                  h = l[0],
                  g = o.getNumericRefinement(f, "<=") || [],
                  b = a(g, 1),
                  _ = b[0],
                  O = void 0 === r || "" === r,
                  j = void 0 === n || "" === n,
                  P = d({
                    min: O ? void 0 : parseFloat(r),
                    max: j ? void 0 : parseFloat(n),
                    precision: y,
                  }),
                  w = P.min,
                  S = P.max;
                i =
                  (0, p.isFiniteNumber)(v) || s !== w
                    ? (0, p.isFiniteNumber)(v) && O
                      ? v
                      : w
                    : void 0;
                var E;
                E =
                  (0, p.isFiniteNumber)(m) || c !== S
                    ? (0, p.isFiniteNumber)(m) && j
                      ? m
                      : S
                    : void 0;
                var R = void 0 === i,
                  x = (0, p.isFiniteNumber)(s) && s <= i,
                  k =
                    R ||
                    ((0, p.isFiniteNumber)(i) &&
                      (!(0, p.isFiniteNumber)(s) || x)),
                  I = void 0 === E,
                  A = (0, p.isFiniteNumber)(E) && c >= E,
                  M =
                    I ||
                    ((0, p.isFiniteNumber)(E) &&
                      (!(0, p.isFiniteNumber)(c) || A)),
                  C = h !== i,
                  T = _ !== E;
                return (C || T) && k && M
                  ? ((o = o.removeNumericRefinement(f)),
                    (0, p.isFiniteNumber)(i) &&
                      (o = o.addNumericRefinement(f, ">=", i)),
                    (0, p.isFiniteNumber)(E) &&
                      (o = o.addNumericRefinement(f, "<=", E)),
                    o.resetPage())
                  : null;
              },
              j = function (e) {
                return function () {
                  if (1 === arguments.length)
                    return void e.sendEventToInsights(
                      arguments.length <= 0 ? void 0 : arguments[0]
                    );
                };
              };
            return {
              $$type: "ais.range",
              init: function (t) {
                e(
                  i(
                    i({}, this.getWidgetRenderState(t)),
                    {},
                    { instantSearchInstance: t.instantSearchInstance }
                  ),
                  !0
                );
              },
              render: function (t) {
                e(
                  i(
                    i({}, this.getWidgetRenderState(t)),
                    {},
                    { instantSearchInstance: t.instantSearchInstance }
                  ),
                  !1
                );
              },
              getRenderState: function (e, t) {
                return i(
                  i({}, e),
                  {},
                  {
                    range: i(
                      i({}, e.range),
                      {},
                      o({}, f, this.getWidgetRenderState(t))
                    ),
                  }
                );
              },
              getWidgetRenderState: function (e) {
                var t,
                  o = e.results,
                  a = e.helper,
                  u = e.instantSearchInstance,
                  l = (o && o.disjunctiveFacets) || [],
                  d = (0, p.find)(l, function (e) {
                    return e.name === f;
                  }),
                  h = (d && d.stats) || { min: void 0, max: void 0 },
                  v = n(h),
                  m = s(a);
                return (
                  (t = o ? c(a, v) : c(a, { min: void 0, max: void 0 })),
                  {
                    refine: t,
                    canRefine: v.min !== v.max,
                    format: _,
                    range: v,
                    sendEvent: j(u),
                    widgetParams: i(i({}, r), {}, { precision: y }),
                    start: m,
                  }
                );
              },
              dispose: function (e) {
                var r = e.state;
                return (
                  t(), r.removeDisjunctiveFacet(f).removeNumericRefinement(f)
                );
              },
              getWidgetUiState: function (e, t) {
                var r = t.searchParameters,
                  n = r.getNumericRefinements(f),
                  a = n[">="],
                  s = void 0 === a ? [] : a,
                  c = n["<="],
                  u = void 0 === c ? [] : c;
                return 0 === s.length && 0 === u.length
                  ? e
                  : i(
                      i({}, e),
                      {},
                      {
                        range: i(
                          i({}, e.range),
                          {},
                          o({}, f, "".concat(s, ":").concat(u))
                        ),
                      }
                    );
              },
              getWidgetSearchParameters: function (e, t) {
                var r = t.uiState,
                  n = e
                    .addDisjunctiveFacet(f)
                    .setQueryParameters({
                      numericRefinements: i(
                        i({}, e.numericRefinements),
                        {},
                        o({}, f, {})
                      ),
                    });
                (0, p.isFiniteNumber)(v) &&
                  (n = n.addNumericRefinement(f, ">=", v)),
                  (0, p.isFiniteNumber)(m) &&
                    (n = n.addNumericRefinement(f, "<=", m));
                var s = r.range && r.range[f];
                if (!s || -1 === s.indexOf(":")) return n;
                var c = s.split(":").map(parseFloat),
                  u = a(c, 2),
                  l = u[0],
                  d = u[1];
                return (
                  (0, p.isFiniteNumber)(l) &&
                    (!(0, p.isFiniteNumber)(v) || v < l) &&
                    ((n = n.removeNumericRefinement(f, ">=")),
                    (n = n.addNumericRefinement(f, ">=", l))),
                  (0, p.isFiniteNumber)(d) &&
                    (!(0, p.isFiniteNumber)(m) || d < m) &&
                    ((n = n.removeNumericRefinement(f, "<=")),
                    (n = n.addNumericRefinement(f, "<=", d))),
                  n
                );
              },
            };
          }
        );
      },
      m = v;
    t.default = m;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    var a = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var s = r(2),
      c = a(r(3)),
      u = a(r(87)),
      l = a(r(343)),
      f = a(r(344)),
      d = r(1),
      p = r(12),
      h = r(6),
      v = (0, d.createDocumentationMessageGenerator)({ name: "menu" }),
      m = (0, h.component)("Menu"),
      g = function (e) {
        var t = e.containerNode,
          r = e.cssClasses,
          n = e.renderState,
          o = e.templates,
          a = e.showMore;
        return function (e, c) {
          var l = e.refine,
            d = e.items,
            h = e.createURL,
            v = e.instantSearchInstance,
            m = e.isShowingMore,
            g = e.toggleShowMore,
            y = e.canToggleShowMore;
          if (c)
            return void (n.templateProps = (0, p.prepareTemplateProps)({
              defaultTemplates: f.default,
              templatesConfig: v.templatesConfig,
              templates: o,
            }));
          var b = d.map(function (e) {
            return i(i({}, e), {}, { url: h(e.value) });
          });
          (0, s.render)(
            (0, s.h)(u.default, {
              createURL: h,
              cssClasses: r,
              facetValues: b,
              showMore: a,
              templateProps: n.templateProps,
              toggleRefinement: l,
              toggleShowMore: g,
              isShowingMore: m,
              canToggleShowMore: y,
            }),
            t
          );
        };
      },
      y = function (e) {
        var t = e || {},
          r = t.container,
          n = t.attribute,
          o = t.sortBy,
          a = t.limit,
          u = t.showMore,
          f = t.showMoreLimit,
          p = t.cssClasses,
          h = void 0 === p ? {} : p,
          y = t.templates,
          b = void 0 === y ? {} : y,
          _ = t.transformItems;
        if (!r) throw new Error(v("The `container` option is required."));
        var O = (0, d.getContainerNode)(r),
          j = {
            root: (0, c.default)(m(), h.root),
            noRefinementRoot: (0, c.default)(
              m({ modifierName: "noRefinement" }),
              h.noRefinementRoot
            ),
            list: (0, c.default)(m({ descendantName: "list" }), h.list),
            item: (0, c.default)(m({ descendantName: "item" }), h.item),
            selectedItem: (0, c.default)(
              m({ descendantName: "item", modifierName: "selected" }),
              h.selectedItem
            ),
            link: (0, c.default)(m({ descendantName: "link" }), h.link),
            label: (0, c.default)(m({ descendantName: "label" }), h.label),
            count: (0, c.default)(m({ descendantName: "count" }), h.count),
            showMore: (0, c.default)(
              m({ descendantName: "showMore" }),
              h.showMore
            ),
            disabledShowMore: (0, c.default)(
              m({ descendantName: "showMore", modifierName: "disabled" }),
              h.disabledShowMore
            ),
          },
          P = g({
            containerNode: O,
            cssClasses: j,
            renderState: {},
            templates: b,
            showMore: u,
          });
        return i(
          i(
            {},
            (0, l.default)(P, function () {
              return (0, s.render)(null, O);
            })({
              attribute: n,
              limit: a,
              showMore: u,
              showMoreLimit: f,
              sortBy: o,
              transformItems: _,
            })
          ),
          {},
          { $$widgetType: "ais.menu" }
        );
      },
      b = y;
    t.default = b;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e) {
      return l(e) || u(e) || c(e) || s();
    }
    function s() {
      throw new TypeError(
        "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function c(e, t) {
      if (e) {
        if ("string" == typeof e) return f(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? f(e, t)
            : void 0
        );
      }
    }
    function u(e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e))
        return Array.from(e);
    }
    function l(e) {
      if (Array.isArray(e)) return f(e);
    }
    function f(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function d(e) {
      var t =
        arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return (0, h.uniq)(
        [].concat(a(Object.keys(e || {})), a(Object.keys(t)))
      ).reduce(
        function (r, n) {
          var i = e ? e[n] : void 0,
            o = t[n],
            a = void 0 !== o && o !== i;
          return (
            (r.templates[n] = a ? o : i), (r.useCustomCompileOptions[n] = a), r
          );
        },
        { templates: {}, useCustomCompileOptions: {} }
      );
    }
    function p(e) {
      var t = e.defaultTemplates,
        r = e.templates;
      return i({ templatesConfig: e.templatesConfig }, d(t, r));
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.prepareTemplateProps = p);
    var h = r(31);
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      "@babel/helpers - typeof";
      return (n =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    function i(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function o(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? i(Object(r), !0).forEach(function (t) {
              a(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : i(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function a(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function s() {
      var e =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = arguments.length > 1 ? arguments[1] : void 0,
        r = arguments.length > 2 ? arguments[2] : void 0;
      return Object.keys(e).reduce(function (n, i) {
        return o(
          o({}, n),
          {},
          a({}, i, function () {
            var n = this;
            return function (o) {
              var a = function (e) {
                return l.default.compile(e, t).render(n);
              };
              return e[i].call(r, o, a);
            };
          })
        );
      }, {});
    }
    function c(e) {
      var t = e.templates,
        r = e.templateKey,
        i = e.compileOptions,
        a = e.helpers,
        c = e.data,
        u = e.bindEvent,
        p = e.sendEvent,
        h = t[r];
      if ("string" != typeof h && "function" != typeof h)
        throw new Error(
          "Template must be 'string' or 'function', was '"
            .concat(n(h), "' (key: ")
            .concat(r, ")")
        );
      if ("function" == typeof h) {
        var v = u || {};
        return (
          (v.html = f.html),
          (v.sendEvent = p),
          (v.components = {
            Highlight: d.Highlight,
            ReverseHighlight: d.ReverseHighlight,
            Snippet: d.Snippet,
            ReverseSnippet: d.ReverseSnippet,
          }),
          h(c, v)
        );
      }
      var m = s(a, i, c);
      return l.default
        .compile(h, i)
        .render(o(o({}, c), {}, { helpers: m }))
        .replace(/[ \n\r\t\f\xA0]+/g, function (e) {
          return e.replace(/(^|\xA0+)[^\xA0]+/g, "$1 ");
        })
        .trim();
    }
    var u = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.renderTemplate = c);
    var l = u(r(322)),
      f = r(85),
      d = r(325);
  },
  function (e, t, r) {
    "use strict";
    var n = r(323);
    (n.Template = r(324).Template), (n.template = n.Template), (e.exports = n);
  },
  function (e, t, r) {
    "use strict";
    !(function (e) {
      function t(e) {
        "}" === e.n.substr(e.n.length - 1) &&
          (e.n = e.n.substring(0, e.n.length - 1));
      }
      function r(e) {
        return e.trim ? e.trim() : e.replace(/^\s*|\s*$/g, "");
      }
      function n(e, t, r) {
        if (t.charAt(r) != e.charAt(0)) return !1;
        for (var n = 1, i = e.length; n < i; n++)
          if (t.charAt(r + n) != e.charAt(n)) return !1;
        return !0;
      }
      function i(t, r, n, s) {
        var c = [],
          u = null,
          l = null,
          f = null;
        for (l = n[n.length - 1]; t.length > 0; ) {
          if (((f = t.shift()), l && "<" == l.tag && !(f.tag in O)))
            throw new Error("Illegal content in < super tag.");
          if (e.tags[f.tag] <= e.tags.$ || o(f, s))
            n.push(f), (f.nodes = i(t, f.tag, n, s));
          else {
            if ("/" == f.tag) {
              if (0 === n.length)
                throw new Error("Closing tag without opener: /" + f.n);
              if (((u = n.pop()), f.n != u.n && !a(f.n, u.n, s)))
                throw new Error("Nesting error: " + u.n + " vs. " + f.n);
              return (u.end = f.i), c;
            }
            "\n" == f.tag && (f.last = 0 == t.length || "\n" == t[0].tag);
          }
          c.push(f);
        }
        if (n.length > 0) throw new Error("missing closing tag: " + n.pop().n);
        return c;
      }
      function o(e, t) {
        for (var r = 0, n = t.length; r < n; r++)
          if (t[r].o == e.n) return (e.tag = "#"), !0;
      }
      function a(e, t, r) {
        for (var n = 0, i = r.length; n < i; n++)
          if (r[n].c == e && r[n].o == t) return !0;
      }
      function s(e) {
        var t = [];
        for (var r in e)
          t.push('"' + u(r) + '": function(c,p,t,i) {' + e[r] + "}");
        return "{ " + t.join(",") + " }";
      }
      function c(e) {
        var t = [];
        for (var r in e.partials)
          t.push(
            '"' +
              u(r) +
              '":{name:"' +
              u(e.partials[r].name) +
              '", ' +
              c(e.partials[r]) +
              "}"
          );
        return "partials: {" + t.join(",") + "}, subs: " + s(e.subs);
      }
      function u(e) {
        return e
          .replace(y, "\\\\")
          .replace(v, '\\"')
          .replace(m, "\\n")
          .replace(g, "\\r")
          .replace(b, "\\u2028")
          .replace(_, "\\u2029");
      }
      function l(e) {
        return ~e.indexOf(".") ? "d" : "f";
      }
      function f(e, t) {
        var r = "<" + (t.prefix || ""),
          n = r + e.n + j++;
        return (
          (t.partials[n] = { name: e.n, partials: {} }),
          (t.code +=
            't.b(t.rp("' + u(n) + '",c,p,"' + (e.indent || "") + '"));'),
          n
        );
      }
      function d(e, t) {
        t.code += "t.b(t.t(t." + l(e.n) + '("' + u(e.n) + '",c,p,0)));';
      }
      function p(e) {
        return "t.b(" + e + ");";
      }
      var h = /\S/,
        v = /\"/g,
        m = /\n/g,
        g = /\r/g,
        y = /\\/g,
        b = /\u2028/,
        _ = /\u2029/;
      (e.tags = {
        "#": 1,
        "^": 2,
        "<": 3,
        $: 4,
        "/": 5,
        "!": 6,
        ">": 7,
        "=": 8,
        _v: 9,
        "{": 10,
        "&": 11,
        _t: 12,
      }),
        (e.scan = function (i, o) {
          function a() {
            p.length > 0 &&
              (v.push({ tag: "_t", text: new String(p) }), (p = ""));
          }
          function s() {
            for (var t = !0, r = y; r < v.length; r++)
              if (
                !(t =
                  e.tags[v[r].tag] < e.tags._v ||
                  ("_t" == v[r].tag && null === v[r].text.match(h)))
              )
                return !1;
            return t;
          }
          function c(e, t) {
            if ((a(), e && s()))
              for (var r, n = y; n < v.length; n++)
                v[n].text &&
                  ((r = v[n + 1]) &&
                    ">" == r.tag &&
                    (r.indent = v[n].text.toString()),
                  v.splice(n, 1));
            else t || v.push({ tag: "\n" });
            (m = !1), (y = v.length);
          }
          var u = i.length,
            l = 0,
            f = null,
            d = null,
            p = "",
            v = [],
            m = !1,
            g = 0,
            y = 0,
            b = "{{",
            _ = "}}";
          for (
            o && ((o = o.split(" ")), (b = o[0]), (_ = o[1])), g = 0;
            g < u;
            g++
          )
            0 == l
              ? n(b, i, g)
                ? (--g, a(), (l = 1))
                : "\n" == i.charAt(g)
                ? c(m)
                : (p += i.charAt(g))
              : 1 == l
              ? ((g += b.length - 1),
                (d = e.tags[i.charAt(g + 1)]),
                (f = d ? i.charAt(g + 1) : "_v"),
                "=" == f
                  ? ((g = (function (e, t) {
                      var n = "=" + _,
                        i = e.indexOf(n, t),
                        o = r(e.substring(e.indexOf("=", t) + 1, i)).split(" ");
                      return (
                        (b = o[0]), (_ = o[o.length - 1]), i + n.length - 1
                      );
                    })(i, g)),
                    (l = 0))
                  : (d && g++, (l = 2)),
                (m = g))
              : n(_, i, g)
              ? (v.push({
                  tag: f,
                  n: r(p),
                  otag: b,
                  ctag: _,
                  i: "/" == f ? m - b.length : g + _.length,
                }),
                (p = ""),
                (g += _.length - 1),
                (l = 0),
                "{" == f && ("}}" == _ ? g++ : t(v[v.length - 1])))
              : (p += i.charAt(g));
          return c(m, !0), v;
        });
      var O = { _t: !0, "\n": !0, $: !0, "/": !0 };
      e.stringify = function (t, r, n) {
        return (
          "{code: function (c,p,i) { " + e.wrapMain(t.code) + " }," + c(t) + "}"
        );
      };
      var j = 0;
      (e.generate = function (t, r, n) {
        j = 0;
        var i = { code: "", subs: {}, partials: {} };
        return (
          e.walk(t, i),
          n.asString ? this.stringify(i, r, n) : this.makeTemplate(i, r, n)
        );
      }),
        (e.wrapMain = function (e) {
          return 'var t=this;t.b(i=i||"");' + e + "return t.fl();";
        }),
        (e.template = e.Template),
        (e.makeTemplate = function (e, t, r) {
          var n = this.makePartials(e);
          return (
            (n.code = new Function("c", "p", "i", this.wrapMain(e.code))),
            new this.template(n, t, this, r)
          );
        }),
        (e.makePartials = function (e) {
          var t,
            r = { subs: {}, partials: e.partials, name: e.name };
          for (t in r.partials)
            r.partials[t] = this.makePartials(r.partials[t]);
          for (t in e.subs)
            r.subs[t] = new Function("c", "p", "t", "i", e.subs[t]);
          return r;
        }),
        (e.codegen = {
          "#": function (t, r) {
            (r.code +=
              "if(t.s(t." +
              l(t.n) +
              '("' +
              u(t.n) +
              '",c,p,1),c,p,0,' +
              t.i +
              "," +
              t.end +
              ',"' +
              t.otag +
              " " +
              t.ctag +
              '")){t.rs(c,p,function(c,p,t){'),
              e.walk(t.nodes, r),
              (r.code += "});c.pop();}");
          },
          "^": function (t, r) {
            (r.code +=
              "if(!t.s(t." +
              l(t.n) +
              '("' +
              u(t.n) +
              '",c,p,1),c,p,1,0,0,"")){'),
              e.walk(t.nodes, r),
              (r.code += "};");
          },
          ">": f,
          "<": function (t, r) {
            var n = { partials: {}, code: "", subs: {}, inPartial: !0 };
            e.walk(t.nodes, n);
            var i = r.partials[f(t, r)];
            (i.subs = n.subs), (i.partials = n.partials);
          },
          $: function (t, r) {
            var n = { subs: {}, code: "", partials: r.partials, prefix: t.n };
            e.walk(t.nodes, n),
              (r.subs[t.n] = n.code),
              r.inPartial || (r.code += 't.sub("' + u(t.n) + '",c,p,i);');
          },
          "\n": function (e, t) {
            t.code += p('"\\n"' + (e.last ? "" : " + i"));
          },
          _v: function (e, t) {
            t.code += "t.b(t.v(t." + l(e.n) + '("' + u(e.n) + '",c,p,0)));';
          },
          _t: function (e, t) {
            t.code += p('"' + u(e.text) + '"');
          },
          "{": d,
          "&": d,
        }),
        (e.walk = function (t, r) {
          for (var n, i = 0, o = t.length; i < o; i++)
            (n = e.codegen[t[i].tag]) && n(t[i], r);
          return r;
        }),
        (e.parse = function (e, t, r) {
          return (r = r || {}), i(e, "", [], r.sectionTags || []);
        }),
        (e.cache = {}),
        (e.cacheKey = function (e, t) {
          return [
            e,
            !!t.asString,
            !!t.disableLambda,
            t.delimiters,
            !!t.modelGet,
          ].join("||");
        }),
        (e.compile = function (t, r) {
          r = r || {};
          var n = e.cacheKey(t, r),
            i = this.cache[n];
          if (i) {
            var o = i.partials;
            for (var a in o) delete o[a].instance;
            return i;
          }
          return (
            (i = this.generate(
              this.parse(this.scan(t, r.delimiters), t, r),
              t,
              r
            )),
            (this.cache[n] = i)
          );
        });
    })(t);
  },
  function (e, t, r) {
    "use strict";
    var n = r(0),
      i = n(r(4));
    !(function (e) {
      function t(e, t, r) {
        var n;
        return (
          t &&
            "object" == (0, i.default)(t) &&
            (void 0 !== t[e]
              ? (n = t[e])
              : r && t.get && "function" == typeof t.get && (n = t.get(e))),
          n
        );
      }
      function r(e, t, r, n, i, o) {
        function a() {}
        function s() {}
        (a.prototype = e), (s.prototype = e.subs);
        var c,
          u = new a();
        (u.subs = new s()),
          (u.subsText = {}),
          (u.buf = ""),
          (n = n || {}),
          (u.stackSubs = n),
          (u.subsText = o);
        for (c in t) n[c] || (n[c] = t[c]);
        for (c in n) u.subs[c] = n[c];
        (i = i || {}), (u.stackPartials = i);
        for (c in r) i[c] || (i[c] = r[c]);
        for (c in i) u.partials[c] = i[c];
        return u;
      }
      function n(e) {
        return String(null === e || void 0 === e ? "" : e);
      }
      function o(e) {
        return (
          (e = n(e)),
          f.test(e)
            ? e
                .replace(a, "&amp;")
                .replace(s, "&lt;")
                .replace(c, "&gt;")
                .replace(u, "&#39;")
                .replace(l, "&quot;")
            : e
        );
      }
      (e.Template = function (e, t, r, n) {
        (e = e || {}),
          (this.r = e.code || this.r),
          (this.c = r),
          (this.options = n || {}),
          (this.text = t || ""),
          (this.partials = e.partials || {}),
          (this.subs = e.subs || {}),
          (this.buf = "");
      }),
        (e.Template.prototype = {
          r: function (e, t, r) {
            return "";
          },
          v: o,
          t: n,
          render: function (e, t, r) {
            return this.ri([e], t || {}, r);
          },
          ri: function (e, t, r) {
            return this.r(e, t, r);
          },
          ep: function (e, t) {
            var n = this.partials[e],
              i = t[n.name];
            if (n.instance && n.base == i) return n.instance;
            if ("string" == typeof i) {
              if (!this.c) throw new Error("No compiler available.");
              i = this.c.compile(i, this.options);
            }
            if (!i) return null;
            if (((this.partials[e].base = i), n.subs)) {
              t.stackText || (t.stackText = {});
              for (key in n.subs)
                t.stackText[key] ||
                  (t.stackText[key] =
                    void 0 !== this.activeSub && t.stackText[this.activeSub]
                      ? t.stackText[this.activeSub]
                      : this.text);
              i = r(
                i,
                n.subs,
                n.partials,
                this.stackSubs,
                this.stackPartials,
                t.stackText
              );
            }
            return (this.partials[e].instance = i), i;
          },
          rp: function (e, t, r, n) {
            var i = this.ep(e, r);
            return i ? i.ri(t, r, n) : "";
          },
          rs: function (e, t, r) {
            var n = e[e.length - 1];
            if (!d(n)) return void r(e, t, this);
            for (var i = 0; i < n.length; i++)
              e.push(n[i]), r(e, t, this), e.pop();
          },
          s: function (e, t, r, n, o, a, s) {
            var c;
            return (
              (!d(e) || 0 !== e.length) &&
              ("function" == typeof e && (e = this.ms(e, t, r, n, o, a, s)),
              (c = !!e),
              !n &&
                c &&
                t &&
                t.push("object" == (0, i.default)(e) ? e : t[t.length - 1]),
              c)
            );
          },
          d: function (e, r, n, i) {
            var o,
              a = e.split("."),
              s = this.f(a[0], r, n, i),
              c = this.options.modelGet,
              u = null;
            if ("." === e && d(r[r.length - 2])) s = r[r.length - 1];
            else
              for (var l = 1; l < a.length; l++)
                (o = t(a[l], s, c)),
                  void 0 !== o ? ((u = s), (s = o)) : (s = "");
            return (
              !(i && !s) &&
              (i ||
                "function" != typeof s ||
                (r.push(u), (s = this.mv(s, r, n)), r.pop()),
              s)
            );
          },
          f: function (e, r, n, i) {
            for (
              var o = !1,
                a = null,
                s = !1,
                c = this.options.modelGet,
                u = r.length - 1;
              u >= 0;
              u--
            )
              if (((a = r[u]), void 0 !== (o = t(e, a, c)))) {
                s = !0;
                break;
              }
            return s
              ? (i || "function" != typeof o || (o = this.mv(o, r, n)), o)
              : !i && "";
          },
          ls: function (e, t, r, i, o) {
            var a = this.options.delimiters;
            return (
              (this.options.delimiters = o),
              this.b(this.ct(n(e.call(t, i)), t, r)),
              (this.options.delimiters = a),
              !1
            );
          },
          ct: function (e, t, r) {
            if (this.options.disableLambda)
              throw new Error("Lambda features disabled.");
            return this.c.compile(e, this.options).render(t, r);
          },
          b: function (e) {
            this.buf += e;
          },
          fl: function () {
            var e = this.buf;
            return (this.buf = ""), e;
          },
          ms: function (e, t, r, n, i, o, a) {
            var s,
              c = t[t.length - 1],
              u = e.call(c);
            return "function" == typeof u
              ? !!n ||
                  ((s =
                    this.activeSub &&
                    this.subsText &&
                    this.subsText[this.activeSub]
                      ? this.subsText[this.activeSub]
                      : this.text),
                  this.ls(u, c, r, s.substring(i, o), a))
              : u;
          },
          mv: function (e, t, r) {
            var i = t[t.length - 1],
              o = e.call(i);
            return "function" == typeof o ? this.ct(n(o.call(i)), i, r) : o;
          },
          sub: function (e, t, r, n) {
            var i = this.subs[e];
            i &&
              ((this.activeSub = e), i(t, r, this, n), (this.activeSub = !1));
          },
        });
      var a = /&/g,
        s = /</g,
        c = />/g,
        u = /\'/g,
        l = /\"/g,
        f = /[&<>\"\']/,
        d =
          Array.isArray ||
          function (e) {
            return "[object Array]" === Object.prototype.toString.call(e);
          };
    })(t);
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(326);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
    var i = r(336);
    Object.keys(i).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return i[e];
          },
        });
    });
    var o = r(338);
    Object.keys(o).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return o[e];
          },
        });
    });
    var a = r(340);
    Object.keys(a).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return a[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    function n() {
      return (
        (n =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r)
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          }),
        n.apply(this, arguments)
      );
    }
    function i(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = o(e, t);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for (n = 0; n < a.length; n++)
          (r = a[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function o(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    function a(e) {
      var t = e.hit,
        r = e.attribute,
        o = e.cssClasses,
        a = i(e, ["hit", "attribute", "cssClasses"]),
        l = (0, u.getPropertyByPath)(t._highlightResult, r) || [],
        f = (0, u.toArray)(l),
        d = f.map(function (e) {
          var t = e.value;
          return (0, u.getHighlightedParts)((0, u.unescape)(t || ""));
        });
      return (0, s.h)(c.Highlight, n({}, a, { parts: d, classNames: o }));
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.Highlight = a);
    var s = r(2),
      c = r(327),
      u = r(1);
  },
  function (e, t, r) {
    "use strict";
    function n() {
      return (
        (n =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r)
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          }),
        n.apply(this, arguments)
      );
    }
    function i(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = o(e, t);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for (n = 0; n < a.length; n++)
          (r = a[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function o(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    function a(e) {
      var t = e.classNames,
        r = void 0 === t ? {} : t,
        o = i(e, ["classNames"]);
      return (0, c.h)(
        u.InternalHighlight,
        n(
          {
            classNames: {
              root: (0, s.cx)("ais-Highlight", r.root),
              highlighted: (0, s.cx)(
                "ais-Highlight-highlighted",
                r.highlighted
              ),
              nonHighlighted: (0, s.cx)(
                "ais-Highlight-nonHighlighted",
                r.nonHighlighted
              ),
              separator: (0, s.cx)("ais-Highlight-separator", r.separator),
            },
          },
          o
        )
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.Highlight = a);
    var s = r(14),
      c = r(2),
      u = r(22);
  },
  function (e, t, r) {
    "use strict";
    function n() {
      for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
        t[r] = arguments[r];
      return t.filter(Boolean).join(" ") || void 0;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.cx = n);
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(331);
    Object.keys(n).forEach(function (e) {
      "default" !== e &&
        "__esModule" !== e &&
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: function () {
            return n[e];
          },
        });
    });
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t = e.createElement;
      return function (e) {
        var r = e.classNames,
          n = e.children,
          i = e.highlightedTagName,
          o = e.isHighlighted,
          a = e.nonHighlightedTagName;
        return t(
          o ? i : a,
          { className: o ? r.highlighted : r.nonHighlighted },
          n
        );
      };
    }
    function i(e) {
      var t = e.createElement,
        r = e.Fragment,
        i = n({ createElement: t, Fragment: r });
      return function (e) {
        var n = e.parts,
          o = e.highlightedTagName,
          l = void 0 === o ? "mark" : o,
          f = e.nonHighlightedTagName,
          d = void 0 === f ? "span" : f,
          p = e.separator,
          h = void 0 === p ? ", " : p,
          v = e.className,
          m = e.classNames,
          g = void 0 === m ? {} : m,
          y = (0, s.default)(e, u);
        return t(
          "span",
          (0, a.default)({}, y, { className: (0, c.cx)(g.root, v) }),
          n.map(function (e, o) {
            var a = o === n.length - 1;
            return t(
              r,
              { key: o },
              e.map(function (e, r) {
                return t(
                  i,
                  {
                    key: r,
                    classNames: g,
                    highlightedTagName: l,
                    nonHighlightedTagName: d,
                    isHighlighted: e.isHighlighted,
                  },
                  e.value
                );
              }),
              !a && t("span", { className: g.separator }, h)
            );
          })
        );
      };
    }
    var o = r(332);
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.createHighlightComponent = i);
    var a = o(r(333)),
      s = o(r(334)),
      c = r(14),
      u = [
        "parts",
        "highlightedTagName",
        "nonHighlightedTagName",
        "separator",
        "className",
        "classNames",
      ];
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return e && e.__esModule ? e : { default: e };
    }
    (e.exports = n),
      (e.exports.__esModule = !0),
      (e.exports.default = e.exports);
  },
  function (e, t, r) {
    "use strict";
    function n() {
      return (
        (e.exports = n =
          Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var r = arguments[t];
                  for (var n in r)
                    Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
              }),
        (e.exports.__esModule = !0),
        (e.exports.default = e.exports),
        n.apply(this, arguments)
      );
    }
    (e.exports = n),
      (e.exports.__esModule = !0),
      (e.exports.default = e.exports);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      if (null == e) return {};
      var r,
        n,
        o = i(e, t);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for (n = 0; n < a.length; n++)
          (r = a[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (o[r] = e[r]));
      }
      return o;
    }
    var i = r(335);
    (e.exports = n),
      (e.exports.__esModule = !0),
      (e.exports.default = e.exports);
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    (e.exports = n),
      (e.exports.__esModule = !0),
      (e.exports.default = e.exports);
  },
  function (e, t, r) {
    "use strict";
    function n() {
      return (
        (n =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r)
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          }),
        n.apply(this, arguments)
      );
    }
    function i(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function o(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? i(Object(r), !0).forEach(function (t) {
              a(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : i(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function a(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function s(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = c(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (n = 0; n < o.length; n++)
          (r = o[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function c(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    function u(e) {
      var t = e.hit,
        r = e.attribute,
        i = e.cssClasses,
        a = s(e, ["hit", "attribute", "cssClasses"]),
        c = (0, d.getPropertyByPath)(t._highlightResult, r) || [],
        u = (0, d.toArray)(c),
        p = u.map(function (e) {
          var t = e.value;
          return (0, d.getHighlightedParts)((0, d.unescape)(t || "")).map(
            function (e) {
              var t = e.isHighlighted;
              return o(
                o({}, s(e, ["isHighlighted"])),
                {},
                { isHighlighted: !t }
              );
            }
          );
        });
      return (0, l.h)(
        f.ReverseHighlight,
        n({}, a, { parts: p, classNames: i })
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.ReverseHighlight = u);
    var l = r(2),
      f = r(337),
      d = r(1);
  },
  function (e, t, r) {
    "use strict";
    function n() {
      return (
        (n =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r)
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          }),
        n.apply(this, arguments)
      );
    }
    function i(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = o(e, t);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for (n = 0; n < a.length; n++)
          (r = a[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function o(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    function a(e) {
      var t = e.classNames,
        r = void 0 === t ? {} : t,
        o = i(e, ["classNames"]);
      return (0, c.h)(
        u.InternalHighlight,
        n(
          {
            classNames: {
              root: (0, s.cx)("ais-ReverseHighlight", r.root),
              highlighted: (0, s.cx)(
                "ais-ReverseHighlight-highlighted",
                r.highlighted
              ),
              nonHighlighted: (0, s.cx)(
                "ais-ReverseHighlight-nonHighlighted",
                r.nonHighlighted
              ),
              separator: (0, s.cx)(
                "ais-ReverseHighlight-separator",
                r.separator
              ),
            },
          },
          o
        )
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.ReverseHighlight = a);
    var s = r(14),
      c = r(2),
      u = r(22);
  },
  function (e, t, r) {
    "use strict";
    function n() {
      return (
        (n =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r)
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          }),
        n.apply(this, arguments)
      );
    }
    function i(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function o(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? i(Object(r), !0).forEach(function (t) {
              a(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : i(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function a(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function s(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = c(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (n = 0; n < o.length; n++)
          (r = o[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function c(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    function u(e) {
      var t = e.hit,
        r = e.attribute,
        i = e.cssClasses,
        a = s(e, ["hit", "attribute", "cssClasses"]),
        c = (0, d.getPropertyByPath)(t._snippetResult, r) || [],
        u = (0, d.toArray)(c),
        p = u.map(function (e) {
          var t = e.value;
          return (0, d.getHighlightedParts)((0, d.unescape)(t || "")).map(
            function (e) {
              var t = e.isHighlighted;
              return o(
                o({}, s(e, ["isHighlighted"])),
                {},
                { isHighlighted: !t }
              );
            }
          );
        });
      return (0, l.h)(f.ReverseSnippet, n({}, a, { parts: p, classNames: i }));
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.ReverseSnippet = u);
    var l = r(2),
      f = r(339),
      d = r(1);
  },
  function (e, t, r) {
    "use strict";
    function n() {
      return (
        (n =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r)
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          }),
        n.apply(this, arguments)
      );
    }
    function i(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = o(e, t);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for (n = 0; n < a.length; n++)
          (r = a[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function o(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    function a(e) {
      var t = e.classNames,
        r = void 0 === t ? {} : t,
        o = i(e, ["classNames"]);
      return (0, c.h)(
        u.InternalHighlight,
        n(
          {
            classNames: {
              root: (0, s.cx)("ais-ReverseSnippet", r.root),
              highlighted: (0, s.cx)(
                "ais-ReverseSnippet-highlighted",
                r.highlighted
              ),
              nonHighlighted: (0, s.cx)(
                "ais-ReverseSnippet-nonHighlighted",
                r.nonHighlighted
              ),
              separator: (0, s.cx)("ais-ReverseSnippet-separator", r.separator),
            },
          },
          o
        )
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.ReverseSnippet = a);
    var s = r(14),
      c = r(2),
      u = r(22);
  },
  function (e, t, r) {
    "use strict";
    function n() {
      return (
        (n =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r)
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          }),
        n.apply(this, arguments)
      );
    }
    function i(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = o(e, t);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for (n = 0; n < a.length; n++)
          (r = a[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function o(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    function a(e) {
      var t = e.hit,
        r = e.attribute,
        o = e.cssClasses,
        a = i(e, ["hit", "attribute", "cssClasses"]),
        l = (0, u.getPropertyByPath)(t._snippetResult, r) || [],
        f = (0, u.toArray)(l),
        d = f.map(function (e) {
          var t = e.value;
          return (0, u.getHighlightedParts)((0, u.unescape)(t || ""));
        });
      return (0, s.h)(c.Snippet, n({}, a, { parts: d, classNames: o }));
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.Snippet = a);
    var s = r(2),
      c = r(341),
      u = r(1);
  },
  function (e, t, r) {
    "use strict";
    function n() {
      return (
        (n =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r)
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          }),
        n.apply(this, arguments)
      );
    }
    function i(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = o(e, t);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for (n = 0; n < a.length; n++)
          (r = a[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function o(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    function a(e) {
      var t = e.classNames,
        r = void 0 === t ? {} : t,
        o = i(e, ["classNames"]);
      return (0, c.h)(
        u.InternalHighlight,
        n(
          {
            classNames: {
              root: (0, s.cx)("ais-Snippet", r.root),
              highlighted: (0, s.cx)("ais-Snippet-highlighted", r.highlighted),
              nonHighlighted: (0, s.cx)(
                "ais-Snippet-nonHighlighted",
                r.nonHighlighted
              ),
              separator: (0, s.cx)("ais-Snippet-separator", r.separator),
            },
          },
          o
        )
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.Snippet = a);
    var s = r(14),
      c = r(2),
      u = r(22);
  },
  function (e, t, r) {
    "use strict";
    function n() {
      return (
        (n =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r)
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          }),
        n.apply(this, arguments)
      );
    }
    function i(e) {
      var t = e.className,
        r = e.handleClick,
        i = e.facetValueToRefine,
        o = e.isRefined,
        c = e.templateProps,
        u = e.templateKey,
        l = e.templateData,
        f = e.subItems;
      return (0, a.h)(
        "li",
        {
          className: t,
          onClick: function (e) {
            r({ facetValueToRefine: i, isRefined: o, originalEvent: e });
          },
        },
        (0, a.h)(s.default, n({}, c, { templateKey: u, data: l })),
        f
      );
    }
    var o = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var a = r(2),
      s = o(r(8)),
      c = i;
    t.default = c;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      if (null == e) return {};
      var r,
        n,
        o = i(e, t);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for (n = 0; n < a.length; n++)
          (r = a[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (o[r] = e[r]));
      }
      return o;
    }
    function i(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    function o(e, t) {
      return l(e) || u(e, t) || s(e, t) || a();
    }
    function a() {
      throw new TypeError(
        "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function s(e, t) {
      if (e) {
        if ("string" == typeof e) return c(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? c(e, t)
            : void 0
        );
      }
    }
    function c(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function u(e, t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
        var r = [],
          n = !0,
          i = !1,
          o = void 0;
        try {
          for (
            var a, s = e[Symbol.iterator]();
            !(n = (a = s.next()).done) &&
            (r.push(a.value), !t || r.length !== t);
            n = !0
          );
        } catch (e) {
          (i = !0), (o = e);
        } finally {
          try {
            n || null == s.return || s.return();
          } finally {
            if (i) throw o;
          }
        }
        return r;
      }
    }
    function l(e) {
      if (Array.isArray(e)) return e;
    }
    function f(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function d(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? f(Object(r), !0).forEach(function (t) {
              p(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : f(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function p(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var h = r(1),
      v = (0, h.createDocumentationMessageGenerator)({
        name: "menu",
        connector: !0,
      }),
      m = ["isRefined", "name:asc"],
      g = function (e) {
        var t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : h.noop;
        return (
          (0, h.checkRendering)(e, v()),
          function (r) {
            function i(e, t) {
              return function () {
                (x = !x), t.render(e);
              };
            }
            function a() {
              k();
            }
            function s() {
              return x ? _ : f;
            }
            var c = r || {},
              u = c.attribute,
              l = c.limit,
              f = void 0 === l ? 10 : l,
              g = c.showMore,
              y = void 0 !== g && g,
              b = c.showMoreLimit,
              _ = void 0 === b ? 20 : b,
              O = c.sortBy,
              j = void 0 === O ? m : O,
              P = c.transformItems,
              w =
                void 0 === P
                  ? function (e) {
                      return e;
                    }
                  : P;
            if (!u) throw new Error(v("The `attribute` option is required."));
            if (!0 === y && _ <= f)
              throw new Error(
                v("The `showMoreLimit` option must be greater than `limit`.")
              );
            var S,
              E,
              R,
              x = !1,
              k = function () {};
            return {
              $$type: "ais.menu",
              init: function (t) {
                var r = t.instantSearchInstance;
                e(
                  d(
                    d({}, this.getWidgetRenderState(t)),
                    {},
                    { instantSearchInstance: r }
                  ),
                  !0
                );
              },
              render: function (t) {
                var r = t.instantSearchInstance;
                e(
                  d(
                    d({}, this.getWidgetRenderState(t)),
                    {},
                    { instantSearchInstance: r }
                  ),
                  !1
                );
              },
              dispose: function (e) {
                var r = e.state;
                return (
                  t(),
                  r
                    .removeHierarchicalFacet(u)
                    .setQueryParameter("maxValuesPerFacet", void 0)
                );
              },
              getRenderState: function (e, t) {
                return d(
                  d({}, e),
                  {},
                  {
                    menu: d(
                      d({}, e.menu),
                      {},
                      p({}, u, this.getWidgetRenderState(t))
                    ),
                  }
                );
              },
              getWidgetRenderState: function (e) {
                var t = e.results,
                  c = e.createURL,
                  l = e.instantSearchInstance,
                  f = e.helper,
                  p = [],
                  v = !1;
                if (
                  (S ||
                    (S = (0, h.createSendEventForFacet)({
                      instantSearchInstance: l,
                      helper: f,
                      attribute: u,
                      widgetType: this.$$type,
                    })),
                  E ||
                    (E = function (e) {
                      return c(f.state.resetPage().toggleFacetRefinement(u, e));
                    }),
                  R ||
                    (R = function (e) {
                      var t = f.getHierarchicalFacetBreadcrumb(u),
                        r = o(t, 1),
                        n = r[0];
                      S("click", e || n),
                        f.toggleFacetRefinement(u, e || n).search();
                    }),
                  e.results && (k = i(e, this)),
                  t)
                ) {
                  var g = t.getFacetValues(u, {
                      sortBy: j,
                      facetOrdering: j === m,
                    }),
                    b = g && !Array.isArray(g) && g.data ? g.data : [];
                  (v = y && (x || b.length > s())),
                    (p = w(
                      b.slice(0, s()).map(function (e) {
                        var t = e.name,
                          r = e.escapedValue;
                        return (
                          e.path,
                          d(
                            d({}, n(e, ["name", "escapedValue", "path"])),
                            {},
                            { label: t, value: r }
                          )
                        );
                      }),
                      { results: t }
                    ));
                }
                return {
                  items: p,
                  createURL: E,
                  refine: R,
                  sendEvent: S,
                  canRefine: p.length > 0,
                  widgetParams: r,
                  isShowingMore: x,
                  toggleShowMore: a,
                  canToggleShowMore: v,
                };
              },
              getWidgetUiState: function (e, t) {
                var r = t.searchParameters,
                  n = r.getHierarchicalFacetBreadcrumb(u),
                  i = o(n, 1),
                  a = i[0];
                return a
                  ? d(d({}, e), {}, { menu: d(d({}, e.menu), {}, p({}, u, a)) })
                  : e;
              },
              getWidgetSearchParameters: function (e, t) {
                var r = t.uiState,
                  n = r.menu && r.menu[u],
                  i = e
                    .removeHierarchicalFacet(u)
                    .addHierarchicalFacet({ name: u, attributes: [u] }),
                  o = i.maxValuesPerFacet || 0,
                  a = Math.max(o, y ? _ : f),
                  s = i.setQueryParameter("maxValuesPerFacet", a);
                return n
                  ? s.addHierarchicalFacetRefinement(u, n)
                  : s.setQueryParameters({
                      hierarchicalFacetsRefinements: d(
                        d({}, s.hierarchicalFacetsRefinements),
                        {},
                        p({}, u, [])
                      ),
                    });
              },
            };
          }
        );
      },
      y = g;
    t.default = y;
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var n = r(2),
      i = r(17),
      o = r(1),
      a = {
        item: function (e) {
          var t = e.cssClasses,
            r = e.url,
            a = e.label,
            s = e.count;
          return (0, n.h)(
            "a",
            { className: (0, o.cx)(t.link), href: r },
            (0, n.h)("span", { className: (0, o.cx)(t.label) }, a),
            (0, n.h)(
              "span",
              { className: (0, o.cx)(t.count) },
              (0, i.formatNumber)(s)
            )
          );
        },
        showMoreText: function (e) {
          return e.isShowingMore ? "Show less" : "Show more";
        },
      },
      s = a;
    t.default = s;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    var a = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var s = r(2),
      c = a(r(3)),
      u = a(r(87)),
      l = a(r(346)),
      f = r(1),
      d = r(12),
      p = r(6),
      h = a(r(89)),
      v = a(r(347)),
      m = (0, f.createDocumentationMessageGenerator)({
        name: "refinement-list",
      }),
      g = (0, p.component)("RefinementList"),
      y = (0, p.component)("SearchBox"),
      b = function (e) {
        var t = e.containerNode,
          r = e.cssClasses,
          n = e.templates,
          i = e.searchBoxTemplates,
          o = e.renderState,
          a = e.showMore,
          c = e.searchable,
          l = e.searchablePlaceholder,
          f = e.searchableIsAlwaysActive;
        return function (e, p) {
          var m = e.refine,
            g = e.items,
            y = e.createURL,
            b = e.searchForItems,
            _ = e.isFromSearch,
            O = e.instantSearchInstance,
            j = e.toggleShowMore,
            P = e.isShowingMore,
            w = e.hasExhaustiveItems,
            S = e.canToggleShowMore;
          if (p)
            return (
              (o.templateProps = (0, d.prepareTemplateProps)({
                defaultTemplates: v.default,
                templatesConfig: O.templatesConfig,
                templates: n,
              })),
              void (o.searchBoxTemplateProps = (0, d.prepareTemplateProps)({
                defaultTemplates: h.default,
                templatesConfig: O.templatesConfig,
                templates: i,
              }))
            );
          (0, s.render)(
            (0, s.h)(u.default, {
              createURL: y,
              cssClasses: r,
              facetValues: g,
              templateProps: o.templateProps,
              searchBoxTemplateProps: o.searchBoxTemplateProps,
              toggleRefinement: m,
              searchFacetValues: c ? b : void 0,
              searchPlaceholder: l,
              searchIsAlwaysActive: f,
              isFromSearch: _,
              showMore: a && !_ && g.length > 0,
              toggleShowMore: j,
              isShowingMore: P,
              hasExhaustiveItems: w,
              canToggleShowMore: S,
            }),
            t
          );
        };
      },
      _ = function (e) {
        var t = e || {},
          r = t.container,
          n = t.attribute,
          o = t.operator,
          a = t.sortBy,
          u = t.limit,
          d = t.showMore,
          p = t.showMoreLimit,
          h = t.searchable,
          v = void 0 !== h && h,
          _ = t.searchablePlaceholder,
          O = void 0 === _ ? "Search..." : _,
          j = t.searchableEscapeFacetValues,
          P = void 0 === j || j,
          w = t.searchableIsAlwaysActive,
          S = void 0 === w || w,
          E = t.cssClasses,
          R = void 0 === E ? {} : E,
          x = t.templates,
          k = void 0 === x ? {} : x,
          I = t.transformItems;
        if (!r) throw new Error(m("The `container` option is required."));
        var A = !!v && Boolean(P),
          M = (0, f.getContainerNode)(r),
          C = {
            root: (0, c.default)(g(), R.root),
            noRefinementRoot: (0, c.default)(
              g({ modifierName: "noRefinement" }),
              R.noRefinementRoot
            ),
            list: (0, c.default)(g({ descendantName: "list" }), R.list),
            item: (0, c.default)(g({ descendantName: "item" }), R.item),
            selectedItem: (0, c.default)(
              g({ descendantName: "item", modifierName: "selected" }),
              R.selectedItem
            ),
            searchBox: (0, c.default)(
              g({ descendantName: "searchBox" }),
              R.searchBox
            ),
            label: (0, c.default)(g({ descendantName: "label" }), R.label),
            checkbox: (0, c.default)(
              g({ descendantName: "checkbox" }),
              R.checkbox
            ),
            labelText: (0, c.default)(
              g({ descendantName: "labelText" }),
              R.labelText
            ),
            count: (0, c.default)(g({ descendantName: "count" }), R.count),
            noResults: (0, c.default)(
              g({ descendantName: "noResults" }),
              R.noResults
            ),
            showMore: (0, c.default)(
              g({ descendantName: "showMore" }),
              R.showMore
            ),
            disabledShowMore: (0, c.default)(
              g({ descendantName: "showMore", modifierName: "disabled" }),
              R.disabledShowMore
            ),
            searchable: {
              root: (0, c.default)(y(), R.searchableRoot),
              form: (0, c.default)(
                y({ descendantName: "form" }),
                R.searchableForm
              ),
              input: (0, c.default)(
                y({ descendantName: "input" }),
                R.searchableInput
              ),
              submit: (0, c.default)(
                y({ descendantName: "submit" }),
                R.searchableSubmit
              ),
              submitIcon: (0, c.default)(
                y({ descendantName: "submitIcon" }),
                R.searchableSubmitIcon
              ),
              reset: (0, c.default)(
                y({ descendantName: "reset" }),
                R.searchableReset
              ),
              resetIcon: (0, c.default)(
                y({ descendantName: "resetIcon" }),
                R.searchableResetIcon
              ),
              loadingIndicator: (0, c.default)(
                y({ descendantName: "loadingIndicator" }),
                R.searchableLoadingIndicator
              ),
              loadingIcon: (0, c.default)(
                y({ descendantName: "loadingIcon" }),
                R.searchableLoadingIcon
              ),
            },
          },
          T = b({
            containerNode: M,
            cssClasses: C,
            templates: k,
            searchBoxTemplates: {
              submit: k.searchableSubmit,
              reset: k.searchableReset,
              loadingIndicator: k.searchableLoadingIndicator,
            },
            renderState: {},
            searchable: v,
            searchablePlaceholder: O,
            searchableIsAlwaysActive: S,
            showMore: d,
          });
        return i(
          i(
            {},
            (0, l.default)(T, function () {
              return (0, s.render)(null, M);
            })({
              attribute: n,
              operator: o,
              limit: u,
              showMore: d,
              showMoreLimit: p,
              sortBy: a,
              escapeFacetValues: A,
              transformItems: I,
            })
          ),
          {},
          { $$widgetType: "ais.refinementList" }
        );
      },
      O = _;
    t.default = O;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = s(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (n = 0; n < o.length; n++)
          (r = o[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function s(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var c = r(1),
      u = (0, c.createDocumentationMessageGenerator)({
        name: "refinement-list",
        connector: !0,
      }),
      l = ["isRefined", "count:desc", "name:asc"],
      f = function (e) {
        var t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : c.noop;
        return (
          (0, c.checkRendering)(e, u()),
          function (r) {
            function n() {
              N();
            }
            function s(e, t) {
              return function () {
                (T = !T), t.render(e);
              };
            }
            function f() {
              return T ? O : g;
            }
            var d = r || {},
              p = d.attribute,
              h = d.operator,
              v = void 0 === h ? "or" : h,
              m = d.limit,
              g = void 0 === m ? 10 : m,
              y = d.showMore,
              b = void 0 !== y && y,
              _ = d.showMoreLimit,
              O = void 0 === _ ? 20 : _,
              j = d.sortBy,
              P = void 0 === j ? l : j,
              w = d.escapeFacetValues,
              S = void 0 === w || w,
              E = d.transformItems,
              R =
                void 0 === E
                  ? function (e) {
                      return e;
                    }
                  : E;
            if (!p) throw new Error(u("The `attribute` option is required."));
            if (!/^(and|or)$/.test(v))
              throw new Error(
                u(
                  'The `operator` must one of: `"and"`, `"or"` (got "'.concat(
                    v,
                    '").'
                  )
                )
              );
            if (!0 === b && O <= g)
              throw new Error(
                u("`showMoreLimit` should be greater than `limit`.")
              );
            var x,
              k,
              I,
              A = function (e) {
                var t = e.name,
                  r = e.escapedValue;
                return i(
                  i({}, a(e, ["name", "escapedValue"])),
                  {},
                  { value: r, label: t, highlighted: t }
                );
              },
              M = [],
              C = !0,
              T = !1,
              N = function () {},
              D = function () {
                return function () {};
              },
              F = function (t, r) {
                return function (n) {
                  return function (o) {
                    var s = n.instantSearchInstance,
                      u = n.results;
                    if ("" === o && M)
                      e(
                        i(
                          i(
                            {},
                            r.getWidgetRenderState(
                              i(i({}, n), {}, { results: x })
                            )
                          ),
                          {},
                          { instantSearchInstance: s }
                        ),
                        !1
                      );
                    else {
                      var l = {
                        highlightPreTag: S
                          ? c.TAG_PLACEHOLDER.highlightPreTag
                          : c.TAG_REPLACEMENT.highlightPreTag,
                        highlightPostTag: S
                          ? c.TAG_PLACEHOLDER.highlightPostTag
                          : c.TAG_REPLACEMENT.highlightPostTag,
                      };
                      t.searchForFacetValues(p, o, Math.min(f(), 100), l).then(
                        function (t) {
                          var o = S
                              ? (0, c.escapeFacets)(t.facetHits)
                              : t.facetHits,
                            l = R(
                              o.map(function (e) {
                                var t = e.escapedValue,
                                  r = e.value;
                                return i(
                                  i({}, a(e, ["escapedValue", "value"])),
                                  {},
                                  { value: t, label: r }
                                );
                              }),
                              { results: u }
                            );
                          e(
                            i(
                              i(
                                {},
                                r.getWidgetRenderState(
                                  i(i({}, n), {}, { results: x })
                                )
                              ),
                              {},
                              {
                                items: l,
                                canToggleShowMore: !1,
                                canRefine: !0,
                                isFromSearch: !0,
                                instantSearchInstance: s,
                              }
                            ),
                            !1
                          );
                        }
                      );
                    }
                  };
                };
              };
            return {
              $$type: "ais.refinementList",
              init: function (t) {
                e(
                  i(
                    i({}, this.getWidgetRenderState(t)),
                    {},
                    { instantSearchInstance: t.instantSearchInstance }
                  ),
                  !0
                );
              },
              render: function (t) {
                e(
                  i(
                    i({}, this.getWidgetRenderState(t)),
                    {},
                    { instantSearchInstance: t.instantSearchInstance }
                  ),
                  !1
                );
              },
              getRenderState: function (e, t) {
                return i(
                  i({}, e),
                  {},
                  {
                    refinementList: i(
                      i({}, e.refinementList),
                      {},
                      o({}, p, this.getWidgetRenderState(t))
                    ),
                  }
                );
              },
              getWidgetRenderState: function (e) {
                var t = e.results,
                  i = e.state,
                  o = e.createURL,
                  a = e.instantSearchInstance,
                  u = e.helper,
                  d = [],
                  h = [];
                if (
                  ((I && k && D) ||
                    ((I = (0, c.createSendEventForFacet)({
                      instantSearchInstance: a,
                      helper: u,
                      attribute: p,
                      widgetType: this.$$type,
                    })),
                    (k = function (e) {
                      I("click", e), u.toggleFacetRefinement(p, e).search();
                    }),
                    (D = F(u, this))),
                  t)
                ) {
                  var v = t.getFacetValues(p, {
                    sortBy: P,
                    facetOrdering: P === l,
                  });
                  (h = v && Array.isArray(v) ? v : []),
                    (d = R(h.slice(0, f()).map(A), { results: t }));
                  var m = i.maxValuesPerFacet,
                    y = f();
                  (C = m > y ? h.length <= y : h.length < y),
                    (x = t),
                    (M = d),
                    e.results && (N = s(e, this));
                }
                var _ = D && D(e),
                  O = T && M.length > g,
                  j = b && !C,
                  w = O || j;
                return {
                  createURL: function (e) {
                    return o(i.resetPage().toggleFacetRefinement(p, e));
                  },
                  items: d,
                  refine: k,
                  searchForItems: _,
                  isFromSearch: !1,
                  canRefine: d.length > 0,
                  widgetParams: r,
                  isShowingMore: T,
                  canToggleShowMore: w,
                  toggleShowMore: n,
                  sendEvent: I,
                  hasExhaustiveItems: C,
                };
              },
              dispose: function (e) {
                var r = e.state;
                t();
                var n = r.setQueryParameter("maxValuesPerFacet", void 0);
                return "and" === v
                  ? n.removeFacet(p)
                  : n.removeDisjunctiveFacet(p);
              },
              getWidgetUiState: function (e, t) {
                var r = t.searchParameters,
                  n =
                    "or" === v
                      ? r.getDisjunctiveRefinements(p)
                      : r.getConjunctiveRefinements(p);
                return n.length
                  ? i(
                      i({}, e),
                      {},
                      {
                        refinementList: i(
                          i({}, e.refinementList),
                          {},
                          o({}, p, n)
                        ),
                      }
                    )
                  : e;
              },
              getWidgetSearchParameters: function (e, t) {
                var r = t.uiState,
                  n = "or" === v,
                  a = r.refinementList && r.refinementList[p],
                  s = e.clearRefinements(p),
                  c = n ? s.addDisjunctiveFacet(p) : s.addFacet(p),
                  u = c.maxValuesPerFacet || 0,
                  l = Math.max(u, b ? O : g),
                  f = c.setQueryParameter("maxValuesPerFacet", l);
                if (!a) {
                  var d = n
                    ? "disjunctiveFacetsRefinements"
                    : "facetsRefinements";
                  return f.setQueryParameters(
                    o({}, d, i(i({}, f[d]), {}, o({}, p, [])))
                  );
                }
                return a.reduce(function (e, t) {
                  return n
                    ? e.addDisjunctiveFacetRefinement(p, t)
                    : e.addFacetRefinement(p, t);
                }, f);
              },
            };
          }
        );
      },
      d = f;
    t.default = d;
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var n = r(2),
      i = r(17),
      o = r(1),
      a = {
        item: function (e) {
          var t = e.cssClasses,
            r = e.count,
            a = e.value,
            s = e.highlighted,
            c = e.isRefined,
            u = e.isFromSearch;
          return (0, n.h)(
            "label",
            { className: (0, o.cx)(t.label) },
            (0, n.h)("input", {
              type: "checkbox",
              className: (0, o.cx)(t.checkbox),
              value: a,
              defaultChecked: c,
            }),
            (0, n.h)(
              "span",
              {
                className: (0, o.cx)(t.labelText),
                dangerouslySetInnerHTML: u ? { __html: s } : void 0,
              },
              !u && s
            ),
            (0, n.h)(
              "span",
              { className: (0, o.cx)(t.count) },
              (0, i.formatNumber)(r)
            )
          );
        },
        showMoreText: function (e) {
          return e.isShowingMore ? "Show less" : "Show more";
        },
        searchableNoResults: function () {
          return "No results";
        },
      },
      s = a;
    t.default = s;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    var a = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var s = r(2),
      c = a(r(3)),
      u = r(1),
      l = r(6),
      f = a(r(349)),
      d = a(r(88)),
      p = a(r(89)),
      h = (0, u.createDocumentationMessageGenerator)({ name: "search-box" }),
      v = (0, l.component)("SearchBox"),
      m = function (e) {
        var t = e.containerNode,
          r = e.cssClasses,
          n = e.placeholder,
          i = e.templates,
          o = e.autofocus,
          a = e.searchAsYouType,
          c = e.showReset,
          u = e.showSubmit,
          l = e.showLoadingIndicator;
        return function (e) {
          var f = e.refine,
            p = e.query,
            h = e.isSearchStalled;
          (0, s.render)(
            (0, s.h)(d.default, {
              query: p,
              placeholder: n,
              autofocus: o,
              refine: f,
              searchAsYouType: a,
              templates: i,
              showSubmit: u,
              showReset: c,
              showLoadingIndicator: l,
              isSearchStalled: h,
              cssClasses: r,
            }),
            t
          );
        };
      },
      g = function (e) {
        var t = e || {},
          r = t.container,
          n = t.placeholder,
          o = void 0 === n ? "" : n,
          a = t.cssClasses,
          l = void 0 === a ? {} : a,
          d = t.autofocus,
          g = void 0 !== d && d,
          y = t.searchAsYouType,
          b = void 0 === y || y,
          _ = t.showReset,
          O = void 0 === _ || _,
          j = t.showSubmit,
          P = void 0 === j || j,
          w = t.showLoadingIndicator,
          S = void 0 === w || w,
          E = t.queryHook,
          R = t.templates,
          x = void 0 === R ? {} : R;
        if (!r) throw new Error(h("The `container` option is required."));
        var k = (0, u.getContainerNode)(r),
          I = {
            root: (0, c.default)(v(), l.root),
            form: (0, c.default)(v({ descendantName: "form" }), l.form),
            input: (0, c.default)(v({ descendantName: "input" }), l.input),
            submit: (0, c.default)(v({ descendantName: "submit" }), l.submit),
            submitIcon: (0, c.default)(
              v({ descendantName: "submitIcon" }),
              l.submitIcon
            ),
            reset: (0, c.default)(v({ descendantName: "reset" }), l.reset),
            resetIcon: (0, c.default)(
              v({ descendantName: "resetIcon" }),
              l.resetIcon
            ),
            loadingIndicator: (0, c.default)(
              v({ descendantName: "loadingIndicator" }),
              l.loadingIndicator
            ),
            loadingIcon: (0, c.default)(
              v({ descendantName: "loadingIcon" }),
              l.loadingIcon
            ),
          },
          A = i(i({}, p.default), x),
          M = m({
            containerNode: k,
            cssClasses: I,
            placeholder: o,
            templates: A,
            autofocus: g,
            searchAsYouType: b,
            showReset: O,
            showSubmit: P,
            showLoadingIndicator: S,
          });
        return i(
          i(
            {},
            (0, f.default)(M, function () {
              return (0, s.render)(null, k);
            })({ queryHook: E })
          ),
          {},
          { $$widgetType: "ais.searchBox" }
        );
      },
      y = g;
    t.default = y;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var a = r(1),
      s = (0, a.createDocumentationMessageGenerator)({
        name: "search-box",
        connector: !0,
      }),
      c = function (e, t) {
        return t(e);
      },
      u = function (e) {
        var t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : a.noop;
        return (
          (0, a.checkRendering)(e, s()),
          function (r) {
            var n,
              o,
              a = r || {},
              s = a.queryHook,
              u = void 0 === s ? c : s;
            return {
              $$type: "ais.searchBox",
              init: function (t) {
                var r = t.instantSearchInstance;
                e(
                  i(
                    i({}, this.getWidgetRenderState(t)),
                    {},
                    { instantSearchInstance: r }
                  ),
                  !0
                );
              },
              render: function (t) {
                var r = t.instantSearchInstance;
                e(
                  i(
                    i({}, this.getWidgetRenderState(t)),
                    {},
                    { instantSearchInstance: r }
                  ),
                  !1
                );
              },
              dispose: function (e) {
                var r = e.state;
                return t(), r.setQueryParameter("query", void 0);
              },
              getRenderState: function (e, t) {
                return i(
                  i({}, e),
                  {},
                  { searchBox: this.getWidgetRenderState(t) }
                );
              },
              getWidgetRenderState: function (e) {
                var t = e.helper,
                  i = e.searchMetadata,
                  a = e.state;
                return (
                  n ||
                    ((n = function (e) {
                      u(e, function (e) {
                        return t.setQuery(e).search();
                      });
                    }),
                    (o = function () {
                      t.setQuery("").search();
                    })),
                  {
                    query: a.query || "",
                    refine: n,
                    clear: o,
                    widgetParams: r,
                    isSearchStalled: i.isSearchStalled,
                  }
                );
              },
              getWidgetUiState: function (e, t) {
                var r = t.searchParameters,
                  n = r.query || "";
                return "" === n || (e && e.query === n)
                  ? e
                  : i(i({}, e), {}, { query: n });
              },
              getWidgetSearchParameters: function (e, t) {
                var r = t.uiState;
                return e.setQueryParameter("query", r.query || "");
              },
            };
          }
        );
      },
      l = u;
    t.default = l;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e) {
      var t = e.nbHits,
        r = e.hasNoSortedResults,
        n = e.hasOneSortedResults,
        i = e.hasManySortedResults,
        o = e.nbSortedHits,
        a = "sorted out of ".concat((0, m.formatNumber)(t));
      return r
        ? "No relevant results ".concat(a)
        : n
        ? "1 relevant result ".concat(a)
        : i
        ? "".concat((0, m.formatNumber)(o || 0), " relevant results ").concat(a)
        : "";
    }
    function s(e) {
      var t = e.nbHits,
        r = e.hasNoResults,
        n = e.hasOneResult,
        i = e.hasManyResults;
      return r
        ? "No results"
        : n
        ? "1 result"
        : i
        ? "".concat((0, m.formatNumber)(t), " results")
        : "";
    }
    var c = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = t.defaultTemplates = void 0);
    var u = r(2),
      l = c(r(3)),
      f = c(r(351)),
      d = c(r(352)),
      p = r(1),
      h = r(12),
      v = r(6),
      m = r(17),
      g = (0, p.createDocumentationMessageGenerator)({ name: "stats" }),
      y = (0, v.component)("Stats"),
      b = {
        text: function (e) {
          return ""
            .concat(e.areHitsSorted ? a(e) : s(e), " found in ")
            .concat(e.processingTimeMS, "ms");
        },
      };
    t.defaultTemplates = b;
    var _ = function (e) {
        var t = e.renderState,
          r = e.cssClasses,
          n = e.containerNode,
          i = e.templates;
        return function (e, o) {
          var a = e.hitsPerPage,
            s = e.nbHits,
            c = e.nbSortedHits,
            l = e.areHitsSorted,
            d = e.nbPages,
            p = e.page,
            v = e.processingTimeMS,
            m = e.query,
            g = e.instantSearchInstance;
          if (o)
            return void (t.templateProps = (0, h.prepareTemplateProps)({
              defaultTemplates: b,
              templatesConfig: g.templatesConfig,
              templates: i,
            }));
          (0, u.render)(
            (0, u.h)(f.default, {
              cssClasses: r,
              hitsPerPage: a,
              nbHits: s,
              nbSortedHits: c,
              areHitsSorted: l,
              nbPages: d,
              page: p,
              processingTimeMS: v,
              query: m,
              templateProps: t.templateProps,
            }),
            n
          );
        };
      },
      O = function (e) {
        var t = e || {},
          r = t.container,
          n = t.cssClasses,
          o = void 0 === n ? {} : n,
          a = t.templates,
          s = void 0 === a ? {} : a;
        if (!r) throw new Error(g("The `container` option is required."));
        var c = (0, p.getContainerNode)(r),
          f = {
            root: (0, l.default)(y(), o.root),
            text: (0, l.default)(y({ descendantName: "text" }), o.text),
          },
          h = _({
            containerNode: c,
            cssClasses: f,
            templates: s,
            renderState: {},
          });
        return i(
          i(
            {},
            (0, d.default)(h, function () {
              return (0, u.render)(null, c);
            })({})
          ),
          {},
          { $$widgetType: "ais.stats" }
        );
      },
      j = O;
    t.default = j;
  },
  function (e, t, r) {
    "use strict";
    function n() {
      return (
        (n =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r)
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          }),
        n.apply(this, arguments)
      );
    }
    function i(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function o(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? i(Object(r), !0).forEach(function (t) {
              a(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : i(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function a(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function s(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = c(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (n = 0; n < o.length; n++)
          (r = o[n]),
            t.indexOf(r) >= 0 ||
              (Object.prototype.propertyIsEnumerable.call(e, r) &&
                (i[r] = e[r]));
      }
      return i;
    }
    function c(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++)
        (r = o[n]), t.indexOf(r) >= 0 || (i[r] = e[r]);
      return i;
    }
    var u = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var l = r(2),
      f = u(r(3)),
      d = u(r(8)),
      p = function (e) {
        var t = e.nbHits,
          r = e.nbSortedHits,
          i = e.cssClasses,
          a = e.templateProps,
          c = s(e, ["nbHits", "nbSortedHits", "cssClasses", "templateProps"]);
        return (0, l.h)(
          "div",
          { className: (0, f.default)(i.root) },
          (0, l.h)(
            d.default,
            n({}, a, {
              templateKey: "text",
              rootTagName: "span",
              rootProps: { className: i.text },
              data: o(
                {
                  hasManySortedResults: r && r > 1,
                  hasNoSortedResults: 0 === r,
                  hasOneSortedResults: 1 === r,
                  hasManyResults: t > 1,
                  hasNoResults: 0 === t,
                  hasOneResult: 1 === t,
                  nbHits: t,
                  nbSortedHits: r,
                  cssClasses: i,
                },
                c
              ),
            })
          )
        );
      },
      h = p;
    t.default = h;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var a = r(1),
      s = (0, a.createDocumentationMessageGenerator)({
        name: "stats",
        connector: !0,
      }),
      c = function (e) {
        var t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : a.noop;
        return (
          (0, a.checkRendering)(e, s()),
          function (r) {
            return {
              $$type: "ais.stats",
              init: function (t) {
                var r = t.instantSearchInstance;
                e(
                  i(
                    i({}, this.getWidgetRenderState(t)),
                    {},
                    { instantSearchInstance: r }
                  ),
                  !0
                );
              },
              render: function (t) {
                var r = t.instantSearchInstance;
                e(
                  i(
                    i({}, this.getWidgetRenderState(t)),
                    {},
                    { instantSearchInstance: r }
                  ),
                  !1
                );
              },
              dispose: function () {
                t();
              },
              getRenderState: function (e, t) {
                return i(i({}, e), {}, { stats: this.getWidgetRenderState(t) });
              },
              getWidgetRenderState: function (e) {
                var t = e.results,
                  n = e.state;
                return t
                  ? {
                      hitsPerPage: t.hitsPerPage,
                      nbHits: t.nbHits,
                      nbSortedHits: t.nbSortedHits,
                      areHitsSorted:
                        void 0 !== t.appliedRelevancyStrictness &&
                        t.appliedRelevancyStrictness > 0 &&
                        t.nbSortedHits !== t.nbHits,
                      nbPages: t.nbPages,
                      page: t.page,
                      processingTimeMS: t.processingTimeMS,
                      query: t.query,
                      widgetParams: r,
                    }
                  : {
                      hitsPerPage: n.hitsPerPage,
                      nbHits: 0,
                      nbSortedHits: void 0,
                      areHitsSorted: !1,
                      nbPages: 0,
                      page: n.page || 0,
                      processingTimeMS: -1,
                      query: n.query || "",
                      widgetParams: r,
                    };
              },
            };
          }
        );
      },
      u = c;
    t.default = u;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    var a = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var s = r(2),
      c = a(r(3)),
      u = a(r(354)),
      l = a(r(355)),
      f = r(1),
      d = r(6),
      p = (0, f.createDocumentationMessageGenerator)({ name: "sort-by" }),
      h = (0, d.component)("SortBy"),
      v = function (e) {
        var t = e.containerNode,
          r = e.cssClasses;
        return function (e, n) {
          var i = e.currentRefinement,
            o = e.options,
            a = e.refine;
          n ||
            (0, s.render)(
              (0, s.h)(
                "div",
                { className: r.root },
                (0, s.h)(u.default, {
                  cssClasses: r,
                  currentValue: i,
                  options: o,
                  setValue: a,
                })
              ),
              t
            );
        };
      },
      m = function (e) {
        var t = e || {},
          r = t.container,
          n = t.items,
          o = t.cssClasses,
          a = void 0 === o ? {} : o,
          u = t.transformItems;
        if (!r) throw new Error(p("The `container` option is required."));
        var d = (0, f.getContainerNode)(r),
          m = {
            root: (0, c.default)(h(), a.root),
            select: (0, c.default)(h({ descendantName: "select" }), a.select),
            option: (0, c.default)(h({ descendantName: "option" }), a.option),
          },
          g = v({ containerNode: d, cssClasses: m });
        return i(
          i(
            {},
            (0, l.default)(g, function () {
              return (0, s.render)(null, d);
            })({ container: d, items: n, transformItems: u })
          ),
          {},
          { $$widgetType: "ais.sortBy" }
        );
      },
      g = m;
    t.default = g;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      var t = e.currentValue,
        r = e.options,
        n = e.cssClasses,
        i = e.setValue;
      return (0, o.h)(
        "select",
        {
          className: (0, a.default)(n.select),
          onChange: function (e) {
            return i(e.target.value);
          },
          value: "".concat(t),
        },
        r.map(function (e) {
          return (0,
          o.h)("option", { className: (0, a.default)(n.option), key: e.label + e.value, value: "".concat(e.value) }, e.label);
        })
      );
    }
    var i = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var o = r(2),
      a = i(r(3)),
      s = n;
    t.default = s;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var a = r(1),
      s = (0, a.createDocumentationMessageGenerator)({
        name: "sort-by",
        connector: !0,
      }),
      c = function (e) {
        var t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : a.noop;
        (0, a.checkRendering)(e, s());
        var r = {};
        return function (n) {
          var o = n || {},
            c = o.items,
            u = o.transformItems,
            l =
              void 0 === u
                ? function (e) {
                    return e;
                  }
                : u;
          if (!Array.isArray(c))
            throw new Error(
              s("The `items` option expects an array of objects.")
            );
          return {
            $$type: "ais.sortBy",
            init: function (t) {
              var r = t.instantSearchInstance,
                n = this.getWidgetRenderState(t),
                o = n.currentRefinement;
              (0, a.find)(c, function (e) {
                return e.value === o;
              }),
                e(i(i({}, n), {}, { instantSearchInstance: r }), !0);
            },
            render: function (t) {
              var r = t.instantSearchInstance;
              e(
                i(
                  i({}, this.getWidgetRenderState(t)),
                  {},
                  { instantSearchInstance: r }
                ),
                !1
              );
            },
            dispose: function (e) {
              var n = e.state;
              return t(), r.initialIndex ? n.setIndex(r.initialIndex) : n;
            },
            getRenderState: function (e, t) {
              return i(i({}, e), {}, { sortBy: this.getWidgetRenderState(t) });
            },
            getWidgetRenderState: function (e) {
              var t = e.results,
                i = e.helper,
                o = e.state,
                a = e.parent;
              !r.initialIndex && a && (r.initialIndex = a.getIndexName()),
                r.setIndex ||
                  (r.setIndex = function (e) {
                    i.setIndex(e).search();
                  });
              var s = !t || 0 === t.nbHits;
              return {
                currentRefinement: o.index,
                options: l(c, { results: t }),
                refine: r.setIndex,
                hasNoResults: s,
                canRefine: !s && c.length > 0,
                widgetParams: n,
              };
            },
            getWidgetUiState: function (e, t) {
              var n = t.searchParameters,
                o = n.index;
              return i(
                i({}, e),
                {},
                { sortBy: o !== r.initialIndex ? o : void 0 }
              );
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState;
              return e.setQueryParameter(
                "index",
                n.sortBy || r.initialIndex || e.index
              );
            },
          };
        };
      },
      u = c;
    t.default = u;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    var a = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var s = r(2),
      c = a(r(357)),
      u = a(r(3)),
      l = a(r(358)),
      f = a(r(359)),
      d = r(1),
      p = r(12),
      h = r(6),
      v = (0, d.createDocumentationMessageGenerator)({
        name: "clear-refinements",
      }),
      m = (0, h.component)("ClearRefinements"),
      g = function (e) {
        var t = e.containerNode,
          r = e.cssClasses,
          n = e.renderState,
          i = e.templates;
        return function (e, o) {
          var a = e.refine,
            u = e.canRefine,
            l = e.instantSearchInstance;
          if (o)
            return void (n.templateProps = (0, p.prepareTemplateProps)({
              defaultTemplates: f.default,
              templatesConfig: l.templatesConfig,
              templates: i,
            }));
          (0, s.render)(
            (0, s.h)(c.default, {
              refine: a,
              cssClasses: r,
              hasRefinements: u,
              templateProps: n.templateProps,
            }),
            t
          );
        };
      },
      y = function (e) {
        var t = e || {},
          r = t.container,
          n = t.templates,
          o = void 0 === n ? {} : n,
          a = t.includedAttributes,
          c = t.excludedAttributes,
          f = t.transformItems,
          p = t.cssClasses,
          h = void 0 === p ? {} : p;
        if (!r) throw new Error(v("The `container` option is required."));
        var y = (0, d.getContainerNode)(r),
          b = {
            root: (0, u.default)(m(), h.root),
            button: (0, u.default)(m({ descendantName: "button" }), h.button),
            disabledButton: (0, u.default)(
              m({ descendantName: "button", modifierName: "disabled" }),
              h.disabledButton
            ),
          },
          _ = g({
            containerNode: y,
            cssClasses: b,
            renderState: {},
            templates: o,
          });
        return i(
          i(
            {},
            (0, l.default)(_, function () {
              return (0, s.render)(null, y);
            })({
              includedAttributes: a,
              excludedAttributes: c,
              transformItems: f,
            })
          ),
          {},
          { $$widgetType: "ais.clearRefinements" }
        );
      },
      b = y;
    t.default = b;
  },
  function (e, t, r) {
    "use strict";
    function n() {
      return (
        (n =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r)
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          }),
        n.apply(this, arguments)
      );
    }
    function i(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    var o = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var a = r(2),
      s = o(r(3)),
      c = o(r(8)),
      u = function (e) {
        var t = e.hasRefinements,
          r = e.refine,
          o = e.cssClasses,
          u = e.templateProps;
        return (0, a.h)(
          "div",
          { className: o.root },
          (0, a.h)(
            c.default,
            n({}, u, {
              templateKey: "resetLabel",
              rootTagName: "button",
              rootProps: {
                className: (0, s.default)(
                  o.button,
                  i({}, o.disabledButton, !t)
                ),
                onClick: r,
                disabled: !t,
              },
              data: { hasRefinements: t },
            })
          )
        );
      },
      l = u;
    t.default = l;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return s(e) || a(e) || o(e) || i();
    }
    function i() {
      throw new TypeError(
        "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function o(e, t) {
      if (e) {
        if ("string" == typeof e) return c(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? c(e, t)
            : void 0
        );
      }
    }
    function a(e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e))
        return Array.from(e);
    }
    function s(e) {
      if (Array.isArray(e)) return c(e);
    }
    function c(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function u(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function l(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? u(Object(r), !0).forEach(function (t) {
              f(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : u(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function f(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function d(e) {
      var t = e.scopedResult,
        r = e.includedAttributes,
        n = e.excludedAttributes,
        i = e.transformItems,
        o = e.results,
        a = -1 !== r.indexOf("query") || -1 === n.indexOf("query");
      return {
        helper: t.helper,
        items: i(
          (0, p.uniq)(
            (0, p.getRefinements)(t.results, t.helper.state, a)
              .map(function (e) {
                return e.attribute;
              })
              .filter(function (e) {
                return 0 === r.length || -1 !== r.indexOf(e);
              })
              .filter(function (e) {
                return ("query" === e && a) || -1 === n.indexOf(e);
              })
          ),
          { results: o }
        ),
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var p = r(1),
      h = (0, p.createDocumentationMessageGenerator)({
        name: "clear-refinements",
        connector: !0,
      }),
      v = function (e) {
        var t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : p.noop;
        return (
          (0, p.checkRendering)(e, h()),
          function (r) {
            var i = r || {},
              o = i.includedAttributes,
              a = void 0 === o ? [] : o,
              s = i.excludedAttributes,
              c = void 0 === s ? ["query"] : s,
              u = i.transformItems,
              f =
                void 0 === u
                  ? function (e) {
                      return e;
                    }
                  : u;
            if (r && r.includedAttributes && r.excludedAttributes)
              throw new Error(
                h(
                  "The options `includedAttributes` and `excludedAttributes` cannot be used together."
                )
              );
            var v = {
                refine: p.noop,
                createURL: function () {
                  return "";
                },
                attributesToClear: [],
              },
              m = function () {
                return v.refine();
              },
              g = function () {
                return v.createURL();
              };
            return {
              $$type: "ais.clearRefinements",
              init: function (t) {
                var r = t.instantSearchInstance;
                e(
                  l(
                    l({}, this.getWidgetRenderState(t)),
                    {},
                    { instantSearchInstance: r }
                  ),
                  !0
                );
              },
              render: function (t) {
                var r = t.instantSearchInstance;
                e(
                  l(
                    l({}, this.getWidgetRenderState(t)),
                    {},
                    { instantSearchInstance: r }
                  ),
                  !1
                );
              },
              dispose: function () {
                t();
              },
              getRenderState: function (e, t) {
                return l(
                  l({}, e),
                  {},
                  { clearRefinements: this.getWidgetRenderState(t) }
                );
              },
              getWidgetRenderState: function (e) {
                var t = e.createURL,
                  i = e.scopedResults,
                  o = e.results;
                (v.attributesToClear = i.reduce(function (e, t) {
                  return e.concat(
                    d({
                      scopedResult: t,
                      includedAttributes: a,
                      excludedAttributes: c,
                      transformItems: f,
                      results: o,
                    })
                  );
                }, [])),
                  (v.refine = function () {
                    v.attributesToClear.forEach(function (e) {
                      var t = e.helper,
                        r = e.items;
                      t.setState(
                        (0, p.clearRefinements)({
                          helper: t,
                          attributesToClear: r,
                        })
                      ).search();
                    });
                  }),
                  (v.createURL = function () {
                    return t(
                      p.mergeSearchParameters.apply(
                        void 0,
                        n(
                          v.attributesToClear.map(function (e) {
                            var t = e.helper,
                              r = e.items;
                            return (0,
                            p.clearRefinements)({ helper: t, attributesToClear: r });
                          })
                        )
                      )
                    );
                  });
                var s = v.attributesToClear.some(function (e) {
                  return e.items.length > 0;
                });
                return {
                  canRefine: s,
                  hasRefinements: s,
                  refine: m,
                  createURL: g,
                  widgetParams: r,
                };
              },
            };
          }
        );
      },
      m = v;
    t.default = m;
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var n = {
        resetLabel: function () {
          return "Clear refinements";
        },
      },
      i = n;
    t.default = i;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    var a = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var s = r(2),
      c = a(r(3)),
      u = r(1),
      l = r(6),
      f = a(r(361)),
      d = (0, u.createDocumentationMessageGenerator)({ name: "panel" }),
      p = (0, l.component)("Panel"),
      h = function (e) {
        var t = e.containerNode,
          r = e.bodyContainerNode,
          n = e.cssClasses,
          i = e.templates;
        return function (e) {
          var o = e.options,
            a = e.hidden,
            c = e.collapsible,
            u = e.collapsed;
          (0, s.render)(
            (0, s.h)(f.default, {
              cssClasses: n,
              hidden: a,
              collapsible: c,
              isCollapsed: u,
              templates: i,
              data: o,
              bodyElement: r,
            }),
            t
          );
        };
      },
      v = function (e) {
        var t = e || {},
          r = t.templates,
          n = void 0 === r ? {} : r,
          o = t.hidden,
          a =
            void 0 === o
              ? function () {
                  return !1;
                }
              : o,
          l = t.collapsed,
          f = t.cssClasses,
          v = void 0 === f ? {} : f,
          m = document.createElement("div"),
          g = Boolean(l),
          y =
            "function" == typeof l
              ? l
              : function () {
                  return !1;
                },
          b = {
            root: (0, c.default)(p(), v.root),
            noRefinementRoot: (0, c.default)(
              p({ modifierName: "noRefinement" }),
              v.noRefinementRoot
            ),
            collapsibleRoot: (0, c.default)(
              p({ modifierName: "collapsible" }),
              v.collapsibleRoot
            ),
            collapsedRoot: (0, c.default)(
              p({ modifierName: "collapsed" }),
              v.collapsedRoot
            ),
            collapseButton: (0, c.default)(
              p({ descendantName: "collapseButton" }),
              v.collapseButton
            ),
            collapseIcon: (0, c.default)(
              p({ descendantName: "collapseIcon" }),
              v.collapseIcon
            ),
            body: (0, c.default)(p({ descendantName: "body" }), v.body),
            header: (0, c.default)(p({ descendantName: "header" }), v.header),
            footer: (0, c.default)(p({ descendantName: "footer" }), v.footer),
          };
        return function (e) {
          return function (t) {
            if (!t || !t.container)
              throw new Error(
                d(
                  "The `container` option is required in the widget within the panel."
                )
              );
            var r = (0, u.getContainerNode)(t.container),
              o = {
                header: "",
                footer: "",
                collapseButtonText: function (e) {
                  var t = e.collapsed;
                  return '<svg\n          class="'
                    .concat(
                      b.collapseIcon,
                      '"\n          width="1em"\n          height="1em"\n          viewBox="0 0 500 500"\n        >\n        <path d="'
                    )
                    .concat(
                      t ? "M100 250l300-150v300z" : "M250 400l150-300H100z",
                      '" fill="currentColor" />\n        </svg>'
                    );
                },
              },
              c = h({
                containerNode: r,
                bodyContainerNode: m,
                cssClasses: b,
                templates: i(i({}, o), n),
              }),
              l = e(i(i({}, t), {}, { container: m }));
            return i(
              i({}, l),
              {},
              {
                init: function () {
                  for (
                    var e = arguments.length, t = new Array(e), r = 0;
                    r < e;
                    r++
                  )
                    t[r] = arguments[r];
                  var n = t[0],
                    o = i(
                      i(
                        {},
                        l.getWidgetRenderState ? l.getWidgetRenderState(n) : {}
                      ),
                      n
                    );
                  if (
                    (c({
                      options: o,
                      hidden: !0,
                      collapsible: g,
                      collapsed: !1,
                    }),
                    "function" == typeof l.init)
                  ) {
                    var a;
                    (a = l.init).call.apply(a, [this].concat(t));
                  }
                },
                render: function () {
                  for (
                    var e = arguments.length, t = new Array(e), r = 0;
                    r < e;
                    r++
                  )
                    t[r] = arguments[r];
                  var n = t[0],
                    o = i(
                      i(
                        {},
                        l.getWidgetRenderState ? l.getWidgetRenderState(n) : {}
                      ),
                      n
                    );
                  if (
                    (c({
                      options: o,
                      hidden: Boolean(a(o)),
                      collapsible: g,
                      collapsed: Boolean(y(o)),
                    }),
                    "function" == typeof l.render)
                  ) {
                    var s;
                    (s = l.render).call.apply(s, [this].concat(t));
                  }
                },
                dispose: function () {
                  if (
                    ((0, s.render)(null, r), "function" == typeof l.dispose)
                  ) {
                    for (
                      var e, t = arguments.length, n = new Array(t), i = 0;
                      i < t;
                      i++
                    )
                      n[i] = arguments[i];
                    return (e = l.dispose).call.apply(e, [this].concat(n));
                  }
                },
              }
            );
          };
        };
      },
      m = v;
    t.default = m;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function i(e, t) {
      return u(e) || c(e, t) || a(e, t) || o();
    }
    function o() {
      throw new TypeError(
        "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function a(e, t) {
      if (e) {
        if ("string" == typeof e) return s(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? s(e, t)
            : void 0
        );
      }
    }
    function s(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function c(e, t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
        var r = [],
          n = !0,
          i = !1,
          o = void 0;
        try {
          for (
            var a, s = e[Symbol.iterator]();
            !(n = (a = s.next()).done) &&
            (r.push(a.value), !t || r.length !== t);
            n = !0
          );
        } catch (e) {
          (i = !0), (o = e);
        } finally {
          try {
            n || null == s.return || s.return();
          } finally {
            if (i) throw o;
          }
        }
        return r;
      }
    }
    function u(e) {
      if (Array.isArray(e)) return e;
    }
    function l(e) {
      var t,
        r = (0, p.useState)(e.isCollapsed),
        o = i(r, 2),
        a = o[0],
        s = o[1],
        c = (0, p.useState)(!1),
        u = i(c, 2),
        l = u[0],
        f = u[1],
        m = (0, p.useRef)(null);
      return (
        (0, p.useEffect)(
          function () {
            var t = m.current;
            if (t)
              return (
                t.appendChild(e.bodyElement),
                function () {
                  t.removeChild(e.bodyElement);
                }
              );
          },
          [m, e.bodyElement]
        ),
        l || e.isCollapsed === a || s(e.isCollapsed),
        (0, d.h)(
          "div",
          {
            className: (0, h.default)(
              e.cssClasses.root,
              ((t = {}),
              n(t, e.cssClasses.noRefinementRoot, e.hidden),
              n(t, e.cssClasses.collapsibleRoot, e.collapsible),
              n(t, e.cssClasses.collapsedRoot, a),
              t)
            ),
            hidden: e.hidden,
          },
          e.templates.header &&
            (0, d.h)(
              "div",
              { className: e.cssClasses.header },
              (0, d.h)(v.default, {
                templates: e.templates,
                templateKey: "header",
                rootTagName: "span",
                data: e.data,
              }),
              e.collapsible &&
                (0, d.h)(
                  "button",
                  {
                    className: e.cssClasses.collapseButton,
                    "aria-expanded": !a,
                    onClick: function (e) {
                      e.preventDefault(),
                        f(!0),
                        s(function (e) {
                          return !e;
                        });
                    },
                  },
                  (0, d.h)(v.default, {
                    templates: e.templates,
                    templateKey: "collapseButtonText",
                    rootTagName: "span",
                    data: { collapsed: a },
                  })
                )
            ),
          (0, d.h)("div", { className: e.cssClasses.body, ref: m }),
          e.templates.footer &&
            (0, d.h)(v.default, {
              templates: e.templates,
              templateKey: "footer",
              rootProps: { className: e.cssClasses.footer },
              data: e.data,
            })
        )
      );
    }
    var f = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var d = r(2),
      p = r(362),
      h = f(r(3)),
      v = f(r(8)),
      m = l;
    t.default = m;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      E.options.__h && E.options.__h(P, e, R || t), (R = 0);
      var r = P.__H || (P.__H = { __: [], __h: [] });
      return e >= r.__.length && r.__.push({ __V: k }), r.__[e];
    }
    function i(e) {
      return (R = 1), o(O, e);
    }
    function o(e, t, r) {
      var i = n(j++, 2);
      if (
        ((i.t = e),
        !i.__c &&
          ((i.__ = [
            r ? r(t) : O(void 0, t),
            function (e) {
              var t = i.__N ? i.__N[0] : i.__[0],
                r = i.t(t, e);
              t !== r && ((i.__N = [r, i.__[1]]), i.__c.setState({}));
            },
          ]),
          (i.__c = P),
          !P.u))
      ) {
        P.u = !0;
        var o = P.shouldComponentUpdate;
        P.shouldComponentUpdate = function (e, t, r) {
          if (!i.__c.__H) return !0;
          var n = i.__c.__H.__.filter(function (e) {
            return e.__c;
          });
          if (
            n.every(function (e) {
              return !e.__N;
            })
          )
            return !o || o.call(this, e, t, r);
          var a = !1;
          return (
            n.forEach(function (e) {
              if (e.__N) {
                var t = e.__[0];
                (e.__ = e.__N), (e.__N = void 0), t !== e.__[0] && (a = !0);
              }
            }),
            !(!a && i.__c.props === e) && (!o || o.call(this, e, t, r))
          );
        };
      }
      return i.__N || i.__;
    }
    function a(e, t) {
      var r = n(j++, 3);
      !E.options.__s &&
        _(r.__H, t) &&
        ((r.__ = e), (r.i = t), P.__H.__h.push(r));
    }
    function s(e, t) {
      var r = n(j++, 4);
      !E.options.__s && _(r.__H, t) && ((r.__ = e), (r.i = t), P.__h.push(r));
    }
    function c(e) {
      return (
        (R = 5),
        l(function () {
          return { current: e };
        }, [])
      );
    }
    function u(e, t, r) {
      (R = 6),
        s(
          function () {
            return "function" == typeof e
              ? (e(t()),
                function () {
                  return e(null);
                })
              : e
              ? ((e.current = t()),
                function () {
                  return (e.current = null);
                })
              : void 0;
          },
          null == r ? r : r.concat(e)
        );
    }
    function l(e, t) {
      var r = n(j++, 7);
      return _(r.__H, t)
        ? ((r.__V = e()), (r.i = t), (r.__h = e), r.__V)
        : r.__;
    }
    function f(e, t) {
      return (
        (R = 8),
        l(function () {
          return e;
        }, t)
      );
    }
    function d(e) {
      var t = P.context[e.__c],
        r = n(j++, 9);
      return (
        (r.c = e),
        t ? (null == r.__ && ((r.__ = !0), t.sub(P)), t.props.value) : e.__
      );
    }
    function p(e, t) {
      E.options.useDebugValue && E.options.useDebugValue(t ? t(e) : e);
    }
    function h(e) {
      var t = n(j++, 10),
        r = i();
      return (
        (t.__ = e),
        P.componentDidCatch ||
          (P.componentDidCatch = function (e, n) {
            t.__ && t.__(e, n), r[1](e);
          }),
        [
          r[0],
          function () {
            r[1](void 0);
          },
        ]
      );
    }
    function v() {
      var e = n(j++, 11);
      return (
        e.__ ||
          (e.__ =
            "P" +
            (function (e) {
              for (var t = 0, r = e.length; r > 0; )
                t = ((t << 5) - t + e.charCodeAt(--r)) | 0;
              return t;
            })(P.__v.__m) +
            j),
        e.__
      );
    }
    function m() {
      for (var e; (e = x.shift()); )
        if (e.__P && e.__H)
          try {
            e.__H.__h.forEach(y), e.__H.__h.forEach(b), (e.__H.__h = []);
          } catch (t) {
            (e.__H.__h = []), E.options.__e(t, e.__v);
          }
    }
    function g(e) {
      var t,
        r = function () {
          clearTimeout(n), N && cancelAnimationFrame(t), setTimeout(e);
        },
        n = setTimeout(r, 100);
      N && (t = requestAnimationFrame(r));
    }
    function y(e) {
      var t = P,
        r = e.__c;
      "function" == typeof r && ((e.__c = void 0), r()), (P = t);
    }
    function b(e) {
      var t = P;
      (e.__c = e.__()), (P = t);
    }
    function _(e, t) {
      return (
        !e ||
        e.length !== t.length ||
        t.some(function (t, r) {
          return t !== e[r];
        })
      );
    }
    function O(e, t) {
      return "function" == typeof t ? t(e) : t;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.useCallback = f),
      (t.useContext = d),
      (t.useDebugValue = p),
      (t.useEffect = a),
      (t.useErrorBoundary = h),
      (t.useId = v),
      (t.useImperativeHandle = u),
      (t.useLayoutEffect = s),
      (t.useMemo = l),
      (t.useReducer = o),
      (t.useRef = c),
      (t.useState = i);
    var j,
      P,
      w,
      S,
      E = r(2),
      R = 0,
      x = [],
      k = [],
      I = E.options.__b,
      A = E.options.__r,
      M = E.options.diffed,
      C = E.options.__c,
      T = E.options.unmount;
    (E.options.__b = function (e) {
      "function" != typeof e.type || e.__m || e.type === E.Fragment
        ? e.__m || (e.__m = e.__ && e.__.__m ? e.__.__m : "")
        : (e.__m =
            (e.__ && e.__.__m ? e.__.__m : "") +
            (e.__ && e.__.__k ? e.__.__k.indexOf(e) : 0)),
        (P = null),
        I && I(e);
    }),
      (E.options.__r = function (e) {
        A && A(e), (j = 0);
        var t = (P = e.__c).__H;
        t &&
          (w === P
            ? ((t.__h = []),
              (P.__h = []),
              t.__.forEach(function (e) {
                e.__N && (e.__ = e.__N), (e.__V = k), (e.__N = e.i = void 0);
              }))
            : (t.__h.forEach(y), t.__h.forEach(b), (t.__h = []))),
          (w = P);
      }),
      (E.options.diffed = function (e) {
        M && M(e);
        var t = e.__c;
        t &&
          t.__H &&
          (t.__H.__h.length &&
            ((1 !== x.push(t) && S === E.options.requestAnimationFrame) ||
              ((S = E.options.requestAnimationFrame) || g)(m)),
          t.__H.__.forEach(function (e) {
            e.i && (e.__H = e.i),
              e.__V !== k && (e.__ = e.__V),
              (e.i = void 0),
              (e.__V = k);
          })),
          (w = P = null);
      }),
      (E.options.__c = function (e, t) {
        t.some(function (e) {
          try {
            e.__h.forEach(y),
              (e.__h = e.__h.filter(function (e) {
                return !e.__ || b(e);
              }));
          } catch (r) {
            t.some(function (e) {
              e.__h && (e.__h = []);
            }),
              (t = []),
              E.options.__e(r, e.__v);
          }
        }),
          C && C(e, t);
      }),
      (E.options.unmount = function (e) {
        T && T(e);
        var t,
          r = e.__c;
        r &&
          r.__H &&
          (r.__H.__.forEach(function (e) {
            try {
              y(e);
            } catch (e) {
              t = e;
            }
          }),
          (r.__H = void 0),
          t && E.options.__e(t, r.__v));
      });
    var N = "function" == typeof requestAnimationFrame;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    var a = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var s = r(2),
      c = a(r(3)),
      u = a(r(364)),
      l = a(r(365)),
      f = a(r(366)),
      d = r(1),
      p = r(12),
      h = r(6),
      v = r(367),
      m = (0, d.createDocumentationMessageGenerator)({ name: "hits" }),
      g = (0, h.component)("Hits"),
      y = (0, v.withInsightsListener)(l.default),
      b = function (e) {
        var t = e.renderState,
          r = e.cssClasses,
          n = e.containerNode,
          i = e.templates;
        return function (e, o) {
          var a = e.hits,
            c = e.results,
            u = e.instantSearchInstance,
            l = e.insights,
            d = e.bindEvent;
          if (o)
            return void (t.templateProps = (0, p.prepareTemplateProps)({
              defaultTemplates: f.default,
              templatesConfig: u.templatesConfig,
              templates: i,
            }));
          (0, s.render)(
            (0, s.h)(y, {
              cssClasses: r,
              hits: a,
              results: c,
              templateProps: t.templateProps,
              insights: l,
              sendEvent: function (e) {
                u.sendEventToInsights(e);
              },
              bindEvent: d,
            }),
            n
          );
        };
      },
      _ = function (e) {
        var t = e || {},
          r = t.container,
          n = t.escapeHTML,
          o = t.transformItems,
          a = t.templates,
          l = void 0 === a ? {} : a,
          f = t.cssClasses,
          p = void 0 === f ? {} : f;
        if (!r) throw new Error(m("The `container` option is required."));
        var h = (0, d.getContainerNode)(r),
          y = {
            root: (0, c.default)(g(), p.root),
            emptyRoot: (0, c.default)(
              g({ modifierName: "empty" }),
              p.emptyRoot
            ),
            list: (0, c.default)(g({ descendantName: "list" }), p.list),
            item: (0, c.default)(g({ descendantName: "item" }), p.item),
          },
          _ = b({
            containerNode: h,
            cssClasses: y,
            renderState: {},
            templates: l,
          });
        return i(
          i(
            {},
            (0, v.withInsights)(u.default)(_, function () {
              return (0, s.render)(null, h);
            })({ escapeHTML: n, transformItems: o })
          ),
          {},
          { $$widgetType: "ais.hits" }
        );
      },
      O = _;
    t.default = O;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var a = r(1),
      s = (0, a.createDocumentationMessageGenerator)({
        name: "hits",
        connector: !0,
      }),
      c = function (e) {
        var t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : a.noop;
        return (
          (0, a.checkRendering)(e, s()),
          function (r) {
            var n,
              s,
              c = r || {},
              u = c.escapeHTML,
              l = void 0 === u || u,
              f = c.transformItems,
              d =
                void 0 === f
                  ? function (e) {
                      return e;
                    }
                  : f;
            return {
              $$type: "ais.hits",
              init: function (t) {
                e(
                  i(
                    i({}, this.getWidgetRenderState(t)),
                    {},
                    { instantSearchInstance: t.instantSearchInstance }
                  ),
                  !0
                );
              },
              render: function (t) {
                var r = this.getWidgetRenderState(t);
                e(
                  i(
                    i({}, r),
                    {},
                    { instantSearchInstance: t.instantSearchInstance }
                  ),
                  !1
                ),
                  r.sendEvent("view", r.hits);
              },
              getRenderState: function (e, t) {
                return i(i({}, e), {}, { hits: this.getWidgetRenderState(t) });
              },
              getWidgetRenderState: function (e) {
                var t = e.results,
                  i = e.helper,
                  o = e.instantSearchInstance;
                if (
                  (n ||
                    (n = (0, a.createSendEventForHits)({
                      instantSearchInstance: o,
                      index: i.getIndex(),
                      widgetType: this.$$type,
                    })),
                  s ||
                    (s = (0, a.createBindEventForHits)({
                      index: i.getIndex(),
                      widgetType: this.$$type,
                    })),
                  !t)
                )
                  return {
                    hits: [],
                    results: void 0,
                    sendEvent: n,
                    bindEvent: s,
                    widgetParams: r,
                  };
                l && t.hits.length > 0 && (t.hits = (0, a.escapeHits)(t.hits));
                var c = (0, a.addAbsolutePosition)(
                    t.hits,
                    t.page,
                    t.hitsPerPage
                  ),
                  u = (0, a.addQueryID)(c, t.queryID);
                return {
                  hits: d(u, { results: t }),
                  results: t,
                  sendEvent: n,
                  bindEvent: s,
                  widgetParams: r,
                };
              },
              dispose: function (e) {
                var r = e.state;
                return (
                  t(),
                  l
                    ? r.setQueryParameters(
                        Object.keys(a.TAG_PLACEHOLDER).reduce(function (e, t) {
                          return i(i({}, e), {}, o({}, t, void 0));
                        }, {})
                      )
                    : r
                );
              },
              getWidgetSearchParameters: function (e) {
                return l ? e.setQueryParameters(a.TAG_PLACEHOLDER) : e;
              },
            };
          }
        );
      },
      u = c;
    t.default = u;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a() {
      return (
        (a =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r)
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          }),
        a.apply(this, arguments)
      );
    }
    var s = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var c = r(2),
      u = s(r(3)),
      l = s(r(8)),
      f = function (e) {
        var t = e.results,
          r = e.hits,
          n = e.bindEvent,
          o = e.sendEvent,
          s = e.cssClasses,
          f = e.templateProps;
        return 0 === t.hits.length
          ? (0, c.h)(
              l.default,
              a({}, f, {
                templateKey: "empty",
                rootProps: { className: (0, u.default)(s.root, s.emptyRoot) },
                data: t,
              })
            )
          : (0, c.h)(
              "div",
              { className: s.root },
              (0, c.h)(
                "ol",
                { className: s.list },
                r.map(function (e, t) {
                  return (0,
                  c.h)(l.default, a({}, f, { templateKey: "item", rootTagName: "li", rootProps: { className: s.item }, key: e.objectID, data: i(i({}, e), {}, { __hitIndex: t }), bindEvent: n, sendEvent: o }));
                })
              )
            );
      },
      d = f;
    t.default = d;
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var n = {
        empty: function () {
          return "No results";
        },
        item: function (e) {
          return JSON.stringify(e, null, 2);
        },
      },
      i = n;
    t.default = i;
  },
  function (e, t, r) {
    "use strict";
    var n = r(0),
      i = r(57);
    Object.defineProperty(t, "__esModule", { value: !0 }),
      Object.defineProperty(t, "withInsights", {
        enumerable: !0,
        get: function () {
          return o.default;
        },
      }),
      Object.defineProperty(t, "inferInsightsPayload", {
        enumerable: !0,
        get: function () {
          return o.inferPayload;
        },
      }),
      Object.defineProperty(t, "withInsightsListener", {
        enumerable: !0,
        get: function () {
          return a.default;
        },
      });
    var o = i(r(368)),
      a = n(r(369));
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e) {
      return function (t, r) {
        return e(function (e, r) {
          var n = e.results,
            o = e.hits,
            a = e.instantSearchInstance;
          if (n && o && a) {
            var s = d(a.insightsClient, n, o);
            return t(i(i({}, e), {}, { insights: s }), r);
          }
          return t(e, r);
        }, r);
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = a),
      (t.inferPayload = void 0);
    var s = r(1),
      c = function (e, t) {
        return t.map(function (t) {
          var r = (0, s.find)(e, function (e) {
            return e.objectID === t;
          });
          if (void 0 === r)
            throw new Error(
              'Could not find objectID "'.concat(
                t,
                '" passed to `clickedObjectIDsAfterSearch` in the returned hits. This is necessary to infer the absolute position and the query ID.'
              )
            );
          return r;
        });
      },
      u = function (e) {
        var t = (0, s.uniq)(
          e.map(function (e) {
            return e.__queryID;
          })
        );
        if (t.length > 1)
          throw new Error(
            "Insights currently allows a single `queryID`. The `objectIDs` provided map to multiple `queryID`s."
          );
        var r = t[0];
        if ("string" != typeof r)
          throw new Error(
            "Could not infer `queryID`. Ensure InstantSearch `clickAnalytics: true` was added with the Configure widget.\n\nSee: https://alg.li/lNiZZ7"
          );
        return r;
      },
      l = function (e) {
        return e.map(function (e) {
          return e.__position;
        });
      },
      f = function (e) {
        var t = e.method,
          r = e.results,
          n = e.hits,
          i = e.objectIDs,
          o = r.index,
          a = c(n, i),
          s = u(a);
        switch (t) {
          case "clickedObjectIDsAfterSearch":
            return { index: o, queryID: s, objectIDs: i, positions: l(a) };
          case "convertedObjectIDsAfterSearch":
            return { index: o, queryID: s, objectIDs: i };
          default:
            throw new Error(
              'Unsupported method passed to insights: "'.concat(t, '".')
            );
        }
      };
    t.inferPayload = f;
    var d = function (e, t, r) {
      return function (n) {
        for (
          var o = arguments.length, a = new Array(o > 1 ? o - 1 : 0), c = 1;
          c < o;
          c++
        )
          a[c - 1] = arguments[c];
        var u = a[0];
        if (!e) {
          var l = (0, s.createDocumentationMessageGenerator)({
            name: "instantsearch",
          });
          throw new Error(
            l(
              "The `insightsClient` option has not been provided to `instantsearch`."
            )
          );
        }
        if (!Array.isArray(u.objectIDs))
          throw new TypeError("Expected `objectIDs` to be an array.");
        var d = f({ method: n, results: t, hits: r, objectIDs: u.objectIDs });
        e(n, i(i({}, d), u));
      };
    };
  },
  function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var n = r(2),
      i = r(1),
      o = r(58),
      a = function (e, t, r) {
        for (var n = e; n && !r(n); ) {
          if (n === t) return null;
          n = n.parentElement;
        }
        return n;
      },
      s = function (e) {
        var t = e.getAttribute("data-insights-event");
        if ("string" != typeof t)
          throw new Error(
            "The insights middleware expects `data-insights-event` to be a base64-encoded JSON string."
          );
        try {
          return (0, i.deserializePayload)(t);
        } catch (e) {
          throw new Error(
            "The insights middleware was unable to parse `data-insights-event`."
          );
        }
      },
      c = function (e) {
        function t(t) {
          var r = function (e) {
            if (t.sendEvent) {
              var r = a(e.target, e.currentTarget, function (e) {
                return e.hasAttribute("data-insights-event");
              });
              r &&
                s(r).forEach(function (e) {
                  return t.sendEvent(e);
                });
            }
            var n = a(e.target, e.currentTarget, function (e) {
              return (0, o.hasDataAttributes)(e);
            });
            if (n) {
              var i = (0, o.readDataAttributes)(n),
                c = i.method,
                u = i.payload;
              t.insights(c, u);
            }
          };
          return (0, n.h)("div", { onClick: r }, (0, n.h)(e, t));
        }
        return t;
      },
      u = c;
    t.default = u;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    var a = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var s = r(2),
      c = a(r(3)),
      u = a(r(371)),
      l = a(r(372)),
      f = r(1),
      d = r(6),
      p = (0, d.component)("Pagination"),
      h = (0, f.createDocumentationMessageGenerator)({ name: "pagination" }),
      v = { previous: "‹", next: "›", first: "«", last: "»" },
      m = function (e) {
        var t = e.containerNode,
          r = e.cssClasses,
          n = e.templates,
          i = e.showFirst,
          o = e.showLast,
          a = e.showPrevious,
          c = e.showNext,
          l = e.scrollToNode;
        return function (e, f) {
          var d = e.createURL,
            p = e.currentRefinement,
            h = e.nbPages,
            v = e.pages,
            m = e.isFirstPage,
            g = e.isLastPage,
            y = e.refine;
          if (!f) {
            var b = function (e) {
              y(e), !1 !== l && l.scrollIntoView();
            };
            (0, s.render)(
              (0, s.h)(u.default, {
                createURL: d,
                cssClasses: r,
                currentPage: p,
                templates: n,
                nbPages: h,
                pages: v,
                isFirstPage: m,
                isLastPage: g,
                setCurrentPage: b,
                showFirst: i,
                showLast: o,
                showPrevious: a,
                showNext: c,
              }),
              t
            );
          }
        };
      },
      g = function (e) {
        var t = e || {},
          r = t.container,
          n = t.templates,
          o = void 0 === n ? {} : n,
          a = t.cssClasses,
          u = void 0 === a ? {} : a,
          d = t.totalPages,
          g = t.padding,
          y = t.showFirst,
          b = void 0 === y || y,
          _ = t.showLast,
          O = void 0 === _ || _,
          j = t.showPrevious,
          P = void 0 === j || j,
          w = t.showNext,
          S = void 0 === w || w,
          E = t.scrollTo,
          R = void 0 === E ? "body" : E;
        if (!r) throw new Error(h("The `container` option is required."));
        var x = (0, f.getContainerNode)(r),
          k = !0 === R ? "body" : R,
          I = !1 !== k && (0, f.getContainerNode)(k),
          A = {
            root: (0, c.default)(p(), u.root),
            noRefinementRoot: (0, c.default)(
              p({ modifierName: "noRefinement" }),
              u.noRefinementRoot
            ),
            list: (0, c.default)(p({ descendantName: "list" }), u.list),
            item: (0, c.default)(p({ descendantName: "item" }), u.item),
            firstPageItem: (0, c.default)(
              p({ descendantName: "item", modifierName: "firstPage" }),
              u.firstPageItem
            ),
            lastPageItem: (0, c.default)(
              p({ descendantName: "item", modifierName: "lastPage" }),
              u.lastPageItem
            ),
            previousPageItem: (0, c.default)(
              p({ descendantName: "item", modifierName: "previousPage" }),
              u.previousPageItem
            ),
            nextPageItem: (0, c.default)(
              p({ descendantName: "item", modifierName: "nextPage" }),
              u.nextPageItem
            ),
            pageItem: (0, c.default)(
              p({ descendantName: "item", modifierName: "page" }),
              u.pageItem
            ),
            selectedItem: (0, c.default)(
              p({ descendantName: "item", modifierName: "selected" }),
              u.selectedItem
            ),
            disabledItem: (0, c.default)(
              p({ descendantName: "item", modifierName: "disabled" }),
              u.disabledItem
            ),
            link: (0, c.default)(p({ descendantName: "link" }), u.link),
          },
          M = i(i({}, v), o),
          C = m({
            containerNode: x,
            cssClasses: A,
            templates: M,
            showFirst: b,
            showLast: O,
            showPrevious: P,
            showNext: S,
            scrollToNode: I,
          });
        return i(
          i(
            {},
            (0, l.default)(C, function () {
              return (0, s.render)(null, x);
            })({ totalPages: d, padding: g })
          ),
          {},
          { $$widgetType: "ais.pagination" }
        );
      },
      y = g;
    t.default = y;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function i(e) {
      function t(t) {
        return function (r) {
          (0, u.isSpecialClick)(r) || (r.preventDefault(), e.setCurrentPage(t));
        };
      }
      return (0, s.h)(
        "div",
        {
          className: (0, c.default)(
            e.cssClasses.root,
            n({}, e.cssClasses.noRefinementRoot, e.nbPages <= 1)
          ),
        },
        (0, s.h)(
          "ul",
          { className: e.cssClasses.list },
          e.showFirst &&
            (0, s.h)(o, {
              ariaLabel: "First",
              className: e.cssClasses.firstPageItem,
              isDisabled: e.isFirstPage,
              label: e.templates.first,
              pageNumber: 0,
              createURL: e.createURL,
              cssClasses: e.cssClasses,
              createClickHandler: t,
            }),
          e.showPrevious &&
            (0, s.h)(o, {
              ariaLabel: "Previous",
              className: e.cssClasses.previousPageItem,
              isDisabled: e.isFirstPage,
              label: e.templates.previous,
              pageNumber: e.currentPage - 1,
              createURL: e.createURL,
              cssClasses: e.cssClasses,
              createClickHandler: t,
            }),
          e.pages.map(function (r) {
            return (0,
            s.h)(o, { key: r, ariaLabel: "".concat(r + 1), className: e.cssClasses.pageItem, isSelected: r === e.currentPage, label: "".concat(r + 1), pageNumber: r, createURL: e.createURL, cssClasses: e.cssClasses, createClickHandler: t });
          }),
          e.showNext &&
            (0, s.h)(o, {
              ariaLabel: "Next",
              className: e.cssClasses.nextPageItem,
              isDisabled: e.isLastPage,
              label: e.templates.next,
              pageNumber: e.currentPage + 1,
              createURL: e.createURL,
              cssClasses: e.cssClasses,
              createClickHandler: t,
            }),
          e.showLast &&
            (0, s.h)(o, {
              ariaLabel: "Last",
              className: e.cssClasses.lastPageItem,
              isDisabled: e.isLastPage,
              label: e.templates.last,
              pageNumber: e.nbPages - 1,
              createURL: e.createURL,
              cssClasses: e.cssClasses,
              createClickHandler: t,
            })
        )
      );
    }
    function o(e) {
      var t = e.label,
        r = e.ariaLabel,
        n = e.pageNumber,
        i = e.className,
        o = e.isDisabled,
        a = void 0 !== o && o,
        u = e.isSelected,
        l = void 0 !== u && u,
        f = e.cssClasses,
        d = e.createURL,
        p = e.createClickHandler;
      return (0, s.h)(
        "li",
        {
          className: (0, c.default)(
            f.item,
            i,
            a && f.disabledItem,
            l && f.selectedItem
          ),
        },
        a
          ? (0, s.h)("span", {
              className: f.link,
              dangerouslySetInnerHTML: { __html: t },
            })
          : (0, s.h)("a", {
              className: f.link,
              "aria-label": r,
              href: d(n),
              onClick: p(n),
              dangerouslySetInnerHTML: { __html: t },
            })
      );
    }
    var a = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var s = r(2),
      c = a(r(3)),
      u = r(1),
      l = i;
    t.default = l;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    var a = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var s = r(1),
      c = a(r(373)),
      u = (0, s.createDocumentationMessageGenerator)({
        name: "pagination",
        connector: !0,
      }),
      l = function (e) {
        var t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : s.noop;
        return (
          (0, s.checkRendering)(e, u()),
          function (r) {
            function n(e) {
              var t = e.nbPages;
              return void 0 !== a ? Math.min(a, t) : t;
            }
            var o = r || {},
              a = o.totalPages,
              s = o.padding,
              u = void 0 === s ? 3 : s,
              l = new c.default({ currentPage: 0, total: 0, padding: u }),
              f = {};
            return {
              $$type: "ais.pagination",
              init: function (t) {
                var r = t.instantSearchInstance;
                e(
                  i(
                    i({}, this.getWidgetRenderState(t)),
                    {},
                    { instantSearchInstance: r }
                  ),
                  !0
                );
              },
              render: function (t) {
                var r = t.instantSearchInstance;
                e(
                  i(
                    i({}, this.getWidgetRenderState(t)),
                    {},
                    { instantSearchInstance: r }
                  ),
                  !1
                );
              },
              dispose: function (e) {
                var r = e.state;
                return t(), r.setQueryParameter("page", void 0);
              },
              getWidgetUiState: function (e, t) {
                var r = t.searchParameters,
                  n = r.page || 0;
                return n ? i(i({}, e), {}, { page: n + 1 }) : e;
              },
              getWidgetSearchParameters: function (e, t) {
                var r = t.uiState,
                  n = r.page ? r.page - 1 : 0;
                return e.setQueryParameter("page", n);
              },
              getWidgetRenderState: function (e) {
                var t = e.results,
                  i = e.helper,
                  o = e.state,
                  a = e.createURL;
                f.refine ||
                  (f.refine = function (e) {
                    i.setPage(e), i.search();
                  }),
                  f.createURL ||
                    (f.createURL = function (e) {
                      return function (t) {
                        return a(e.setPage(t));
                      };
                    });
                var s = o.page || 0,
                  c = n(t || { nbPages: 0 });
                return (
                  (l.currentPage = s),
                  (l.total = c),
                  {
                    createURL: f.createURL(o),
                    refine: f.refine,
                    canRefine: c > 1,
                    currentRefinement: s,
                    nbHits:
                      (null === t || void 0 === t ? void 0 : t.nbHits) || 0,
                    nbPages: c,
                    pages: t ? l.pages() : [],
                    isFirstPage: l.isFirstPage(),
                    isLastPage: l.isLastPage(),
                    widgetParams: r,
                  }
                );
              },
              getRenderState: function (e, t) {
                return i(
                  i({}, e),
                  {},
                  { pagination: this.getWidgetRenderState(t) }
                );
              },
            };
          }
        );
      },
      f = l;
    t.default = f;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n);
      }
    }
    function o(e, t, r) {
      return t && i(e.prototype, t), r && i(e, r), e;
    }
    function a(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var s = r(1),
      c = (function () {
        function e(t) {
          n(this, e),
            a(this, "currentPage", void 0),
            a(this, "total", void 0),
            a(this, "padding", void 0),
            (this.currentPage = t.currentPage),
            (this.total = t.total),
            (this.padding = t.padding);
        }
        return (
          o(e, [
            {
              key: "pages",
              value: function () {
                var e = this.total,
                  t = this.currentPage,
                  r = this.padding;
                if (0 === e) return [0];
                var n = this.nbPagesDisplayed(r, e);
                if (n === e) return (0, s.range)({ end: e });
                var i = this.calculatePaddingLeft(t, r, e, n),
                  o = n - i,
                  a = t - i,
                  c = t + o;
                return (0, s.range)({ start: a, end: c });
              },
            },
            {
              key: "nbPagesDisplayed",
              value: function (e, t) {
                return Math.min(2 * e + 1, t);
              },
            },
            {
              key: "calculatePaddingLeft",
              value: function (e, t, r, n) {
                return e <= t ? e : e >= r - t ? n - (r - e) : t;
              },
            },
            {
              key: "isLastPage",
              value: function () {
                return this.currentPage === this.total - 1 || 0 === this.total;
              },
            },
            {
              key: "isFirstPage",
              value: function () {
                return 0 === this.currentPage;
              },
            },
          ]),
          e
        );
      })(),
      u = c;
    t.default = u;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    var a = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var s = a(r(375)),
      c = r(1),
      u = function (e) {
        return i(
          i({}, (0, s.default)(c.noop)({ searchParameters: e })),
          {},
          { $$widgetType: "ais.configure" }
        );
      },
      l = u;
    t.default = l;
  },
  function (e, t, r) {
    "use strict";
    function n(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? n(Object(r), !0).forEach(function (t) {
              o(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : n(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function o(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function a(e, t) {
      return e.setQueryParameters(
        Object.keys(t.searchParameters).reduce(function (e, t) {
          return i(i({}, e), {}, o({}, t, void 0));
        }, {})
      );
    }
    var s = r(0);
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var c = s(r(23)),
      u = r(1),
      l = (0, u.createDocumentationMessageGenerator)({
        name: "configure",
        connector: !0,
      }),
      f = function () {
        var e =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : u.noop,
          t =
            arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : u.noop;
        return function (r) {
          function n(e) {
            return function (t) {
              var n = a(e.state, r),
                i = (0, u.mergeSearchParameters)(
                  n,
                  new c.default.SearchParameters(t)
                );
              (r.searchParameters = t), e.setState(i).search();
            };
          }
          if (!r || !(0, u.isPlainObject)(r.searchParameters))
            throw new Error(
              l("The `searchParameters` option expects an object.")
            );
          var o = {};
          return {
            $$type: "ais.configure",
            init: function (t) {
              var r = t.instantSearchInstance;
              e(
                i(
                  i({}, this.getWidgetRenderState(t)),
                  {},
                  { instantSearchInstance: r }
                ),
                !0
              );
            },
            render: function (t) {
              var r = t.instantSearchInstance;
              e(
                i(
                  i({}, this.getWidgetRenderState(t)),
                  {},
                  { instantSearchInstance: r }
                ),
                !1
              );
            },
            dispose: function (e) {
              var n = e.state;
              return t(), a(n, r);
            },
            getRenderState: function (e, t) {
              var r,
                n = this.getWidgetRenderState(t);
              return i(
                i({}, e),
                {},
                {
                  configure: i(
                    i({}, n),
                    {},
                    {
                      widgetParams: i(
                        i({}, n.widgetParams),
                        {},
                        {
                          searchParameters: (0, u.mergeSearchParameters)(
                            new c.default.SearchParameters(
                              null === (r = e.configure) || void 0 === r
                                ? void 0
                                : r.widgetParams.searchParameters
                            ),
                            new c.default.SearchParameters(
                              n.widgetParams.searchParameters
                            )
                          ).getQueryParams(),
                        }
                      ),
                    }
                  ),
                }
              );
            },
            getWidgetRenderState: function (e) {
              var t = e.helper;
              return (
                o.refine || (o.refine = n(t)),
                { refine: o.refine, widgetParams: r }
              );
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState;
              return (0, u.mergeSearchParameters)(
                e,
                new c.default.SearchParameters(
                  i(i({}, n.configure), r.searchParameters)
                )
              );
            },
            getWidgetUiState: function (e) {
              return i(
                i({}, e),
                {},
                { configure: i(i({}, e.configure), r.searchParameters) }
              );
            },
          };
        };
      },
      d = f;
    t.default = d;
  },
  function (e, t, r) {
    "use strict";
    function n(e) {
      return s(e) || a(e) || o(e) || i();
    }
    function i() {
      throw new TypeError(
        "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function o(e, t) {
      if (e) {
        if ("string" == typeof e) return c(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === r && e.constructor && (r = e.constructor.name),
          "Map" === r || "Set" === r
            ? Array.from(e)
            : "Arguments" === r ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
            ? c(e, t)
            : void 0
        );
      }
    }
    function a(e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e))
        return Array.from(e);
    }
    function s(e) {
      if (Array.isArray(e)) return c(e);
    }
    function c(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function u(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function l(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? u(Object(r), !0).forEach(function (t) {
              f(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : u(Object(r)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(r, t)
              );
            });
      }
      return e;
    }
    function f(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    function d(e) {
      var t = e.results,
        r = e.helper,
        i = e.includedAttributes,
        o = e.excludedAttributes,
        a =
          -1 !== (i || []).indexOf("query") ||
          -1 === (o || []).indexOf("query"),
        s = i
          ? function (e) {
              return -1 !== i.indexOf(e.attribute);
            }
          : function (e) {
              return -1 === o.indexOf(e.attribute);
            },
        c = (0, y.getRefinements)(t, r.state, a).map(m).filter(s);
      return c.reduce(function (e, t) {
        return [].concat(
          n(
            e.filter(function (e) {
              return e.attribute !== t.attribute;
            })
          ),
          [
            {
              indexName: r.state.index,
              attribute: t.attribute,
              label: t.attribute,
              refinements: c
                .filter(function (e) {
                  return e.attribute === t.attribute;
                })
                .sort(function (e, t) {
                  return "numeric" === e.type ? e.value - t.value : 0;
                }),
              refine: function (e) {
                return h(r, e);
              },
            },
          ]
        );
      }, []);
    }
    function p(e, t) {
      switch (t.type) {
        case "facet":
          return e.removeFacetRefinement(t.attribute, String(t.value));
        case "disjunctive":
          return e.removeDisjunctiveFacetRefinement(
            t.attribute,
            String(t.value)
          );
        case "hierarchical":
          return e.removeHierarchicalFacetRefinement(t.attribute);
        case "exclude":
          return e.removeExcludeRefinement(t.attribute, String(t.value));
        case "numeric":
          return e.removeNumericRefinement(
            t.attribute,
            t.operator,
            String(t.value)
          );
        case "tag":
          return e.removeTagRefinement(String(t.value));
        case "query":
          return e.setQueryParameter("query", "");
        default:
          return e;
      }
    }
    function h(e, t) {
      e.setState(p(e.state, t)).search();
    }
    function v(e) {
      switch (e) {
        case ">=":
          return "≥";
        case "<=":
          return "≤";
        default:
          return e;
      }
    }
    function m(e) {
      var t = g(e),
        r = e.operator ? "".concat(v(e.operator), " ").concat(e.name) : e.name,
        n = { attribute: e.attribute, type: e.type, value: t, label: r };
      return (
        void 0 !== e.operator && (n.operator = e.operator),
        void 0 !== e.count && (n.count = e.count),
        void 0 !== e.exhaustive && (n.exhaustive = e.exhaustive),
        n
      );
    }
    function g(e) {
      return "numeric" === e.type
        ? Number(e.name)
        : "escapedValue" in e
        ? e.escapedValue
        : e.name;
    }
    Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = void 0);
    var y = r(1),
      b = (0, y.createDocumentationMessageGenerator)({
        name: "current-refinements",
        connector: !0,
      }),
      _ = function (e) {
        var t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : y.noop;
        return (
          (0, y.checkRendering)(e, b()),
          function (r) {
            if ((r || {}).includedAttributes && (r || {}).excludedAttributes)
              throw new Error(
                b(
                  "The options `includedAttributes` and `excludedAttributes` cannot be used together."
                )
              );
            var n = r || {},
              i = n.includedAttributes,
              o = n.excludedAttributes,
              a = void 0 === o ? ["query"] : o,
              s = n.transformItems,
              c =
                void 0 === s
                  ? function (e) {
                      return e;
                    }
                  : s;
            return {
              $$type: "ais.currentRefinements",
              init: function (t) {
                var r = t.instantSearchInstance;
                e(
                  l(
                    l({}, this.getWidgetRenderState(t)),
                    {},
                    { instantSearchInstance: r }
                  ),
                  !0
                );
              },
              render: function (t) {
                var r = t.instantSearchInstance;
                e(
                  l(
                    l({}, this.getWidgetRenderState(t)),
                    {},
                    { instantSearchInstance: r }
                  ),
                  !1
                );
              },
              dispose: function () {
                t();
              },
              getRenderState: function (e, t) {
                return l(
                  l({}, e),
                  {},
                  { currentRefinements: this.getWidgetRenderState(t) }
                );
              },
              getWidgetRenderState: function (e) {
                var t = e.results,
                  n = e.scopedResults,
                  o = e.createURL,
                  s = e.helper,
                  u = (function () {
                    return t
                      ? n.reduce(function (e, r) {
                          return e.concat(
                            c(
                              d({
                                results: r.results,
                                helper: r.helper,
                                includedAttributes: i,
                                excludedAttributes: a,
                              }),
                              { results: t }
                            )
                          );
                        }, [])
                      : c(
                          d({
                            results: {},
                            helper: s,
                            includedAttributes: i,
                            excludedAttributes: a,
                          }),
                          { results: t }
                        );
                  })();
                return {
                  items: u,
                  canRefine: u.length > 0,
                  refine: function (e) {
                    return h(s, e);
                  },
                  createURL: function (e) {
                    return o(p(s.state, e));
                  },
                  widgetParams: r,
                };
              },
            };
          }
        );
      },
      O = _;
    t.default = O;
  },
]);
